
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("iCEM6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79927e3c1c348660896b3e18285ccee2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8eb67a1caac8a7e$var$_react = $d8eb67a1caac8a7e$var$_interopRequireDefault((parcelRequire("euxye")));

var $d8eb67a1caac8a7e$var$_iconNew = $d8eb67a1caac8a7e$var$_interopRequireDefault((parcelRequire("52mjj")));
function $d8eb67a1caac8a7e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/question-circle
 * Usage guidance:
 * Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8eb67a1caac8a7e$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $d8eb67a1caac8a7e$var$_react.default.createElement($d8eb67a1caac8a7e$var$_iconNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$d8eb67a1caac8a7e$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $d8eb67a1caac8a7e$var$_default = module.exports.default = $d8eb67a1caac8a7e$var$QuestionCircleIcon;

});

parcelRegister("61kjS", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $4e07a872968511c6$export$68f3db7f6af48bcb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::932d47dd87f3f2976aabd1b4699b27b4>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ed9Xn = parcelRequire("ed9Xn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $4e07a872968511c6$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673"/>
</svg>
`;
const $4e07a872968511c6$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135"/>
</svg>
`;
function $4e07a872968511c6$export$68f3db7f6af48bcb({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Confluence', testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ed9Xn.IconWrapper), {
        svg: $4e07a872968511c6$var$svg,
        customThemeSvg: $4e07a872968511c6$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$4e07a872968511c6$export$68f3db7f6af48bcb.displayName = "ConfluenceIcon";

});
parcelRegister("ed9Xn", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $b0dd5313c450f2ae$export$be58b4326e23250f);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $iqfTZ = parcelRequire("iqfTZ");

var $4C7HL = parcelRequire("4C7HL");
const $b0dd5313c450f2ae$var$styles = {
    root: "_3iDTPbvbI6",
    TEMP_assets: "_0C0F9q1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $b0dd5313c450f2ae$var$cloudLightAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jyBRVV _0C0F9q1qiM",
    inverse: "_36J4jyCl79 _0C0F9qt28M",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $b0dd5313c450f2ae$var$cloudDarkAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jynrF4 _0C0F9qMlgR",
    inverse: "_36J4jyt28M _0C0F9qCl79",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $b0dd5313c450f2ae$var$dataCenterLightAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM",
    neutral: "_36J4jyBRVV _0C0F9q1qiM _0g0wFMBRVV",
    inverse: "_36J4jyt28M _0C0F9qRvDB _0g0wFMt28M",
    legacy: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $b0dd5313c450f2ae$var$dataCenterDarkAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR",
    neutral: "_36J4jynrF4 _0C0F9qMlgR _0g0wFMnrF4",
    inverse: "_36J4jyMmzW _0C0F9qt28M _0g0wFMMmzW",
    legacy: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR"
};
const $b0dd5313c450f2ae$var$rovoDarkAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6nrF4 _05MzPYnrF4 _0Yajk0nrF4 _40KAGSnrF4",
    inverse: "_2PY8Z6RvDB _05MzPYRvDB _0Yajk0RvDB _40KAGSRvDB",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
};
const $b0dd5313c450f2ae$var$rovoLightAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6BRVV _05MzPYBRVV _0Yajk0BRVV _40KAGSBRVV",
    inverse: "_2PY8Z6t28M _05MzPYt28M _0Yajk0t28M _40KAGSt28M",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $b0dd5313c450f2ae$var$sizeMap = {
    xxsmall: "_0jFU0Vey7F",
    xsmall: "_0jFU0VSPN1",
    small: "_0jFU0VoWWg",
    medium: "_0jFU0VUofl",
    large: "_0jFU0VUF4f",
    xlarge: "_0jFU0VpJKa",
    '12': "_0jFU0VxpxF",
    '16': "_0jFU0Vey7F",
    '20': "_0jFU0VSPN1",
    '24': "_0jFU0VoWWg",
    '32': "_0jFU0VUofl"
};
function $b0dd5313c450f2ae$export$be58b4326e23250f({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $4C7HL.useThemeObserver)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $4jQY2.default)([
            $b0dd5313c450f2ae$var$styles.root,
            $b0dd5313c450f2ae$var$sizeMap[size],
            colorMode === 'dark' ? $b0dd5313c450f2ae$var$dataCenterDarkAppearanceMap[appearance] : $b0dd5313c450f2ae$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $b0dd5313c450f2ae$var$rovoDarkAppearanceMap[appearance] : $b0dd5313c450f2ae$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $b0dd5313c450f2ae$var$cloudDarkAppearanceMap[appearance] : $b0dd5313c450f2ae$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $iqfTZ.fg)('assets-platform-branding') || (0, $iqfTZ.fg)('assets-platform-branding-v2')) && $b0dd5313c450f2ae$var$styles.TEMP_assets
        ])
    });
}
$b0dd5313c450f2ae$export$be58b4326e23250f.displayName = "IconWrapper";

});
parcelRegister("4C7HL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "useThemeObserver", () => $4ce28424b164f90a$export$3dd7971102e44fa8);
$parcel$export(module.exports, "default", () => $4ce28424b164f90a$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $3CpXJ = parcelRequire("3CpXJ");

var $izxUu = parcelRequire("izxUu");
const $4ce28424b164f90a$export$3dd7971102e44fa8 = ()=>{
    const [theme, setTheme] = (0, $euxye.useState)((0, $3CpXJ.getGlobalTheme)());
    (0, $euxye.useEffect)(()=>{
        const observer = new (0, $izxUu.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $4ce28424b164f90a$export$2e2bcd8739ae039 = $4ce28424b164f90a$export$3dd7971102e44fa8;

});



parcelRegister("7Wzf8", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $a9e75167f7bc58ea$export$c4b5b1f965d8b3eb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c0e4bfbb3ca87324a6e97db845b2ae2c>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ed9Xn = parcelRequire("ed9Xn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $a9e75167f7bc58ea$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z"/>
</svg>
`;
const $a9e75167f7bc58ea$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z"/>
</svg>
`;
function $a9e75167f7bc58ea$export$c4b5b1f965d8b3eb({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira', testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ed9Xn.IconWrapper), {
        svg: $a9e75167f7bc58ea$var$svg,
        customThemeSvg: $a9e75167f7bc58ea$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$a9e75167f7bc58ea$export$c4b5b1f965d8b3eb.displayName = "JiraIcon";

});

parcelRegister("gpyJM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $511d49cd21aeda2c$export$2e2bcd8739ae039);
/* modal-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");
parcelRequire("euxye");

var $2XXtG = parcelRequire("2XXtG");

var $keJFr = parcelRequire("keJFr");

var $bN4k1 = parcelRequire("bN4k1");
const $511d49cd21aeda2c$var$styles = {
    header: "_2Y7lL4NHnM _3iDTPbQ4SZ _1mT5xdRAKS _0hPCNLDIqT _37wbyuI7V3 _0rIjykLl21 _0xmtko5zaO _46hvQmNHnM",
    flex: "_0aFT5vf5Xk _39xV02N91d",
    titleContainer: "_4ouGXIdnbC"
};
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $511d49cd21aeda2c$var$ModalHeader = (props)=>{
    const { children: children, testId: userDefinedTestId, hasCloseButton: hasCloseButton = false } = props;
    const { hasProvidedOnClose: hasProvidedOnClose, onClose: onClose, testId: modalTestId } = (0, $bN4k1.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
    // Only show if an onClose was provided for the modal dialog
    const shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            $511d49cd21aeda2c$var$styles.header
        ]),
        children: shouldShowCloseButton ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2XXtG.Flex), {
            gap: "space.200",
            justifyContent: "space-between",
            xcss: $511d49cd21aeda2c$var$styles.flex,
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2XXtG.Flex), {
                    justifyContent: "end",
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $keJFr.CloseButton), {
                        onClick: onClose,
                        testId: modalTestId
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2XXtG.Flex), {
                    justifyContent: "start",
                    alignItems: "center",
                    xcss: $511d49cd21aeda2c$var$styles.titleContainer,
                    children: children
                })
            ]
        }) : children
    });
};
$511d49cd21aeda2c$var$ModalHeader.displayName = "ModalHeader";
var $511d49cd21aeda2c$export$2e2bcd8739ae039 = $511d49cd21aeda2c$var$ModalHeader;

});
parcelRegister("keJFr", function(module, exports) {
$parcel$export(module.exports, "CloseButton", () => $6bf473bb828d88a4$export$de65de8213222d10);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");

var $i68tN = parcelRequire("i68tN");
const $6bf473bb828d88a4$export$de65de8213222d10 = ({ label: label, onBlur: onBlur, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
        testId: testId && `${testId}--close-button`,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i68tN))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });
$6bf473bb828d88a4$export$de65de8213222d10.displayName = "CloseButton";

});

parcelRegister("bN4k1", function(module, exports) {
$parcel$export(module.exports, "useModal", () => $5d20576dbad41f3e$export$33ffd74ebf07f060);

var $euxye = parcelRequire("euxye");

var $cjFhY = parcelRequire("cjFhY");
const $5d20576dbad41f3e$export$33ffd74ebf07f060 = ()=>{
    const modalContext = (0, $euxye.useContext)((0, $cjFhY.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});
parcelRegister("cjFhY", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $757dd50c93629ab1$export$ab57792b9b6974a6);

var $euxye = parcelRequire("euxye");
const $757dd50c93629ab1$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $euxye.createContext)(null);

});



parcelRegister("dNPnD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6eaea66615208969$export$2e2bcd8739ae039);
/* modal-title.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $ah9qo = parcelRequire("ah9qo");

var $8QmUu = parcelRequire("8QmUu");

var $bN4k1 = parcelRequire("bN4k1");
const $6eaea66615208969$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E06C00)"
};
const $6eaea66615208969$var$iconStyles = null;
const $6eaea66615208969$var$titleStyles = null;
const $6eaea66615208969$var$textStyles = null;
const $6eaea66615208969$var$truncatedTextStyles = null;
const $6eaea66615208969$var$TitleIcon = ({ appearance: appearance })=>{
    const Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($ah9qo))) : (0, (/*@__PURE__*/$parcel$interopDefault($8QmUu)));
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        className: (0, $4jQY2.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _1UtDYzOLYo _4ya3eEOLYo _2l4i3rOLYo _1kk5TkOLYo _3iugoSOLYo _26BoRwOLYo"
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)(Icon, {
            label: appearance,
            color: $6eaea66615208969$var$iconColor[appearance],
            spacing: "spacious"
        })
    });
};
$6eaea66615208969$var$TitleIcon.displayName = "TitleIcon";
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $6eaea66615208969$var$ModalTitle = (props)=>{
    const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $bN4k1.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("h1", {
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            "_2mHwu82ADO _2sNsIgWSk4 _3iDTPbQ4SZ _4ouGXIdnbC _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg"
        ]),
        children: [
            appearance && /*#__PURE__*/ (0, $e79Pd.jsx)($6eaea66615208969$var$TitleIcon, {
                appearance: appearance
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                id: titleId,
                "data-testid": testId && `${testId}-text`,
                className: (0, $4jQY2.default)([
                    "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _2sNsIgWSk4 _4ouGXIdnbC _1T2N03wPeg",
                    !isMultiline && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7"
                ]),
                children: children
            })
        ]
    });
};
$6eaea66615208969$var$ModalTitle.displayName = "ModalTitle";
var $6eaea66615208969$export$2e2bcd8739ae039 = $6eaea66615208969$var$ModalTitle;

});

parcelRegister("2v3yi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $fe85c49f20af32d7$export$2e2bcd8739ae039);
/* modal-body.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");
parcelRequire("euxye");

var $jr1Vl = parcelRequire("jr1Vl");

var $bN4k1 = parcelRequire("bN4k1");

var $b3azy = parcelRequire("b3azy");

var $3hxlW = parcelRequire("3hxlW");
const $fe85c49f20af32d7$var$styles = {
    root: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _2sNsIgmnOE",
    paddingBlock: "_4c065UFQfX",
    paddingInline: "_2Y7lL4NHnM"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $fe85c49f20af32d7$var$ModalBody = (props)=>{
    const { children: children, testId: userDefinedTestId, hasInlinePadding: hasInlinePadding = true } = props;
    const { testId: modalTestId } = (0, $bN4k1.useModal)();
    const shouldScrollInViewport = (0, $3hxlW.default)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            $fe85c49f20af32d7$var$styles.root,
            hasInlinePadding && $fe85c49f20af32d7$var$styles.paddingInline
        ]),
        children: children
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jr1Vl.TouchScrollable), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $b3azy.default), {
            testId: userDefinedTestId || modalTestId,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                "data-testid": testId,
                className: (0, $4jQY2.default)([
                    $fe85c49f20af32d7$var$styles.root,
                    /**
       * Adding block padding for scroll keylines, which are only shown when the scrolling
       * is on the container.
       */ $fe85c49f20af32d7$var$styles.paddingBlock,
                    hasInlinePadding && $fe85c49f20af32d7$var$styles.paddingInline
                ]),
                children: children
            })
        })
    });
};
$fe85c49f20af32d7$var$ModalBody.displayName = "ModalBody";
var $fe85c49f20af32d7$export$2e2bcd8739ae039 = $fe85c49f20af32d7$var$ModalBody;

});
parcelRegister("b3azy", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9489df48ec65d72$export$2e2bcd8739ae039);
/* scroll-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $1qU3G = parcelRequire("1qU3G");

var $1MNmN = parcelRequire("1MNmN");

var $ljVHR = parcelRequire("ljVHR");

var $2oRWW = parcelRequire("2oRWW");

var $gURE8 = parcelRequire("gURE8");

var $9vMEI = parcelRequire("9vMEI");
const $c9489df48ec65d72$var$keylineColor = "var(--ds-border, #0B120E24)";
const $c9489df48ec65d72$var$styles = {
    base: "_1ma2CfOLYo _3iDTPbOLYo _0aFT5vOLYo _2O5Vij7dHp _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _4bt5LAnQyn _2WAcuGIZbP _3GZDR8ZqHV _2aYxTvIZbP",
    topKeyline: "_1v3aPqOeNX",
    bottomKeyline: "_2R4pr3OeNX"
};
const $c9489df48ec65d72$var$keylineHeight = 1;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $c9489df48ec65d72$var$ScrollContainer = /*#__PURE__*/ (0, $euxye.forwardRef)(({ testId: testId, children: children }, ref)=>{
    const scrollableRef = (0, $euxye.useRef)(null);
    const [showTopKeyline, setTopKeyline] = (0, $euxye.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $euxye.useState)(false);
    const [showContentFocus, setContentFocus] = (0, $euxye.useState)(false);
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $euxye.useEffect)(()=>{
        const schedule = (0, $1qU3G.default)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    const setLazyKeylines = (0, $gURE8.default)((0, $1qU3G.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $c9489df48ec65d72$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $c9489df48ec65d72$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $euxye.useEffect)(()=>{
        const target = scrollableRef.current;
        setLazyKeylines();
        const unbindWindowEvent = (0, $glbdM.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, $glbdM.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $2oRWW.default);
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9vMEI.Focusable), {
        as: "div",
        isInset: true,
        // tabindex is allowed here so that keyboard users can scroll content
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && `${testId}--scrollable`,
        ref: (0, $ljVHR.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $1MNmN.cx)($c9489df48ec65d72$var$styles.base, showTopKeyline && $c9489df48ec65d72$var$styles.topKeyline, showBottomKeyline && $c9489df48ec65d72$var$styles.bottomKeyline),
        children: children
    });
});
$c9489df48ec65d72$var$ScrollContainer.displayName = 'ScrollContainer';
var $c9489df48ec65d72$export$2e2bcd8739ae039 = $c9489df48ec65d72$var$ScrollContainer;

});
parcelRegister("gURE8", function(module, exports) {
$parcel$export(module.exports, "default", () => $fcd51105193d257e$export$2e2bcd8739ae039);

var $1EnJS = parcelRequire("1EnJS");
function $fcd51105193d257e$export$2e2bcd8739ae039(callback) {
    const ref = (0, $1EnJS.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("1EnJS", function(module, exports) {
$parcel$export(module.exports, "default", () => $76e80e63ddab217f$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
const $76e80e63ddab217f$var$uniqueReferencedValue = {};
function $76e80e63ddab217f$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $euxye.useRef)($76e80e63ddab217f$var$uniqueReferencedValue);
    if (ref.current === $76e80e63ddab217f$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});



parcelRegister("3hxlW", function(module, exports) {
$parcel$export(module.exports, "default", () => $823a3d75b44277c3$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $ehssC = parcelRequire("ehssC");
function $823a3d75b44277c3$export$2e2bcd8739ae039() {
    const shouldScrollInViewport = (0, $euxye.useContext)((0, $ehssC.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});
parcelRegister("ehssC", function(module, exports) {
$parcel$export(module.exports, "ScrollContext", () => $b25027ed53b9bf9f$export$dece24112a937f92);

var $euxye = parcelRequire("euxye");
const $b25027ed53b9bf9f$export$dece24112a937f92 = /*#__PURE__*/ (0, $euxye.createContext)(null);

});



parcelRegister("4vluQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d810f6b8d0f04d48$export$2e2bcd8739ae039);
/* modal-footer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $bN4k1 = parcelRequire("bN4k1");
const $d810f6b8d0f04d48$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $d810f6b8d0f04d48$var$ModalFooter = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $bN4k1.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            "_2mHwu82ADO _2Y7lL4NHnM _3iDTPbQ4SZ _1mT5xdRAKS _0hPCNLDIqT _37wbyuz9WS _43nrzTLl21 _0xmtkoNHnM _46hvQm5zaO"
        ]),
        children: children
    });
};
$d810f6b8d0f04d48$var$ModalFooter.displayName = "ModalFooter";
var $d810f6b8d0f04d48$export$2e2bcd8739ae039 = $d810f6b8d0f04d48$var$ModalFooter;

});

parcelRegister("2AOCd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::403d648a4ec6dc7540968c496b0b831a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e3634b5aca6c915$var$_react = $1e3634b5aca6c915$var$_interopRequireDefault((parcelRequire("euxye")));

var $1e3634b5aca6c915$var$_iconNew = $1e3634b5aca6c915$var$_interopRequireDefault((parcelRequire("52mjj")));
function $1e3634b5aca6c915$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/dashboard
 * Usage guidance:
 * Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1e3634b5aca6c915$var$DashboardIcon = (props)=>/*#__PURE__*/ $1e3634b5aca6c915$var$_react.default.createElement($1e3634b5aca6c915$var$_iconNew.default, Object.assign({
        name: "DashboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.25v-11zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$1e3634b5aca6c915$var$DashboardIcon.displayName = 'DashboardIcon';
var $1e3634b5aca6c915$var$_default = module.exports.default = $1e3634b5aca6c915$var$DashboardIcon;

});

parcelRegister("ikOED", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07ce97dc138cd4f55e8a1bb0a6f266b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d591632dd4c0a235$var$_react = $d591632dd4c0a235$var$_interopRequireDefault((parcelRequire("euxye")));

var $d591632dd4c0a235$var$_iconNew = $d591632dd4c0a235$var$_interopRequireDefault((parcelRequire("52mjj")));
function $d591632dd4c0a235$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/add
 * Usage guidance:
 * Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d591632dd4c0a235$var$AddIcon = (props)=>/*#__PURE__*/ $d591632dd4c0a235$var$_react.default.createElement($d591632dd4c0a235$var$_iconNew.default, Object.assign({
        name: "AddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 1.5v5.75h5.75v1.5H8.75v5.75h-1.5V8.75H1.5v-1.5h5.75V1.5z"/>`
    }, props));
$d591632dd4c0a235$var$AddIcon.displayName = 'AddIcon';
var $d591632dd4c0a235$var$_default = module.exports.default = $d591632dd4c0a235$var$AddIcon;

});

parcelRegister("6JMJ2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d485ff62f9140a59decb65646f9f10e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e7cbdeca3faba3c$var$_react = $4e7cbdeca3faba3c$var$_interopRequireDefault((parcelRequire("euxye")));

var $4e7cbdeca3faba3c$var$_iconNew = $4e7cbdeca3faba3c$var$_interopRequireDefault((parcelRequire("52mjj")));
function $4e7cbdeca3faba3c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-left
 * Usage guidance:
 * Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4e7cbdeca3faba3c$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $4e7cbdeca3faba3c$var$_react.default.createElement($4e7cbdeca3faba3c$var$_iconNew.default, Object.assign({
        name: "ArrowLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$4e7cbdeca3faba3c$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $4e7cbdeca3faba3c$var$_default = module.exports.default = $4e7cbdeca3faba3c$var$ArrowLeftIcon;

});

parcelRegister("kJKna", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::790216e1b1c39b618aa630400c4ea535>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f18bfb4511b753b0$var$_react = $f18bfb4511b753b0$var$_interopRequireDefault((parcelRequire("euxye")));

var $f18bfb4511b753b0$var$_iconNew = $f18bfb4511b753b0$var$_interopRequireDefault((parcelRequire("52mjj")));
function $f18bfb4511b753b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/check-circle
 * Usage guidance:
 * Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f18bfb4511b753b0$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $f18bfb4511b753b0$var$_react.default.createElement($f18bfb4511b753b0$var$_iconNew.default, Object.assign({
        name: "CheckCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-2.174-2.52-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$f18bfb4511b753b0$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $f18bfb4511b753b0$var$_default = module.exports.default = $f18bfb4511b753b0$var$CheckCircleIcon;

});

parcelRegister("dIQFJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::289e45520b45682e3c0f255c5bc3a3e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9fd83e0178457642$var$_react = $9fd83e0178457642$var$_interopRequireDefault((parcelRequire("euxye")));

var $9fd83e0178457642$var$_iconNew = $9fd83e0178457642$var$_interopRequireDefault((parcelRequire("52mjj")));
function $9fd83e0178457642$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CreditCard".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/credit-card
 * Usage guidance:
 * Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9fd83e0178457642$var$CreditCardIcon = (props)=>/*#__PURE__*/ $9fd83e0178457642$var$_react.default.createElement($9fd83e0178457642$var$_iconNew.default, Object.assign({
        name: "CreditCardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1.5h13V4a.5.5 0 0 0-.5-.5zM14.5 7h-13v5a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM9 9.5h4V11H9z" clip-rule="evenodd"/>`
    }, props));
$9fd83e0178457642$var$CreditCardIcon.displayName = 'CreditCardIcon';
var $9fd83e0178457642$var$_default = module.exports.default = $9fd83e0178457642$var$CreditCardIcon;

});

parcelRegister("9qT28", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23550e9a9f6f237ba15b0b9afdf2850e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6de13b3ee9d17dc6$var$_react = $6de13b3ee9d17dc6$var$_interopRequireDefault((parcelRequire("euxye")));

var $6de13b3ee9d17dc6$var$_iconNew = $6de13b3ee9d17dc6$var$_interopRequireDefault((parcelRequire("52mjj")));
function $6de13b3ee9d17dc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross-circle
 * Usage guidance:
 * Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6de13b3ee9d17dc6$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $6de13b3ee9d17dc6$var$_react.default.createElement($6de13b3ee9d17dc6$var$_iconNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 6.94L5.03 3.97 3.97 5.03 6.94 8l-2.97 2.97 1.06 1.06L8 9.06l2.97 2.97 1.06-1.06L9.06 8l2.97-2.97-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$6de13b3ee9d17dc6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $6de13b3ee9d17dc6$var$_default = module.exports.default = $6de13b3ee9d17dc6$var$CrossCircleIcon;

});

parcelRegister("7Fzpe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cdb9e6baa42be79f49a55523cb2c1b4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5957d3a3d6bb2e8d$var$_react = $5957d3a3d6bb2e8d$var$_interopRequireDefault((parcelRequire("euxye")));

var $5957d3a3d6bb2e8d$var$_iconNew = $5957d3a3d6bb2e8d$var$_interopRequireDefault((parcelRequire("52mjj")));
function $5957d3a3d6bb2e8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/show-more-horizontal
 * Usage guidance:
 * Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5957d3a3d6bb2e8d$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $5957d3a3d6bb2e8d$var$_react.default.createElement($5957d3a3d6bb2e8d$var$_iconNew.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$5957d3a3d6bb2e8d$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $5957d3a3d6bb2e8d$var$_default = module.exports.default = $5957d3a3d6bb2e8d$var$ShowMoreHorizontalIcon;

});

parcelRegister("3xiQi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f9c38bfa054ce139eb4eb1d828621cdf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $293311e28d1a3e40$var$_react = $293311e28d1a3e40$var$_interopRequireDefault((parcelRequire("euxye")));

var $293311e28d1a3e40$var$_iconNew = $293311e28d1a3e40$var$_interopRequireDefault((parcelRequire("52mjj")));
function $293311e28d1a3e40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/clock
 * Usage guidance:
 * Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $293311e28d1a3e40$var$ClockIcon = (props)=>/*#__PURE__*/ $293311e28d1a3e40$var$_react.default.createElement($293311e28d1a3e40$var$_iconNew.default, Object.assign({
        name: "ClockIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M8.75 3.25v4.389l2.219 1.775-.938 1.172-2.5-2-.281-.226V3.25zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$293311e28d1a3e40$var$ClockIcon.displayName = 'ClockIcon';
var $293311e28d1a3e40$var$_default = module.exports.default = $293311e28d1a3e40$var$ClockIcon;

});

parcelRegister("eAQb7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::455ddf841838a21b0f783ea6448b0f9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9fce7016a4a629c$var$_react = $a9fce7016a4a629c$var$_interopRequireDefault((parcelRequire("euxye")));

var $a9fce7016a4a629c$var$_iconNew = $a9fce7016a4a629c$var$_interopRequireDefault((parcelRequire("52mjj")));
function $a9fce7016a4a629c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/search
 * Usage guidance:
 * Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9fce7016a4a629c$var$SearchIcon = (props)=>/*#__PURE__*/ $a9fce7016a4a629c$var$_react.default.createElement($a9fce7016a4a629c$var$_iconNew.default, Object.assign({
        name: "SearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$a9fce7016a4a629c$var$SearchIcon.displayName = 'SearchIcon';
var $a9fce7016a4a629c$var$_default = module.exports.default = $a9fce7016a4a629c$var$SearchIcon;

});

parcelRegister("gBaKj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bfb96ac8121d6e86aa07f23b47de6511>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1586ffd750e5d01$var$_react = $c1586ffd750e5d01$var$_interopRequireDefault((parcelRequire("euxye")));

var $c1586ffd750e5d01$var$_iconNew = $c1586ffd750e5d01$var$_interopRequireDefault((parcelRequire("52mjj")));
function $c1586ffd750e5d01$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/settings
 * Usage guidance:
 * Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1586ffd750e5d01$var$SettingsIcon = (props)=>/*#__PURE__*/ $c1586ffd750e5d01$var$_react.default.createElement($c1586ffd750e5d01$var$_iconNew.default, Object.assign({
        name: "SettingsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$c1586ffd750e5d01$var$SettingsIcon.displayName = 'SettingsIcon';
var $c1586ffd750e5d01$var$_default = module.exports.default = $c1586ffd750e5d01$var$SettingsIcon;

});

parcelRegister("8A8fZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a56ed314940e96507f3d40e0a0c01e78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63f81730aa798b58$var$_react = $63f81730aa798b58$var$_interopRequireDefault((parcelRequire("euxye")));

var $63f81730aa798b58$var$_iconNew = $63f81730aa798b58$var$_interopRequireDefault((parcelRequire("52mjj")));
function $63f81730aa798b58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Filter".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/filter
 * Usage guidance:
 * Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63f81730aa798b58$var$FilterIcon = (props)=>/*#__PURE__*/ $63f81730aa798b58$var$_react.default.createElement($63f81730aa798b58$var$_iconNew.default, Object.assign({
        name: "FilterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 12v1.5H5V12zm2-4.75v1.5H3v-1.5zm2-4.75V4H1V2.5z"/>`
    }, props));
$63f81730aa798b58$var$FilterIcon.displayName = 'FilterIcon';
var $63f81730aa798b58$var$_default = module.exports.default = $63f81730aa798b58$var$FilterIcon;

});

parcelRegister("2OHo9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7bd0b1f6d8e717040c997f247b7acc7d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20d1e8549f5f4b7a$var$_react = $20d1e8549f5f4b7a$var$_interopRequireDefault((parcelRequire("euxye")));

var $20d1e8549f5f4b7a$var$_iconNew = $20d1e8549f5f4b7a$var$_interopRequireDefault((parcelRequire("52mjj")));
function $20d1e8549f5f4b7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/notification
 * Usage guidance:
 * Single purpose - Reserved for notifications within global app navigation and within app screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $20d1e8549f5f4b7a$var$NotificationIcon = (props)=>/*#__PURE__*/ $20d1e8549f5f4b7a$var$_react.default.createElement($20d1e8549f5f4b7a$var$_iconNew.default, Object.assign({
        name: "NotificationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.42 13.5a1.748 1.748 0 0 0 3.16 0zM4.5 8.636c0 .215-.06.426-.175.608L2.603 12h10.795l-1.723-2.756a1.15 1.15 0 0 1-.175-.608V5a3.5 3.5 0 0 0-7 0zm8.5-.1 1.788 2.86a1.375 1.375 0 0 1-1.166 2.104h-2.46a3.25 3.25 0 0 1-6.324 0h-2.46a1.375 1.375 0 0 1-1.166-2.104L3 8.537V5a5 5 0 0 1 10 0z"/>`
    }, props));
$20d1e8549f5f4b7a$var$NotificationIcon.displayName = 'NotificationIcon';
var $20d1e8549f5f4b7a$var$_default = module.exports.default = $20d1e8549f5f4b7a$var$NotificationIcon;

});

parcelRegister("lxN43", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1823cfe9afabe77ba419bd26f71a4aac>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $faf2bd34b276535f$var$_react = $faf2bd34b276535f$var$_interopRequireDefault((parcelRequire("euxye")));

var $faf2bd34b276535f$var$_iconNew = $faf2bd34b276535f$var$_interopRequireDefault((parcelRequire("52mjj")));
function $faf2bd34b276535f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person-avatar
 * Usage guidance:
 * Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $faf2bd34b276535f$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $faf2bd34b276535f$var$_react.default.createElement($faf2bd34b276535f$var$_iconNew.default, Object.assign({
        name: "PersonAvatarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$faf2bd34b276535f$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $faf2bd34b276535f$var$_default = module.exports.default = $faf2bd34b276535f$var$PersonAvatarIcon;

});

parcelRegister("dSCsJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a375ef61b97315ae7ff25123b3ed791c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1ae275ac7bd141e$var$_react = $a1ae275ac7bd141e$var$_interopRequireDefault((parcelRequire("euxye")));

var $a1ae275ac7bd141e$var$_iconNew = $a1ae275ac7bd141e$var$_interopRequireDefault((parcelRequire("52mjj")));
function $a1ae275ac7bd141e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/release
 * Usage guidance:
 * Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1ae275ac7bd141e$var$ReleaseIcon = (props)=>/*#__PURE__*/ $a1ae275ac7bd141e$var$_react.default.createElement($a1ae275ac7bd141e$var$_iconNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$a1ae275ac7bd141e$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $a1ae275ac7bd141e$var$_default = module.exports.default = $a1ae275ac7bd141e$var$ReleaseIcon;

});

parcelRegister("5FApK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::508bd9728f54ab48d8a573901bb484ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $420d073a96c136c6$var$_react = $420d073a96c136c6$var$_interopRequireDefault((parcelRequire("euxye")));

var $420d073a96c136c6$var$_iconNew = $420d073a96c136c6$var$_interopRequireDefault((parcelRequire("52mjj")));
function $420d073a96c136c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogIn".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/log-in
 * Usage guidance:
 * Single purpose - Reserved for log in.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $420d073a96c136c6$var$LogInIcon = (props)=>/*#__PURE__*/ $420d073a96c136c6$var$_react.default.createElement($420d073a96c136c6$var$_iconNew.default, Object.assign({
        name: "LogInIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5H8V1h5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8v-1.5h5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5M7.44 7.25 5.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$420d073a96c136c6$var$LogInIcon.displayName = 'LogInIcon';
var $420d073a96c136c6$var$_default = module.exports.default = $420d073a96c136c6$var$LogInIcon;

});

parcelRegister("cXTqc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53379c98771562c0fa194d02f1725934>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9705fc4e39ad48d6$var$_react = $9705fc4e39ad48d6$var$_interopRequireDefault((parcelRequire("euxye")));

var $9705fc4e39ad48d6$var$_iconNew = $9705fc4e39ad48d6$var$_interopRequireDefault((parcelRequire("52mjj")));
function $9705fc4e39ad48d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/star-unstarred
 * Usage guidance:
 * Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9705fc4e39ad48d6$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $9705fc4e39ad48d6$var$_react.default.createElement($9705fc4e39ad48d6$var$_iconNew.default, Object.assign({
        name: "StarUnstarredIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/>`
    }, props));
$9705fc4e39ad48d6$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $9705fc4e39ad48d6$var$_default = module.exports.default = $9705fc4e39ad48d6$var$StarUnstarredIcon;

});

parcelRegister("34RnZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e1c792fe94266e0516d7c57a92d4d2b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23db282b4907d49c$var$_react = $23db282b4907d49c$var$_interopRequireDefault((parcelRequire("euxye")));

var $23db282b4907d49c$var$_iconNew = $23db282b4907d49c$var$_interopRequireDefault((parcelRequire("52mjj")));
function $23db282b4907d49c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FullscreenEnter".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/fullscreen-enter
 * Usage guidance:
 * Single purpose - Reserved for full screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23db282b4907d49c$var$FullscreenEnterIcon = (props)=>/*#__PURE__*/ $23db282b4907d49c$var$_react.default.createElement($23db282b4907d49c$var$_iconNew.default, Object.assign({
        name: "FullscreenEnterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5h-3V1h3a2 2 0 0 1 2 2v3h-1.5V3a.5.5 0 0 0-.5-.5m-10 0a.5.5 0 0 0-.5.5v3H1V3a2 2 0 0 1 2-2h3v1.5zM2.5 10v3a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2v-3zm11 3v-3H15v3a2 2 0 0 1-2 2h-3v-1.5h3a.5.5 0 0 0 .5-.5" clip-rule="evenodd"/>`
    }, props));
$23db282b4907d49c$var$FullscreenEnterIcon.displayName = 'FullscreenEnterIcon';
var $23db282b4907d49c$var$_default = module.exports.default = $23db282b4907d49c$var$FullscreenEnterIcon;

});

parcelRegister("63GEN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::891f8b0b0e6811694a02696ff381b7b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $46941cb16fed6b11$var$_react = $46941cb16fed6b11$var$_interopRequireDefault((parcelRequire("euxye")));

var $46941cb16fed6b11$var$_iconNew = $46941cb16fed6b11$var$_interopRequireDefault((parcelRequire("52mjj")));
function $46941cb16fed6b11$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/app-switcher
 * Usage guidance:
 * Single purpose - Reserved for app switcher in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $46941cb16fed6b11$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $46941cb16fed6b11$var$_react.default.createElement($46941cb16fed6b11$var$_iconNew.default, Object.assign({
        name: "AppSwitcherIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm-8-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zM7 5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$46941cb16fed6b11$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $46941cb16fed6b11$var$_default = module.exports.default = $46941cb16fed6b11$var$AppSwitcherIcon;

});

parcelRegister("lWRvF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44bfe3fda6843e57916c639848bc7fcd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ffa885b185d619e5$var$_react = $ffa885b185d619e5$var$_interopRequireDefault((parcelRequire("euxye")));

var $ffa885b185d619e5$var$_iconNew = $ffa885b185d619e5$var$_interopRequireDefault((parcelRequire("52mjj")));
function $ffa885b185d619e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person
 * Usage guidance:
 * Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ffa885b185d619e5$var$PersonIcon = (props)=>/*#__PURE__*/ $ffa885b185d619e5$var$_react.default.createElement($ffa885b185d619e5$var$_iconNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$ffa885b185d619e5$var$PersonIcon.displayName = 'PersonIcon';
var $ffa885b185d619e5$var$_default = module.exports.default = $ffa885b185d619e5$var$PersonIcon;

});

parcelRegister("alDF5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc8c5bcc855f6883f121e0d08f8186bb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $788aa184808071de$var$_react = $788aa184808071de$var$_interopRequireDefault((parcelRequire("euxye")));

var $788aa184808071de$var$_iconNew = $788aa184808071de$var$_interopRequireDefault((parcelRequire("52mjj")));
function $788aa184808071de$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/roadmap
 * Usage guidance:
 * Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $788aa184808071de$var$RoadmapIcon = (props)=>/*#__PURE__*/ $788aa184808071de$var$_react.default.createElement($788aa184808071de$var$_iconNew.default, Object.assign({
        name: "RoadmapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$788aa184808071de$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $788aa184808071de$var$_default = module.exports.default = $788aa184808071de$var$RoadmapIcon;

});

parcelRegister("4Olij", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e090651e87a4c0aa5c0215d940612c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $380c5991477ec4cf$var$_react = $380c5991477ec4cf$var$_interopRequireDefault((parcelRequire("euxye")));

var $380c5991477ec4cf$var$_iconNew = $380c5991477ec4cf$var$_interopRequireDefault((parcelRequire("52mjj")));
function $380c5991477ec4cf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/teams
 * Usage guidance:
 * Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $380c5991477ec4cf$var$TeamsIcon = (props)=>/*#__PURE__*/ $380c5991477ec4cf$var$_react.default.createElement($380c5991477ec4cf$var$_iconNew.default, Object.assign({
        name: "TeamsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$380c5991477ec4cf$var$TeamsIcon.displayName = 'TeamsIcon';
var $380c5991477ec4cf$var$_default = module.exports.default = $380c5991477ec4cf$var$TeamsIcon;

});

parcelRegister("jRVsm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1078ad25bb88c0aacc625e83cbe31eaf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e76f893a9ccc7624$var$_react = $e76f893a9ccc7624$var$_interopRequireDefault((parcelRequire("euxye")));

var $e76f893a9ccc7624$var$_iconNew = $e76f893a9ccc7624$var$_interopRequireDefault((parcelRequire("52mjj")));
function $e76f893a9ccc7624$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-agent
 * Usage guidance:
 * Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e76f893a9ccc7624$var$AiAgentIcon = (props)=>/*#__PURE__*/ $e76f893a9ccc7624$var$_react.default.createElement($e76f893a9ccc7624$var$_iconNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$e76f893a9ccc7624$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $e76f893a9ccc7624$var$_default = module.exports.default = $e76f893a9ccc7624$var$AiAgentIcon;

});

parcelRegister("fOxy5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5d9d22b41ee491811e82fedd8cf80d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02f89b0ad5c9f1ac$var$_react = $02f89b0ad5c9f1ac$var$_interopRequireDefault((parcelRequire("euxye")));

var $02f89b0ad5c9f1ac$var$_iconNew = $02f89b0ad5c9f1ac$var$_interopRequireDefault((parcelRequire("52mjj")));
function $02f89b0ad5c9f1ac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Apps".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/apps
 * Usage guidance:
 * Single purpose - Reserved for adding or viewing apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $02f89b0ad5c9f1ac$var$AppsIcon = (props)=>/*#__PURE__*/ $02f89b0ad5c9f1ac$var$_react.default.createElement($02f89b0ad5c9f1ac$var$_iconNew.default, Object.assign({
        name: "AppsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm7.25-2v2.25H15v1.5h-2.25V15h-1.5v-2.25H9v-1.5h2.25V9zM5.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm0-8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$02f89b0ad5c9f1ac$var$AppsIcon.displayName = 'AppsIcon';
var $02f89b0ad5c9f1ac$var$_default = module.exports.default = $02f89b0ad5c9f1ac$var$AppsIcon;

});

parcelRegister("atP3J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98f19b4ce1cb01bc604b2707417d4c9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a14381df3bdbd53$var$_react = $7a14381df3bdbd53$var$_interopRequireDefault((parcelRequire("euxye")));

var $7a14381df3bdbd53$var$_iconNew = $7a14381df3bdbd53$var$_interopRequireDefault((parcelRequire("52mjj")));
function $7a14381df3bdbd53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrendUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chart-trend-up
 * Usage guidance:
 * Known uses: Upward trending data; Trend charts; Reports in Jira; Sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7a14381df3bdbd53$var$ChartTrendUpIcon = (props)=>/*#__PURE__*/ $7a14381df3bdbd53$var$_react.default.createElement($7a14381df3bdbd53$var$_iconNew.default, Object.assign({
        name: "ChartTrendUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M15 7.5h-1.5V5.56L9.78 9.28a.75.75 0 0 1-1.06 0L7.25 7.81l-2.22 2.22-1.06-1.06 2.75-2.75.056-.052a.75.75 0 0 1 1.004.052l1.47 1.47 3.19-3.19H10.5V3h3.75a.75.75 0 0 1 .75.75z"/>`
    }, props));
$7a14381df3bdbd53$var$ChartTrendUpIcon.displayName = 'ChartTrendUpIcon';
var $7a14381df3bdbd53$var$_default = module.exports.default = $7a14381df3bdbd53$var$ChartTrendUpIcon;

});

parcelRegister("jcIfU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0f3b83dd529b07788ee27a881ae63826>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dfb1778bd52bad81$var$_react = $dfb1778bd52bad81$var$_interopRequireDefault((parcelRequire("euxye")));

var $dfb1778bd52bad81$var$_iconNew = $dfb1778bd52bad81$var$_interopRequireDefault((parcelRequire("52mjj")));
function $dfb1778bd52bad81$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Devices".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/devices
 * Usage guidance:
 * Known usages: 'Asset' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dfb1778bd52bad81$var$DevicesIcon = (props)=>/*#__PURE__*/ $dfb1778bd52bad81$var$_react.default.createElement($dfb1778bd52bad81$var$_iconNew.default, Object.assign({
        name: "DevicesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a.5.5 0 0 0-.5-.5h-2.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5zM13 3a.5.5 0 0 0-.5-.5h-9A.5.5 0 0 0 3 3v7h5v1.5H1.5v.5a.5.5 0 0 0 .5.5h6V14H2a2 2 0 0 1-2-2v-1.25l.004-.077A.75.75 0 0 1 .75 10h.75V3a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1.5H13zm3 11a2 2 0 0 1-2 2h-2.5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2z"/>`
    }, props));
$dfb1778bd52bad81$var$DevicesIcon.displayName = 'DevicesIcon';
var $dfb1778bd52bad81$var$_default = module.exports.default = $dfb1778bd52bad81$var$DevicesIcon;

});

parcelRegister("3SFM2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d79300678d2a12fe66aec1aaa52c9d3a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d36d1abdc6a33ba$var$_react = $2d36d1abdc6a33ba$var$_interopRequireDefault((parcelRequire("euxye")));

var $2d36d1abdc6a33ba$var$_iconNew = $2d36d1abdc6a33ba$var$_interopRequireDefault((parcelRequire("52mjj")));
function $2d36d1abdc6a33ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/goal
 * Usage guidance:
 * Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2d36d1abdc6a33ba$var$GoalIcon = (props)=>/*#__PURE__*/ $2d36d1abdc6a33ba$var$_react.default.createElement($2d36d1abdc6a33ba$var$_iconNew.default, Object.assign({
        name: "GoalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0" clip-rule="evenodd"/>`
    }, props));
$2d36d1abdc6a33ba$var$GoalIcon.displayName = 'GoalIcon';
var $2d36d1abdc6a33ba$var$_default = module.exports.default = $2d36d1abdc6a33ba$var$GoalIcon;

});

parcelRegister("cqJ3S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4635c4898bffdbedd4e5aefaeceb12e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90cade0b1411ac3c$var$_react = $90cade0b1411ac3c$var$_interopRequireDefault((parcelRequire("euxye")));

var $90cade0b1411ac3c$var$_iconNew = $90cade0b1411ac3c$var$_interopRequireDefault((parcelRequire("52mjj")));
function $90cade0b1411ac3c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Headphones".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/headphones
 * Usage guidance:
 * Known uses: music, audio.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90cade0b1411ac3c$var$HeadphonesIcon = (props)=>/*#__PURE__*/ $90cade0b1411ac3c$var$_react.default.createElement($90cade0b1411ac3c$var$_iconNew.default, Object.assign({
        name: "HeadphonesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 7a5.5 5.5 0 1 0-11 0v5H1V7a7 7 0 0 1 14 0v5h-1.5z"/><path fill="currentcolor" d="M4.5 10a1 1 0 0 0-2 0v1.92c0 .87.71 1.58 1.58 1.58.23 0 .42-.19.42-.42zM6 13.08A1.92 1.92 0 0 1 4.08 15 3.08 3.08 0 0 1 1 11.92V10a2.5 2.5 0 0 1 5 0zm7.5-1.16V10a1 1 0 1 0-2 0v3.08c0 .23.19.42.42.42.87 0 1.58-.71 1.58-1.58m1.5 0A3.08 3.08 0 0 1 11.92 15 1.92 1.92 0 0 1 10 13.08V10a2.5 2.5 0 0 1 5 0z"/>`
    }, props));
$90cade0b1411ac3c$var$HeadphonesIcon.displayName = 'HeadphonesIcon';
var $90cade0b1411ac3c$var$_default = module.exports.default = $90cade0b1411ac3c$var$HeadphonesIcon;

});

parcelRegister("fgD0F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8426d0f71b15f9c5b7a2d1d52ee1c968>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1d69c23954e68e7$var$_react = $b1d69c23954e68e7$var$_interopRequireDefault((parcelRequire("euxye")));

var $b1d69c23954e68e7$var$_iconNew = $b1d69c23954e68e7$var$_interopRequireDefault((parcelRequire("52mjj")));
function $b1d69c23954e68e7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Operations".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/operations
 * Usage guidance:
 * Single purpose - Reserved for IT Operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1d69c23954e68e7$var$OperationsIcon = (props)=>/*#__PURE__*/ $b1d69c23954e68e7$var$_react.default.createElement($b1d69c23954e68e7$var$_iconNew.default, Object.assign({
        name: "OperationsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.036 2.904A6.501 6.501 0 1 0 8 14.5V16a8 8 0 1 1 5.657-13.657l.53.53L8.28 8.78 7.22 7.72l2.304-2.305A3.001 3.001 0 1 0 8 11v1.5a4.5 4.5 0 1 1 2.608-8.168z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M14.58 4.862a.75.75 0 0 1 .959.454l.008.025a.75.75 0 1 1-1.414.499l-.007-.02a.75.75 0 0 1 .454-.958m-2.798 2.573a.75.75 0 0 1 .713.786l-.001.015-.001.014a.75.75 0 1 1-1.498-.083v-.01l.001-.01a.75.75 0 0 1 .786-.712m3.497.184a.75.75 0 0 1 .71.787v.026a.75.75 0 1 1-1.498-.081V8.33a.75.75 0 0 1 .788-.711m-4.205 2.656a.75.75 0 0 1-.052 1.06l-.022.019a.75.75 0 1 1-1-1.118l.015-.013a.75.75 0 0 1 1.059.052m3.799.16a.75.75 0 0 1 .355.999l-.011.023a.75.75 0 0 1-1.353-.649l.01-.019a.75.75 0 0 1 .999-.355m-1.457 2.442a.75.75 0 0 1-.053 1.06l-.02.017a.75.75 0 0 1-1.001-1.117l.015-.014a.75.75 0 0 1 1.06.054m-2.278 1.703a.75.75 0 0 1-.454.959l-.025.008a.75.75 0 0 1-.499-1.414l.02-.007a.75.75 0 0 1 .958.454" clip-rule="evenodd"/>`
    }, props));
$b1d69c23954e68e7$var$OperationsIcon.displayName = 'OperationsIcon';
var $b1d69c23954e68e7$var$_default = module.exports.default = $b1d69c23954e68e7$var$OperationsIcon;

});

parcelRegister("faDlH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e9008592011ce9e8020afead221c92f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0b6500dfa567f6c$var$_react = $b0b6500dfa567f6c$var$_interopRequireDefault((parcelRequire("euxye")));

var $b0b6500dfa567f6c$var$_iconNew = $b0b6500dfa567f6c$var$_interopRequireDefault((parcelRequire("52mjj")));
function $b0b6500dfa567f6c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/project
 * Usage guidance:
 * Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0b6500dfa567f6c$var$ProjectIcon = (props)=>/*#__PURE__*/ $b0b6500dfa567f6c$var$_react.default.createElement($b0b6500dfa567f6c$var$_iconNew.default, Object.assign({
        name: "ProjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.482a.5.5 0 0 0-.354.146L7.78 5.03a.75.75 0 0 1-.53.22H3.018a.5.5 0 0 0-.354.146l-.353.354 1.72 1.72a.75.75 0 0 1 0 1.06l-2.25 2.25L.72 9.72 2.44 8 .72 6.28a.75.75 0 0 1 0-1.06l.884-.884a2 2 0 0 1 1.414-.586h3.921l2.165-2.164A2 2 0 0 1 10.518 1H13a2 2 0 0 1 2 2v2.482a2 2 0 0 1-.586 1.414L12.25 9.061v3.921a2 2 0 0 1-.586 1.415l-.884.883a.75.75 0 0 1-1.06 0L8 13.56l-1.72 1.72-1.06-1.06 2.25-2.25a.75.75 0 0 1 1.06 0l1.72 1.72.354-.354a.5.5 0 0 0 .146-.354V8.75a.75.75 0 0 1 .22-.53l2.384-2.384a.5.5 0 0 0 .146-.354zm-6.72 7.28-5 5-1.06-1.06 5-5z" clip-rule="evenodd"/><path fill="currentcolor" d="M12.5 4.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$b0b6500dfa567f6c$var$ProjectIcon.displayName = 'ProjectIcon';
var $b0b6500dfa567f6c$var$_default = module.exports.default = $b0b6500dfa567f6c$var$ProjectIcon;

});

parcelRegister("aeUJp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b4f1367f1cd984cea139cd322f85553>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $774737df346d0828$var$_react = $774737df346d0828$var$_interopRequireDefault((parcelRequire("euxye")));

var $774737df346d0828$var$_iconNew = $774737df346d0828$var$_interopRequireDefault((parcelRequire("52mjj")));
function $774737df346d0828$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sidebar-collapse
 * Usage guidance:
 * Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $774737df346d0828$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $774737df346d0828$var$_react.default.createElement($774737df346d0828$var$_iconNew.default, Object.assign({
        name: "SidebarCollapseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$774737df346d0828$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $774737df346d0828$var$_default = module.exports.default = $774737df346d0828$var$SidebarCollapseIcon;

});

parcelRegister("b7KOW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a887af9d6920f2ef0ce00494c960319>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8194aabcf9effd73$var$_react = $8194aabcf9effd73$var$_interopRequireDefault((parcelRequire("euxye")));

var $8194aabcf9effd73$var$_iconNew = $8194aabcf9effd73$var$_interopRequireDefault((parcelRequire("52mjj")));
function $8194aabcf9effd73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sidebar-expand
 * Usage guidance:
 * Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8194aabcf9effd73$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $8194aabcf9effd73$var$_react.default.createElement($8194aabcf9effd73$var$_iconNew.default, Object.assign({
        name: "SidebarExpandIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-2v-11zm-3.5 0v11H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.03 7.47l-2.5-2.5-1.06 1.06L6.44 8 4.47 9.97l1.06 1.06 2.5-2.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$8194aabcf9effd73$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $8194aabcf9effd73$var$_default = module.exports.default = $8194aabcf9effd73$var$SidebarExpandIcon;

});

parcelRegister("a7nVR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4c39bfa2c8ba34f67b9a83cec6525e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75dd1f43b03a2323$var$_react = $75dd1f43b03a2323$var$_interopRequireDefault((parcelRequire("euxye")));

var $75dd1f43b03a2323$var$_iconNew = $75dd1f43b03a2323$var$_interopRequireDefault((parcelRequire("52mjj")));
function $75dd1f43b03a2323$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Support".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/support
 * Usage guidance:
 * Reserved for representing help support.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75dd1f43b03a2323$var$SupportIcon = (props)=>/*#__PURE__*/ $75dd1f43b03a2323$var$_react.default.createElement($75dd1f43b03a2323$var$_iconNew.default, Object.assign({
        name: "SupportIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.964 2.904 5.752 4.69a4 4 0 0 1 4.497 0l1.787-1.787a6.5 6.5 0 0 0-8.072 0m9.132 1.06L11.31 5.752a4 4 0 0 1 0 4.497l1.787 1.787a6.5 6.5 0 0 0 0-8.072m-1.06 9.132-1.787-1.787a4 4 0 0 1-4.497 0l-1.788 1.787a6.5 6.5 0 0 0 8.072 0m-9.132-1.06 1.787-1.787a4 4 0 0 1 0-4.497L2.904 3.964a6.5 6.5 0 0 0 0 8.072m-.56-9.693a8 8 0 1 1 11.313 11.314A8 8 0 0 1 2.343 2.343m7.424 3.89a2.5 2.5 0 1 0-3.536 3.535 2.5 2.5 0 0 0 3.536-3.536" clip-rule="evenodd"/>`
    }, props));
$75dd1f43b03a2323$var$SupportIcon.displayName = 'SupportIcon';
var $75dd1f43b03a2323$var$_default = module.exports.default = $75dd1f43b03a2323$var$SupportIcon;

});

parcelRegister("b47ZF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25fc5e06165a31c1790a9d0782b9d836>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $80e644d2333c1760$var$_react = $80e644d2333c1760$var$_interopRequireDefault((parcelRequire("euxye")));

var $80e644d2333c1760$var$_iconNew = $80e644d2333c1760$var$_interopRequireDefault((parcelRequire("52mjj")));
function $80e644d2333c1760$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Plan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/plan
 * Usage guidance:
 * Reserved for representing plans.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $80e644d2333c1760$var$PlanIcon = (props)=>/*#__PURE__*/ $80e644d2333c1760$var$_react.default.createElement($80e644d2333c1760$var$_iconNew.default, Object.assign({
        name: "PlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 12.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m1.5 0a2.75 2.75 0 0 1-5.394.75H5.625a3.125 3.125 0 1 1 0-6.25h4.75a1.625 1.625 0 1 0 0-3.25H5.394A2.749 2.749 0 0 1 0 3.25a2.75 2.75 0 0 1 5.394-.75h4.981a3.125 3.125 0 1 1 0 6.25h-4.75a1.625 1.625 0 0 0 0 3.25h4.981a2.749 2.749 0 0 1 5.394.75M1.5 3.25a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0"/>`
    }, props));
$80e644d2333c1760$var$PlanIcon.displayName = 'PlanIcon';
var $80e644d2333c1760$var$_default = module.exports.default = $80e644d2333c1760$var$PlanIcon;

});

parcelRegister("2AJY0", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ed2ed524dcae343$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de6ef34f23a4cbd2a036384f0ad58249>>
 * @codegenCommand yarn build tokens
 */ const $8ed2ed524dcae343$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.button.hovered': '--ds-button-hovered',
    'motion.button.pressed': '--ds-button-pressed',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.form.message.enter': '--ds-form-message-enter',
    'motion.form.message.exit': '--ds-form-message-exit',
    'motion.input': '--ds-input',
    'motion.input.selection': '--ds-input-selection',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.grid.column.in': '--ds-keyframe-grid-column-in',
    'motion.keyframe.grid.column.out': '--ds-keyframe-grid-column-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.label.enter': '--ds-label-enter',
    'motion.label.exit': '--ds-label-exit',
    'motion.listitem.hovered': '--ds-listitem-hovered',
    'motion.listitem.pressed': '--ds-listitem-pressed',
    'motion.listitem.selected': '--ds-listitem-selected',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.panel.content.enter': '--ds-panel-content-enter',
    'motion.panel.content.exit': '--ds-panel-content-exit',
    'motion.panel.enter': '--ds-panel-enter',
    'motion.panel.enter.left': '--ds-panel-enter-left',
    'motion.panel.enter.right': '--ds-panel-enter-right',
    'motion.panel.exit': '--ds-panel-exit',
    'motion.panel.exit.left': '--ds-panel-exit-left',
    'motion.panel.exit.right': '--ds-panel-exit-right',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.sidenav.enter.left': '--ds-sidenav-enter-left',
    'motion.sidenav.enter.right': '--ds-sidenav-enter-right',
    'motion.sidenav.exit.left': '--ds-sidenav-exit-left',
    'motion.sidenav.exit.right': '--ds-sidenav-exit-right',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'motion.tab': '--ds-tab',
    'motion.tab.indicator.enter.left': '--ds-tab-indicator-enter-left',
    'motion.tab.indicator.enter.right': '--ds-tab-indicator-enter-right',
    'motion.tab.indicator.exit.left': '--ds-tab-indicator-exit-left',
    'motion.tab.indicator.exit.right': '--ds-tab-indicator-exit-right',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.code.added.highlight': '--ds-background-code-added-highlight',
    'color.background.code.added.line': '--ds-background-code-added-line',
    'color.background.code.default': '--ds-background-code-default',
    'color.background.code.gutter': '--ds-background-code-gutter',
    'color.background.code.highlight': '--ds-background-code-highlight',
    'color.background.code.removed.highlight': '--ds-background-code-removed-highlight',
    'color.background.code.removed.line': '--ds-background-code-removed-line',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.subtle': '--ds-background-danger-subtle',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.subtle': '--ds-background-warning-subtle',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.subtle': '--ds-background-success-subtle',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.subtle': '--ds-background-discovery-subtle',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.subtle': '--ds-background-information-subtle',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.lime.subtle': '--ds-border-accent-lime-subtle',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.red.subtle': '--ds-border-accent-red-subtle',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.orange.subtle': '--ds-border-accent-orange-subtle',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.yellow.subtle': '--ds-border-accent-yellow-subtle',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.green.subtle': '--ds-border-accent-green-subtle',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.teal.subtle': '--ds-border-accent-teal-subtle',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.blue.subtle': '--ds-border-accent-blue-subtle',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.purple.subtle': '--ds-border-accent-purple-subtle',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.magenta.subtle': '--ds-border-accent-magenta-subtle',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.accent.gray.subtle': '--ds-border-accent-gray-subtle',
    'color.border.code': '--ds-border-code',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.input.search': '--ds-border-input-search',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.danger.subtle': '--ds-border-danger-subtle',
    'color.border.warning': '--ds-border-warning',
    'color.border.warning.subtle': '--ds-border-warning-subtle',
    'color.border.success': '--ds-border-success',
    'color.border.success.subtle': '--ds-border-success-subtle',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.discovery.subtle': '--ds-border-discovery-subtle',
    'color.border.information': '--ds-border-information',
    'color.border.information.subtle': '--ds-border-information-subtle',
    'color.border.bold': '--ds-border-bold',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.code.accent.1': '--ds-text-code-accent-1',
    'color.text.code.accent.2': '--ds-text-code-accent-2',
    'color.text.code.comments': '--ds-text-code-comments',
    'color.text.code.default': '--ds-text-code-default',
    'color.text.code.functions': '--ds-text-code-functions',
    'color.text.code.gutter': '--ds-text-code-gutter',
    'color.text.code.keywords': '--ds-text-code-keywords',
    'color.text.code.numbers': '--ds-text-code-numbers',
    'color.text.code.operators': '--ds-text-code-operators',
    'color.text.code.strings': '--ds-text-code-strings',
    'color.text.code.tags': '--ds-text-code-tags',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'color.rovo.background.brand.bold': '--ds-rovo-background-brand-bold',
    'color.rovo.background.brand.bold.hovered': '--ds-rovo-background-brand-bold-hovered',
    'color.rovo.background.brand.bold.pressed': '--ds-rovo-background-brand-bold-pressed',
    'color.rovo.border.lime': '--ds-rovo-border-lime',
    'color.rovo.border.saffron': '--ds-rovo-border-saffron',
    'color.rovo.border.blue': '--ds-rovo-border-blue',
    'color.rovo.border.purple': '--ds-rovo-border-purple',
    'color.rovo.icon.lime': '--ds-rovo-icon-lime',
    'color.rovo.icon.saffron': '--ds-rovo-icon-saffron',
    'color.rovo.icon.blue': '--ds-rovo-icon-blue',
    'color.rovo.icon.purple': '--ds-rovo-icon-purple',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.container': '--ds-surface-container',
    'elevation.surface.container.hovered': '--ds-surface-container-hovered',
    'elevation.surface.container.pressed': '--ds-surface-container-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.rovo.surface.overlay': '--ds-rovo-surface-overlay',
    'elevation.rovo.surface.overlay.hovered': '--ds-rovo-surface-overlay-hovered',
    'elevation.rovo.surface.overlay.pressed': '--ds-rovo-surface-overlay-pressed',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $8ed2ed524dcae343$export$2e2bcd8739ae039 = $8ed2ed524dcae343$var$tokens;

});

parcelRegister("9imxF", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbc215d22acc33fc$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8L2z6 = parcelRequire("8L2z6");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $dbc215d22acc33fc$var$ModalTransition = (props)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
        appear: true,
        children: //Checking if children are undefined to prevent potential runtime errors in React 17
        props.children ?? null
    });
};
$dbc215d22acc33fc$var$ModalTransition.displayName = "ModalTransition";
var $dbc215d22acc33fc$export$2e2bcd8739ae039 = $dbc215d22acc33fc$var$ModalTransition;

});

parcelRegister("hzWaA", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8714a247748fc13$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $1MNmN = parcelRequire("1MNmN");

var $iqfTZ = parcelRequire("iqfTZ");

var $9MWap = parcelRequire("9MWap");
var $ihEDU = parcelRequire("ihEDU");
const $d8714a247748fc13$var$styles = {
    base: "_0bjKvDcjp5 _0WKd3G4z3T",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCYyL8i _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYzM7Tp _32C2rkyL8i _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _0clgaMM7Tp _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8 _0CMRbkAwSC",
    defaultAppearanceMotion: "_00uqCYyL8i _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rkyL8i _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9Ds4Fm _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGis4Fm _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
    subtleAppearance: "_00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzZpcK _32C2rkyL8i _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9DyL8i _3932vv0Rl6 _02cRtH6wH8 _0clgaMZpcK _3WzCGiyL8i _0NqVRt0Rl6 _3BKYwu6wH8 _0CMRbky7kJ",
    subtleAppearanceMotion: "_00uqCYs4Fm _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rks4Fm _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9DyL8i _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGiyL8i _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
    inverseAppearance: "_00uqCYyL8i _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYze5R3 _2nTuUYe5R3 _32C2rkyL8i _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _0clgaMe5R3 _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8 _0CMRbke5R3",
    inverseAppearanceMotion: "_00uqCYyL8i _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rkyL8i _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9Ds4Fm _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGis4Fm _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiyL8i _1mT5xdRAKS _2I62gzVQEB"
};
const $d8714a247748fc13$var$iconStyles = null;
const $d8714a247748fc13$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $9MWap.Anchor), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1MNmN.cx)($d8714a247748fc13$var$styles.base, appearance === 'default' && ((0, $iqfTZ.fg)('platform-dst-motion-uplift-list-item') ? $d8714a247748fc13$var$styles.defaultAppearanceMotion : $d8714a247748fc13$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $iqfTZ.fg)('platform-dst-motion-uplift-list-item') ? $d8714a247748fc13$var$styles.subtleAppearanceMotion : $d8714a247748fc13$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $iqfTZ.fg)('platform-dst-motion-uplift-list-item') ? $d8714a247748fc13$var$styles.inverseAppearanceMotion : $d8714a247748fc13$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $d8714a247748fc13$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.Box), {
                as: "span",
                xcss: $d8714a247748fc13$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $e79Pd.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $4jQY2.default)([
                            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                        ]),
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
$d8714a247748fc13$var$LinkWithoutRef.displayName = "LinkWithoutRef";
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $d8714a247748fc13$var$Link = /*#__PURE__*/ (0, $euxye.forwardRef)($d8714a247748fc13$var$LinkWithoutRef);
var $d8714a247748fc13$export$2e2bcd8739ae039 = $d8714a247748fc13$var$Link;

});
parcelRegister("9MWap", function(module, exports) {
$parcel$export(module.exports, "Anchor", () => $d9fce5d8cfa357f1$export$b688253958b8dfe7);
/* anchor.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $9S1b6 = parcelRequire("9S1b6");

var $jiTLE = parcelRequire("jiTLE");

var $aZBDA = parcelRequire("aZBDA");

var $5atpW = parcelRequire("5atpW");

var $2oRWW = parcelRequire("2oRWW");

var $gUxVT = parcelRequire("gUxVT");

var $Cs8MU = parcelRequire("Cs8MU");

var $apUrw = parcelRequire("apUrw");

var $9vMEI = parcelRequire("9vMEI");
const $d9fce5d8cfa357f1$var$styles = {
    root: "_00uqCYyL8i _3xtjKN0Rl6 _0H9qDF6wH8 _24h04i2Njc",
    position: "_1mT5xdRAKS"
};
const $d9fce5d8cfa357f1$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $d9fce5d8cfa357f1$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/; /**
                                                              * __Anchor__
                                                              *
                                                              * A primitive for building custom anchor links.
                                                              *
                                                              * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
                                                              * - [Code](https://atlassian.design/components/primitives/anchor/code)
                                                              * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
                                                              */ 
const $d9fce5d8cfa357f1$var$AnchorNoRef = ({ href: href, children: children, onClick: providedOnClick = (0, $2oRWW.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $euxye.useContext)((0, $Cs8MU.default));
    const handleClick = (0, $euxye.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $gUxVT.useId)();
    const onClick = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $5atpW.useRouterLink)();
    const isExternal = typeof href === 'string' && $d9fce5d8cfa357f1$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $d9fce5d8cfa357f1$var$IS_NON_HTTP_BASED.test(href); /**
                                                                                    * Renders a router link if:
                                                                                    *
                                                                                    * - a link component is set in the app provider
                                                                                    * - it's not an external link (starting with `http://` or `https://`)
                                                                                    * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
                                                                                    */ 
    const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $jiTLE.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $9vMEI.Focusable // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
    ), {
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $9S1b6.cx)($d9fce5d8cfa357f1$var$styles.root, $d9fce5d8cfa357f1$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apUrw.default), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    });
};
$d9fce5d8cfa357f1$var$AnchorNoRef.displayName = "AnchorNoRef";
const $d9fce5d8cfa357f1$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $euxye.forwardRef)($d9fce5d8cfa357f1$var$AnchorNoRef);

});
parcelRegister("5atpW", function(module, exports) {
$parcel$export(module.exports, "useRouterLink", () => $7bd1ec8a8c0c6511$export$6d558eab13290f59);

var $euxye = parcelRequire("euxye");

var $jlh1Q = parcelRequire("jlh1Q");
const $7bd1ec8a8c0c6511$export$6d558eab13290f59 = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $euxye.useContext)((0, $jlh1Q.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};

});
parcelRegister("jlh1Q", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", () => $e954823dae0f2e13$export$2931e0ee690eee88);
$parcel$export(module.exports, "default", () => $e954823dae0f2e13$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
const $e954823dae0f2e13$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $euxye.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $e954823dae0f2e13$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)($e954823dae0f2e13$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
$e954823dae0f2e13$var$RouterLinkProvider.displayName = "RouterLinkProvider";
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$e954823dae0f2e13$export$2e2bcd8739ae039 = $e954823dae0f2e13$var$RouterLinkProvider;

});




parcelRegister("yn9go", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f0d40da21d539e5$export$2e2bcd8739ae039);
/* banner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");
var $defJG = parcelRequire("defJG");
const $2f0d40da21d539e5$var$CSS_VAR_TEXT_COLOR = '--banner-text-color';
const $2f0d40da21d539e5$var$inlineStyles = {
    root: "_4ouGXIdnbC"
};
const $2f0d40da21d539e5$var$textStyles = {
    root: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1UtDYzH6EN _1kk5Tkf7mX _39HuIbz8Lp _1ANEUSLRg7 _0luBOgyL8i _0uGipIyL8i _0DlTgXyL8i _1Oh6lcyL8i _1KbF3ryL8i _2h5UOz0Rl6 _2LQVB40Rl6 _27PHXJ0Rl6 _38ddKy0Rl6 _1R2oCZ0Rl6 _3W2WEt6wH8 _4BW6TR6wH8 _2IWu1s6wH8 _4i4dA66wH8 _06nYrP6wH8 _0gKGie98eZ _1EjoPe98eZ _1BrKNs98eZ _1E1xWz98eZ _3bFj0T98eZ"
};
const $2f0d40da21d539e5$var$backgroundColors = {
    warning: 'color.background.warning.bold',
    error: 'color.background.danger.bold',
    announcement: 'color.background.neutral.bold'
};
const $2f0d40da21d539e5$var$tokenBackgroundColors = {
    warning: "var(--ds-background-warning-bold, #FBC828)",
    error: "var(--ds-background-danger-bold, #C9372C)",
    announcement: "var(--ds-background-neutral-bold, #292A2E)"
};
const $2f0d40da21d539e5$var$tokenTextColors = {
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    announcement: "var(--ds-text-inverse, #FFFFFF)"
};
const $2f0d40da21d539e5$var$containerStyles = {
    root: "_0jFU0VDuDI _0hPCNLDIqT _3iDTPbQ4SZ"
};
const $2f0d40da21d539e5$var$iconWrapperStyles = {
    root: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV029DVM _0jFU0V9DVM _3YEZNOdnbC"
};
/**
 * __Banner__
 *
 * A banner displays a prominent message at the top of the screen.
 *
 * - [Examples](https://atlassian.design/components/banner/examples)
 * - [Code](https://atlassian.design/components/banner/code)
 * - [Usage](https://atlassian.design/components/banner/usage)
 */ const $2f0d40da21d539e5$var$Banner = /*#__PURE__*/ (0, $euxye.forwardRef)(({ appearance: appearance = 'warning', children: children, icon: icon, testId: testId }, ref)=>{
    const appearanceType = appearance in $2f0d40da21d539e5$var$backgroundColors ? appearance : 'warning';
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: $2f0d40da21d539e5$var$containerStyles.root,
        backgroundColor: $2f0d40da21d539e5$var$backgroundColors[appearanceType],
        padding: "space.150",
        testId: testId,
        ref: ref,
        role: "alert",
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.Inline), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "start",
            xcss: $2f0d40da21d539e5$var$inlineStyles.root,
            children: [
                icon ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                    as: "span",
                    xcss: $2f0d40da21d539e5$var$iconWrapperStyles.root,
                    style: {
                        fill: $2f0d40da21d539e5$var$tokenBackgroundColors[appearanceType],
                        color: $2f0d40da21d539e5$var$tokenTextColors[appearanceType]
                    },
                    children: icon
                }) : null,
                /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                    style: {
                        [$2f0d40da21d539e5$var$CSS_VAR_TEXT_COLOR]: $2f0d40da21d539e5$var$tokenTextColors[appearanceType]
                    },
                    className: (0, $4jQY2.default)([
                        $2f0d40da21d539e5$var$textStyles.root
                    ]),
                    children: children
                })
            ]
        })
    });
});
var $2f0d40da21d539e5$export$2e2bcd8739ae039 = $2f0d40da21d539e5$var$Banner;

});

parcelRegister("j0ADo", function(module, exports) {
$parcel$export(module.exports, "default", () => $35813c2ef2600a68$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $aZBDA = parcelRequire("aZBDA");

var $2oRWW = parcelRequire("2oRWW");

var $fLi8o = parcelRequire("fLi8o");

var $g54uT = parcelRequire("g54uT");

var $fe5lW = parcelRequire("fe5lW");

var $iqfTZ = parcelRequire("iqfTZ");

var $1DTca = parcelRequire("1DTca");

var $aFVSm = parcelRequire("aFVSm");

var $hD6gn = parcelRequire("hD6gn");

var $b2Kr2 = parcelRequire("b2Kr2");

var $jFfaj = parcelRequire("jFfaj");
const $35813c2ef2600a68$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $35813c2ef2600a68$var$checkIsChildOfPortal(node.parentElement);
};
// Close manager for layering
const $35813c2ef2600a68$var$CloseManager = ({ handleEscapeClose: handleEscapeClose, handleClick: handleClick })=>{
    (0, $g54uT.useCloseOnEscapePress)({
        onClose: handleEscapeClose
    });
    const { isLayerDisabled: isLayerDisabled } = (0, $fe5lW.useLayering)();
    (0, $euxye.useEffect)(()=>{
        return (0, $glbdM.bind)(window, {
            type: 'click',
            listener: (e)=>{
                if (isLayerDisabled()) return;
                handleClick(e);
            },
            options: {
                capture: true
            }
        });
    }, [
        handleClick,
        isLayerDisabled
    ]);
    // only create a dummy component for using ths hook in class component
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {});
};
$35813c2ef2600a68$var$CloseManager.displayName = "CloseManager";
const $35813c2ef2600a68$var$InlineDialog = /*#__PURE__*/ (0, $euxye.memo)(function InlineDialog(props) {
    if ((0, $iqfTZ.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jFfaj.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($35813c2ef2600a68$var$InlineDialogLegacy, {
        ...props
    });
});
function $35813c2ef2600a68$var$InlineDialogLegacy({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $2oRWW.default), onContentClick: onContentClick = (0, $2oRWW.default), onContentFocus: onContentFocus = (0, $2oRWW.default), onClose: providedOnClose = (0, $2oRWW.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children, fallbackPlacements: fallbackPlacements }) {
    const containerRef = (0, $euxye.useRef)(null);
    const triggerRef = (0, $euxye.useRef)(null);
    const onClose = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (event)=>providedOnClose(event),
        action: 'closed',
        componentName: 'inlineDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $euxye.useRef)(onClose);
    (0, $euxye.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const handleCloseRequest = (0, $euxye.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isOpen) {
            onCloseRef.current?.({
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($35813c2ef2600a68$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
            isOpen: false,
            event: event
        });
    }, [
        isOpen
    ]);
    const handleClick = (0, $euxye.useCallback)((event)=>{
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        if (containerRef.current?.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        containerRef,
        triggerRef
    ]);
    /**
   * Auto-flip is enabled by default in `@atlaskit/popper` and
   * the `InlineDialog` API does not allow disabling it.
   *
   * We only need to override it if there are `fallbackPlacements` specified.
   */ const modifiers = (0, $euxye.useMemo)(()=>fallbackPlacements ? [
            {
                name: 'flip',
                options: {
                    fallbackPlacements: fallbackPlacements
                }
            }
        ] : [], [
        fallbackPlacements
    ]);
    const popper = isOpen ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1DTca.Popper), {
        placement: placement,
        strategy: strategy,
        modifiers: modifiers,
        children: ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $b2Kr2.Container), {
                onBlur: onContentBlur,
                onFocus: onContentFocus,
                onClick: onContentClick,
                ref: (node)=>{
                    if (node) {
                        containerRef.current = node;
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                    }
                },
                style: style,
                testId: testId,
                children: typeof content === 'function' ? content() : content
            })
    }) : null;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $aFVSm.Manager), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hD6gn.Reference), {
                children: ({ ref: ref })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        ref: (node)=>{
                            // Resolve to the first element child of the div in `children`
                            const firstElementChild = node?.firstElementChild || null;
                            triggerRef.current = firstElementChild;
                            if (typeof ref === 'function') ref(firstElementChild);
                            else ref.current = firstElementChild;
                        },
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, {
                            children: children
                        })
                    })
            }),
            isOpen ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $fLi8o.Layering), {
                isDisabled: false,
                children: [
                    popper,
                    /*#__PURE__*/ (0, $e79Pd.jsx)($35813c2ef2600a68$var$CloseManager, {
                        handleEscapeClose: handleCloseRequest,
                        handleClick: handleClick
                    })
                ]
            }) : popper
        ]
    });
}
$35813c2ef2600a68$var$InlineDialogLegacy.displayName = "InlineDialogLegacy";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$35813c2ef2600a68$export$2e2bcd8739ae039 = $35813c2ef2600a68$var$InlineDialog;

});
parcelRegister("fLi8o", function(module, exports) {
$parcel$export(module.exports, "Layering", () => $ac13b593f23a0578$export$7c885f891c940977);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $fdta2 = parcelRequire("fdta2");

var $c5gPq = parcelRequire("c5gPq");

var $cgg5K = parcelRequire("cgg5K");

var $h0ArS = parcelRequire("h0ArS");
const $ac13b593f23a0578$var$LevelProvider = ({ children: children, currentLevel: currentLevel, node: levelNode })=>{
    (0, $euxye.useEffect)(()=>{
        const levelNodeSafe = levelNode.current;
        const parentNode = levelNodeSafe.parent;
        parentNode?.addChild(levelNodeSafe);
        return ()=>{
            parentNode?.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $c5gPq.LevelContext).Provider, {
        value: currentLevel,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cgg5K.LevelNodeContext).Provider, {
            value: levelNode,
            children: children
        })
    });
};
$ac13b593f23a0578$var$LevelProvider.displayName = "LevelProvider";
const $ac13b593f23a0578$export$7c885f891c940977 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $euxye.useContext)((0, $c5gPq.LevelContext));
    const parentNode = (0, $euxye.useContext)((0, $cgg5K.LevelNodeContext));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    const newNode = (0, $euxye.useRef)(new (0, $fdta2.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, $e79Pd.jsx)($ac13b593f23a0578$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode,
        children: children
    });
    return isNested ? content : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $h0ArS.RootNodeContext).Provider, {
        value: newNode,
        children: content
    });
};
$ac13b593f23a0578$export$7c885f891c940977.displayName = "Layering";

});
parcelRegister("fdta2", function(module, exports) {
$parcel$export(module.exports, "LayerNode", () => $3ccc415cb5b0ac2e$export$da4f61fd78d35243);
class $3ccc415cb5b0ac2e$export$da4f61fd78d35243 {
    constructor(id, parent){
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    addChild(node) {
        this.childNodes.push(node);
    }
    removeChild(node) {
        this.childNodes = this.childNodes.filter((child)=>child.id !== node.id);
    }
    getLevel() {
        if (!this.parent) return 1;
        return this.parent.getLevel() + 1;
    }
    getHeight() {
        if (this.childNodes.length === 0) return 1;
        return Math.max(...this.childNodes.map((child)=>child.getHeight())) + 1;
    }
}
$3ccc415cb5b0ac2e$export$da4f61fd78d35243.displayName = "LayerNode";

});

parcelRegister("c5gPq", function(module, exports) {
$parcel$export(module.exports, "LevelContext", () => $c8b5a4326f68fe80$export$650d12d3c2ddb8fc);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $euxye = parcelRequire("euxye");
const $c8b5a4326f68fe80$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $euxye.createContext)(0);

});

parcelRegister("cgg5K", function(module, exports) {
$parcel$export(module.exports, "LevelNodeContext", () => $69bed27833204791$export$18f4d8b5b3a77f59);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $euxye = parcelRequire("euxye");
const $69bed27833204791$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $euxye.createContext)({
    current: null
});

});

parcelRegister("h0ArS", function(module, exports) {
$parcel$export(module.exports, "RootNodeContext", () => $81bd2a77feaf9e9e$export$fa973f110e8f6ca8);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $euxye = parcelRequire("euxye");
const $81bd2a77feaf9e9e$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $euxye.createContext)({
    current: null
});

});


parcelRegister("g54uT", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", () => $1b179312d81fd466$export$4a4bf067ea9e7886);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $fe5lW = parcelRequire("fe5lW");
const $1b179312d81fd466$var$ESCAPE = 'Escape';
function $1b179312d81fd466$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $euxye.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = (0, $fe5lW.useLayering)();
    const onKeyDown = (0, $euxye.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $1b179312d81fd466$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $euxye.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $euxye.useEffect)(()=>{
        return (0, $glbdM.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("fe5lW", function(module, exports) {
$parcel$export(module.exports, "useLayering", () => $20ee9fd2767220c8$export$c8b4d54e03dee6ed);

var $euxye = parcelRequire("euxye");

var $c5gPq = parcelRequire("c5gPq");

var $cgg5K = parcelRequire("cgg5K");

var $h0ArS = parcelRequire("h0ArS");
function $20ee9fd2767220c8$export$c8b4d54e03dee6ed() {
    const currentLevel = (0, $euxye.useContext)((0, $c5gPq.LevelContext));
    const layerNode = (0, $euxye.useContext)((0, $cgg5K.LevelNodeContext));
    const rootNode = (0, $euxye.useContext)((0, $h0ArS.RootNodeContext));
    const isLayerDisabled = (0, $euxye.useCallback)(()=>{
        // This is an impossible case, added for type safety
        if (!layerNode?.current || !rootNode?.current) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    const getTopLevel = (0, $euxye.useCallback)(()=>rootNode?.current ? rootNode.current.getHeight() : null, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});


parcelRegister("b2Kr2", function(module, exports) {
$parcel$export(module.exports, "Container", () => $e3438b42ab59e3bd$export$42a852a2b6b56249);
/* inline-dialog-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $e3438b42ab59e3bd$var$containerStyles = null;
const $e3438b42ab59e3bd$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        className: (0, $4jQY2.default)([
            "_0bjKvDzXzM _24h04iyL8i _1EqgXlhPwX _0NUa3rhPwX _42Yu6BPvK5 _0KLXruoI2d _2OUyjtGk8v _1UtDYzy7kJ _0xmtko5zaO _46hvQm5zaO _03SyCPNHnM _0LQT5ENHnM _1zr6Dc98eZ _0htemXYbGa _067LceT6kp"
        ]),
        children: typeof children === 'function' ? children() : children
    });
});

});

parcelRegister("jFfaj", function(module, exports) {
$parcel$export(module.exports, "default", () => $4753dce77c30f729$export$2e2bcd8739ae039);
/* inline-dialog-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $aZBDA = parcelRequire("aZBDA");

var $2oRWW = parcelRequire("2oRWW");

var $gD1FN = parcelRequire("gD1FN");

var $gkWVj = parcelRequire("gkWVj");

var $1KSfL = parcelRequire("1KSfL");

var $Yce2Z = parcelRequire("Yce2Z");

var $4uAo9 = parcelRequire("4uAo9");

var $kUmcP = parcelRequire("kUmcP");
const $4753dce77c30f729$var$displayContentsStyles = {
    root: "_3iDTPbcK7c"
};
const $4753dce77c30f729$var$styles = {
    container: "_0bjKvDzXzM _24h04iyL8i _1EqgXlhPwX _0NUa3rhPwX _0KLXruoI2d _2OUyjtGk8v _1UtDYzy7kJ _0xmtko5zaO _46hvQm5zaO _03SyCPNHnM _0LQT5ENHnM"
};
function $4753dce77c30f729$var$getTriggerElement(trigger) {
    if (!trigger) return null;
    if (trigger instanceof HTMLButtonElement) return trigger;
    return trigger.querySelector('button');
} /**
   * Applies ARIA attributes to the child trigger element via an effect,
   * keeping them in sync with popup state.
   */ 
function $4753dce77c30f729$var$TriggerWrapper({ children: children, triggerRef: triggerRef, ariaAttributes: ariaAttributes }) {
    (0, $euxye.useEffect)(()=>{
        const trigger = $4753dce77c30f729$var$getTriggerElement(triggerRef.current);
        if (!trigger) return;
         // Apply each attribute. When a value is `undefined` (e.g.
        // `aria-controls` while the popover host is not in the DOM),
        // remove the attribute so the trigger does not retain a stale
        // reference from a previous open.
        Object.entries(ariaAttributes).forEach(([key, value])=>{
            if (value === undefined) {
                trigger.removeAttribute(key);
                return;
            }
            trigger.setAttribute(key, String(value));
        });
    }, [
        ariaAttributes,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: (node)=>{
            if (!node) {
                triggerRef.current = null;
                return;
            } // CSS-in-JS may inject <style> elements into this wrapper; they are not trigger elements.
            const triggerElement = Array.from(node.children).find((child)=>child instanceof HTMLElement && !(child instanceof HTMLStyleElement));
            triggerRef.current = triggerElement ?? null;
        },
        className: (0, $4jQY2.default)([
            $4753dce77c30f729$var$displayContentsStyles.root
        ]),
        children: children
    });
}
$4753dce77c30f729$var$TriggerWrapper.displayName = "TriggerWrapper";
/**
 * Top-layer implementation of InlineDialog.
 *
 * Replaces the legacy rendering pipeline (Popper.js + Portal + @atlaskit/layering)
 * with the native Popover API + CSS Anchor Positioning via @atlaskit/top-layer.
 *
 * Gated behind the `platform-dst-top-layer` feature flag.
 */ const $4753dce77c30f729$var$InlineDialogTopLayer = /*#__PURE__*/ (0, $euxye.memo)(function InlineDialogTopLayer({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $2oRWW.default), onContentClick: onContentClick = (0, $2oRWW.default), onContentFocus: onContentFocus = (0, $2oRWW.default), onClose: providedOnClose = (0, $2oRWW.default), placement: placement = 'bottom-start', testId: testId, content: content, children: children, // No-op props.
// These props are accepted for API compatibility but have no effect
// in the top-layer path. Each is documented with why it is unnecessary.
// top-layer: CSS Anchor Positioning replaces Popper strategy. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
strategy: _strategy, // top-layer: Popper.js fallbackPlacements not applicable. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
fallbackPlacements: _fallbackPlacements }) {
    const triggerRef = (0, $euxye.useRef)(null);
    const popoverRef = (0, $euxye.useRef)(null);
    const popoverId = (0, $kUmcP.usePopoverId)();
    const onClose = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (event)=>providedOnClose(event),
        action: 'closed',
        componentName: 'inlineDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    }); // Placement conversion.
    const topLayerPlacement = (0, $euxye.useMemo)(()=>(0, $gkWVj.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]); // `isOpen` is included so the anchor positioning effect re-runs when
    // the Popover host element is unmounted/remounted across open cycles.
    (0, $4uAo9.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen
    }); // onClose bridge.
    // Translates top-layer's { reason } into the legacy onClose({ isOpen, event }) shape.
    // Focus restoration is handled automatically by the Popover based on the content role
    // (role="dialog" -> auto-restore).
    const handleOnClose = (0, $euxye.useCallback)(({ reason: reason })=>{
        const syntheticEvent = (0, $1KSfL.createPopoverCloseEvent)({
            reason: reason
        });
        onClose({
            isOpen: false,
            event: syntheticEvent
        });
    }, [
        onClose
    ]);
    const ariaAttributes = (0, $gD1FN.getAriaForTrigger)({
        role: 'dialog',
        isOpen: isOpen,
        popoverId: popoverId
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)($4753dce77c30f729$var$TriggerWrapper, {
                triggerRef: triggerRef,
                ariaAttributes: ariaAttributes,
                children: children
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $Yce2Z.Popover), {
                ref: popoverRef,
                id: popoverId,
                role: "dialog",
                // Acceptable given this component is intent-to-deprecate.
                label: "Inline dialog",
                isOpen: isOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    role: "presentation",
                    onBlur: onContentBlur,
                    onClick: onContentClick,
                    onFocus: onContentFocus,
                    className: (0, $4jQY2.default)([
                        $4753dce77c30f729$var$styles.container
                    ]),
                    children: typeof content === 'function' ? content() : content
                })
            })
        ]
    });
});
var $4753dce77c30f729$export$2e2bcd8739ae039 = $4753dce77c30f729$var$InlineDialogTopLayer;

});
parcelRegister("gD1FN", function(module, exports) {
$parcel$export(module.exports, "getAriaForTrigger", () => $bd66b998eb5c8248$export$9dd1d61dd4d4755);
/**
 * Maps each supported popover role to its `aria-haspopup` value.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. Roles that do not produce a popup use `undefined` instead (for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading), so they are intentionally excluded
 * from this mapping and from `getAriaForTrigger`.
 *
 * `true` is intentionally not a value in this mapping. The runtime only ever
 * produces the explicit string forms, so allowing it would invite consumers
 * to pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ const $bd66b998eb5c8248$var$roleToAriaHasPopup = {
    dialog: 'dialog',
    alertdialog: 'dialog',
    menu: 'menu',
    listbox: 'listbox',
    tree: 'tree',
    grid: 'grid'
};
function $bd66b998eb5c8248$export$9dd1d61dd4d4755({ role: role, isOpen: isOpen, popoverId: popoverId }) {
    // `aria-controls` is set to `undefined` while closed. The `Popover` /
    // `Dialog` primitives unmount their host element after the exit
    // animation finishes, so a closed-state `aria-controls` would point
    // at a node that is not in the DOM. Returning `undefined` here means
    // JSX spread renders no `aria-controls` attribute on the trigger
    // until the target exists, avoiding the dangling reference while
    // keeping the relationship live whenever it is meaningful.
    return {
        'aria-haspopup': $bd66b998eb5c8248$var$roleToAriaHasPopup[role],
        'aria-expanded': isOpen,
        'aria-controls': isOpen ? popoverId : undefined
    };
}

});

parcelRegister("1KSfL", function(module, exports) {
$parcel$export(module.exports, "createPopoverCloseEvent", () => $063980cb245c974c$export$27b4de066896ac63);
function $063980cb245c974c$export$27b4de066896ac63({ reason: reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        bubbles: true
    });
    if (reason === 'light-dismiss') return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
    return new Event('close');
}

});



parcelRegister("7tY81", function(module, exports) {
$parcel$export(module.exports, "default", () => $74f56f6d0a08ebdb$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4GQwg = parcelRequire("4GQwg");
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $74f56f6d0a08ebdb$var$ModalWrapper = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4GQwg.default), {
        ...props,
        isFullScreen: false,
        ref: ref
    });
});
$74f56f6d0a08ebdb$var$ModalWrapper.displayName = 'ModalWrapper';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$74f56f6d0a08ebdb$export$2e2bcd8739ae039 = $74f56f6d0a08ebdb$var$ModalWrapper;

});
parcelRegister("4GQwg", function(module, exports) {
$parcel$export(module.exports, "default", () => $a582ee1cbcdb8414$export$2e2bcd8739ae039);
/* modal-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $glbdM = parcelRequire("glbdM");

var $g6TgS = parcelRequire("g6TgS");

var $jr1Vl = parcelRequire("jr1Vl");

var $aZBDA = parcelRequire("aZBDA");

var $zLbDw = parcelRequire("zLbDw");

var $2oRWW = parcelRequire("2oRWW");

var $4jiTv = parcelRequire("4jiTv");

var $gUxVT = parcelRequire("gUxVT");

var $fLi8o = parcelRequire("fLi8o");

var $9fOPQ = parcelRequire("9fOPQ");

var $p9mZs = parcelRequire("p9mZs");

var $lDu73 = parcelRequire("lDu73");

var $eCdE8 = parcelRequire("eCdE8");

var $iqfTZ = parcelRequire("iqfTZ");

var $5PG2M = parcelRequire("5PG2M");

var $7aH0o = parcelRequire("7aH0o");

var $akMu8 = parcelRequire("akMu8");

var $dTWzO = parcelRequire("dTWzO");

var $l5WnI = parcelRequire("l5WnI");

var $4syWN = parcelRequire("4syWN");

var $cjFhY = parcelRequire("cjFhY");

var $h6T2I = parcelRequire("h6T2I");

var $bomi6 = parcelRequire("bomi6");

var $cR8wB = parcelRequire("cR8wB");

var $ihyCI = parcelRequire("ihyCI");

var $479xQ = parcelRequire("479xQ");

var $ehssC = parcelRequire("ehssC");

var $eFO8n = parcelRequire("eFO8n");

var $k0oj8 = parcelRequire("k0oj8");
const $a582ee1cbcdb8414$var$fillScreenStyles = null; /**
                                * Styles applied to the <dialog> wrapper, NOT the visual modal surface.
                                */ 
const $a582ee1cbcdb8414$var$dialogStyles = {
    'body-scroll': "_4bt5LAYvD1 _2WAcuGYvD1 _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _4fJ90yfI2J _1tgHQuIZbP _3GDW4sfI2J _4ntsTKIZbP",
    'viewport-scroll': "_1qyfxmyhct _39xV02qUim _0jFU0VWP8C",
    'full-screen': ""
}; // Visual styles for modal content inside native <dialog>.
// Uses cssMap (not css) to avoid triggering no-nested-styles lint rule.
const $a582ee1cbcdb8414$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current'; /**
                                                                                                         * Styles applied to the visual modal surface.
                                                                                                         */ 
const $a582ee1cbcdb8414$var$surfaceStyles = {
    root: "_3iDTPbQ4SZ _0aFT5vbt8w _0KLXruoI2d _1UtDYzy7kJ _45TjwHoI2d _1pp6NdIZbP _3Sk04SOLYo _1s1YRNOLYo _3gkMN6OLYo _1ubuxonXvL _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _2l47gTGk8v",
    borderRadius: "_0bjKvDdnbC _0YcdZAyzSk"
};
const $a582ee1cbcdb8414$var$topLayerScrollModeStyles = {
    'full-screen': "_39xV02qUim _0jFU0VWP8C _1mT5xdy1CL _2I62gzPgdg _3iC0zdPgdg _2WAcuGIZbP _0xWutCdqJc",
    'viewport-scroll': "_0jFU0VWP8C _4fJ90yfI2J _1tgHQuIZbP _3GDW4sfI2J _4ntsTKIZbP _3ShBvMBY1A _3GZDR8k2yd _14gTsZ5dtV _28xGbQw4ra",
    'body-scroll': "_39xV02qUim _0jFU0VWP8C _3GZDR8k2yd _14gTsZ5dtV _28xGbQw4ra"
};
const $a582ee1cbcdb8414$var$topLayerAutoHeightStyles = null;
const $a582ee1cbcdb8414$var$allowlistElements = (element, callback)=>{
    // Allow focus outside modal when AUI dialog is visible
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- legacy FocusLock allowlist
    if (document.querySelector('.aui-blanket:not([hidden])')) return false;
     // Optional callback to let consumers exclude elements from focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
}; // Analytics-wrapped close handler. Extracted so both rendering paths build it
// identically.
function $a582ee1cbcdb8414$var$useModalCloseHandler(providedOnClose) {
    return (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $2oRWW.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
}
function $a582ee1cbcdb8414$var$getScrollMode({ shouldScrollInViewport: shouldScrollInViewport, isFullScreen: isFullScreen }) {
    if (isFullScreen) return 'full-screen';
    if (shouldScrollInViewport) return 'viewport-scroll';
    return 'body-scroll';
}
function $a582ee1cbcdb8414$var$isWidthName(value) {
    return (0, $eFO8n.width).values.includes(value);
}
function $a582ee1cbcdb8414$var$getTopLayerSurfaceWidth(input) {
    if (!input) return 'auto';
    if (typeof input === 'number') return `${input}px`;
    if ($a582ee1cbcdb8414$var$isWidthName(input)) return `${(0, $eFO8n.width).widths[input]}px`;
    if (input.endsWith('%')) // Percentage widths need special handling in the top layer.
    // In legacy, the percentage resolved against the Positioner's max-width
    // (100vw - 120px). In the top layer, the <dialog>'s containing block is the
    // viewport (100vw), so a raw percentage would produce a wider modal.
    // Transform e.g. '42%' → 'calc(42 * (100vw - 120px) / 100)' to match legacy.
    return `calc(${parseFloat(input)} * (100vw - 120px) / 100)`;
    return input;
}
function $a582ee1cbcdb8414$var$getTopLayerSurfaceHeight(input) {
    if (!input) // Although this value would ordinarily fill the viewport height,
    // there is also a `max-height: max-content` applied to keep it constrained.
    // But we need to provide the modal with a fixed height (non-keyword, non-percentage)
    // in order for child elements with 100% height to work correctly.
    return 'calc(100vh - 120px)';
    if (typeof input === 'number') return `${input}px`;
    if (input.endsWith('%')) // Percentage heights need special handling in the top layer.
    // In legacy, the percentage resolved against the Positioner's max-height
    // (100vh - 120px). In the top layer, the <dialog>'s containing block is the
    // viewport (100vh), so a raw percentage would produce a taller modal.
    // Transform e.g. '42%' → 'calc(42 * (100vh - 120px) / 100)' to match legacy.
    return `calc(${parseFloat(input)} * (100vh - 120px) / 100)`;
    return input;
}
function $a582ee1cbcdb8414$var$getDialogDismissedBy({ shouldCloseOnEscapePress: shouldCloseOnEscapePress, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick }) {
    if (shouldCloseOnEscapePress && shouldCloseOnOverlayClick) return 'escape-and-outside-click';
    if (shouldCloseOnEscapePress) return 'escape';
    return 'none';
} /**
   * Top-layer rendering path (platform-dst-top-layer).
   *
   * Replaces Portal, FocusLock, ScrollLock, Blanket, Positioner, and z-index
   * management with native <dialog> via @atlaskit/top-layer/dialog.
   *
   * Key decisions:
   * - Animation: CSS transitions via @starting-style / allow-discrete.
   * - Close gating: Dialog only forwards allowed reasons.
   * - onClose event param: undefined - consumers should use close reason.
   * - Focus restoration: native <dialog> behavior replaces react-focus-lock's
   *   returnFocus (see accessibility-criteria.md).
   *
   * Every hook here runs unconditionally: this component only mounts on the
   * top-layer path, so it never shares a hook sequence with the legacy path.
   */ 
function $a582ee1cbcdb8414$var$ModalWrapperTopLayer(props) {
    const { autoFocus: autoFocus, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, onClose: providedOnClose, onStackChange: onStackChange = (0, $2oRWW.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width = 'medium', onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen = false } = props;
    (0, $h6T2I.default)({
        onStackChange: onStackChange
    });
    const onCloseHandler = $a582ee1cbcdb8414$var$useModalCloseHandler(providedOnClose);
    const { isExiting: isExiting, onFinish: onExitFinish } = (0, $lDu73.useExitingPersistence)(); // Native <dialog> always restores focus on close - no opt-out via shouldReturnFocus.
    const defaultTestId = testId || 'modal-dialog';
    const id = (0, $gUxVT.useId)();
    const titleId = `modal-dialog-title-${id}`; // Content container ref - used for onOpenComplete/onCloseComplete callbacks.
    const contentRef = (0, $euxye.useRef)(null); // Cache last content element for onCloseComplete after children unmount
    // (with reduced motion, contentRef clears before onExitFinish fires).
    const lastContentElRef = (0, $euxye.useRef)(null);
    if (contentRef.current) lastContentElRef.current = contentRef.current;
     // Native <dialog> ref - needed for ExitingPersistence to call dialog.close().
    const dialogRef = (0, $euxye.useRef)(null);
    const hasProvidedOnClose = Boolean(providedOnClose);
    const modalDialogContext = (0, $euxye.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onCloseHandler,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen ?? false
        }), [
        defaultTestId,
        titleId,
        onCloseHandler,
        hasProvidedOnClose,
        isFullScreen
    ]); // Dialog has already applied the close behavior configured by `dismissedBy`.
    // Pass a synthetic event to satisfy the KeyboardOrMouseEvent contract.
    const onDialogClose = (0, $euxye.useCallback)(({ reason: reason })=>{
        onCloseHandler((0, $dTWzO.createCloseEvent)({
            reason: reason
        }));
    }, [
        onCloseHandler
    ]);
    const dismissedBy = $a582ee1cbcdb8414$var$getDialogDismissedBy({
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
    });
    const shouldShimCloseOnOverlayClick = shouldCloseOnOverlayClick && !shouldCloseOnEscapePress; // Required until we fully remove `shouldCloseOnEscapePress`.
    // Dialog's `dismissedBy` options do not support outside click without Escape (because it is a bad pattern)
    (0, $euxye.useEffect)(()=>{
        const dialog = dialogRef.current;
        if (!dialog || !shouldShimCloseOnOverlayClick) return;
        return (0, $glbdM.bind)(dialog, {
            type: 'click',
            listener (event) {
                if (event.target === event.currentTarget) onDialogClose({
                    reason: 'overlay-click'
                });
            }
        });
    }, [
        onDialogClose,
        shouldShimCloseOnOverlayClick
    ]); // ExitingPersistence: isExiting → isOpen={false} → Dialog exit animation →
    // onExitFinish → onCloseComplete + unmount.
    const handleDialogExitFinish = (0, $euxye.useCallback)(()=>{
        const el = contentRef.current ?? lastContentElRef.current;
        if (onCloseComplete && el) onCloseComplete(el);
        lastContentElRef.current = null;
        onExitFinish?.();
    }, [
        onExitFinish,
        onCloseComplete
    ]);
    const handleDialogEnterFinish = (0, $euxye.useCallback)(()=>{
        if (onOpenComplete && contentRef.current) onOpenComplete(contentRef.current, true);
    }, [
        onOpenComplete
    ]); // Honor `shouldReturnFocus={ref}` on unmount.
    // Native <dialog>.close() restores focus to the trigger that opened it,
    // but the consumer asked for focus to go to a specific element instead.
    // Run this in an unmount cleanup so it fires after dialog.close()
    // (which fires in the Dialog's effect cleanup).
    const shouldReturnFocusRef = (0, $euxye.useRef)(shouldReturnFocus);
    shouldReturnFocusRef.current = shouldReturnFocus;
    (0, $euxye.useEffect)(()=>{
        return ()=>{
            const target = shouldReturnFocusRef.current;
            if (typeof target === 'object' && target.current) target.current.focus();
        };
    }, []); // Focus a ref-targeted element after mount (when autoFocus is a ref).
    // When true, native <dialog>.showModal() handles focus automatically.
    (0, $4jiTv.default)(typeof autoFocus === 'object' ? autoFocus : undefined, typeof autoFocus === 'object'); // Chrome cross-origin iframe DnD workaround (crbug.com/362301053)
    (0, $euxye.useEffect)(()=>{
        return (0, $7aH0o.combine)((0, $cR8wB.disableDraggingToCrossOriginIFramesForElement)(), (0, $479xQ.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $ihyCI.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    const scrollMode = $a582ee1cbcdb8414$var$getScrollMode({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $l5WnI.Dialog), {
        ref: dialogRef,
        onClose: onDialogClose,
        dismissedBy: dismissedBy,
        onExitFinish: handleDialogExitFinish,
        shouldAnimate: !isFullScreen,
        isOpen: !isExiting,
        onEnterFinish: handleDialogEnterFinish,
        shouldHideBackdrop: isBlanketHidden,
        ...label ? {
            label: label
        } : {
            labelledBy: titleId
        },
        testId: defaultTestId,
        xcss: $a582ee1cbcdb8414$var$dialogStyles[scrollMode],
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4syWN.DialogScrollLock), {
                isOpen: true
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                ref: contentRef,
                style: {
                    '--modal-dialog-height': $a582ee1cbcdb8414$var$getTopLayerSurfaceHeight(height),
                    '--modal-dialog-width': $a582ee1cbcdb8414$var$getTopLayerSurfaceWidth(width)
                },
                className: (0, $4jQY2.default)([
                    $a582ee1cbcdb8414$var$surfaceStyles.root,
                    !isFullScreen && $a582ee1cbcdb8414$var$surfaceStyles.borderRadius,
                    $a582ee1cbcdb8414$var$topLayerScrollModeStyles[scrollMode],
                    !height && !isFullScreen && "_0Wik48W9qI"
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cjFhY.ModalContext).Provider, {
                    value: modalDialogContext,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ehssC.ScrollContext).Provider, {
                        value: shouldScrollInViewport,
                        children: children
                    })
                })
            })
        ]
    });
}
$a582ee1cbcdb8414$var$ModalWrapperTopLayer.displayName = "ModalWrapperTopLayer";
/**
 * Legacy rendering path (Portal + FocusLock + ScrollLock + Blanket).
 *
 * Every hook here runs unconditionally: this component only mounts on the
 * legacy path, so it never shares a hook sequence with the top-layer path.
 */ const $a582ee1cbcdb8414$var$ModalWrapperLegacy = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const { autoFocus: autoFocus, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange: onStackChange = (0, $2oRWW.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const calculatedStackIndex = (0, $h6T2I.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0; // If no ref is provided, autofocus on first element
    const autoFocusLock = !(typeof autoFocus === 'object');
    const onCloseHandler = $a582ee1cbcdb8414$var$useModalCloseHandler(providedOnClose);
    const onBlanketClicked = (0, $euxye.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]); // Stable callback to avoid re-renders when focusLockAllowlist is not provided.
    const allowListCallback = (0, $euxye.useCallback)((element)=>$a582ee1cbcdb8414$var$allowlistElements(element, focusLockAllowlist), [
        focusLockAllowlist
    ]); // Prevent background scroll (top-layer path uses DialogScrollLock instead).
    (0, $bomi6.default)(); // Register with the open layer observer. On the top-layer path the Dialog
    // primitive does this itself, which is why it lives in this legacy-only
    // component rather than the shared dispatcher.
    (0, $9fOPQ.useNotifyOpenLayerObserver)({
        type: 'modal',
        // Always open — modal is conditionally rendered when visible.
        isOpen: true,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, $2oRWW.default)
    });
    const modalDialogWithBlanket = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $zLbDw.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $k0oj8.default), {
            testId: testId,
            label: label,
            autoFocus: autoFocus,
            stackIndex: stackIndex,
            onClose: onCloseHandler,
            shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
            shouldScrollInViewport: shouldScrollInViewport,
            height: height,
            width: width,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete,
            hasProvidedOnClose: Boolean(providedOnClose),
            isFullScreen: isFullScreen,
            UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift,
            ref: ref,
            children: children
        })
    });
    let returnFocus = true;
    let onDeactivation = (0, $2oRWW.default);
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            shouldReturnFocus.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fLi8o.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5PG2M.default), {
            zIndex: (0, $akMu8.layers).modal(),
            children: !UNSAFE_shouldDisableMotionUplift && (0, $iqfTZ.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $p9mZs.default), {
                enteringAnimation: "var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
                exitingAnimation: "var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    "aria-hidden": !isForeground,
                    className: (0, $4jQY2.default)([
                        "_39xV02qUim _0jFU0VWP8C _1mT5xdy1CL _2I62gzPgdg _3iC0zdPgdg _2WAcuGIZbP _0xWutCdqJc"
                    ]),
                    children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $g6TgS.default), {
                        autoFocus: autoFocusLock,
                        returnFocus: returnFocus,
                        onDeactivation: onDeactivation,
                        whiteList: allowListCallback,
                        children: [
                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jr1Vl))), {}),
                            shouldScrollInViewport ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jr1Vl.TouchScrollable), {
                                children: modalDialogWithBlanket
                            }) : modalDialogWithBlanket
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eCdE8.default), {
                children: (fadeInProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        ...fadeInProps,
                        className: (0, $4jQY2.default)([
                            "_39xV02qUim _0jFU0VWP8C _1mT5xdy1CL _2I62gzPgdg _3iC0zdPgdg _2WAcuGIZbP _0xWutCdqJc",
                            fadeInProps.className
                        ]),
                        "aria-hidden": !isForeground,
                        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $g6TgS.default), {
                            autoFocus: autoFocusLock,
                            returnFocus: returnFocus,
                            onDeactivation: onDeactivation,
                            whiteList: allowListCallback,
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jr1Vl))), {}),
                                shouldScrollInViewport ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jr1Vl.TouchScrollable), {
                                    children: modalDialogWithBlanket
                                }) : modalDialogWithBlanket
                            ]
                        })
                    })
            })
        })
    });
}); // Choose the rendering implementation at the component boundary rather than
// gating hooks inside a single component. Each implementation owns its own
// hooks unconditionally, so a runtime feature-flag change swaps component types
// (a clean remount) instead of changing the hook order of a mounted component.
const $a582ee1cbcdb8414$var$InternalModalWrapper = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    if ((0, $iqfTZ.fg)('platform-dst-top-layer')) // TODO: the top-layer path does not forward the external `ref` (parity
    // with the pre-refactor behavior, where the top-layer branch never
    // consumed it). The public type still advertises `RefAttributes`, so a
    // consumer ref silently no-ops here. Follow up by forwarding `ref` to a
    // sensible element (for example the content `div`) once ref parity is
    // intentionally desired.
    return /*#__PURE__*/ (0, $e79Pd.jsx)($a582ee1cbcdb8414$var$ModalWrapperTopLayer, {
        ...props
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($a582ee1cbcdb8414$var$ModalWrapperLegacy, {
        ref: ref,
        ...props
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $a582ee1cbcdb8414$export$2e2bcd8739ae039 = $a582ee1cbcdb8414$var$InternalModalWrapper;

});
parcelRegister("zLbDw", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf500682bcd10cc3$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $aZBDA = parcelRequire("aZBDA");

var $2oRWW = parcelRequire("2oRWW");
const $cf500682bcd10cc3$var$packageName = "platform-pkg";
const $cf500682bcd10cc3$var$packageVersion = "0.0.0-use.local";
const $cf500682bcd10cc3$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $cf500682bcd10cc3$var$packageName,
    packageVersion: $cf500682bcd10cc3$var$packageVersion
};
const $cf500682bcd10cc3$var$baseStyles = null;
const $cf500682bcd10cc3$var$shouldAllowClickThroughStyles = null;
const $cf500682bcd10cc3$var$invisibleStyles = null; /**
                               * __Blanket__
                               *
                               * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
                               *
                               * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
                               */ 
const $cf500682bcd10cc3$var$Blanket = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, $2oRWW.default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
    const mouseDownTarget = (0, $euxye.useRef)(null);
    const onBlanketClickedWithAnalytics = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$cf500682bcd10cc3$var$analyticsAttributes
    });
    const blanketClickOutsideChildren = (0, $euxye.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
        onBlanketClickedWithAnalytics
    ]);
    const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    const onMouseDown = (0, $euxye.useCallback)((e)=>{
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $4jQY2.default)([
            "_49OCfRdnbC _1mT5xdy1CL _42Yu6BN779 _0KLXruA5lS _2WAcuGIZbP _1pp6NdIZbP",
            shouldAllowClickThrough && "_1pp6NdYbGa",
            !isTinted && "_0KLXruyL8i"
        ]),
        children: children
    });
}));
$cf500682bcd10cc3$var$Blanket.displayName = 'Blanket';
var $cf500682bcd10cc3$export$2e2bcd8739ae039 = $cf500682bcd10cc3$var$Blanket;

});

parcelRegister("dTWzO", function(module, exports) {
$parcel$export(module.exports, "createCloseEvent", () => $fac6b045364339c4$export$330cd73b9da5838b);
function $fac6b045364339c4$export$330cd73b9da5838b({ reason: reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        bubbles: true
    });
    return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
}

});

parcelRegister("l5WnI", function(module, exports) {
$parcel$export(module.exports, "Dialog", () => $3a08fcb8847c603e$export$3ddf2d174ce01153);
/* dialog-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $9S1b6 = parcelRequire("9S1b6");

var $glbdM = parcelRequire("glbdM");

var $ljVHR = parcelRequire("ljVHR");

var $2oRWW = parcelRequire("2oRWW");

var $9fOPQ = parcelRequire("9fOPQ");

var $3xxAB = parcelRequire("3xxAB");

var $64jrG = parcelRequire("64jrG");

var $bpTI5 = parcelRequire("bpTI5");
// Surface reset. KEEP IN SYNC with `surfaceResetStyles` in `popover/popover.tsx`.
const $3a08fcb8847c603e$var$surfaceResetStyles = {
    root: "_16fQCjIZbP _22xN0BzUZr _31O5bFzUZr _3npKLMzUZr _1W8Jgq7p2s _1sv16BdnbC _37eVqOYbGa"
};
const $3a08fcb8847c603e$var$dialogStyles = {
    root: "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _1EqgXlYbGa _1rY2tZYbGa _1uleA0Pgdg _1q5MkmPgdg _0SwjAoPgdg _22YA6yPgdg _4DVkoZIZbP _3sidotIZbP _0HFSp6YbGa _3NthtFzUZr _1hzzDPzUZr _3n2izOYbGa _2bmTl7YbGa _1Wet47YbGa _4eTLRPYbGa _2Q5CZ97dHp _3hz6pUy1CL _00JIZJdnbC _4bqM9MyL8i _0sSBqpvLZJ",
    motion: "_1kOSYtHCFx _3Z9K0wLrT7 _4f1LA5ThaV _3Y6bKpZSoF _0LqqFdYbGa _2Iz54kxlqh",
    enter: "_2fBhte18fs",
    exit: "_2fBhte9ddd"
};
const $3a08fcb8847c603e$var$backdropStyles = {
    root: "_3OBRCTA5lS",
    hidden: "_3OBRCTyL8i",
    enter: "_3PXcY4o0Nz",
    exit: "_3PXcY4nJl0"
};
const $3a08fcb8847c603e$export$3ddf2d174ce01153 = /*#__PURE__*/ (0, $euxye.forwardRef)(function Dialog({ children: children, isOpen: isOpen, onClose: onClose, dismissedBy: dismissedBy = 'escape-and-outside-click', onEnterFinish: onEnterFinish, onExitFinish: onExitFinish, shouldAnimate: shouldAnimate = false, xcss: consumerXcss, enteringAnimationXcss: enteringAnimationXcss, exitingAnimationXcss: exitingAnimationXcss, style: style, testId: testId, id: providedId, label: label, labelledBy: labelledBy, shouldHideBackdrop: shouldHideBackdrop }, ref) {
    const generatedId = (0, $euxye.useId)();
    const dialogId = providedId ?? generatedId;
    const ownRef = (0, $euxye.useRef)(null);
    const combinedRef = (0, $ljVHR.default)([
        ownRef,
        ref
    ]);
    const closeReasonRef = (0, $euxye.useRef)(null);
    const dismissedByRef = (0, $euxye.useRef)(dismissedBy);
    const onCloseRef = (0, $euxye.useRef)(onClose);
    // Keep native event handlers stable while ensuring they read the latest committed props.
    (0, $euxye.useLayoutEffect)(()=>{
        dismissedByRef.current = dismissedBy;
        onCloseRef.current = onClose;
    }, [
        dismissedBy,
        onClose
    ]);
    const { phase: phase, isMounted: isMounted, onBeforeToggle: onBeforeToggle, onToggle: onToggle } = (0, $3xxAB.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    });
    // Ordering is important: bind native lifecycle listeners before the later
    // layout effect calls showModal() or close(), because `beforetoggle` fires
    // synchronously during those calls.
    (0, $euxye.useLayoutEffect)(()=>{
        if (!isMounted) return;
        const dialog = ownRef.current;
        if (!dialog) return;
        return (0, $glbdM.bindAll)(dialog, [
            {
                type: 'beforetoggle',
                listener: onBeforeToggle
            },
            {
                // Browsers retarget clicks on ::backdrop to the <dialog> element.
                // Close on backdrop click when outside-click dismissal is enabled.
                type: 'click',
                listener (event) {
                    if (event.target === event.currentTarget && dismissedByRef.current === 'escape-and-outside-click') {
                        closeReasonRef.current = 'overlay-click';
                        dialog.close();
                    }
                }
            },
            {
                type: 'toggle',
                listener (event) {
                    if (event.newState === 'closed') {
                        const reason = closeReasonRef.current;
                        closeReasonRef.current = null;
                        // A reason is only set for user-initiated closes. When React closes the
                        // dialog because isOpen changed, the consumer already knows.
                        if (reason) onCloseRef.current({
                            reason: reason
                        });
                    }
                    onToggle(event);
                }
            }
        ]);
    }, [
        isMounted,
        onBeforeToggle,
        onToggle
    ]);
    // Native `<dialog>.showModal()` traps focus but wraps through `<body>` at
    // the boundary (A → B → C → body → A). This hook intercepts Tab to wrap
    // directly (A → B → C → A), matching the WAI-ARIA APG pattern. Passing
    // `phase` keeps the listener attached through the animated-exit window
    // (WCAG 2.4.3 Focus Order regression guard).
    (0, $64jrG.useFocusWrap)({
        elementRef: ownRef,
        role: 'dialog',
        phase: phase
    });
    // Notify the open layer observer so app-coordination features
    // (open-count subscriptions) work with top-layer dialogs.
    (0, $9fOPQ.useNotifyOpenLayerObserver)({
        type: 'modal',
        isOpen: isOpen,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, $2oRWW.default)
    });
    (0, $euxye.useLayoutEffect)(()=>{
        const dialog = ownRef.current;
        if (!dialog) return;
        if (isOpen) {
            closeReasonRef.current = null;
            if (!dialog.open) dialog.showModal();
            return ()=>{
                if (dialog.open) dialog.close();
            };
        }
        if (dialog.open) dialog.close();
    }, [
        isOpen
    ]);
    // Safari bug: escape closes open dialog and popovers, rather than just innermost popover
    // See notes/decisions/safari-escape-nested-popover-in-dialog.md
    const { shouldIgnoreEscape: shouldIgnoreEscape } = (0, $bpTI5.useSafariEscapeFix)({
        dialogRef: ownRef,
        isVisible: isMounted
    });
    // Handle native Escape (cancel event)
    const handleCancel = (0, $euxye.useCallback)((event)=>{
        // Only handle a cancel targeting THIS dialog. Native `cancel` does not
        // bubble, but React's synthetic event bubbles up the component tree, so
        // for nested dialogs (one rendered inside another's DOM subtree) the
        // inner dialog's Escape would otherwise also fire an ancestor dialog's
        // handler and close it too. Mirrors the backdrop-click target guard below.
        if (event.target !== event.currentTarget) return;
        // Spurious Safari `cancel`: the keydown snapshot saw an open child
        // popover, so this Escape belongs to that popover (light-dismissed
        // natively). Keep the dialog open instead of forwarding to `onClose`.
        if (shouldIgnoreEscape()) {
            event.preventDefault();
            return;
        }
        // Without native `closedby`, cancel Escape only when dismissal is disabled.
        // Allowed dismissal follows Popover behavior: the browser closes the element
        // and `onClose` notifies the controlled owner of the reason.
        if (dismissedBy === 'none') {
            event.preventDefault();
            return;
        }
        closeReasonRef.current = 'escape';
    }, [
        dismissedBy,
        shouldIgnoreEscape
    ]);
    // Unmount the `<dialog>` once exit completes so it does not leave an
    // empty `role="dialog"` element in the accessibility tree. A later open
    // remounts a fresh element, so the listener-binding and native-visibility
    // effects run against that element.
    if (!isMounted) return null;
    const shouldAnimateBackdrop = !shouldHideBackdrop && shouldAnimate;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("dialog", {
        ref: combinedRef,
        id: dialogId,
        // `aria-modal` is intentionally NOT set: native `<dialog>.showModal()`
        // already conveys modal semantics to assistive tech, and double-
        // declaring it forecloses non-modal use cases (consumers calling
        // `.show()` would still appear modal). Modern AT (NVDA / JAWS /
        // VoiceOver) infer modality from the platform accessibility API.
        "aria-label": label,
        "aria-labelledby": label ? undefined : labelledBy,
        style: style,
        onCancel: handleCancel,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            // Dialog styles
            $3a08fcb8847c603e$var$dialogStyles.root,
            $3a08fcb8847c603e$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $3a08fcb8847c603e$var$dialogStyles.enter,
            shouldAnimate && phase === 'exiting' && $3a08fcb8847c603e$var$dialogStyles.exit,
            shouldAnimate && $3a08fcb8847c603e$var$dialogStyles.motion,
            shouldHideBackdrop ? $3a08fcb8847c603e$var$backdropStyles.hidden : $3a08fcb8847c603e$var$backdropStyles.root,
            shouldAnimateBackdrop && phase === 'entering' && $3a08fcb8847c603e$var$backdropStyles.enter,
            shouldAnimateBackdrop && phase === 'exiting' && $3a08fcb8847c603e$var$backdropStyles.exit,
            (0, $9S1b6.cx)(consumerXcss, shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ]),
        children: children
    });
});

});
parcelRegister("bpTI5", function(module, exports) {
$parcel$export(module.exports, "useSafariEscapeFix", () => $fc692b201f0e6093$export$52c229d83e45be61);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $bWvjc = parcelRequire("bWvjc");
function $fc692b201f0e6093$export$52c229d83e45be61({ dialogRef: dialogRef, isVisible: isVisible }) {
    const childPopoverOpenAtEscapeRef = (0, $euxye.useRef)(false);
    (0, $euxye.useEffect)(()=>{
        if (!(0, $bWvjc.isSafari)()) return;
        const dialog = dialogRef.current;
        if (!dialog) return;
        // Bind to `document`, not the dialog: on Safari focus can be on `<body>`
        // (buttons are not focused on click), where a dialog-scoped listener would
        // never fire. The query below stays scoped to this dialog's subtree.
        return (0, $glbdM.bind)(document, {
            type: 'keydown',
            listener (event) {
                if (event.key !== 'Escape') return;
                try {
                    childPopoverOpenAtEscapeRef.current = Boolean(dialog.querySelector('[popover="auto"]:popover-open, [popover="hint"]:popover-open'));
                } catch  {
                    // `:popover-open` is unsupported in some environments (e.g. jsdom);
                    // treat as "no child popover" so a plain Escape still closes the dialog.
                    childPopoverOpenAtEscapeRef.current = false;
                }
            },
            options: {
                capture: true
            }
        });
    }, [
        dialogRef,
        isVisible
    ]);
    const api = (0, $euxye.useMemo)(()=>{
        return {
            shouldIgnoreEscape () {
                if (childPopoverOpenAtEscapeRef.current) {
                    childPopoverOpenAtEscapeRef.current = false;
                    return true;
                }
                return false;
            }
        };
    }, []);
    return api;
}

});


parcelRegister("4syWN", function(module, exports) {
$parcel$export(module.exports, "DialogScrollLock", () => $efd8d4d0e3fc63a0$export$e458030908e2d723);

var $euxye = parcelRequire("euxye");

var $eIbOZ = parcelRequire("eIbOZ");
function $efd8d4d0e3fc63a0$export$e458030908e2d723({ isOpen: isOpen }) {
    (0, $euxye.useLayoutEffect)(()=>{
        if (!isOpen) return;
        const body = (0, $eIbOZ.getDocument)()?.body;
        if (!body) return;
        const previousOverflow = body.style.overflow;
        body.style.overflow = 'hidden';
        return ()=>{
            body.style.overflow = previousOverflow;
        };
    }, [
        isOpen
    ]);
    return null;
}
$efd8d4d0e3fc63a0$export$e458030908e2d723.displayName = "DialogScrollLock";

});

parcelRegister("h6T2I", function(module, exports) {
$parcel$export(module.exports, "default", () => $f60dc0b58cc5aa61$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $gURE8 = parcelRequire("gURE8");

var $gQ56h = parcelRequire("gQ56h");

var $cX2U3 = parcelRequire("cX2U3");

var $lDu73 = parcelRequire("lDu73");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const $f60dc0b58cc5aa61$var$modalStackRegister = [];
function $f60dc0b58cc5aa61$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
    const { isExiting: isExiting } = (0, $lDu73.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, $cX2U3.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, $gQ56h.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, $gURE8.default)(()=>{
        const newStackIndex = $f60dc0b58cc5aa61$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $euxye.useEffect)(()=>{
        const currentStackIndex = $f60dc0b58cc5aa61$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $f60dc0b58cc5aa61$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $f60dc0b58cc5aa61$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $f60dc0b58cc5aa61$var$modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, $euxye.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex = $f60dc0b58cc5aa61$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $f60dc0b58cc5aa61$var$modalStackRegister.splice(currentStackIndex, 1);
                $f60dc0b58cc5aa61$var$modalStackRegister.forEach((cb)=>cb());
            }
        }, [
        updateStack
    ]);
    (0, $euxye.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("gQ56h", function(module, exports) {
$parcel$export(module.exports, "default", () => $79bc0582d4ddb164$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
function $79bc0582d4ddb164$export$2e2bcd8739ae039(value) {
    const ref = (0, $euxye.useRef)();
    (0, $euxye.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("cX2U3", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d9efc9afe46d745$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
function $1d9efc9afe46d745$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $euxye.useState)(initialState);
    const valueRef = (0, $euxye.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("bomi6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3ad855b4d1d33d6$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $e3ad855b4d1d33d6$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $e3ad855b4d1d33d6$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $euxye.useState)(0);
    (0, $euxye.useLayoutEffect)(()=>{
        setScrollTopOffset($e3ad855b4d1d33d6$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $euxye.useCallback)(()=>{
        if ($e3ad855b4d1d33d6$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $euxye.useEffect)(()=>{
        return (0, $glbdM.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("cR8wB", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $4656b667d7ed10aa$export$ec28e97c7d8b1b35);

var $glbdM = parcelRequire("glbdM");

var $gOKKd = parcelRequire("gOKKd");

var $7aH0o = parcelRequire("7aH0o");

var $dI5Ri = parcelRequire("dI5Ri");
function $4656b667d7ed10aa$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    const unbindEvents = (0, $glbdM.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $gOKKd.monitorForElements)({
        onGenerateDragPreview () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $7aH0o.combine)(unbindEvents, unbindMonitor);
}
function $4656b667d7ed10aa$var$watchForInteractionStart({ start: start }) {
    return (0, $glbdM.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener (event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
const $4656b667d7ed10aa$var$api = (0, $dI5Ri.makeFixForAdapter)({
    watchForInteractionStart: $4656b667d7ed10aa$var$watchForInteractionStart,
    watchForInteractionEnd: $4656b667d7ed10aa$var$watchForInteractionEnd
});
function $4656b667d7ed10aa$export$ec28e97c7d8b1b35() {
    return $4656b667d7ed10aa$var$api.registerUsage();
}

});
parcelRegister("dI5Ri", function(module, exports) {
$parcel$export(module.exports, "makeFixForAdapter", () => $d2ffa29278154276$export$a74bff2507e6126b);

var $7aH0o = parcelRequire("7aH0o");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $d2ffa29278154276$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $d2ffa29278154276$var$hasSameOrigin(href1, href2) {
    let url1;
    let url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch  {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $d2ffa29278154276$var$isIframeOnAnotherDomain(iframe) {
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
	 */ if (iframe.srcdoc) return false;
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
	 */ if (iframe.src.startsWith('data:')) return false;
    return !$d2ffa29278154276$var$hasSameOrigin(window.location.href, iframe.src);
}
const $d2ffa29278154276$var$registry = new Map();
function $d2ffa29278154276$var$applyFix(watchForEndOfInteraction) {
    const iframes = Array.from(document.querySelectorAll('iframe')).filter($d2ffa29278154276$var$isIframeOnAnotherDomain);
    const cleanups = iframes.map((iframe)=>{
        let entry = $d2ffa29278154276$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $d2ffa29278154276$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $d2ffa29278154276$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $d2ffa29278154276$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $7aH0o.combine)(...cleanups)();
    }
    const cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $d2ffa29278154276$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
    let registrationCount = 0;
    let stopWatchingInteractionStart = null;
    function start() {
        $d2ffa29278154276$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            registrationCount--;
            if (registrationCount !== 0) return;
            stopWatchingInteractionStart?.();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("ihyCI", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $aa1d7a2807819ac4$export$27d79116d3a4e7d5);

var $j3Rpf = parcelRequire("j3Rpf");

var $dI5Ri = parcelRequire("dI5Ri");
function $aa1d7a2807819ac4$var$watchForInteractionStart({ start: start }) {
    return (0, $j3Rpf.monitorForExternal)({
        onDragStart () {
            start();
        }
    });
}
function $aa1d7a2807819ac4$var$watchForInteractionEnd({ stop: stop }) {
    return (0, $j3Rpf.monitorForExternal)({
        onDrop () {
            stop();
        }
    });
}
const $aa1d7a2807819ac4$var$api = (0, $dI5Ri.makeFixForAdapter)({
    watchForInteractionStart: $aa1d7a2807819ac4$var$watchForInteractionStart,
    watchForInteractionEnd: $aa1d7a2807819ac4$var$watchForInteractionEnd
});
function $aa1d7a2807819ac4$export$27d79116d3a4e7d5() {
    return $aa1d7a2807819ac4$var$api.registerUsage();
}

});

parcelRegister("479xQ", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $4383a4dd339143b5$export$9c0606fcefb5d1e2);

var $glbdM = parcelRequire("glbdM");

var $aGJFe = parcelRequire("aGJFe");

var $7aH0o = parcelRequire("7aH0o");

var $dI5Ri = parcelRequire("dI5Ri");
function $4383a4dd339143b5$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    let frameId = null;
    const unbindEvents = (0, $glbdM.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener () {
                /**
					 * The pdnd `onDragStart()` fires in the frame after "dragstart"
					 * So we are delaying our isDragging check to give a chance
					 * for `onDragStart()` to set the value correctly.
					 *
					 * Note: could not use "pointercancel" as it is not
					 * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
					 */ frameId = requestAnimationFrame(()=>{
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $aGJFe.monitorForTextSelection)({
        onDragStart () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $7aH0o.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $4383a4dd339143b5$var$watchForInteractionStart({ start: start }) {
    return (0, $glbdM.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener () {
            // A text selection drag will only start when there is
            // an active text selection.
            const selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
const $4383a4dd339143b5$var$api = (0, $dI5Ri.makeFixForAdapter)({
    watchForInteractionStart: $4383a4dd339143b5$var$watchForInteractionStart,
    watchForInteractionEnd: $4383a4dd339143b5$var$watchForInteractionEnd
});
function $4383a4dd339143b5$export$9c0606fcefb5d1e2() {
    return $4383a4dd339143b5$var$api.registerUsage();
}

});

parcelRegister("eFO8n", function(module, exports) {
$parcel$export(module.exports, "width", () => $22ffcd346017f05d$export$7e3df82ee760448c);
const $22ffcd346017f05d$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};

});

parcelRegister("k0oj8", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6f25e1550c154ba$export$2e2bcd8739ae039);
/* modal-dialog.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $1MNmN = parcelRequire("1MNmN");

var $ljVHR = parcelRequire("ljVHR");

var $4jiTv = parcelRequire("4jiTv");

var $gUxVT = parcelRequire("gUxVT");

var $g54uT = parcelRequire("g54uT");

var $fe5lW = parcelRequire("fe5lW");

var $p9mZs = parcelRequire("p9mZs");

var $eCdE8 = parcelRequire("eCdE8");

var $iqfTZ = parcelRequire("iqfTZ");

var $7aH0o = parcelRequire("7aH0o");

var $cjFhY = parcelRequire("cjFhY");

var $hnGDX = parcelRequire("hnGDX");

var $cR8wB = parcelRequire("cR8wB");

var $ihyCI = parcelRequire("ihyCI");

var $479xQ = parcelRequire("479xQ");

var $ehssC = parcelRequire("ehssC");

var $6w9Le = parcelRequire("6w9Le");

var $54u0U = parcelRequire("54u0U");

var $eBtc1 = parcelRequire("eBtc1");
const $c6f25e1550c154ba$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $c6f25e1550c154ba$var$dialogStyles = {
    root: "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _3iDTPbQ4SZ _39xV02N91d _1EqgXlqUim _0jFU0VN91d _4kiQYAdnbC _0NUa3rWP8C _0aFT5vbt8w _0KLXruoI2d _1UtDYzy7kJ _45TjwHoI2d _1pp6NdIZbP _3Sk04SOLYo _1s1YRNOLYo _3gkMN6OLYo _1ubuxonXvL _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _3e11vU6wH8 _0hSAgbHZdu _28xGbQOLYo _2l47gTGk8v _2gkHrTOLYo _0iOkeGOLYo _4APJLd5dtV",
    borderRadius: "_0YcdZAyzSk",
    motion: "_0NUa3rOLYo _1EqgXlOLYo _3iDTPbQ4SZ _3GZDR8B2PM _3AHHrTN91d",
    rootMotion: "_2gkHrTIZbP _0iOkeGIZbP",
    fullscreen: "_3GZDR8N91d"
};
const $c6f25e1550c154ba$var$viewportScrollStyles = null;
const $c6f25e1550c154ba$var$bodyScrollStyles = null;
const $c6f25e1550c154ba$var$ModalDialog = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, hasProvidedOnClose: hasProvidedOnClose, children: children, label: label, testId: testId, isFullScreen: isFullScreen = false, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const id = (0, $gUxVT.useId)();
    const titleId = `modal-dialog-title-${id}`;
    const defaultTestId = testId || 'modal-dialog';
    (0, $euxye.useEffect)(()=>// Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        (0, $7aH0o.combine)((0, $cR8wB.disableDraggingToCrossOriginIFramesForElement)(), (0, $479xQ.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $ihyCI.disableDraggingToCrossOriginIFramesForExternal)()), []);
    (0, $4jiTv.default)(autoFocus, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object');
    const [motionRef, onMotionFinish] = (0, $hnGDX.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    });
    const modalDialogContext = (0, $euxye.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        }), [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $g54uT.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    const { currentLevel: currentLevel } = (0, $fe5lW.useLayering)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eBtc1.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cjFhY.ModalContext).Provider, {
            value: modalDialogContext,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ehssC.ScrollContext).Provider, {
                value: shouldScrollInViewport,
                children: !UNSAFE_shouldDisableMotionUplift && (0, $iqfTZ.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $p9mZs.default), {
                    enteringAnimation: "var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)",
                    exitingAnimation: "var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)",
                    onFinish: onMotionFinish,
                    xcss: (0, $1MNmN.cx)($c6f25e1550c154ba$var$dialogStyles.motion, isFullScreen && $c6f25e1550c154ba$var$dialogStyles.fullscreen),
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--modal-dialog-width': (0, $54u0U.dialogWidth)(width),
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--modal-dialog-height': (0, $6w9Le.dialogHeight)(height)
                    },
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)("section", {
                        "aria-label": label,
                        ref: (0, $ljVHR.default)([
                            motionRef,
                            ref
                        ]),
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            '--modal-dialog-width': (0, $54u0U.dialogWidth)(width),
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            '--modal-dialog-height': (0, $6w9Le.dialogHeight)(height)
                        },
                        role: "dialog",
                        "aria-labelledby": label ? undefined : titleId,
                        "data-testid": defaultTestId,
                        "data-modal-stack": stackIndex,
                        tabIndex: -1,
                        "aria-modal": true,
                        "data-ds--level": currentLevel,
                        className: (0, $4jQY2.default)([
                            $c6f25e1550c154ba$var$dialogStyles.root,
                            $c6f25e1550c154ba$var$dialogStyles.rootMotion,
                            !isFullScreen && $c6f25e1550c154ba$var$dialogStyles.borderRadius,
                            shouldScrollInViewport ? "_4kiQYAWP8C _0NUa3rYbGa _0z5aewk2yd" : "_0OpL60k2yd _0LO9FMOLYo"
                        ]),
                        children: children
                    })
                }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eCdE8.default /**
                           * We don't want a 'slide in' for the full screen modals.
                           */ ), {
                    entranceDirection: isFullScreen ? undefined : 'bottom',
                    onFinish: onMotionFinish,
                    children: (bottomFadeInProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)("section", {
                            ...bottomFadeInProps,
                            "aria-label": label,
                            ref: (0, $ljVHR.default)([
                                bottomFadeInProps.ref,
                                motionRef,
                                ref
                            ]),
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-width': (0, $54u0U.dialogWidth)(width),
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-height': (0, $6w9Le.dialogHeight)(height)
                            },
                            className: (0, $4jQY2.default)([
                                $c6f25e1550c154ba$var$dialogStyles.root,
                                !isFullScreen && $c6f25e1550c154ba$var$dialogStyles.borderRadius,
                                shouldScrollInViewport ? "_4kiQYAWP8C _0NUa3rYbGa _0z5aewk2yd" : "_0OpL60k2yd _0LO9FMOLYo",
                                bottomFadeInProps.className
                            ]),
                            role: "dialog",
                            "aria-labelledby": label ? undefined : titleId,
                            "data-testid": defaultTestId,
                            "data-modal-stack": stackIndex,
                            tabIndex: -1,
                            "aria-modal": true,
                            "data-ds--level": currentLevel,
                            children: children
                        })
                })
            })
        })
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc, @atlaskit/volt-strict-mode/no-multiple-exports
var $c6f25e1550c154ba$export$2e2bcd8739ae039 = $c6f25e1550c154ba$var$ModalDialog;

});
parcelRegister("hnGDX", function(module, exports) {
$parcel$export(module.exports, "default", () => $71890e4940e18401$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
function $71890e4940e18401$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
    const motionRef = (0, $euxye.useRef)(null);
    const onMotionFinish = (0, $euxye.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("6w9Le", function(module, exports) {
$parcel$export(module.exports, "dialogHeight", () => $a7c59b835c585e00$export$ceba93bf0bdd16f2);
const $a7c59b835c585e00$export$ceba93bf0bdd16f2 = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("54u0U", function(module, exports) {
$parcel$export(module.exports, "dialogWidth", () => $7d7de0db96ed1f16$export$a3da89b899389ed8);

var $eFO8n = parcelRequire("eFO8n");
const $7d7de0db96ed1f16$export$a3da89b899389ed8 = (input)=>{
    if (!input) return 'auto';
    const isWidthName = (0, $eFO8n.width).values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${(0, $eFO8n.width).widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("eBtc1", function(module, exports) {
$parcel$export(module.exports, "default", () => $2986f711ef81aac5$export$2e2bcd8739ae039);
/* positioner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");


var $9VFAH = parcelRequire("9VFAH");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
const $2986f711ef81aac5$var$positionerStyles = null;
const $2986f711ef81aac5$var$stackStyles = {
    stackTransition: "_1kOSYtC67X _39Ohv4YbGa _1SdfoHYbGa",
    stackTransform: "_1VJPcamUxd",
    stackIdle: "_1VJPcaYbGa"
};
// Hardcoded pixels are based off a 60px base gutter
const $2986f711ef81aac5$var$scrollStyles = {
    viewport: "_0jFU0VIZbP _1mT5xdRAKS _3ns3u9fI2J _3lqkkiIZbP _0Y3dgaYbGa",
    body: "_28xGbQw4ra _0Wik48UMig _2fj8asWVPG _0m5YQyahDP _4pesVsdnbC _3GyDTtdnbC _2gkHrTIZbP _0iOkeGIZbP _0Y3dgaYbGa",
    fullScreen: ""
};
function $2986f711ef81aac5$var$getScrollBehavior({ isFullScreen: isFullScreen, shouldScrollInViewport: shouldScrollInViewport }) {
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
const $2986f711ef81aac5$var$Positioner = (props)=>{
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId, isFullScreen: isFullScreen } = props;
    const scrollBehavior = $2986f711ef81aac5$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        style: {
            '--modal-dialog-translate-y': `calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: `${(0, $9VFAH.durations).medium}ms`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $a6abf1ec3b2246b3$export$c07234257a03d5e9)
        },
        "data-testid": testId && `${testId}--positioner`,
        className: (0, $4jQY2.default)([
            "_3iDTPbQ4SZ _39xV02N91d _1EqgXlN91d _0jFU0VN91d _1mT5xdy1CL _42Yu6BFIQA _0aFT5vbt8w _2I62gzdnbC _3iC0zddnbC",
            $2986f711ef81aac5$var$stackStyles.stackTransition,
            stackIndex > 0 ? $2986f711ef81aac5$var$stackStyles.stackTransform : $2986f711ef81aac5$var$stackStyles.stackIdle,
            $2986f711ef81aac5$var$scrollStyles[scrollBehavior]
        ]),
        children: children
    });
};
$2986f711ef81aac5$var$Positioner.displayName = "Positioner";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2986f711ef81aac5$export$2e2bcd8739ae039 = $2986f711ef81aac5$var$Positioner;

});
const $a6abf1ec3b2246b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $a6abf1ec3b2246b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $a6abf1ec3b2246b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $a6abf1ec3b2246b3$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
const $a6abf1ec3b2246b3$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
const $a6abf1ec3b2246b3$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
const $a6abf1ec3b2246b3$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';





parcelRegister("fxLck", function(module, exports) {
$parcel$export(module.exports, "PopoverContent", () => $218fcbe79cadbace$export$d7e1f420b25549ff);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $7qcdO = parcelRequire("7qcdO");

var $7TTTr = parcelRequire("7TTTr");
/**
 * __PopoverContent__
 *
 * A `PopoverContent` is the element that is shown as a popover.
 */ const $218fcbe79cadbace$var$renderPopoverContent = (Component, { children: children, placement: placement, motion: motion, isVisible: isVisible, shouldDismissOnClickOutside: shouldDismissOnClickOutside, dismiss: dismiss, back: back, testId: testId, offset: offset, strategy: strategy, ...actionProps })=>{
    if ('next' in actionProps && actionProps.next) return /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
        placement: placement,
        motion: motion,
        isVisible: isVisible,
        shouldDismissOnClickOutside: shouldDismissOnClickOutside,
        dismiss: dismiss,
        back: back,
        testId: testId,
        offset: offset,
        strategy: strategy,
        next: actionProps.next,
        children: children
    });
    if ('done' in actionProps && actionProps.done) return /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
        placement: placement,
        motion: motion,
        isVisible: isVisible,
        shouldDismissOnClickOutside: shouldDismissOnClickOutside,
        dismiss: dismiss,
        back: back,
        testId: testId,
        offset: offset,
        strategy: strategy,
        done: actionProps.done,
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
        placement: placement,
        motion: motion,
        isVisible: isVisible,
        shouldDismissOnClickOutside: shouldDismissOnClickOutside,
        dismiss: dismiss,
        back: back,
        testId: testId,
        offset: offset,
        strategy: strategy,
        children: children
    });
};
const $218fcbe79cadbace$export$d7e1f420b25549ff = (props)=>(0, $iqfTZ.fg)('platform-dst-top-layer-spotlight') ? $218fcbe79cadbace$var$renderPopoverContent((0, $7TTTr.PopoverContent), props) : $218fcbe79cadbace$var$renderPopoverContent((0, $7qcdO.PopoverContent), props);

});
parcelRegister("7qcdO", function(module, exports) {
$parcel$export(module.exports, "PopoverContent", () => $4f9258c947cfd475$export$d7e1f420b25549ff);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $ljVHR = parcelRequire("ljVHR");

var $p9mZs = parcelRequire("p9mZs");

var $iqfTZ = parcelRequire("iqfTZ");

var $1DTca = parcelRequire("1DTca");

var $2voEL = parcelRequire("2voEL");

var $farwH = parcelRequire("farwH");

var $8Sq8O = parcelRequire("8Sq8O");

var $cIr5V = parcelRequire("cIr5V");

var $ld31E = parcelRequire("ld31E");
const $4f9258c947cfd475$var$styles = {
    root: "_42Yu6BkKjW"
};
/**
 * The `transform: rotate(45deg);` styles used to rotate the `Caret` component result in the corners of
 * the caret extending beyond the bounding box (by roughly 2px). So, apply an offset to ensure
 * the caret points to the very edge of the target element.
 *
 * Note: `@atlaskit/popper` maps the offset to the placement, so we only need to define `[0, 2]` and
 * the offset will get correctly rotated depending on the placement.
 */ const $4f9258c947cfd475$var$defaultOffset = [
    0,
    2
];
/**
 * The Spotlight card can be positioned in many different configurations, but the caret should always point to
 * the center of the target element. `@atlaskit/popper` uses `'top' | 'right' | 'bottom' | 'left'` values for
 * this center alignment along the respective face. So we translate between the Spotlight position, and the
 * Popper position using this map.
 */ const $4f9258c947cfd475$var$popperPlacementMap = {
    'top-start': 'top',
    'top-center': 'top',
    'top-end': 'top',
    'bottom-start': 'bottom',
    'bottom-center': 'bottom',
    'bottom-end': 'bottom',
    'right-start': 'right',
    'right-end': 'right',
    'left-start': 'left',
    'left-end': 'left'
};
const $4f9258c947cfd475$var$DefaultMotion = ({ children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $p9mZs.default), {
        enteringAnimation: "var(--ds-spotlight-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
        exitingAnimation: "var(--ds-spotlight-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
        children: children
    });
$4f9258c947cfd475$var$DefaultMotion.displayName = "DefaultMotion";
const $4f9258c947cfd475$export$d7e1f420b25549ff = (props)=>{
    const { children: children, placement: placement, motion: motion = $4f9258c947cfd475$var$DefaultMotion, isVisible: isVisible = true, shouldDismissOnClickOutside: shouldDismissOnClickOutside = true, dismiss: dismiss, back: back, testId: testId, offset: offset = $4f9258c947cfd475$var$defaultOffset, strategy: strategy } = props;
    /**
   * A user should only be able to pass a `done` or a `next`. Not both.
   * The type is set up as a discriminant union. So, we need a typeguard
   * here to destructure it properly.
   */ const done = 'done' in props ? props.done : undefined;
    const next = 'next' in props ? props.next : undefined;
    const updateRef = (0, $euxye.useRef)(()=>new Promise(()=>undefined));
    const ref = (0, $euxye.useRef)(null);
    const { heading: heading, popoverContent: popoverContent, card: card, primaryAction: primaryAction, secondaryAction: secondaryAction } = (0, $euxye.useContext)((0, $2voEL.SpotlightContext));
    const focusWithin = (0, $farwH.useFocusWithin)(popoverContent.ref);
    (0, $euxye.useEffect)(()=>{
        popoverContent.setRef(ref);
    }, [
        ref,
        popoverContent
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!done && !next) return;
        if (done) {
            primaryAction.setAction(done);
            return;
        } else if (next) {
            primaryAction.setAction(next);
            return;
        }
    }, [
        done,
        next,
        primaryAction
    ]);
    (0, $euxye.useEffect)(()=>{
        popoverContent.setDismiss(dismiss);
    }, [
        dismiss,
        popoverContent
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!back) return;
        secondaryAction.setAction(back);
    }, [
        back,
        secondaryAction
    ]);
    (0, $euxye.useLayoutEffect)(()=>{
        card.setPlacement(placement);
        if (motion) card.setMotion(()=>motion);
    }, [
        placement,
        card,
        motion
    ]);
    (0, $euxye.useEffect)(()=>{
        if (updateRef.current) popoverContent.setUpdate(()=>updateRef.current);
    }, [
        popoverContent
    ]);
    (0, $cIr5V.useOnEscape)((event)=>{
        if (!focusWithin) return;
        popoverContent.dismiss.current(event);
    });
    (0, $8Sq8O.useOnClickOutside)((event)=>{
        if (!shouldDismissOnClickOutside) return;
        popoverContent.dismiss.current(event);
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1DTca.Popper), {
        offset: offset,
        strategy: strategy,
        placement: $4f9258c947cfd475$var$popperPlacementMap[placement],
        children: ({ ref: localRef, style: style, update: update })=>{
            if (!isVisible && !(0, $iqfTZ.fg)('platform-dst-motion-uplift-spotlight')) return;
            updateRef.current = update;
            return (0, $iqfTZ.fg)('platform-dst-motion-uplift-spotlight') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ld31E.ConditionalExitingPersistence), {
                children: isVisible && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    role: "dialog",
                    "data-testid": testId,
                    "aria-labelledby": heading.id,
                    ref: (0, $ljVHR.default)([
                        ref,
                        localRef
                    ]),
                    style: style,
                    className: (0, $4jQY2.default)([
                        $4f9258c947cfd475$var$styles.root
                    ]),
                    children: children
                })
            }) : /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                role: "dialog",
                "data-testid": testId,
                "aria-labelledby": heading.id,
                ref: (0, $ljVHR.default)([
                    ref,
                    localRef
                ]),
                style: style,
                className: (0, $4jQY2.default)([
                    $4f9258c947cfd475$var$styles.root
                ]),
                children: children
            });
        }
    });
};
$4f9258c947cfd475$export$d7e1f420b25549ff.displayName = "PopoverContent";

});
parcelRegister("2voEL", function(module, exports) {
$parcel$export(module.exports, "SpotlightContext", () => $e6f1545db91299f3$export$7b5aa0f5b37a336d);
$parcel$export(module.exports, "SpotlightContextProvider", () => $e6f1545db91299f3$export$ad26233dae620a42);
/* context.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
const $e6f1545db91299f3$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $euxye.createContext)({
    card: {
        ref: null,
        setRef: ()=>undefined,
        placement: 'bottom-end',
        setPlacement: ()=>undefined,
        motion: undefined,
        setMotion: ()=>undefined
    },
    heading: {
        id: '',
        setId: ()=>undefined
    },
    popoverContent: {
        ref: undefined,
        setRef: ()=>undefined,
        positionArea: undefined,
        setPositionArea: ()=>undefined,
        update: ()=>new Promise(()=>null),
        setUpdate: ()=>new Promise(()=>null),
        dismiss: {
            current: ()=>undefined
        },
        setDismiss: ()=>undefined
    },
    target: {
        ref: {
            current: null
        },
        setRef: ()=>undefined
    },
    primaryAction: {
        action: {
            current: ()=>undefined
        },
        setAction: ()=>undefined
    },
    secondaryAction: {
        action: {
            current: ()=>undefined
        },
        setAction: ()=>undefined
    }
});
const $e6f1545db91299f3$export$ad26233dae620a42 = ({ children: children, targetRef: targetRef })=>{
    const id = (0, $euxye.useId)();
    const defaultTargetRef = (0, $euxye.useRef)(null);
    const [motion, setMotion] = (0, $euxye.useState)();
    const [placement, setPlacement] = (0, $euxye.useState)('bottom-end');
    const [headingId, setHeadingId] = (0, $euxye.useState)(`${id}-heading`);
    const [update, setUpdate] = (0, $euxye.useState)(()=>async ()=>undefined);
    const [popoverRef, setPopoverRef] = (0, $euxye.useState)();
    const [positionArea, setPositionArea] = (0, $euxye.useState)();
    const [cardRef, setCardRef] = (0, $euxye.useState)(null);
    const [internalTargetRef, setInternalTargetRef] = (0, $euxye.useState)(defaultTargetRef);
    // `targetRef` (the prop) takes precedence when provided. Its identity is
    // allowed to change over time; downstream consumers that depend on
    // `target.ref` identity (e.g. `useAnchoredPopover`'s effect deps) will
    // re-run accordingly.
    const effectiveTargetRef = targetRef ?? internalTargetRef;
    const dismissRef = (0, $euxye.useRef)(()=>undefined);
    const setDismiss = (dismissFn)=>{
        dismissRef.current = dismissFn;
    };
    const secondaryActionRef = (0, $euxye.useRef)(()=>undefined);
    const setSecondaryAction = (actionFn)=>{
        secondaryActionRef.current = actionFn;
    };
    const primaryActionRef = (0, $euxye.useRef)(()=>undefined);
    const setPrimaryAction = (actionFn)=>{
        primaryActionRef.current = actionFn;
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)($e6f1545db91299f3$export$7b5aa0f5b37a336d.Provider, {
        value: {
            card: {
                ref: cardRef,
                setRef: setCardRef,
                placement: placement,
                setPlacement: setPlacement,
                motion: motion,
                setMotion: setMotion
            },
            heading: {
                id: headingId,
                setId: setHeadingId
            },
            popoverContent: {
                ref: popoverRef,
                setRef: setPopoverRef,
                positionArea: positionArea,
                setPositionArea: setPositionArea,
                update: update,
                setUpdate: setUpdate,
                dismiss: dismissRef,
                setDismiss: setDismiss
            },
            target: {
                ref: effectiveTargetRef,
                setRef: setInternalTargetRef
            },
            primaryAction: {
                action: primaryActionRef,
                setAction: setPrimaryAction
            },
            secondaryAction: {
                action: secondaryActionRef,
                setAction: setSecondaryAction
            }
        },
        children: children
    });
};
$e6f1545db91299f3$export$ad26233dae620a42.displayName = "SpotlightContextProvider";

});

parcelRegister("farwH", function(module, exports) {
$parcel$export(module.exports, "useFocusWithin", () => $f3b906645f850304$export$420e68273165f4ec);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $eIbOZ = parcelRequire("eIbOZ");
const $f3b906645f850304$export$420e68273165f4ec = (ref)=>{
    const [active, setActive] = (0, $euxye.useState)(null);
    const updateFocusedElement = (0, $euxye.useCallback)(()=>{
        const doc = (0, $eIbOZ.getDocument)();
        const activeElement = doc?.activeElement || null;
        if (!ref || !ref.current) {
            setActive(null);
            return;
        }
        if (!activeElement) {
            setActive(null);
            return;
        }
        // Check if the focused element is within the ref element
        if (!ref.current.contains(activeElement)) {
            setActive(null);
            return;
        }
        setActive(activeElement);
    }, [
        ref
    ]);
    (0, $euxye.useEffect)(()=>{
        const doc = (0, $eIbOZ.getDocument)();
        if (!doc) return;
        updateFocusedElement();
        const unbindFocusIn = (0, $glbdM.bind)(doc, {
            type: 'focusin',
            listener: updateFocusedElement
        });
        return ()=>{
            unbindFocusIn();
        };
    }, [
        updateFocusedElement
    ]);
    return active;
};

});

parcelRegister("8Sq8O", function(module, exports) {
$parcel$export(module.exports, "useOnClickOutside", () => $a8350df63c45d5c6$export$9afc64c180e82dc4);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $eIbOZ = parcelRequire("eIbOZ");

var $2voEL = parcelRequire("2voEL");
const $a8350df63c45d5c6$export$9afc64c180e82dc4 = (onClickOutside)=>{
    const { card: card } = (0, $euxye.useContext)((0, $2voEL.SpotlightContext));
    const ref = card.ref;
    (0, $euxye.useEffect)(()=>{
        const doc = (0, $eIbOZ.getDocument)();
        if (!doc) return;
        const unbindMouseUp = (0, $glbdM.bind)(doc, {
            type: 'mouseup',
            listener: (event)=>{
                if (!ref || !ref.current) return;
                const target = event.target instanceof Node ? event.target : null;
                if (ref.current.contains(target)) return;
                onClickOutside(event);
            }
        });
        return ()=>{
            unbindMouseUp();
        };
    }, [
        onClickOutside,
        ref
    ]);
};

});

parcelRegister("cIr5V", function(module, exports) {
$parcel$export(module.exports, "useOnEscape", () => $4a28b9b91aeec76c$export$795d56022f0285ed);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $eIbOZ = parcelRequire("eIbOZ");
const $4a28b9b91aeec76c$var$onKeyDown = (event, { onEscape: onEscape })=>{
    switch(event.key){
        case 'Escape':
            onEscape();
            break;
        default:
            break;
    }
};
const $4a28b9b91aeec76c$export$795d56022f0285ed = (onEscape)=>{
    (0, $euxye.useEffect)(()=>{
        const doc = (0, $eIbOZ.getDocument)();
        if (!doc) return;
        const unbindFocusIn = (0, $glbdM.bind)(doc, {
            type: 'keydown',
            listener: (event)=>$4a28b9b91aeec76c$var$onKeyDown(event, {
                    onEscape: ()=>onEscape(event)
                })
        });
        return ()=>{
            unbindFocusIn();
        };
    }, [
        onEscape
    ]);
};

});

parcelRegister("ld31E", function(module, exports) {
$parcel$export(module.exports, "ConditionalExitingPersistence", () => $d06804724a0b5e58$export$4c013c06aa0aee51);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $8L2z6 = parcelRequire("8L2z6");

var $2voEL = parcelRequire("2voEL");
const $d06804724a0b5e58$export$4c013c06aa0aee51 = ({ children: children })=>{
    const { card: card } = (0, $euxye.useContext)((0, $2voEL.SpotlightContext));
    if (card.motion) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
        children: children
    });
    return children;
};
$d06804724a0b5e58$export$4c013c06aa0aee51.displayName = "ConditionalExitingPersistence";

});


parcelRegister("7TTTr", function(module, exports) {
$parcel$export(module.exports, "PopoverContent", () => $4e314ce86c506405$export$d7e1f420b25549ff);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $p9mZs = parcelRequire("p9mZs");

var $1KSfL = parcelRequire("1KSfL");

var $Yce2Z = parcelRequire("Yce2Z");

var $4uAo9 = parcelRequire("4uAo9");

var $fewJ0 = parcelRequire("fewJ0");

var $2voEL = parcelRequire("2voEL");

var $faUqM = parcelRequire("faUqM");

var $i8ses = parcelRequire("i8ses");
const $4e314ce86c506405$var$noopUpdate = ()=>Promise.resolve();
const $4e314ce86c506405$var$DefaultMotion = ({ children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $p9mZs.default), {
        enteringAnimation: "var(--ds-spotlight-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
        exitingAnimation: "var(--ds-spotlight-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
        children: children
    });
$4e314ce86c506405$var$DefaultMotion.displayName = "DefaultMotion";
const $4e314ce86c506405$export$d7e1f420b25549ff = (props)=>{
    /**
   * This composes the low-level `@atlaskit/top-layer` `Popover` primitive directly
   * (rather than `@atlaskit/popup` or a higher-level wrapper) for two reasons:
   *
   * 1. Spotlight has bespoke positioning, dismiss, and motion requirements that
   *    are coupled to the surrounding `SpotlightContext` (heading id, card
   *    placement, primary/secondary actions, etc.). Building on the primitive
   *    keeps that wiring local to spotlight without leaking into a shared popup.
   * 2. Spotlight's public API exposes a `dismiss(event)` callback that takes a
   *    `KeyboardEvent` / `MouseEvent`, while the top-layer primitive surfaces a
   *    structured `{ reason }`. Bridging that contract here (via
   *    `createPopoverCloseEvent`) preserves backwards compatibility for existing
   *    consumers as we migrate behind the `platform-dst-top-layer-spotlight` gate.
   */ const { children: children, placement: placement, motion: motion = $4e314ce86c506405$var$DefaultMotion, isVisible: isVisible = true, shouldDismissOnClickOutside: shouldDismissOnClickOutside = true, dismiss: dismiss, back: back, testId: testId, offset: offset } = props;
    const done = 'done' in props ? props.done : undefined;
    const next = 'next' in props ? props.next : undefined;
    const popoverRef = (0, $euxye.useRef)(null);
    const { heading: heading, popoverContent: popoverContent, card: card, primaryAction: primaryAction, secondaryAction: secondaryAction, target: target } = (0, $euxye.useContext)((0, $2voEL.SpotlightContext));
    (0, $4uAo9.useAnchoredPopover)({
        anchorRef: target.ref,
        popoverRef: popoverRef,
        placement: (0, $i8ses.getPlacementWithOffset)({
            placement: placement,
            offset: offset
        }),
        isOpen: isVisible
    });
    (0, $fewJ0.useSimpleLightDismiss)({
        popoverRef: popoverRef,
        isOpen: isVisible,
        onClose: ({ reason: reason })=>{
            if (reason === 'light-dismiss' && !shouldDismissOnClickOutside) return;
            // `createPopoverCloseEvent` is typed as `KeyboardEvent | MouseEvent | Event`
            // for forward-compatibility, but only `escape` / `light-dismiss` are
            // possible here, so the result is always a Keyboard/MouseEvent.
            dismiss((0, $1KSfL.createPopoverCloseEvent)({
                reason: reason
            }));
        }
    });
    (0, $euxye.useEffect)(()=>{
        popoverContent.setRef(popoverRef);
        popoverContent.setUpdate(()=>$4e314ce86c506405$var$noopUpdate);
    }, [
        popoverContent
    ]);
    const positionArea = (0, $faUqM.usePositionArea)(popoverRef);
    (0, $euxye.useEffect)(()=>{
        popoverContent.setPositionArea(positionArea);
    }, [
        popoverContent,
        positionArea
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!done && !next) return;
        if (done) {
            primaryAction.setAction(done);
            return;
        } else if (next) {
            primaryAction.setAction(next);
            return;
        }
    }, [
        done,
        next,
        primaryAction
    ]);
    (0, $euxye.useEffect)(()=>{
        popoverContent.setDismiss(dismiss);
    }, [
        dismiss,
        popoverContent
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!back) return;
        secondaryAction.setAction(back);
    }, [
        back,
        secondaryAction
    ]);
    (0, $euxye.useLayoutEffect)(()=>{
        card.setPlacement(placement);
        if (motion) card.setMotion(()=>motion);
    }, [
        placement,
        card,
        motion
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $Yce2Z.Popover), {
        ref: popoverRef,
        isOpen: isVisible,
        mode: "manual",
        role: "dialog",
        labelledBy: heading.id,
        testId: testId,
        children: children
    });
};
$4e314ce86c506405$export$d7e1f420b25549ff.displayName = "PopoverContent";

});
parcelRegister("fewJ0", function(module, exports) {
$parcel$export(module.exports, "useSimpleLightDismiss", () => $5060daa12289d0ae$export$a1840020a453c833);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");
function $5060daa12289d0ae$export$a1840020a453c833({ popoverRef: popoverRef, additionalInsideElementRefs: additionalInsideElementRefs, isOpen: isOpen, onClose: onClose }) {
    // Keep a stable ref to onClose so the effect does not re-bind on every render.
    const onCloseRef = (0, $euxye.useRef)(onClose);
    onCloseRef.current = onClose;
    (0, $euxye.useEffect)(()=>{
        if (!isOpen) return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- binding to document for light dismiss
        const unbindEscape = (0, $glbdM.bind)(document, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key !== 'Escape' || event.defaultPrevented) return;
                // Preserve JavaScript bubbling while preventing a native/manual
                // popover ancestor from also handling this Escape key.
                event.preventDefault();
                onCloseRef.current({
                    reason: 'escape'
                });
            }
        });
        // Listen for click-outside in the **capture** phase.
        //
        // The click that opened the popover propagates in bubble phase
        // (trigger onClick → setIsOpen(true) → React render → useEffect).
        // By the time this effect runs, the opening click has finished
        // bubbling. A capture-phase listener added now cannot retroactively
        // fire for that event - it only fires for *future* clicks.
        //
        // This avoids the need for timestamp guards or deferred binding.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- binding to document for light dismiss
        const unbindClickOutside = (0, $glbdM.bind)(document, {
            type: 'click',
            listener: (event)=>{
                const element = popoverRef.current;
                const target = event.target;
                if (!element || !(target instanceof Node)) return;
                // Clicks inside the popover or its additional inside elements do not dismiss it.
                if (element.contains(target) || additionalInsideElementRefs?.some((insideElementRef)=>insideElementRef.current?.contains(target))) return;
                onCloseRef.current({
                    reason: 'light-dismiss'
                });
            },
            options: {
                capture: true
            }
        });
        return ()=>{
            unbindEscape();
            unbindClickOutside();
        };
    }, [
        additionalInsideElementRefs,
        isOpen,
        popoverRef
    ]);
}

});

parcelRegister("faUqM", function(module, exports) {
$parcel$export(module.exports, "usePositionArea", () => $fb33e3e771ea4af0$export$c25d226a9f6a64fa);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");
const $fb33e3e771ea4af0$export$c25d226a9f6a64fa = (ref)=>{
    const [positionArea, setPositionArea] = (0, $euxye.useState)(undefined);
    (0, $euxye.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const readPositionArea = ()=>{
            try {
                return el.computedStyleMap().get('position-area')?.toString();
            } catch  {
                // Some old browsers do not support computedStyleMap, so fall back to getPropertyValue
                return window.getComputedStyle(el).getPropertyValue('position-area').trim();
            }
        };
        const read = ()=>{
            const positionArea = readPositionArea();
            setPositionArea(positionArea);
        };
        read();
        /**
		 * requestAnimationFrame ensures that initial renders are in a different position
		 * to the supplied prop value (e.g. the viewport is too small so the position is
		 * recalculated) are rendered correctly.
		 */ const rafId = window.requestAnimationFrame(read);
        // Check if the viewport resizes
        const unbindResize = (0, $glbdM.bind)(window, {
            type: 'resize',
            listener: read,
            options: {
                passive: true
            }
        });
        // Check if the viewport scrolls
        const unbindScroll = (0, $glbdM.bind)(window, {
            type: 'scroll',
            listener: read,
            options: {
                passive: true,
                capture: true
            }
        });
        return ()=>{
            window.cancelAnimationFrame(rafId);
            unbindResize();
            unbindScroll();
        };
    }, [
        ref
    ]);
    return positionArea;
};

});

parcelRegister("i8ses", function(module, exports) {
$parcel$export(module.exports, "getPlacementWithOffset", () => $ad621f2c0d5a66cb$export$ca1bb198c4ca0115);

var $2riQV = parcelRequire("2riQV");
const $ad621f2c0d5a66cb$var$DEFAULT_GAP = "var(--ds-space-050, 4px)";
function $ad621f2c0d5a66cb$var$normalizeOffsetMember({ value: value }) {
    return value ?? 0;
}
function $ad621f2c0d5a66cb$var$addCssLength({ base: base, delta: delta }) {
    if (delta === 0) return base;
    if (typeof base === 'number') return base + delta;
    const operator = delta > 0 ? '+' : '-';
    return `calc(${base} ${operator} ${Math.abs(delta)}px)`;
}
function $ad621f2c0d5a66cb$var$toSignedCrossAxisShiftValue({ crossAxisShift: crossAxisShift }) {
    const baseValue = crossAxisShift.value ?? 0;
    if (crossAxisShift.direction === 'forwards') return baseValue;
    if (typeof baseValue === 'number') return -baseValue;
    return `calc(-1 * ${baseValue})`;
}
function $ad621f2c0d5a66cb$var$getCrossAxisShiftWithOffset({ baseCrossAxisShift: baseCrossAxisShift, along: along }) {
    if (!baseCrossAxisShift) {
        if (along === 0) return undefined;
        return {
            value: along,
            direction: 'forwards'
        };
    }
    if (along === 0) return baseCrossAxisShift;
    // Collapse sign into the CSS length so additive composition works even
    // when the existing shift is already expressed as a `calc(...)` string.
    return {
        value: $ad621f2c0d5a66cb$var$addCssLength({
            base: $ad621f2c0d5a66cb$var$toSignedCrossAxisShiftValue({
                crossAxisShift: baseCrossAxisShift
            }),
            delta: along
        }),
        direction: 'forwards'
    };
}
function $ad621f2c0d5a66cb$export$ca1bb198c4ca0115({ placement: placement, offset: offset }) {
    const basePlacement = (0, $2riQV.placementMap)[placement];
    if (!offset) return basePlacement;
    const [alongRaw, awayRaw] = offset;
    const along = $ad621f2c0d5a66cb$var$normalizeOffsetMember({
        value: alongRaw
    });
    const away = $ad621f2c0d5a66cb$var$normalizeOffsetMember({
        value: awayRaw
    });
    if (along === 0 && away === 0) return basePlacement;
    const gap = $ad621f2c0d5a66cb$var$addCssLength({
        base: basePlacement.offset?.gap ?? $ad621f2c0d5a66cb$var$DEFAULT_GAP,
        delta: away
    });
    const crossAxisShift = $ad621f2c0d5a66cb$var$getCrossAxisShiftWithOffset({
        baseCrossAxisShift: basePlacement.offset?.crossAxisShift,
        along: along
    });
    return {
        ...basePlacement,
        offset: {
            ...basePlacement.offset,
            gap: gap,
            ...crossAxisShift ? {
                crossAxisShift: crossAxisShift
            } : {}
        }
    };
}

});
parcelRegister("2riQV", function(module, exports) {
$parcel$export(module.exports, "placementMap", () => $15c7d912e9db629d$export$168f55451c1c934);
const $15c7d912e9db629d$var$GAP = "var(--ds-space-050, 4px)";
/**
 * Cross-axis shift toward target centre on block-axis placements (CSS anchor path).
 */ const $15c7d912e9db629d$var$INLINE_TARGET_CENTER_SHIFT = 'calc(anchor-size(width) / 2 - 28px)';
/**
 * Cross-axis shift toward target centre on inline-axis placements (CSS anchor path).
 */ const $15c7d912e9db629d$var$BLOCK_TARGET_CENTER_SHIFT = 'calc(anchor-size(height) / 2 - 22px)';
const $15c7d912e9db629d$export$168f55451c1c934 = {
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'end',
        offset: {
            gap: $15c7d912e9db629d$var$GAP,
            crossAxisShift: {
                value: $15c7d912e9db629d$var$INLINE_TARGET_CENTER_SHIFT,
                direction: 'backwards'
            }
        }
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center',
        offset: {
            gap: $15c7d912e9db629d$var$GAP
        }
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'start',
        offset: {
            gap: $15c7d912e9db629d$var$GAP,
            crossAxisShift: {
                value: $15c7d912e9db629d$var$INLINE_TARGET_CENTER_SHIFT,
                direction: 'forwards'
            }
        }
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'end',
        offset: {
            gap: $15c7d912e9db629d$var$GAP,
            crossAxisShift: {
                value: $15c7d912e9db629d$var$INLINE_TARGET_CENTER_SHIFT,
                direction: 'backwards'
            }
        }
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center',
        offset: {
            gap: $15c7d912e9db629d$var$GAP
        }
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'start',
        offset: {
            gap: $15c7d912e9db629d$var$GAP,
            crossAxisShift: {
                value: $15c7d912e9db629d$var$INLINE_TARGET_CENTER_SHIFT,
                direction: 'forwards'
            }
        }
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'end',
        offset: {
            gap: $15c7d912e9db629d$var$GAP,
            crossAxisShift: {
                value: $15c7d912e9db629d$var$BLOCK_TARGET_CENTER_SHIFT,
                direction: 'backwards'
            }
        }
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'start',
        offset: {
            gap: $15c7d912e9db629d$var$GAP,
            crossAxisShift: {
                value: `calc(${$15c7d912e9db629d$var$BLOCK_TARGET_CENTER_SHIFT} - 4px)`,
                direction: 'forwards'
            }
        }
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'end',
        offset: {
            gap: $15c7d912e9db629d$var$GAP,
            crossAxisShift: {
                value: $15c7d912e9db629d$var$BLOCK_TARGET_CENTER_SHIFT,
                direction: 'backwards'
            }
        }
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'start',
        offset: {
            gap: $15c7d912e9db629d$var$GAP,
            crossAxisShift: {
                value: `calc(${$15c7d912e9db629d$var$BLOCK_TARGET_CENTER_SHIFT} - 4px)`,
                direction: 'forwards'
            }
        }
    }
};

});




parcelRegister("4QBVk", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $5a268147587f54e0$export$129a32eedafa97c5);
/* popup.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $gUxVT = parcelRequire("gUxVT");

var $fLi8o = parcelRequire("fLi8o");

var $9fOPQ = parcelRequire("9fOPQ");

var $8L2z6 = parcelRequire("8L2z6");

var $iqfTZ = parcelRequire("iqfTZ");

var $aFVSm = parcelRequire("aFVSm");

var $hD6gn = parcelRequire("hD6gn");

var $5PG2M = parcelRequire("5PG2M");

var $ihEDU = parcelRequire("ihEDU");

var $k4Tvn = parcelRequire("k4Tvn");

var $bkJxH = parcelRequire("bkJxH");

var $9Va4w = parcelRequire("9Va4w");

var $hfmwh = parcelRequire("hfmwh");

var $atWeo = parcelRequire("atWeo");
const $5a268147587f54e0$var$defaultLayer = 400;
const $5a268147587f54e0$var$wrapperStyles = {
    root: "_1mT5xdRAKS"
};
const $5a268147587f54e0$var$PopupLegacy = (props)=>{
    const { xcss: xcss, appearance: inAppearance = 'default', isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, zIndex: zIndex = $5a268147587f54e0$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: inShouldRenderToParent = false, shouldFitContainer: shouldFitContainer = false, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport } = props;
    const [triggerRef, setTriggerRef] = (0, $euxye.useState)(null);
    const getMergedTriggerRef = (0, $hfmwh.useGetMemoizedMergedTriggerRef)();
    const getMergedTriggerRefNew = (0, $atWeo.useGetMemoizedMergedTriggerRefNew)();
    const generatedId = (0, $gUxVT.useId)();
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $9Va4w.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const id = providedId || generatedId;
    const handleOpenLayerObserverCloseSignal = (0, $euxye.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $9fOPQ.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    // `xcss` is part of Popup's public API and is forwarded as-is to
    // the internal PopperWrapper, which rebuilds the inner styles. We
    // re-bind via a property accessor on a stable object so the
    // design-system css-prop lint rule's identifier-shape check no
    // longer flags it (avoiding a ratcheted lint suppression here).
    const xcssPassthrough = {
        value: xcss
    };
    const renderPopperWrapper = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fLi8o.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $k4Tvn.default), {
            xcss: xcssPassthrough.value,
            appearance: appearance,
            content: content,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: PopupContainer,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
            shouldFitContainer: shouldFitContainer,
            shouldDisableFocusLock: shouldDisableFocusLock,
            shouldReturnFocus: shouldReturnFocus,
            triggerRef: triggerRef,
            zIndex: zIndex,
            strategy: shouldFitContainer ? 'absolute' : strategy,
            role: role,
            label: label,
            titleId: titleId,
            modifiers: modifiers,
            shouldFitViewport: shouldFitViewport
        })
    });
    const popupContent = /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $aFVSm.Manager), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hD6gn.Reference), {
                children: ({ ref: ref })=>{
                    return trigger({
                        ref: !(0, $iqfTZ.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
                        'aria-controls': isOpen ? id : undefined,
                        'aria-expanded': isOpen,
                        'aria-haspopup': role === 'dialog' && (0, $iqfTZ.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
                    });
                }
            }),
            !(0, $iqfTZ.fg)('platform-dst-motion-uplift-popup') && isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5PG2M.default), {
                zIndex: zIndex,
                children: renderPopperWrapper
            })),
            (0, $iqfTZ.fg)('platform-dst-motion-uplift-popup') && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
                appear: true,
                children: isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5PG2M.default), {
                    zIndex: zIndex,
                    children: renderPopperWrapper
                }))
            })
        ]
    });
    if (shouldFitContainer) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: $5a268147587f54e0$var$wrapperStyles.root,
        children: popupContent
    });
    return popupContent;
};
$5a268147587f54e0$var$PopupLegacy.displayName = "PopupLegacy";
const $5a268147587f54e0$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    // Choose the rendering implementation at the component boundary rather than
    // gating hooks inside a single component. Each implementation owns its own
    // hooks unconditionally, so a runtime feature-flag change swaps component
    // types (a clean remount) instead of changing the hook order of a mounted
    // component.
    if ((0, $iqfTZ.fg)('platform-dst-top-layer')) // Pass the original props object to preserve the discriminated union
    // (shouldFitContainer: true vs false) that is lost after destructuring.
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bkJxH.PopupTopLayer), {
        ...props
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($5a268147587f54e0$var$PopupLegacy, {
        ...props
    });
});

});
parcelRegister("k4Tvn", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b0e97ec8528b0e7$export$2e2bcd8739ae039);
/* popper-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $fe5lW = parcelRequire("fe5lW");

var $p9mZs = parcelRequire("p9mZs");

var $iqfTZ = parcelRequire("iqfTZ");

var $1DTca = parcelRequire("1DTca");

var $hlEf2 = parcelRequire("hlEf2");

var $gUF2K = parcelRequire("gUF2K");

var $haO39 = parcelRequire("haO39");
const $6b0e97ec8528b0e7$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $6b0e97ec8528b0e7$var$fullWidthStyles = null;
const $6b0e97ec8528b0e7$var$wrapperStyles = {
    root: "_0bjKvD8fU6 _3iDTPbvLZJ _24h04i2Njc _42Yu6B3fRC _0KLXruoI2d _2OUyjtGk8v _1UtDYzy7kJ _45TjwHoI2d _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
    fullWidth: "_39xV02N91d",
    motion: "_0NUa3rOLYo _3iDTPbQ4SZ"
};
const $6b0e97ec8528b0e7$var$scrollableStyles = null;
const $6b0e97ec8528b0e7$var$blanketStyles = null;
const $6b0e97ec8528b0e7$var$modalStyles = null;
const $6b0e97ec8528b0e7$var$focusRingStyles = {
    root: "_1ubuxonXvL _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _3e11vU6wH8 _0hSAgbHZdu"
};
const $6b0e97ec8528b0e7$var$placementMap = {
    top: {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-start': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-end': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    bottom: {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-start': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-end': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    left: {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-start': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-end': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    right: {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-start': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-end': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }
};
const $6b0e97ec8528b0e7$var$DefaultPopupComponent = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, children: children, appearance: appearance, className: className, isReferenceHidden: _isReferenceHidden, shouldFitViewport: shouldFitViewport, ...htmlAttributes } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $4jQY2.default)([
            $6b0e97ec8528b0e7$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_0Tuepk1Y8M _0NUa3rEtrx _1mT5xdy1CL _2I62gz1Y8M",
            (!shouldRenderToParent || shouldFitViewport) && "_4bt5LAIZbP _2WAcuGIZbP",
            shouldFitContainer && "_39xV02N91d",
            className
        ]),
        ...htmlAttributes,
        ref: !(0, $iqfTZ.fg)('platform-dst-motion-uplift-popup') ? ref : undefined,
        children: children
    });
});
function $6b0e97ec8528b0e7$var$PopperWrapper({ xcss: xcss, isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', popupComponent: PopupContainer = $6b0e97ec8528b0e7$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport, appearance: appearance = 'default', zIndex: zIndex }) {
    const [popupRef, setPopupRef] = (0, $euxye.useState)(null);
    const [initialFocusRef, setInitialFocusRef] = (0, $euxye.useState)(null); // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    const shouldDisableFocusTrap = role !== 'dialog';
    (0, $haO39.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $gUF2K.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    const { currentLevel: currentLevel } = (0, $fe5lW.useLayering)();
    const mergedModifiers = (0, $euxye.useMemo)(()=>[
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            },
            ...modifiers || []
        ], [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1DTca.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport,
        children: ({ ref: ref, style: style, placement: placement, update: update, isReferenceHidden: isReferenceHidden })=>{
            const popupContainer = /*#__PURE__*/ (0, $e79Pd.jsx)(PopupContainer // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $4jQY2.default)([
                    xcss,
                    // @ts-expect-error: `ax` is not typed correctly
                    !initialFocusRef && (0, $iqfTZ.fg)('platform-design-system-apply-popup-wrapper-focus') && $6b0e97ec8528b0e7$var$focusRingStyles.root
                ]),
                appearance: appearance,
                id: id,
                "data-ds--level": currentLevel,
                "data-placement": placement,
                "data-testid": testId,
                role: role,
                "aria-label": label,
                "aria-labelledby": titleId,
                ref: !(0, $iqfTZ.fg)('platform-dst-motion-uplift-popup') ? (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                } : undefined,
                style: (0, $iqfTZ.fg)('platform-dst-motion-uplift-popup') || appearance === 'UNSAFE_modal-below-sm' ? {} : style,
                // first on the browser address bar when using keyboard
                tabIndex: autoFocus ? 0 : undefined,
                shouldRenderToParent: shouldRenderToParent,
                shouldFitContainer: shouldFitContainer,
                shouldFitViewport: shouldFitViewport,
                isReferenceHidden: isReferenceHidden,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hlEf2.RepositionOnUpdate), {
                    update: update,
                    children: content({
                        update: update,
                        isOpen: isOpen,
                        onClose: onClose,
                        setInitialFocusRef: setInitialFocusRef
                    })
                })
            });
            const isAutoPlacement = placement === 'auto' || placement === 'auto-start' || placement === 'auto-end';
            const container = /*#__PURE__*/ (0, $e79Pd.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            , {
                style: {
                    ...style,
                    zIndex: zIndex
                },
                // first on the browser address bar when using keyboard
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                "data-testid": `${testId}--container`,
                className: (0, $4jQY2.default)([
                    shouldFitContainer && $6b0e97ec8528b0e7$var$wrapperStyles.fullWidth
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $p9mZs.default), {
                    enteringAnimation: !isAutoPlacement ? $6b0e97ec8528b0e7$var$placementMap[placement].enter : undefined,
                    exitingAnimation: !isAutoPlacement ? $6b0e97ec8528b0e7$var$placementMap[placement].exit : undefined,
                    xcss: $6b0e97ec8528b0e7$var$wrapperStyles.motion,
                    children: popupContainer
                })
            });
            return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
                children: [
                    (0, $iqfTZ.fg)('platform-dst-motion-uplift-popup') ? container : popupContainer,
                    appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        className: (0, $4jQY2.default)([
                            "_49OCfRdnbC _1mT5xdy1CL _0KLXruA5lS"
                        ])
                    })
                ]
            });
        }
    });
}
$6b0e97ec8528b0e7$var$PopperWrapper.displayName = "PopperWrapper";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6b0e97ec8528b0e7$export$2e2bcd8739ae039 = $6b0e97ec8528b0e7$var$PopperWrapper;

});
parcelRegister("hlEf2", function(module, exports) {
$parcel$export(module.exports, "RepositionOnUpdate", () => $c7c055d533443653$export$51eddd7655ca235a);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
const $c7c055d533443653$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $euxye.useRef)(true);
    (0, $euxye.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update.
        // Guard against `update` being undefined: on Safari the Popper instance may
        // not be fully initialised when this layout effect fires, in which case the
        // render-prop `update` is undefined and calling it throws
        // `TypeError: e.update is not a function`.
        if (typeof update === 'function') update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Fragment), {
        children: children
    });
};
$c7c055d533443653$export$51eddd7655ca235a.displayName = "RepositionOnUpdate";

});

parcelRegister("gUF2K", function(module, exports) {
$parcel$export(module.exports, "useCloseManager", () => $1ca856a5eaac5d17$export$92dae2778ae88f9d);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $2oRWW = parcelRequire("2oRWW");

var $fe5lW = parcelRequire("fe5lW");

var $iqfTZ = parcelRequire("iqfTZ");

var $gBwiw = parcelRequire("gBwiw");

var $7PJyV = parcelRequire("7PJyV");
const $1ca856a5eaac5d17$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldUseCaptureOnOutsideClick: capture, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldCloseOnTab: shouldCloseOnTab, shouldRenderToParent: shouldRenderToParent })=>{
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $fe5lW.useLayering)();
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $7PJyV.useAnimationFrame)();
    const mouseDownTarget = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        if (!isOpen || !popupRef) return 0, $2oRWW.default;
        const closePopup = (event)=>{
            if (shouldIgnoreCloseEvent?.(event) && (0, $iqfTZ.fg)('cc_blocks_changeboarding')) return;
            if (onClose) {
                let currentLevel = null;
                if (event.target instanceof HTMLElement) currentLevel = event.target.closest(`[data-ds--level]`)?.getAttribute('data-ds--level') ?? null;
                currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $iqfTZ.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(()=>{
                triggerRef?.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        const onClick = (event)=>{
            const { target: target } = event;
            const doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (target instanceof HTMLElement) {
                const layeredElement = target.closest?.(`[data-ds--level]`);
                if (layeredElement) {
                    const closeType = layeredElement.getAttribute('data-ds--close--type');
                    if (closeType === 'single' && isLayerDisabled()) // if the close type is single, we won't close other disabled layers when clicking outside
                    return;
                    const levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                    if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // Don't close this popup when the click landed inside a higher-level layer
                    // (e.g. a Drawer or Modal that portals to <body>). Such nodes are not DOM
                    // descendants of popupRef, so the contains() checks below would wrongly
                    // classify them as "outside" clicks and close the popup prematurely.
                    return;
                }
            }
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            const didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $gBwiw.isInteractiveElement)(document.activeElement) && (0, $iqfTZ.fg)('platform_dst_popup-disable-focuslock')) triggerRef?.focus();
            }
        };
        const onMouseDown = (event)=>{
            /**
			 * Tracking the target of the mouse down event.
			 * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
			 * moves the mouse outside the popup before releasing the mouse button.
			 *
			 * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
			 * so they try to cancel their click by moving their mouse away from what they had moused down on.
			 *
			 * Blanket uses the same technique.
			 */ mouseDownTarget.current = event.target;
        };
        const onKeyDown = (event)=>{
            const key = event.key;
            if ((key === 'Escape' || key === 'Esc') && (0, $iqfTZ.fg)('platform_dst_nested_escape')) {
                const eventTarget = event.target instanceof HTMLElement ? event.target : null;
                const layeredAncestor = eventTarget?.closest?.('[data-ds--level]');
                const levelStr = layeredAncestor?.getAttribute('data-ds--level');
                if (levelStr && Number(levelStr) > currentLevel) return;
            }
            if ((0, $iqfTZ.fg)('platform_dst_popup-disable-focuslock')) {
                const { shiftKey: shiftKey } = event;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(()=>{
                        const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef?.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && document.activeElement?.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(()=>{
                            const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(()=>{
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        let unbind = (0, $2oRWW.default);
        if ((0, $iqfTZ.fg)('popup-onclose-fix')) setTimeout(()=>{
            unbind = (0, $glbdM.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $glbdM.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        let unbindBlur = (0, $2oRWW.default);
        unbindBlur = (0, $glbdM.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return ()=>{
            if ((0, $iqfTZ.fg)('popup-onclose-fix')) setTimeout(()=>{
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        shouldIgnoreCloseEvent,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("gBwiw", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", () => $f9a7ed75162b8d79$export$3dee5e4542c672d9);
const $f9a7ed75162b8d79$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
const $f9a7ed75162b8d79$export$3dee5e4542c672d9 = (element)=>{
    if ($f9a7ed75162b8d79$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("7PJyV", function(module, exports) {
$parcel$export(module.exports, "useAnimationFrame", () => $008db105b51483a7$export$641fa9c94086b46e);

var $euxye = parcelRequire("euxye");
const $008db105b51483a7$export$641fa9c94086b46e = ()=>{
    const animationsRef = (0, $euxye.useRef)([]);
    const requestFrame = (0, $euxye.useCallback)((callback)=>{
        const id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    const cancelFrame = (0, $euxye.useCallback)((id)=>{
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter((frameId)=>frameId !== id);
    }, []);
    const cancelAllFrames = (0, $euxye.useCallback)(()=>{
        animationsRef.current.forEach((id)=>cancelAnimationFrame(id));
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("haO39", function(module, exports) {
$parcel$export(module.exports, "useFocusManager", () => $67bb6d64ec32acd9$export$10c5169755ce7bd7);

var $euxye = parcelRequire("euxye");

var $hsOaS = parcelRequire("hsOaS");

var $2oRWW = parcelRequire("2oRWW");

var $fe5lW = parcelRequire("fe5lW");

var $iqfTZ = parcelRequire("iqfTZ");

var $7PJyV = parcelRequire("7PJyV");
const $67bb6d64ec32acd9$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldCloseOnTab: shouldCloseOnTab, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldReturnFocus: shouldReturnFocus, shouldRenderToParent: shouldRenderToParent })=>{
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $7PJyV.useAnimationFrame)();
    const { currentLevel: currentLevel } = (0, $fe5lW.useLayering)();
    (0, $euxye.useEffect)(()=>{
        if (!popupRef || shouldCloseOnTab) return 0, $2oRWW.default;
        if (shouldDisableFocusTrap && (0, $iqfTZ.fg)('platform_dst_popup-disable-focuslock')) {
            const isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            const popups = document.querySelectorAll(`[data-ds--level="${currentLevel - 1}"]`);
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(()=>{
                    triggerRef?.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $2oRWW.default;
            }
        }
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: (0, $iqfTZ.fg)('platform_dst_nested_escape') ? false : true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($hsOaS)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(()=>{
            focusTrap.activate();
        });
        return ()=>{
            cancelAllFrames();
            focusTrap.deactivate();
            if (((0, $iqfTZ.fg)('platform-dst-popup-trigger-focus-fix') || (0, $iqfTZ.fg)('platform_dst-popup-trigger-initial-focus-ref')) && shouldReturnFocus) requestFrame(()=>{
                if (triggerRef?.isConnected && (document.activeElement === document.body || document.activeElement === document.documentElement || !document.activeElement)) triggerRef.focus();
            });
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("bkJxH", function(module, exports) {
$parcel$export(module.exports, "PopupTopLayer", () => $7276647361a9fbd2$export$e24b8cb659609dee);
/* popup-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");

var $gD1FN = parcelRequire("gD1FN");

var $gkWVj = parcelRequire("gkWVj");

var $j0Y0H = parcelRequire("j0Y0H");

var $1KSfL = parcelRequire("1KSfL");

var $Yce2Z = parcelRequire("Yce2Z");

var $4uAo9 = parcelRequire("4uAo9");

var $kUmcP = parcelRequire("kUmcP");

var $gBHoS = parcelRequire("gBHoS");

var $5CO8g = parcelRequire("5CO8g");
// Top-layer positioning is handled by CSS Anchor Positioning, not inline styles.
const $7276647361a9fbd2$var$EMPTY_STYLE = {};
const $7276647361a9fbd2$export$e24b8cb659609dee = /*#__PURE__*/ (0, $euxye.memo)(function PopupTopLayer({ xcss: xcss, isOpen: isOpen, id: providedId, offset: offsetProp, testId: testId, trigger: trigger, content: content, onClose: onClose = (0, $2oRWW.default), placement: placement = 'auto', fallbackPlacements: _fallbackPlacements, shouldFlip: _shouldFlip = true, popupComponent: PopupContainer, autoFocus: autoFocus = true, shouldFitContainer: shouldFitContainer = false, // top-layer: focus restoration is handled natively by the Popover API. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldReturnFocus: _shouldReturnFocus = true, role: role, label: label, titleId: titleId, // No-op props.
// These props are accepted for API compatibility but have no effect
// in the top-layer path. Each is documented with why it is unnecessary.
// top-layer: stacking managed by browser top layer. zIndex is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
zIndex: _zIndex, // top-layer: always renders in top layer. shouldRenderToParent is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldRenderToParent: _shouldRenderToParent, // top-layer: CSS Anchor Positioning replaces Popper strategy. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
strategy: _strategy, // top-layer: Popper.js modifiers not applicable. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
modifiers: _modifiers, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
boundary: _boundary, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
rootBoundary: _rootBoundary, // top-layer: native light dismiss replaces capture-phase click handler.
// Could add mousedown drag guard later if needed.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldUseCaptureOnOutsideClick: _shouldUseCaptureOnOutsideClick, // top-layer: focus trapping is role-based. shouldDisableFocusLock is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldDisableFocusLock: _shouldDisableFocusLock, shouldFitViewport: // top-layer: maps onto `'max-available'`, capping the popup to the space
// between the trigger and the viewport edge. `PopoverSurface` already owns
// `overflow: auto`, so the capped surface scrolls.
//
// Keep the explicit `false`: `undefined` previously reached an
// `isEnabled = true` default and silently enabled fitting for every popup
// that omitted the prop.
shouldFitViewport = false, // top-layer: appearance is accepted but UNSAFE_modal-below-sm is not yet implemented.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
appearance: _appearance }) {
    const triggerRef = (0, $euxye.useRef)(null);
    const popoverRef = (0, $euxye.useRef)(null);
    /**
   * Escape hatch for consumer-chosen initial focus target.
   *
   * The legacy `Popup` surfaced `setInitialFocusRef` on the content
   * render prop with a `Dispatch<SetStateAction<HTMLElement | null>>`
   * signature so it could be passed as a React `ref` callback. We
   * keep the same shape for API compatibility, but store the value in
   * a ref rather than component state. Flipping state on every open
   * caused a needless re-render and, more importantly, raced the
   * initial-focus effect below. The ref is read in the open-side
   * effect to override the role-based default focus chosen by
   * `useInitialFocus` inside the underlying `Popover`.
   */ const consumerInitialFocusRef = (0, $euxye.useRef)(null);
    const setInitialFocusRef = (0, $euxye.useCallback)((value)=>{
        consumerInitialFocusRef.current = typeof value === 'function' ? value(consumerInitialFocusRef.current) : value;
    }, []);
    /**
   * Override the role-based initial focus chosen by the underlying
   * `Popover` (its internal `useInitialFocus`).
   *
   * React flushes child effects before parent effects, so by the time
   * this effect runs the role-based default focus has already moved.
   * We then apply the legacy `Popup` contract:
   *
   * 1. If the consumer wired `setInitialFocusRef`, focus that element
   *    (escape hatch wins).
   * 2. Otherwise, if `autoFocus={false}`, return focus to the trigger.
   *    The `autoFocus` prop on `Popup` opts out of any initial-focus
   *    movement, even for roles like `dialog`.
   *
   * When neither applies the role-based default from the underlying
   * `Popover` stays in place.
   */ (0, $euxye.useEffect)(()=>{
        if (!isOpen) {
            /**
       * Clear the consumer-supplied focus target on close so a
       * subsequent open does not silently inherit a stale ref from
       * the previous open cycle. The next open will re-collect a
       * target only if the content render prop re-wires
       * `setInitialFocusRef`.
       */ consumerInitialFocusRef.current = null;
            return;
        }
        const consumerTarget = consumerInitialFocusRef.current;
        if (consumerTarget && consumerTarget.isConnected) {
            consumerTarget.focus();
            return;
        }
        if (!autoFocus) {
            const trigger = triggerRef.current;
            if (trigger && trigger.isConnected) trigger.focus();
        }
    }, [
        isOpen,
        autoFocus
    ]);
    const popoverId = (0, $kUmcP.usePopoverId)();
    // Placement conversion.
    // Legacy `offset` is the popper `[along, away]` tuple; `fromLegacyPlacement`
    // folds it into the new `placement.offset` shape so it travels with placement.
    const topLayerPlacement = (0, $euxye.useMemo)(()=>(0, $gkWVj.fromLegacyPlacement)({
            legacy: placement,
            offset: offsetProp
        }), [
        placement,
        offsetProp
    ]);
    (0, $4uAo9.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen,
        ...(0, $gBHoS.getPopupAxisSizes)({
            shouldFitContainer: shouldFitContainer,
            shouldFitViewport: shouldFitViewport
        })
    });
    // onClose bridge.
    // Translates top-layer's { reason: TPopoverCloseReason } into legacy
    // onClose(event, currentLevel?) by synthesizing DOM events.
    //
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    // No manual triggerRef.current?.focus() is needed.
    const handleOnClose = (0, $euxye.useCallback)(({ reason: reason })=>{
        onClose((0, $1KSfL.createPopoverCloseEvent)({
            reason: reason
        }));
    }, [
        onClose
    ]);
    // Content render-prop bridge.
    // Legacy content() receives { isOpen, update, setInitialFocusRef, onClose }.
    // update is a no-op because CSS Anchor Positioning self-updates.
    const contentProps = (0, $euxye.useMemo)(()=>({
            isOpen: isOpen,
            update: (0, $2oRWW.default),
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        }), [
        isOpen,
        onClose,
        setInitialFocusRef
    ]);
    // Role mapping.
    // Build the role/label props for Popover.
    // Roles requiring accessible names must have label or labelledBy.
    const roleProps = (0, $5CO8g.useRoleProps)({
        role: role,
        label: label,
        titleId: titleId
    });
    const resolvedPopoverId = providedId ?? popoverId;
    const ariaAttributes = (0, $gD1FN.getAriaForTrigger)({
        role: roleProps.role ?? 'dialog',
        isOpen: isOpen,
        popoverId: resolvedPopoverId
    });
    // Narrow to ForwardRefExoticComponent so JSX accepts the ref prop.
    // All popupComponent implementations use forwardRef per the PopupComponentProps contract.
    const Container = PopupContainer;
    // Map to legacy TriggerProps.
    const triggerProps = {
        ref: (node)=>{
            triggerRef.current = node;
        },
        'aria-controls': ariaAttributes['aria-controls'],
        // `aria-expanded` reflects current open state.
        'aria-expanded': ariaAttributes['aria-expanded'],
        'aria-haspopup': ariaAttributes['aria-haspopup']
    };
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            trigger(triggerProps),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $Yce2Z.Popover), {
                ref: popoverRef,
                id: resolvedPopoverId,
                ...roleProps,
                isOpen: isOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--content`,
                children: Container ? /*#__PURE__*/ (0, $e79Pd.jsx)(Container, {
                    style: $7276647361a9fbd2$var$EMPTY_STYLE,
                    id: providedId,
                    "data-placement": placement,
                    "data-testid": testId,
                    tabIndex: autoFocus ? -1 : undefined,
                    xcss: xcss,
                    // Forwarded because several in-tree containers key their own
                    // `overflow: auto` branch off it.
                    shouldFitViewport: shouldFitViewport,
                    children: content(contentProps)
                }) : // `PopoverSurface` owns `overflow: auto` and the `box-shadow` on the
                // same element, so it is the scroll container. The wrapper exists only
                // to carry the consumer's `xcss`: `PopoverSurface` exposes no
                // `className` or `xcss` by design, so `xcss` lands on a CHILD of the
                // surface. `width` works there; surface-level declarations apply one
                // level in. Same shape as `compositional/popup-content-top-layer.tsx`.
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $j0Y0H.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: xcss,
                        children: content(contentProps)
                    })
                })
            })
        ]
    });
});

});
parcelRegister("j0Y0H", function(module, exports) {
$parcel$export(module.exports, "PopoverSurface", () => $c559ff5a59df0e75$export$8b7437164e479115);
/* popover-surface.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $c559ff5a59df0e75$var$styles = {
    root: "_0bjKvDzXzM _4bt5LAIZbP _2WAcuGIZbP _0KLXruoI2d _1UtDYzy7kJ _2OUyjtGk8v"
};
function $c559ff5a59df0e75$export$8b7437164e479115({ children: children }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $c559ff5a59df0e75$var$styles.root
        ]),
        children: children
    });
}
$c559ff5a59df0e75$export$8b7437164e479115.displayName = "PopoverSurface";

});

parcelRegister("gBHoS", function(module, exports) {
$parcel$export(module.exports, "getPopupAxisSizes", () => $1e842ec6cb68caff$export$60eb6c71554f82c4);
function $1e842ec6cb68caff$export$60eb6c71554f82c4({ shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport }) {
    const blockSize = shouldFitViewport ? 'max-available' : 'content';
    if (shouldFitContainer) return {
        inlineSize: 'match-anchor',
        blockSize: blockSize
    };
    if (shouldFitViewport) return {
        inlineSize: 'max-available',
        blockSize: blockSize
    };
    return {
        inlineSize: 'content',
        blockSize: blockSize
    };
}

});

parcelRegister("5CO8g", function(module, exports) {
$parcel$export(module.exports, "useRoleProps", () => $74e77a0ee9793aa7$export$892580369e97d8b9);

var $euxye = parcelRequire("euxye");
function $74e77a0ee9793aa7$export$892580369e97d8b9({ role: role, label: label, titleId: titleId }) {
    return (0, $euxye.useMemo)(()=>{
        if (role === 'dialog' || role === 'alertdialog' || role === 'menu') {
            if (titleId) return {
                role: role,
                labelledBy: titleId
            };
            return {
                role: role,
                label: label ?? 'Popup'
            };
        }
        if (role) return {
            role: role,
            label: label
        };
        // No role supplied: preserve the legacy "no popup semantics" contract.
        return {
            role: undefined,
            label: label
        };
    }, [
        role,
        label,
        titleId
    ]);
}

});


parcelRegister("9Va4w", function(module, exports) {
$parcel$export(module.exports, "usePopupAppearance", () => $a62459f169aa58f0$export$4065aef1d79a5730);

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $h07LC = parcelRequire("h07LC");
function $a62459f169aa58f0$export$4065aef1d79a5730({ appearance: _appearance, shouldRenderToParent: _shouldRenderToParent }) {
    const canBecomeModal = _appearance === 'UNSAFE_modal-below-sm';
    /**
	 * This gate removes unnecessary state changes across the below-sm boundary
	 * The state change is only needed if the popup can become a modal - and this is maintained
	 */ const shouldUseMediaQuery = !(0, $iqfTZ.fg)('platform_dst_popup_media_query_perf_fix') || canBecomeModal;
    const mq = (0, $h07LC.UNSAFE_useMediaQuery)('below.sm', shouldUseMediaQuery ? (e)=>{
        setIsSmallViewport(!!e.matches);
    } : undefined);
    const [isSmallViewport, setIsSmallViewport] = (0, $euxye.useState)(!!mq?.matches);
    const appearance = canBecomeModal && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    const shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("h07LC", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $16465a4e5a8df5a4$export$49e55ae2c03d6045);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $h74qX = parcelRequire("h74qX");
const $16465a4e5a8df5a4$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h74qX.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h74qX.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h74qX.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h74qX.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h74qX.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h74qX.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h74qX.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h74qX.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h74qX.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h74qX.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h74qX.media).below.xl.replace('@media ', '').trim())
};
const $16465a4e5a8df5a4$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $euxye.useRef)(listener);
    (0, $euxye.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $16465a4e5a8df5a4$var$queries[queryString];
    (0, $euxye.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $glbdM.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};
$16465a4e5a8df5a4$export$49e55ae2c03d6045.displayName = "UNSAFE_useMediaQuery";

});
parcelRegister("h74qX", function(module, exports) {
$parcel$export(module.exports, "media", () => $fc988e9f1cb33e43$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $fc988e9f1cb33e43$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("hfmwh", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", () => $1117e4f2140921c3$export$7cc5c058dd769dff);

var $euxye = parcelRequire("euxye");

var $emCaV = parcelRequire("emCaV");
const $1117e4f2140921c3$export$7cc5c058dd769dff = ()=>{
    const [getMemoizedMergedTriggerRef] = (0, $euxye.useState)(()=>(0, $emCaV.default)((ref, setTriggerRef, isOpen)=>{
            return (node)=>{
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("atWeo", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", () => $891e075e296859f3$export$5d3a2de79e07b376);

var $euxye = parcelRequire("euxye");

var $emCaV = parcelRequire("emCaV");
const $891e075e296859f3$export$5d3a2de79e07b376 = ()=>{
    const [getMemoizedMergedTriggerRefNew] = (0, $euxye.useState)(()=>(0, $emCaV.default)((ref, setTriggerRef)=>{
            return (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRefNew;
};

});


parcelRegister("12j6D", function(module, exports) {
$parcel$export(module.exports, "default", () => $8546cae2972f8951$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $jdqvo = parcelRequire("jdqvo");

var $jyUW8 = parcelRequire("jyUW8");
/**
 * __Spotlight__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $8546cae2972f8951$var$Spotlight = ({ actions: actions, actionsBeforeElement: actionsBeforeElement, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth = 400, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label, pulse: pulse = true, scrollPositionBlock: scrollPositionBlock, shouldWatchTarget: shouldWatchTarget = false, target: target, targetBgColor: targetBgColor, targetNode: targetNode, targetOnClick: targetOnClick, targetRadius: targetRadius, targetReplacement: targetReplacement, testId: testId = 'spotlight', titleId: titleId, ...rest })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $jyUW8.SpotlightConsumer), {
        children: ({ opened: opened, closed: closed, targets: targets })=>{
            // use the targetNode prop or try get the target from context targets using name
            const actualTargetNode = targetNode || (typeof target === 'string' ? targets[target] : undefined);
            return actualTargetNode ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jdqvo.default), {
                ...rest,
                actions: actions,
                actionsBeforeElement: actionsBeforeElement,
                children: children,
                dialogPlacement: dialogPlacement,
                dialogWidth: dialogWidth,
                footer: footer,
                header: header,
                heading: heading,
                headingAfterElement: headingAfterElement,
                image: image,
                label: label,
                onClosed: closed,
                onOpened: opened,
                pulse: pulse,
                scrollPositionBlock: scrollPositionBlock,
                shouldWatchTarget: shouldWatchTarget,
                target: target,
                targetBgColor: targetBgColor,
                targetNode: actualTargetNode,
                targetOnClick: targetOnClick,
                targetRadius: targetRadius,
                targetReplacement: targetReplacement,
                testId: testId,
                titleId: titleId
            }) : null;
        }
    });
$8546cae2972f8951$var$Spotlight.displayName = "Spotlight";
var $8546cae2972f8951$export$2e2bcd8739ae039 = $8546cae2972f8951$var$Spotlight;

});
parcelRegister("jdqvo", function(module, exports) {
$parcel$export(module.exports, "default", () => $72906340f39a9cc8$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $kt9Lz = parcelRequire("kt9Lz");

var $jr1Vl = parcelRequire("jr1Vl");

var $6iNO1 = parcelRequire("6iNO1");

var $fLi8o = parcelRequire("fLi8o");

var $8L2z6 = parcelRequire("8L2z6");

var $eCdE8 = parcelRequire("eCdE8");

var $iqfTZ = parcelRequire("iqfTZ");

var $5PG2M = parcelRequire("5PG2M");

var $gZV2t = parcelRequire("gZV2t");

var $1X7k8 = parcelRequire("1X7k8");

var $dkJhd = parcelRequire("dkJhd");

var $aEmuS = parcelRequire("aEmuS");

var $kxDv9 = parcelRequire("kxDv9");
/**
 * __Spotlight inner__
 *
 * Renders the spotlight target clone and dialog.
 *
 * @internal
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $72906340f39a9cc8$var$SpotlightInner extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    static{
        this.defaultProps = {
            dialogWidth: 400,
            pulse: true
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.targetNode !== this.props.targetNode) (0, $6iNO1.default)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
    }
    componentDidMount() {
        (0, $6iNO1.default)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
        this.props.onOpened();
    }
    componentWillUnmount() {
        this.props.onClosed();
    }
    render() {
        const { pulse: pulse, shouldWatchTarget: shouldWatchTarget, target: target, targetNode: targetNode, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetRadius: targetRadius, testId: testId, targetReplacement: TargetReplacement } = this.props;
        const { replacementElement: replacementElement } = this.state;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kxDv9.SpotlightTransitionConsumer), {
            children: ({ isOpen: isOpen, onExited: onExited })=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $5PG2M.default), {
                    zIndex: 701,
                    children: [
                        TargetReplacement ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dkJhd.default), {
                            hasNodeResolver: !(0, $iqfTZ.fg)('platform_design_system_team_onboarding_noderesolve'),
                            innerRef: (elem)=>this.setState({
                                    replacementElement: elem
                                }),
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gZV2t.ElementBox), {
                                element: targetNode,
                                resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined,
                                children: (box)=>/*#__PURE__*/ (0, $e79Pd.jsx)(TargetReplacement, {
                                        "data-testid": `${testId}--target`,
                                        ...this.getTargetNodeStyle(box)
                                    })
                            })
                        }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gZV2t.ElementBox), {
                            element: targetNode,
                            resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined,
                            children: (box)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $1X7k8.default), {
                                    shouldWatch: shouldWatchTarget,
                                    testId: `${testId}--target`,
                                    pulse: pulse,
                                    target: target,
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                    style: this.getTargetNodeStyle(box),
                                    targetBgColor: targetBgColor,
                                    targetNode: targetNode,
                                    targetOnClick: targetOnClick,
                                    targetRadius: targetRadius
                                })
                        }),
                        TargetReplacement && !replacementElement ? null : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fLi8o.Layering), {
                            isDisabled: false,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
                                appear: true,
                                children: isOpen && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eCdE8.default), {
                                    onFinish: (state)=>{
                                        state === 'exiting' && onExited();
                                    },
                                    duration: "medium",
                                    children: ({ ref: ref, className: className, style: style })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                                            ref: ref,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                                            className: className,
                                            style: style,
                                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $aEmuS.default), {
                                                testId: `${testId}--dialog`,
                                                actions: this.props.actions,
                                                actionsBeforeElement: this.props.actionsBeforeElement,
                                                children: this.props.children,
                                                dialogPlacement: this.props.dialogPlacement,
                                                dialogWidth: this.props.dialogWidth,
                                                footer: this.props.footer,
                                                header: this.props.header,
                                                heading: this.props.heading,
                                                titleId: this.props.titleId,
                                                label: this.props.label,
                                                headingAfterElement: this.props.headingAfterElement,
                                                image: this.props.image,
                                                targetNode: replacementElement || targetNode
                                            })
                                        })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jr1Vl))), {})
                    ]
                })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            // This is only used when targetReplacement is specified.
            // In this case, we have to render the targetReplacement component,
            // get a dom reference from that component, then render again passing
            // that reference into SpotlightDialog (Popper).
            replacementElement: null
        }, this.getTargetNodeStyle = (box)=>{
            if (!(0, $kt9Lz.canUseDOM)) return {};
            const { height: height, left: left, top: top, width: width, ...rest } = box;
            return {
                // Handling this just in case there are invalid elements being sent in to
                // the `box` arg
                ...rest,
                height: height,
                left: left,
                top: top,
                width: width,
                position: 'fixed',
                // when width is 0, set visibility hidden to avoid the target flashing issue
                ...width === 0 && (0, $iqfTZ.fg)('scroll-lock-replacement') && {
                    visibility: 'hidden'
                }
            };
        };
    }
}
$72906340f39a9cc8$var$SpotlightInner.displayName = "SpotlightInner";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$72906340f39a9cc8$export$2e2bcd8739ae039 = $72906340f39a9cc8$var$SpotlightInner;

});
parcelRegister("gZV2t", function(module, exports) {
$parcel$export(module.exports, "ElementBox", () => $e2ffc9846eba2d47$export$1b6719bd7aff3c00);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $2oRWW = parcelRequire("2oRWW");

var $iqfTZ = parcelRequire("iqfTZ");
// The minimum interval between position updates in milliseconds
const $e2ffc9846eba2d47$var$POSITION_UPDATE_INTERVAL = 200;
const $e2ffc9846eba2d47$var$getElementRect = (element)=>{
    const { height: height, left: left, top: top, width: width } = element.getBoundingClientRect();
    return {
        height: height,
        left: left,
        top: top,
        width: width
    };
};
const $e2ffc9846eba2d47$var$useResizeAwareElementBox = (element, updateMethod)=>{
    const [box, setBox] = (0, $euxye.useState)({
        width: 0,
        height: 0,
        left: 0,
        top: 0
    });
    (0, $euxye.useLayoutEffect)(()=>{
        if (updateMethod === 'resizeListener') {
            if ((0, $iqfTZ.fg)('scroll-lock-replacement')) // use setTimeout 0 to defer the state update to avoid content shifting when pages have scrollbars
            // more details are https://www.loom.com/share/96a5d7c2afd74146a3c005bf20a8c69e?sid=968b00c1-e5ab-4ea0-9fe4-e534fe7088e4
            setTimeout(()=>{
                setBox($e2ffc9846eba2d47$var$getElementRect(element));
            }, 0);
            else setBox($e2ffc9846eba2d47$var$getElementRect(element));
        }
    }, [
        element,
        updateMethod
    ]);
    (0, $euxye.useEffect)(()=>{
        const onResize = ()=>{
            requestAnimationFrame(()=>{
                setBox($e2ffc9846eba2d47$var$getElementRect(element));
            });
        };
        if (updateMethod === 'resizeListener') return (0, $glbdM.bind)(window, {
            type: 'resize',
            listener: onResize
        });
        return 0, $2oRWW.default;
    }, [
        element,
        updateMethod
    ]);
    return box;
};
const $e2ffc9846eba2d47$var$usePollingElementBox = (element, updateMethod)=>{
    // These are intentionally tracked as number primitives rather than as a shared `box` object.
    // Since the requestAnimationFrame code below updates this often, we want to avoid re-renders
    // when the values are the same.  React uses `Object.is` to figure out if the state changed after a setState.
    // If we represent this as a shared `box` object, this will re-render even if the two objects have identical contents.
    const [width, setWidth] = (0, $euxye.useState)(0);
    const [height, setHeight] = (0, $euxye.useState)(0);
    const [left, setLeft] = (0, $euxye.useState)(0);
    const [top, setTop] = (0, $euxye.useState)(0);
    (0, $euxye.useLayoutEffect)(()=>{
        if (updateMethod === 'polling') {
            if ((0, $iqfTZ.fg)('scroll-lock-replacement')) // use setTimeout 0 to defer the state update to avoid content shifting when pages have scrollbars
            // more details are https://www.loom.com/share/96a5d7c2afd74146a3c005bf20a8c69e?sid=968b00c1-e5ab-4ea0-9fe4-e534fe7088e4
            setTimeout(()=>{
                const newBox = $e2ffc9846eba2d47$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
            }, 0);
            else {
                const newBox = $e2ffc9846eba2d47$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
            }
        }
    }, [
        element,
        updateMethod
    ]);
    // Souce: https://css-tricks.com/using-requestanimationframe-with-react-hooks/
    // Use useRef for mutable variables that we want to persist
    // without triggering a re-render on their change
    const requestRef = (0, $euxye.useRef)();
    const previousUpdateTimeRef = (0, $euxye.useRef)();
    const animate = (0, $euxye.useCallback)((time)=>{
        if (previousUpdateTimeRef.current !== undefined) {
            const timeSinceLastUpdate = time - previousUpdateTimeRef.current;
            if (timeSinceLastUpdate > $e2ffc9846eba2d47$var$POSITION_UPDATE_INTERVAL) {
                const newBox = $e2ffc9846eba2d47$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
                previousUpdateTimeRef.current = time;
            }
        } else // Initialize previousUpdateTimeRef
        previousUpdateTimeRef.current = time;
        requestRef.current = requestAnimationFrame(animate);
    }, [
        element
    ]);
    (0, $euxye.useEffect)(()=>{
        if (updateMethod === 'polling') requestRef.current = requestAnimationFrame(animate);
        return ()=>{
            if (requestRef.current !== undefined) cancelAnimationFrame(requestRef.current);
        };
    // This useEffect should only run on mount and when `element` or `updateMethod` changes.
    }, [
        animate,
        element,
        updateMethod
    ]);
    const box = (0, $euxye.useMemo)(()=>({
            width: width,
            height: height,
            left: left,
            top: top
        }), [
        width,
        height,
        left,
        top
    ]);
    return box;
};
/**
 * Will listen to the document resizing to see if an element has moved positions.
 * Not using ResizeObserver because of IE11 support.
 * @param element HTMLElement to watch when resizing.
 */ const $e2ffc9846eba2d47$var$useElementBox = (element, resizeUpdateMethod)=>{
    const updateMethod = resizeUpdateMethod || 'resizeListener';
    const boxViaResizeListener = $e2ffc9846eba2d47$var$useResizeAwareElementBox(element, updateMethod);
    const boxViaPolling = $e2ffc9846eba2d47$var$usePollingElementBox(element, updateMethod);
    return updateMethod === 'resizeListener' ? boxViaResizeListener : boxViaPolling;
};
const $e2ffc9846eba2d47$export$1b6719bd7aff3c00 = (props)=>{
    const box = $e2ffc9846eba2d47$var$useElementBox(props.element, props.resizeUpdateMethod);
    return props.children(box);
};
$e2ffc9846eba2d47$export$1b6719bd7aff3c00.displayName = "ElementBox";

});

parcelRegister("1X7k8", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b56db15d49331dc$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $hTHyV = parcelRequire("hTHyV");

var $9sceD = parcelRequire("9sceD");
const $9b56db15d49331dc$var$computedStyleAttributesToClone = [
    'fontSize',
    'fontWeight',
    'lineHeight',
    'padding',
    'color',
    'textOverflow'
];
function $9b56db15d49331dc$var$cloneAndOverrideStyles(node) {
    const shouldCloneChildren = true;
    const clonedNode = node.cloneNode(shouldCloneChildren);
    const computedStyles = getComputedStyle(node);
    $9b56db15d49331dc$var$computedStyleAttributesToClone.forEach((attribute)=>{
        clonedNode.style[attribute] = computedStyles[attribute];
    });
    clonedNode.style.margin = '0';
    clonedNode.style.position = 'static';
    // The target may have other transforms applied. Avoid unintended side effects
    // by zeroing out "translate" rather than applying a value of "none".
    clonedNode.style.transform = 'translate(0, 0) translate3d(0, 0, 0)';
    return clonedNode;
}
/**
 * __Clone__
 *
 * Used for cloning spotlight targets. The clone is positioned on top of the spotlight target with
 * a pulsing animation.
 *
 * @internal
 */ const $9b56db15d49331dc$var$Clone = (props)=>{
    const { pulse: pulse, style: style, shouldWatch: shouldWatch, target: target, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetNode: targetNode, targetRadius: targetRadius, testId: testId } = props;
    const contentVersion = (0, $9sceD.useElementObserver)(targetNode, {
        disableWatch: !shouldWatch
    });
    const contentHTML = (0, $euxye.useMemo)(()=>$9b56db15d49331dc$var$cloneAndOverrideStyles(targetNode).outerHTML, // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to update when the content changes
    [
        contentVersion,
        targetNode
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $hTHyV.TargetInner), {
        "data-testid": testId,
        pulse: pulse,
        bgColor: targetBgColor,
        radius: targetRadius,
        style: style,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: contentHTML
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    height: '100%',
                    pointerEvents: 'none'
                }
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hTHyV.TargetOverlay), {
                onClick: targetOnClick ? (event)=>targetOnClick({
                        event: event,
                        target: target
                    }) : undefined
            })
        ]
    });
};
$9b56db15d49331dc$var$Clone.displayName = "Clone";
var $9b56db15d49331dc$export$2e2bcd8739ae039 = $9b56db15d49331dc$var$Clone;

});
parcelRegister("hTHyV", function(module, exports) {
$parcel$export(module.exports, "TargetInner", () => $b9150bfd42c55c36$export$b1542cc928b93af);
$parcel$export(module.exports, "TargetOverlay", () => $b9150bfd42c55c36$export$a28a07e0025d709d);
$parcel$export(module.exports, "Pulse", () => $b9150bfd42c55c36$export$927d63e2511364c0);
/* target.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $b9150bfd42c55c36$var$reduceMotionAsPerUserPreference = null;
// NOTE:
// Pulse color "rgb(101, 84, 192)" derived from "colors.P300"
const $b9150bfd42c55c36$var$baseShadow = `0 0 0 2px ${"var(--ds-border-discovery, #AF59E1)"}`;
const $b9150bfd42c55c36$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $b9150bfd42c55c36$var$pulseKeyframes = null;
const $b9150bfd42c55c36$var$animationStyles = null;
const $b9150bfd42c55c36$var$Base = ({ bgColor: bgColor, children: children, className: className, radius: radius, testId: testId, style: style, // The rest of these props are from `HTMLDivElement`
...props })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style is not allowed at the moment
            ...style,
            backgroundColor: bgColor,
            borderRadius: radius ? typeof radius === 'number' ? `${radius}px` : radius : undefined
        },
        ...props,
        children: children
    });
$b9150bfd42c55c36$var$Base.displayName = "Base";
const $b9150bfd42c55c36$export$b1542cc928b93af = ({ bgColor: bgColor, children: children, className: className, pulse: pulse, radius: radius, testId: testId, // Thes rest of these are from `HTMLDivElement`
...props })=>/*#__PURE__*/ (0, $e79Pd.jsx)($b9150bfd42c55c36$var$Base, {
        bgColor: bgColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $4jQY2.default)([
            pulse && "",
            pulse && "_0nFVCG2h6w _03m2nySHWH _1gBibyAup0 _43vdfTs3G2 _2OUyjtgbYL",
            "_39Ohv4YbGa _1SdfoHYbGa",
            className
        ]),
        radius: radius,
        testId: testId,
        ...props,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: props.style,
        children: children
    });
$b9150bfd42c55c36$export$b1542cc928b93af.displayName = "TargetInner";
const $b9150bfd42c55c36$var$targetOverlayStyles = null;
const $b9150bfd42c55c36$export$a28a07e0025d709d = ({ onClick: onClick, ...props })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        onClick: onClick,
        ...props,
        style: {
            cursor: onClick ? 'pointer' : 'auto'
        },
        className: (0, $4jQY2.default)([
            "_39xV02N91d _0jFU0VN91d _1mT5xdWVPG _2I62gzPgdg _3iC0zdPgdg"
        ])
    });
$b9150bfd42c55c36$export$a28a07e0025d709d.displayName = "TargetOverlay";
const $b9150bfd42c55c36$export$927d63e2511364c0 = ({ bgColor: bgColor, children: children, className: className, radius: radius, pulse: pulse = true, testId: testId, ...props })=>/*#__PURE__*/ (0, $e79Pd.jsx)($b9150bfd42c55c36$var$Base, {
        bgColor: bgColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $4jQY2.default)([
            pulse && "",
            pulse && "_0nFVCG2h6w _03m2nySHWH _1gBibyAup0 _43vdfTs3G2 _2OUyjtgbYL",
            "_39Ohv4YbGa _1SdfoHYbGa",
            className
        ]),
        radius: radius,
        testId: testId,
        ...props,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: props.style,
        children: children
    });
$b9150bfd42c55c36$export$927d63e2511364c0.displayName = "Pulse";

});

parcelRegister("9sceD", function(module, exports) {
$parcel$export(module.exports, "useElementObserver", () => $73a459f6cf694005$export$729bafd4e621fba0);

var $euxye = parcelRequire("euxye");
function $73a459f6cf694005$export$729bafd4e621fba0(element, opts = {}) {
    const { onChange: onChange, disableWatch: disableWatch = false } = opts;
    // This state is used to force a re-render when the target changes
    const [targetContentVersion, setTargetContentVersion] = (0, $euxye.useState)(0);
    const mutationObserver = (0, $euxye.useRef)(undefined);
    const cancelIdleCallback1 = (0, $euxye.useRef)(undefined);
    const disposer = (0, $euxye.useCallback)(()=>{
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = undefined;
        mutationObserver.current?.disconnect();
        mutationObserver.current = undefined;
    }, []);
    const onMutation = (0, $euxye.useCallback)(()=>{
        // MutationObserver can make multiple calls to the callback in quick succession so debounce when idle
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = $73a459f6cf694005$var$callWhenIdle(()=>setTargetContentVersion((v)=>{
                const version = v + 1;
                onChange?.(version);
                return version;
            }));
    }, [
        onChange
    ]);
    (0, $euxye.useEffect)(()=>{
        // Clean up any existing observer in the case that the target node has changed
        disposer();
        if (!disableWatch && element) {
            mutationObserver.current = new MutationObserver(onMutation);
            mutationObserver.current.observe(element, {
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        return disposer;
    }, [
        disableWatch,
        disposer,
        element,
        onMutation
    ]);
    return targetContentVersion;
}
/**
 * When the browser is idle call the callback.
 *
 * This function will use `requestIdleCallback` if available, otherwise it will fallback to `setTimeout`.
 *
 * @param callback The function to call when the browser is idle.
 * @param [opts] Options for the idle callback.
 * @param [opts.timeout=100] The maximum time to wait for the browser to be idle.
 *
 * @returns A function that can be called to cancel the idle callback.
 *
 * @internal
 */ function $73a459f6cf694005$var$callWhenIdle(callback, opts = {}) {
    const { timeout: timeout = 100 } = opts;
    if (typeof window.requestIdleCallback === 'function') {
        const idleHandle = window.requestIdleCallback(callback, {
            timeout: timeout
        });
        return ()=>cancelIdleCallback(idleHandle);
    }
    // Fallback to setTimeout if requestIdleCallback is not available
    const timeoutHandle = setTimeout(callback, timeout);
    return ()=>clearTimeout(timeoutHandle);
}

});


parcelRegister("dkJhd", function(module, exports) {
$parcel$export(module.exports, "default", () => $76bb77e6a1246246$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4C2iR = parcelRequire("4C2iR");
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $76bb77e6a1246246$var$NodeResolverSpotlightInner = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    const divRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        if (!hasNodeResolver) innerRef(divRef.current?.firstElementChild);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasNodeResolver
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4C2iR))), {
        innerRef: innerRef,
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: divRef,
        children: children
    });
};
$76bb77e6a1246246$var$NodeResolverSpotlightInner.displayName = "NodeResolverSpotlightInner";
var $76bb77e6a1246246$export$2e2bcd8739ae039 = $76bb77e6a1246246$var$NodeResolverSpotlightInner;

});

parcelRegister("aEmuS", function(module, exports) {
$parcel$export(module.exports, "default", () => $2370f0af1a2f23e9$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $g6TgS = parcelRequire("g6TgS");

var $1DTca = parcelRequire("1DTca");

var $ihEDU = parcelRequire("ihEDU");

var $9Imoa = parcelRequire("9Imoa");

var $UEjKq = parcelRequire("UEjKq");

var $17tM2 = parcelRequire("17tM2");
/**
 * __Spotlight dialog__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $2370f0af1a2f23e9$var$SpotlightDialogComponent extends (0, $euxye.Component) {
    componentDidMount() {
        this.focusLockTimeoutId = window.setTimeout(()=>{
            // we delay the enabling of the focus lock to avoid the scroll position
            // jumping around in some situations
            this.setState({
                focusLockDisabled: false
            });
        }, 200);
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusLockTimeoutId);
    }
    render() {
        const { actions: actions, actionsBeforeElement: actionsBeforeElement, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label = 'Introducing new feature', titleId: titleId, targetNode: targetNode, testId: testId } = this.props;
        const { focusLockDisabled: focusLockDisabled } = this.state;
        const dialogLabel = !heading && !titleId ? label : undefined;
        const dialogLabelledBy = titleId || (heading ? 'spotlight-dialog-label' : undefined);
        const translatedPlacement = dialogPlacement ? ({
            'top left': 'top-start',
            'top center': 'top',
            'top right': 'top-end',
            'right top': 'right-start',
            'right middle': 'right',
            'right bottom': 'right-end',
            'bottom left': 'bottom-start',
            'bottom center': 'bottom',
            'bottom right': 'bottom-end',
            'left top': 'left-start',
            'left middle': 'left',
            'left bottom': 'left-end'
        })[dialogPlacement] : undefined;
        // If there's no room on either side of the popper, it will extend off-screen.
        //  This looks buggy when scroll-lock and focus is placed on the dialog, so we
        //  customise popper so it overflows the spotlight instead with altAxis=true.
        const modifiers = [
            {
                name: 'preventOverflow',
                options: {
                    padding: 5,
                    rootBoundary: 'document',
                    altAxis: true,
                    tether: false
                }
            }
        ];
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1DTca.Popper), {
            modifiers: modifiers,
            referenceElement: targetNode,
            placement: translatedPlacement,
            children: ({ ref: ref, style: style, update: update })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $17tM2.default), {
                    value: dialogWidth,
                    onChange: update,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $g6TgS.default), {
                        disabled: focusLockDisabled,
                        returnFocus: false,
                        autoFocus: true,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                            style: style,
                            ref: ref,
                            "aria-modal": true,
                            role: "dialog",
                            "aria-label": dialogLabel,
                            "aria-labelledby": dialogLabelledBy,
                            testId: `${testId}-container`,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $UEjKq.default), {
                                testId: testId,
                                width: dialogWidth,
                                actions: actions,
                                actionsBeforeElement: actionsBeforeElement,
                                image: image && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9Imoa.DialogImage), {
                                    alt: heading,
                                    src: image
                                }),
                                components: {
                                    Header: header,
                                    Footer: footer
                                },
                                heading: heading,
                                headingId: "spotlight-dialog-label",
                                headingAfterElement: headingAfterElement,
                                // This should be heading level 1 since this is technically a modal, including a focus lock on the modal window.
                                // But because it is not a _true_ modal, we are setting it to `2` until that is fixed.
                                headingLevel: 2,
                                children: children
                            })
                        })
                    })
                })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            focusLockDisabled: true
        };
    }
}
$2370f0af1a2f23e9$var$SpotlightDialogComponent.displayName = "SpotlightDialogComponent";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2370f0af1a2f23e9$export$2e2bcd8739ae039 = $2370f0af1a2f23e9$var$SpotlightDialogComponent;

});
parcelRegister("9Imoa", function(module, exports) {
$parcel$export(module.exports, "DialogImage", () => $c494bac022429a45$export$855e1a47874d6b81);
$parcel$export(module.exports, "DialogActionItemContainer", () => $c494bac022429a45$export$ed9b6b50bbed5f27);
$parcel$export(module.exports, "DialogActionItem", () => $c494bac022429a45$export$6ae54e00f59e1f33);
/* dialog.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $ihEDU = parcelRequire("ihEDU");
const $c494bac022429a45$var$imageStyles = null;
const $c494bac022429a45$var$actionItemContainerStyles = {
    root: "_3iDTPbQ4SZ _0aFT5vf5Xk _0rIjykPgdg _43nrzTPgdg _2xTnZx5UaJ _0GTcwR5UaJ"
};
const $c494bac022429a45$var$actionItemStyles = {
    root: "_0rIjykPgdg _43nrzTPgdg _2xTnZx1Y8M _0GTcwR1Y8M"
};
const $c494bac022429a45$export$855e1a47874d6b81 = ({ alt: alt, ...props })=>/*#__PURE__*/ (0, $e79Pd.jsx)("img", {
        alt: alt,
        ...props,
        className: (0, $4jQY2.default)([
            "_1EqgXlN91d _0jFU0VIZbP"
        ])
    });
$c494bac022429a45$export$855e1a47874d6b81.displayName = "DialogImage";
const $c494bac022429a45$export$ed9b6b50bbed5f27 = ({ children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: $c494bac022429a45$var$actionItemContainerStyles.root,
        children: children
    });
$c494bac022429a45$export$ed9b6b50bbed5f27.displayName = "DialogActionItemContainer";
const $c494bac022429a45$export$6ae54e00f59e1f33 = ({ children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: $c494bac022429a45$var$actionItemStyles.root,
        children: children
    });
$c494bac022429a45$export$6ae54e00f59e1f33.displayName = "DialogActionItem";

});

parcelRegister("UEjKq", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9d170bc1e1ac5e1$export$2e2bcd8739ae039);
/* spotlight-card.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $4YhY5 = parcelRequire("4YhY5");

var $fIDws = parcelRequire("fIDws");

var $1MNmN = parcelRequire("1MNmN");

var $2iotI = parcelRequire("2iotI");

var $fe5lW = parcelRequire("fe5lW");

var $ihEDU = parcelRequire("ihEDU");
var $8Sdzy = parcelRequire("8Sdzy");

var $9Imoa = parcelRequire("9Imoa");

var $flceo = parcelRequire("flceo");
const $c9d170bc1e1ac5e1$var$bodyStyles = null;
const $c9d170bc1e1ac5e1$var$imageStyles = null;
const $c9d170bc1e1ac5e1$var$defaultHeaderStyles = null;
const $c9d170bc1e1ac5e1$var$DefaultHeader = ({ children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            "_3iDTPbQ4SZ _0hPCNLQame _37wbyuI7V3 _0xmtko2ADO"
        ]),
        children: children
    });
$c9d170bc1e1ac5e1$var$DefaultHeader.displayName = "DefaultHeader";
const $c9d170bc1e1ac5e1$var$defaultFooterStyles = null;
const $c9d170bc1e1ac5e1$var$DefaultFooter = ({ children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": "spotlight--dialog-footer",
        className: (0, $4jQY2.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _46hvQm2ADO"
        ]),
        children: children
    });
$c9d170bc1e1ac5e1$var$DefaultFooter.displayName = "DefaultFooter";
const $c9d170bc1e1ac5e1$var$containerStyles = {
    root: "_0bjKvDKxmn _4bt5LAIZbP _2WAcuGIZbP _0jFU0VE6Kk _1UtDYze5R3 _4ouGXIoaux _1EqgXlpNyl"
};
const $c9d170bc1e1ac5e1$var$containerShadowStyles = {
    root: "_2OUyjtzwhj"
};
/**
 * __Spotlight card__
 *
 * A spotlight card is for onboarding messages that need a more flexible layout, or don't require a dialog.
 *
 * - [Examples](https://atlassian.design/components/onboarding/spotlight-card/examples)
 * - [Code](https://atlassian.design/components/onboarding/spotlight-card/code)
 * - [Usage](https://atlassian.design/components/onboarding/spotlight-card/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $c9d170bc1e1ac5e1$var$SpotlightCard = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const { actions: actions = [], actionsBeforeElement: actionsBeforeElement, children: children, components: components = {}, heading: heading, headingLevel: headingLevel = 4, headingAfterElement: headingAfterElement, image: image, innerRef: innerRef, isFlat: isFlat, testId: testId, width: width = 400, headingId: headingId } = props;
    const { Header: Header = $c9d170bc1e1ac5e1$var$DefaultHeader, Footer: Footer = $c9d170bc1e1ac5e1$var$DefaultFooter } = components;
    const { currentLevel: currentLevel } = (0, $fe5lW.useLayering)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fIDws.default).Provider, {
        value: (0, $flceo.spotlightButtonTheme),
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.Box), {
            backgroundColor: "color.background.discovery.bold",
            xcss: (0, $1MNmN.cx)($c9d170bc1e1ac5e1$var$containerStyles.root, !isFlat && $c9d170bc1e1ac5e1$var$containerShadowStyles.root),
            style: {
                width: width
            },
            ref: ref || innerRef,
            testId: testId,
            "data-ds--level": currentLevel,
            // temporarily use this data attribute to prevent clicking outside won't close spotlight correctly issue
            "data-ds--close--type": "single",
            children: [
                typeof image === 'string' ? /*#__PURE__*/ (0, $e79Pd.jsx)("img", {
                    src: image,
                    alt: "",
                    className: (0, $4jQY2.default)([
                        "_3iDTPbvLZJ"
                    ])
                }) : image,
                /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
                    className: (0, $4jQY2.default)([
                        "_3iDTPbQ4SZ _0aFT5vbt8w _0xmtko5zaO _46hvQm5zaO _03SyCPkG2W _0LQT5EkG2W"
                    ]),
                    children: [
                        heading || headingAfterElement ? /*#__PURE__*/ (0, $e79Pd.jsxs)(Header, {
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                                    id: headingId,
                                    size: "medium",
                                    as: `h${headingLevel}`,
                                    color: "color.text.inverse",
                                    children: heading
                                }),
                                headingAfterElement
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                            children: children
                        }),
                        actions.length > 0 || actionsBeforeElement ? /*#__PURE__*/ (0, $e79Pd.jsxs)(Footer, {
                            children: [
                                actionsBeforeElement || /*#__PURE__*/ (0, $e79Pd.jsx)("span", {}),
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9Imoa.DialogActionItemContainer), {
                                    children: actions.map(({ text: text, key: key, ...rest }, idx)=>{
                                        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9Imoa.DialogActionItem), {
                                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4YhY5.default), {
                                                ...rest,
                                                children: text
                                            })
                                        }, key || (typeof text === 'string' ? text : `${idx}`));
                                    })
                                })
                            ]
                        }) : null
                    ]
                })
            ]
        })
    });
});
$c9d170bc1e1ac5e1$var$SpotlightCard.displayName = 'SpotlightCard';
var $c9d170bc1e1ac5e1$export$2e2bcd8739ae039 = $c9d170bc1e1ac5e1$var$SpotlightCard;

});
parcelRegister("flceo", function(module, exports) {
$parcel$export(module.exports, "spotlightButtonTheme", () => $bd9c1b758df81d71$export$39a36121076ca24);
$parcel$export(module.exports, "modalButtonTheme", () => $bd9c1b758df81d71$export$d131eb21ba4cbd16);
const $bd9c1b758df81d71$var$spotlightTheme = {
    default: {
        background: {
            default: "var(--ds-background-inverse-subtle, #00000029)",
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: "var(--ds-background-disabled, #0515240F)",
            selected: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            focus: "var(--ds-background-inverse-subtle, #00000029)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #080F214A)",
                dark: "var(--ds-text-disabled, #080F214A)"
            },
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        background: {
            default: 'none',
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: 'none',
            selected: {
                light: "var(--ds-background-selected-hovered, #CFE1FD)",
                dark: "var(--ds-background-selected-hovered, #CFE1FD)"
            },
            focusSelected: {
                light: "var(--ds-background-selected-hovered, #CFE1FD)",
                dark: "var(--ds-background-selected-hovered, #CFE1FD)"
            }
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-disabled, #080F214A)",
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    'subtle-link': {
        textDecoration: {
            hover: `underline ${"var(--ds-text-inverse, #FFFFFF)"}`
        },
        textDecorationLine: {
            active: 'none'
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-discovery, #803FA5)",
            selected: "var(--ds-text-selected, #1868DB)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $bd9c1b758df81d71$var$modalTheme = {
    primary: {
        background: {
            default: "var(--ds-background-discovery-bold, #964AC0)",
            hover: "var(--ds-background-discovery-bold-hovered, #803FA5)",
            active: "var(--ds-background-discovery-bold-pressed, #673286)",
            disabled: {
                light: "var(--ds-background-disabled, #0515240F)",
                dark: "var(--ds-background-disabled, #0515240F)"
            },
            selected: "var(--ds-background-selected-hovered, #CFE1FD)",
            focus: "var(--ds-background-discovery-bold-hovered, #803FA5)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #080F214A)",
                dark: "var(--ds-text-disabled, #080F214A)"
            },
            selected: "var(--ds-text-selected, #1868DB)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
function $bd9c1b758df81d71$var$extract(newTheme, { mode: mode, appearance: appearance, state: state }) {
    if (!newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!node[item]) return undefined;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return undefined;
            }
            node = node[item];
            return undefined;
        });
        return acc;
    }, {});
}
const $bd9c1b758df81d71$export$39a36121076ca24 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$bd9c1b758df81d71$var$extract($bd9c1b758df81d71$var$spotlightTheme, themeProps)
        },
        ...rest
    };
};
const $bd9c1b758df81d71$export$d131eb21ba4cbd16 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$bd9c1b758df81d71$var$extract($bd9c1b758df81d71$var$modalTheme, themeProps)
        },
        ...rest
    };
};

});


parcelRegister("17tM2", function(module, exports) {
$parcel$export(module.exports, "default", () => $c34bd4288a0a0f94$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
class $c34bd4288a0a0f94$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) this.props.onChange();
    }
    render() {
        return this.props.children;
    }
}
$c34bd4288a0a0f94$export$2e2bcd8739ae039.displayName = "ValueChanged";

});


parcelRegister("kxDv9", function(module, exports) {
$parcel$export(module.exports, "SpotlightTransitionConsumer", () => $0edc14b237a6b4d5$export$7d63b19b854c2fe8);
$parcel$export(module.exports, "default", () => $0edc14b237a6b4d5$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");
const $0edc14b237a6b4d5$var$SpotlightTransitionContext = /*#__PURE__*/ (0, $euxye.createContext)({
    isOpen: true,
    onExited: (0, $2oRWW.default)
});
// checks if children exist and are truthy
const $0edc14b237a6b4d5$var$hasChildren = (children)=>(0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Children.count(children) > 0 && ((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Children.map(children || false, (child)=>!!child)?.filter(Boolean)?.length || 0) > 0;
/**
 * __Spotlight transition__
 *
 * A spotlight transition holds onto spotlights so they can fade out when exiting the viewport.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $0edc14b237a6b4d5$var$SpotlightTransition extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    static getDerivedStateFromProps(props, state) {
        const { currentChildren: previousChildren } = state;
        const exiting = $0edc14b237a6b4d5$var$hasChildren(previousChildren) && !$0edc14b237a6b4d5$var$hasChildren(props.children);
        return {
            currentChildren: exiting ? previousChildren : props.children
        };
    }
    render() {
        return /*#__PURE__*/ (0, $e79Pd.jsx)($0edc14b237a6b4d5$var$SpotlightTransitionContext.Provider, {
            value: {
                onExited: this.onExited,
                isOpen: $0edc14b237a6b4d5$var$hasChildren(this.props.children)
            },
            children: this.state.currentChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            currentChildren: undefined
        }, this.onExited = ()=>{
            this.setState({
                currentChildren: this.props.children
            });
        };
    }
}
$0edc14b237a6b4d5$var$SpotlightTransition.displayName = "SpotlightTransition";
const $0edc14b237a6b4d5$export$7d63b19b854c2fe8 = $0edc14b237a6b4d5$var$SpotlightTransitionContext.Consumer;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0edc14b237a6b4d5$export$2e2bcd8739ae039 = $0edc14b237a6b4d5$var$SpotlightTransition;

});


parcelRegister("jyUW8", function(module, exports) {
$parcel$export(module.exports, "TargetConsumer", () => $793a3d572708f305$export$f643dd64c1952cc8);
$parcel$export(module.exports, "SpotlightContext", () => $793a3d572708f305$export$7b5aa0f5b37a336d);
$parcel$export(module.exports, "SpotlightConsumer", () => $793a3d572708f305$export$3503199acd121708);
$parcel$export(module.exports, "default", () => $793a3d572708f305$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $emCaV = parcelRequire("emCaV");

var $2oRWW = parcelRequire("2oRWW");

var $8L2z6 = parcelRequire("8L2z6");

var $eCdE8 = parcelRequire("eCdE8");

var $5PG2M = parcelRequire("5PG2M");

var $1KLIT = parcelRequire("1KLIT");

var $gIMgJ = parcelRequire("gIMgJ");
const $793a3d572708f305$var$dest = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
const $793a3d572708f305$export$f643dd64c1952cc8 = $793a3d572708f305$var$dest.Consumer;
const $793a3d572708f305$var$TargetProvider = $793a3d572708f305$var$dest.Provider;
const $793a3d572708f305$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $euxye.createContext)({
    opened: (0, $2oRWW.default),
    closed: (0, $2oRWW.default),
    targets: {}
});
const $793a3d572708f305$export$3503199acd121708 = $793a3d572708f305$export$7b5aa0f5b37a336d.Consumer;
const $793a3d572708f305$var$SpotlightStateProvider = $793a3d572708f305$export$7b5aa0f5b37a336d.Provider;
const $793a3d572708f305$var$Container = ({ component: Wrapper, children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)(Wrapper, {
        children: children
    });
$793a3d572708f305$var$Container.displayName = "Container";
class $793a3d572708f305$export$2e2bcd8739ae039 extends (0, $euxye.PureComponent) {
    static{
        this.defaultProps = {
            blanketIsTinted: true
        };
    }
    componentDidMount() {
        typeof $gIMgJ;
    }
    render() {
        const { blanketIsTinted: blanketIsTinted, children: children, component: Tag, onBlanketClicked: onBlanketClicked } = this.props;
        const isActive = this.state.spotlightCount > 0;
        return /*#__PURE__*/ (0, $e79Pd.jsx)($793a3d572708f305$var$SpotlightStateProvider, {
            value: this.getStateProviderValue(this.state.targets),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)($793a3d572708f305$var$TargetProvider, {
                value: this.getTargetRef,
                children: /*#__PURE__*/ (0, $e79Pd.jsxs)($793a3d572708f305$var$Container, {
                    component: Tag || (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment,
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
                            children: isActive && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eCdE8.default), {
                                duration: "medium",
                                children: ({ ref: ref, className: className, style: style })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $5PG2M.default), {
                                        zIndex: 700,
                                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1KLIT.default), {
                                            ref: ref,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                                            className: className,
                                            style: style,
                                            isTinted: blanketIsTinted,
                                            onBlanketClicked: onBlanketClicked
                                        })
                                    })
                            })
                        }),
                        children
                    ]
                })
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            spotlightCount: 0,
            targets: {}
        }, /*
	 * When enabling React Streaming in Confluence, a
	 * "This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering"
	 * error happens.
	 * This is to fix this error by wrapping the state update in startTransition as suggested by React: https://react.dev/errors/421?invariant=421
	 */ this.getTargetRef = (name)=>(element)=>{
                (0, $euxye.startTransition)(()=>{
                    this.setState((state)=>({
                            targets: {
                                ...state.targets,
                                [name]: element || undefined
                            }
                        }));
                });
            }, this.spotlightOpen = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount + 1
                }));
        }, this.spotlightClose = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount - 1
                }));
        }, this.getStateProviderValue = (0, $emCaV.default)((targets)=>({
                opened: this.spotlightOpen,
                closed: this.spotlightClose,
                targets: targets
            }));
    }
}
$793a3d572708f305$export$2e2bcd8739ae039.displayName = "SpotlightManager";

});
parcelRegister("1KLIT", function(module, exports) {
$parcel$export(module.exports, "default", () => $72e547b145882b8f$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
// IE11 and Edge: z-index needed because fixed position calculates z-index relative
// to body instead of nearest stacking context (Portal in our case).
const $72e547b145882b8f$var$blanketStyles = null;
/**
 * __Blanket__
 *
 * A replacement for `@atlaskit/blanket`.
 *
 * We use this for spotlights instead of `@atlaskit/blanket`
 * because spotlights must sit on top of other layered elements,
 * such as modals, which have their own blankets.
 *
 * @internal
 */ const $72e547b145882b8f$var$Blanket = /*#__PURE__*/ (0, $euxye.forwardRef)(({ isTinted: isTinted, onBlanketClicked: onBlanketClicked, style: style, className: className }, ref)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: ref,
        role: "presentation",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $4jQY2.default)([
            "_49OCfRdnbC _23rrnHZtEe _1mT5xdy1CL _42Yu6BkKjW",
            className
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style props are not allowed
            ...style,
            backgroundColor: isTinted ? "var(--ds-blanket, #050C1F75)" : 'transparent'
        },
        onClick: onBlanketClicked
    });
});
var $72e547b145882b8f$export$2e2bcd8739ae039 = $72e547b145882b8f$var$Blanket;

});



parcelRegister("i2sOf", function(module, exports) {
$parcel$export(module.exports, "default", () => $671d30e87ed7aba2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $b9a5g = parcelRequire("b9a5g");

var $4C7HL = parcelRequire("4C7HL");
const $671d30e87ed7aba2$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $671d30e87ed7aba2$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $euxye.useRef)(null);
    const providedColorMode = (0, $b9a5g.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $4C7HL.useThemeObserver)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $euxye.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $4jQY2.default)([
            "_1EqgXlN91d _0jFU0VIZbP",
            className
        ]),
        ref: imgRef,
        ...props
    });
}
$671d30e87ed7aba2$export$2e2bcd8739ae039.displayName = "Image";

});
parcelRegister("b9a5g", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $0ef442903b2883cb$export$ce91654eb9fea460);

var $euxye = parcelRequire("euxye");

var $lUsrP = parcelRequire("lUsrP");
function $0ef442903b2883cb$export$ce91654eb9fea460() {
    const value = (0, $euxye.useContext)((0, $lUsrP.ColorModeContext));
    return value;
}
$0ef442903b2883cb$export$ce91654eb9fea460.displayName = "UNSAFE_useColorModeForMigration";

});


parcelRegister("jFNyB", function(module, exports) {
$parcel$export(module.exports, "SpotlightActions", () => $87cf80f76c666983$export$205c28213090dc52);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2XXtG = parcelRequire("2XXtG");
const $87cf80f76c666983$var$styles = {
    root: "_39xV02N91d"
};
const $87cf80f76c666983$export$205c28213090dc52 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2XXtG.Flex), {
        ref: ref,
        testId: testId,
        xcss: $87cf80f76c666983$var$styles.root,
        role: "group",
        justifyContent: "end",
        gap: "space.050",
        children: children
    });
});

});

parcelRegister("liP0D", function(module, exports) {
$parcel$export(module.exports, "SpotlightBody", () => $690287f5bd18c96d$export$4ae665cf62a00c3f);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");
const $690287f5bd18c96d$var$styles = {
    root: "_2Y7lL45zaO _1UtDYze5R3 _46hvQm2ADO"
};
const $690287f5bd18c96d$export$4ae665cf62a00c3f = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        ref: ref,
        xcss: $690287f5bd18c96d$var$styles.root,
        testId: testId,
        children: children
    });
});

});

parcelRegister("8CDnU", function(module, exports) {
$parcel$export(module.exports, "SpotlightCard", () => $cfdad4a5733c68a0$export$14710e13fc01d383);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $5fO11 = parcelRequire("5fO11");

var $7GDd6 = parcelRequire("7GDd6");
const $cfdad4a5733c68a0$export$14710e13fc01d383 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, placement: placement, testId: testId }, ref)=>(0, $iqfTZ.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7GDd6.SpotlightCard), {
        ref: ref,
        placement: placement,
        testId: testId,
        children: children
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5fO11.SpotlightCard), {
        ref: ref,
        placement: placement,
        testId: testId,
        children: children
    }));

});
parcelRegister("5fO11", function(module, exports) {
$parcel$export(module.exports, "SpotlightCard", () => $e6357b8f967d4819$export$14710e13fc01d383);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $1MNmN = parcelRequire("1MNmN");

var $iqfTZ = parcelRequire("iqfTZ");

var $ihEDU = parcelRequire("ihEDU");

var $2voEL = parcelRequire("2voEL");

var $9ngYq = parcelRequire("9ngYq");
const $e6357b8f967d4819$var$styles = {
    root: "_39xV02E6Kk",
    container: "_1mT5xdRAKS",
    card: "_0bjKvD8fU6 _2mHwu82ADO _1mT5xdWVPG _39xV02T1Vg _46hvQm2ADO _0xmtko8HPE _3iDTPbQ4SZ _0aFT5vbt8w _2OUyjtFYNq"
};
const $e6357b8f967d4819$var$placementStyles = {
    'top-start': "_1ZB6UygVvo _1OKFqYYfXA",
    'top-center': "_1ZB6UygVvo _3iC0zdHCju",
    'top-end': "_1ZB6UygVvo _3iC0zdYfXA",
    'right-start': "_3iC0zdgVvo _1ZB6UyUgYP",
    'right-end': "_3iC0zdgVvo _2I62gzUgYP",
    'bottom-start': "_2I62gzgVvo _1OKFqYYfXA",
    'bottom-center': "_2I62gzgVvo _3iC0zdHCju",
    'bottom-end': "_2I62gzgVvo _3iC0zdYfXA",
    'left-start': "_1OKFqYgVvo _1ZB6UyUgYP",
    'left-end': "_1OKFqYgVvo _2I62gzUgYP"
};
const $e6357b8f967d4819$export$14710e13fc01d383 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, placement: placement, testId: testId }, ref)=>{
    const { card: card } = (0, $euxye.useContext)((0, $2voEL.SpotlightContext));
    const cardRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        card.setRef(cardRef);
    }, [
        card
    ]);
    const content = (0, $iqfTZ.fg)('platform_spotlight_card_fit_content_anchor') ? /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        className: (0, $4jQY2.default)([
            $e6357b8f967d4819$var$styles.root
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
            className: (0, $4jQY2.default)([
                $e6357b8f967d4819$var$styles.container
            ]),
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9ngYq.Caret), {
                    placement: placement || card.placement
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                    ref: cardRef,
                    backgroundColor: "color.background.neutral.bold",
                    xcss: (0, $1MNmN.cx)($e6357b8f967d4819$var$styles.card, $e6357b8f967d4819$var$placementStyles[placement || card.placement]),
                    children: children
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        "data-testid": testId,
        ref: ref,
        className: (0, $4jQY2.default)([
            $e6357b8f967d4819$var$styles.container
        ]),
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9ngYq.Caret), {
                placement: placement || card.placement
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                ref: cardRef,
                backgroundColor: "color.background.neutral.bold",
                xcss: (0, $1MNmN.cx)($e6357b8f967d4819$var$styles.card, $e6357b8f967d4819$var$placementStyles[placement || card.placement]),
                children: children
            })
        ]
    });
    if ((0, $iqfTZ.fg)('platform-dst-motion-uplift-spotlight')) {
        const Motion = card.motion;
        if (Motion) return /*#__PURE__*/ (0, $e79Pd.jsx)(Motion, {
            children: content
        });
        else return content;
    }
    return content;
});

});
parcelRegister("9ngYq", function(module, exports) {
$parcel$export(module.exports, "Caret", () => $192106ad2296f6d1$export$88fca06e22f21720);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $aO3eM = parcelRequire("aO3eM");

var $hZenj = parcelRequire("hZenj");
const $192106ad2296f6d1$export$88fca06e22f21720 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ placement: placement, testId: testId }, ref)=>{
    return (0, $iqfTZ.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZenj.Caret), {
        ref: ref,
        placement: placement,
        testId: testId
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $aO3eM.Caret), {
        ref: ref,
        placement: placement,
        testId: testId
    });
});

});
parcelRegister("aO3eM", function(module, exports) {
$parcel$export(module.exports, "Caret", () => $7713fa467889fa38$export$88fca06e22f21720);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $2voEL = parcelRequire("2voEL");
const $7713fa467889fa38$var$styles = {
    root: "_0KLXrugozt _1uo2Zf1cEy _0jFU0V2sAl _1mT5xdRAKS _39xV022sAl _42Yu6BkKjW",
    'top-start': "_1VJPcaMZzS",
    'top-center': "_1VJPcaMZzS",
    'top-end': "_1VJPcaMZzS",
    'bottom-start': "_1VJPcacqvQ",
    'bottom-center': "_1VJPcacqvQ",
    'bottom-end': "_1VJPcacqvQ",
    'right-start': "_1VJPcaEFNz",
    'right-end': "_1VJPcaEFNz",
    'left-start': "_1VJPcaEoIx",
    'left-end': "_1VJPcaEoIx"
};
const $7713fa467889fa38$export$88fca06e22f21720 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ placement: placement, testId: testId }, ref)=>{
    const { card: card } = (0, $euxye.useContext)((0, $2voEL.SpotlightContext));
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        // Growth Pattern Library designs dictate 1px radius. cssMap only allows tokens
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            borderEndStartRadius: '1px'
        },
        className: (0, $4jQY2.default)([
            $7713fa467889fa38$var$styles.root,
            $7713fa467889fa38$var$styles[placement || card.placement]
        ])
    });
});

});

parcelRegister("hZenj", function(module, exports) {
$parcel$export(module.exports, "Caret", () => $b8d4f67f20aee211$export$88fca06e22f21720);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $2voEL = parcelRequire("2voEL");

var $9TwwC = parcelRequire("9TwwC");
const $b8d4f67f20aee211$var$styles = {
    root: "_0KLXrugozt _1uo2Zf1cEy _0jFU0V2sAl _1mT5xdWVPG _39xV022sAl",
    'start span-start': "_1ZB6UyPgdg _1OKFqYkG2W _1VJPcaMZzS",
    'block-start': "_1ZB6UyPgdg _3iC0zdgHOl _1VJPcaMZzS",
    'start span-end': "_1ZB6UyPgdg _3iC0zdv3tX _1VJPcaMZzS",
    'span-start end': "_3iC0zdPgdg _1ZB6UyEbN9 _1VJPcaEFNz",
    'span-end end': "_3iC0zdPgdg _2I62gzXCiO _1VJPcaEFNz",
    'span-start start': "_1OKFqYPgdg _1ZB6UyEbN9 _1VJPcaEoIx",
    'span-end start': "_1OKFqYPgdg _2I62gzXCiO _1VJPcaEoIx",
    'end span-start': "_2I62gzPgdg _1OKFqYSPN1 _1VJPcacqvQ",
    'block-end': "_2I62gzPgdg _3iC0zdgHOl _1VJPcacqvQ",
    'end span-end': "_2I62gzPgdg _3iC0zdv3tX _1VJPcacqvQ"
};
const $b8d4f67f20aee211$export$88fca06e22f21720 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ placement: placement, testId: testId }, ref)=>{
    const { card: card, popoverContent: popoverContent } = (0, $euxye.useContext)((0, $2voEL.SpotlightContext));
    const positionArea = (0, $9TwwC.getResolvedPositionArea)(placement || card.placement, popoverContent.positionArea);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        // Growth Pattern Library designs dictate 1px radius. cssMap only allows tokens
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            borderEndStartRadius: '1px'
        },
        className: (0, $4jQY2.default)([
            $b8d4f67f20aee211$var$styles.root,
            $b8d4f67f20aee211$var$styles[positionArea]
        ])
    });
});

});
parcelRegister("9TwwC", function(module, exports) {
$parcel$export(module.exports, "getResolvedPositionArea", () => $97fdce8cf1b22c77$export$3aecfab3bd204999);
const $97fdce8cf1b22c77$var$caretPositionMap = {
    'top-start': 'start span-start',
    'top-center': 'block-start',
    'top-end': 'start span-end',
    'left-start': 'span-start start',
    'right-start': 'span-start end',
    'left-end': 'span-end start',
    'right-end': 'span-end end',
    'bottom-start': 'end span-start',
    'bottom-center': 'block-end',
    'bottom-end': 'end span-end'
};
const $97fdce8cf1b22c77$export$3aecfab3bd204999 = (placement, positionArea)=>{
    if (!positionArea || positionArea === 'none') return $97fdce8cf1b22c77$var$caretPositionMap[placement];
    return positionArea;
};

});




parcelRegister("7GDd6", function(module, exports) {
$parcel$export(module.exports, "SpotlightCard", () => $63c66b090da9c3b9$export$14710e13fc01d383);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $iqfTZ = parcelRequire("iqfTZ");

var $ihEDU = parcelRequire("ihEDU");

var $2voEL = parcelRequire("2voEL");

var $9TwwC = parcelRequire("9TwwC");

var $9ngYq = parcelRequire("9ngYq");
const $63c66b090da9c3b9$var$styles = {
    root: "_1mT5xdRAKS _39xV02E6Kk",
    card: "_0bjKvD8fU6 _2mHwu82ADO _39xV02T1Vg _46hvQm2ADO _0xmtko8HPE _3iDTPbQ4SZ _0aFT5vbt8w _2OUyjtFYNq",
    'start span-start': "_0xmtkogVvo",
    'block-start': "_0xmtkogVvo",
    'start span-end': "_0xmtkogVvo",
    'end span-start': "_46hvQmgVvo",
    'block-end': "_46hvQmgVvo",
    'end span-end': "_46hvQmgVvo",
    'span-start end': "_0LQT5EgVvo",
    'span-end end': "_0LQT5EgVvo",
    'span-start start': "_03SyCPgVvo",
    'span-end start': "_03SyCPgVvo"
};
const $63c66b090da9c3b9$export$14710e13fc01d383 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, placement: placement, testId: testId }, ref)=>{
    const { card: card, popoverContent: popoverContent } = (0, $euxye.useContext)((0, $2voEL.SpotlightContext));
    const cardRef = (0, $euxye.useRef)(null);
    const positionArea = (0, $9TwwC.getResolvedPositionArea)(placement || card.placement, popoverContent.positionArea);
    (0, $euxye.useEffect)(()=>{
        card.setRef(cardRef);
    }, [
        card
    ]);
    const content = /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        "data-testid": testId,
        ref: ref,
        className: (0, $4jQY2.default)([
            $63c66b090da9c3b9$var$styles.root,
            $63c66b090da9c3b9$var$styles[positionArea]
        ]),
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9ngYq.Caret), {
                placement: placement
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
                ref: cardRef,
                backgroundColor: "color.background.neutral.bold",
                xcss: $63c66b090da9c3b9$var$styles.card,
                children: children
            })
        ]
    });
    if ((0, $iqfTZ.fg)('platform-dst-motion-uplift-spotlight')) {
        const Motion = card.motion;
        if (Motion) return /*#__PURE__*/ (0, $e79Pd.jsx)(Motion, {
            children: content
        });
    }
    return content;
});

});


parcelRegister("8qQ8A", function(module, exports) {
$parcel$export(module.exports, "SpotlightControls", () => $d80a07ce19bf4418$export$67fb68d4ebe55a86);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $d80a07ce19bf4418$var$styles = {
    root: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5vf5Xk"
};
const $d80a07ce19bf4418$export$67fb68d4ebe55a86 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ testId: testId, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        role: "group",
        className: (0, $4jQY2.default)([
            $d80a07ce19bf4418$var$styles.root
        ]),
        children: children
    });
});

});

parcelRegister("8guPH", function(module, exports) {
$parcel$export(module.exports, "SpotlightDismissControl", () => $bdcee8ae3445c9d3$export$4eef19754b0d485e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1MNmN = parcelRequire("1MNmN");

var $i68tN = parcelRequire("i68tN");

var $6mEZn = parcelRequire("6mEZn");

var $2voEL = parcelRequire("2voEL");
const $bdcee8ae3445c9d3$var$styles = {
    root: "_0bjKvDKTcp _4c065UgVvo _1UtDYze5R3 _0KLXrugozt _1eOmH6kTlo _3gzVzLVbka"
};
const $bdcee8ae3445c9d3$export$4eef19754b0d485e = /*#__PURE__*/ (0, $euxye.forwardRef)(({ autoFocus: autoFocus = true, onClick: onClick, testId: testId }, ref)=>{
    const { popoverContent: popoverContent } = (0, $euxye.useContext)((0, $2voEL.SpotlightContext));
    const dismiss = (event)=>{
        popoverContent.dismiss.current(event);
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.Pressable), {
        autoFocus: autoFocus,
        onClick: onClick || dismiss,
        ref: ref,
        testId: testId,
        xcss: (0, $1MNmN.cx)($bdcee8ae3445c9d3$var$styles.root),
        "aria-label": "Dismiss",
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i68tN))), {
            label: "Close"
        })
    });
});

});

parcelRegister("7okqc", function(module, exports) {
$parcel$export(module.exports, "SpotlightFooter", () => $39ab0b4ff25765ec$export$f76dbc85ba76ccc2);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2XXtG = parcelRequire("2XXtG");
const $39ab0b4ff25765ec$var$styles = {
    root: "_0LQT5E5zaO _03SyCP8HPE _39xV02N91d"
};
const $39ab0b4ff25765ec$export$f76dbc85ba76ccc2 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2XXtG.Flex), {
        ref: ref,
        testId: testId,
        xcss: $39ab0b4ff25765ec$var$styles.root,
        alignItems: "center",
        justifyContent: "space-between",
        children: children
    });
});

});

parcelRegister("KcP1c", function(module, exports) {
$parcel$export(module.exports, "SpotlightHeader", () => $a08ff0490cdb722b$export$d646029b3ba8ab76);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2XXtG = parcelRequire("2XXtG");
const $a08ff0490cdb722b$var$styles = {
    root: "_0LQT5E5zaO _03SyCP8HPE"
};
const $a08ff0490cdb722b$export$d646029b3ba8ab76 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2XXtG.Flex), {
        ref: ref,
        testId: testId,
        xcss: $a08ff0490cdb722b$var$styles.root,
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.100",
        children: children
    });
});

});

parcelRegister("413te", function(module, exports) {
$parcel$export(module.exports, "SpotlightHeadline", () => $c3b5634c29732d73$export$b57275b1b6b9863b);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2iotI = parcelRequire("2iotI");

var $2voEL = parcelRequire("2voEL");
const $c3b5634c29732d73$export$b57275b1b6b9863b = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, testId: testId }, ref)=>{
    const { heading: heading } = (0, $euxye.useContext)((0, $2voEL.SpotlightContext));
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
        id: heading.id,
        ref: ref,
        testId: testId,
        size: "xsmall",
        children: children
    });
});

});

parcelRegister("54cWg", function(module, exports) {
$parcel$export(module.exports, "SpotlightMedia", () => $8dc393765cd13d5f$export$cf33151c3f01cd9a);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");
const $8dc393765cd13d5f$var$styles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _39xV02T1Vg _0jFU0V13wc"
};
const $8dc393765cd13d5f$export$cf33151c3f01cd9a = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        ref: ref,
        xcss: $8dc393765cd13d5f$var$styles.root,
        testId: testId,
        children: children
    });
});

});

parcelRegister("g5k19", function(module, exports) {
$parcel$export(module.exports, "PopoverProvider", () => $7091be7d3de26591$export$bf694c7c431c162a);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $PjTS8 = parcelRequire("PjTS8");

var $iM4OA = parcelRequire("iM4OA");
const $7091be7d3de26591$export$bf694c7c431c162a = ({ children: children })=>(0, $iqfTZ.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iM4OA.PopoverProvider), {
        children: children
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $PjTS8.PopoverProvider), {
        children: children
    });
$7091be7d3de26591$export$bf694c7c431c162a.displayName = "PopoverProvider";

});
parcelRegister("PjTS8", function(module, exports) {
$parcel$export(module.exports, "PopoverProvider", () => $425dadbd5a8e5801$export$bf694c7c431c162a);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $aFVSm = parcelRequire("aFVSm");

var $2voEL = parcelRequire("2voEL");
const $425dadbd5a8e5801$export$bf694c7c431c162a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2voEL.SpotlightContextProvider), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $aFVSm.Manager), {
            children: children
        })
    });
};
$425dadbd5a8e5801$export$bf694c7c431c162a.displayName = "PopoverProvider";

});

parcelRegister("iM4OA", function(module, exports) {
$parcel$export(module.exports, "PopoverProvider", () => $323f7219c31743c5$export$bf694c7c431c162a);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $2voEL = parcelRequire("2voEL");
const $323f7219c31743c5$export$bf694c7c431c162a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2voEL.SpotlightContextProvider), {
        children: children
    });
};
$323f7219c31743c5$export$bf694c7c431c162a.displayName = "PopoverProvider";

});


parcelRegister("5Gxfr", function(module, exports) {
$parcel$export(module.exports, "PopoverTarget", () => $059e7c93a49d2fc2$export$5ad0c0856b469f13);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $6Pi9S = parcelRequire("6Pi9S");

var $hA1WA = parcelRequire("hA1WA");
const $059e7c93a49d2fc2$export$5ad0c0856b469f13 = ({ children: children })=>(0, $iqfTZ.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hA1WA.PopoverTarget), {
        children: children
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6Pi9S.PopoverTarget), {
        children: children
    });
$059e7c93a49d2fc2$export$5ad0c0856b469f13.displayName = "PopoverTarget";

});
parcelRegister("6Pi9S", function(module, exports) {
$parcel$export(module.exports, "PopoverTarget", () => $a57f47321ba52191$export$5ad0c0856b469f13);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $hD6gn = parcelRequire("hD6gn");
const $a57f47321ba52191$export$5ad0c0856b469f13 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hD6gn.Reference), {
        children: ({ ref: ref })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                ref: ref,
                children: children
            })
    });
};
$a57f47321ba52191$export$5ad0c0856b469f13.displayName = "PopoverTarget";

});

parcelRegister("hA1WA", function(module, exports) {
$parcel$export(module.exports, "PopoverTarget", () => $d71269ac7c5f707d$export$5ad0c0856b469f13);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2voEL = parcelRequire("2voEL");
const $d71269ac7c5f707d$export$5ad0c0856b469f13 = ({ children: children })=>{
    const localRef = (0, $euxye.useRef)(null);
    const { target: target } = (0, $euxye.useContext)((0, $2voEL.SpotlightContext));
    (0, $euxye.useLayoutEffect)(()=>{
        target.setRef(localRef);
    }, [
        target
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: localRef,
        children: children
    });
};
$d71269ac7c5f707d$export$5ad0c0856b469f13.displayName = "PopoverTarget";

});


parcelRegister("jukA2", function(module, exports) {
$parcel$export(module.exports, "SpotlightPrimaryAction", () => $d2225780a4332ffe$export$eea27caf91a85655);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1MNmN = parcelRequire("1MNmN");

var $6mEZn = parcelRequire("6mEZn");
var $8Sdzy = parcelRequire("8Sdzy");

var $2voEL = parcelRequire("2voEL");
const $d2225780a4332ffe$var$styles = {
    root: "_0bjKvDKxmn _1UtDYze5R3",
    outline: "_3hxITi6wH8 _2V7sgONvrM _3vBAKHFIvx _0KLXrugozt _1eOmH6kTlo _3gzVzLVbka",
    primary: "_3hxITi6wH8 _2V7sgONvrM _3vBAKHJrlu _0KLXruDM2k _1eOmH6hmrj _3gzVzLczkD"
};
const $d2225780a4332ffe$export$eea27caf91a85655 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, appearance: appearance = 'outline', testId: testId }, ref)=>{
    const { primaryAction: primaryAction } = (0, $euxye.useContext)((0, $2voEL.SpotlightContext));
    const done = (event)=>{
        primaryAction.action.current(event);
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.Pressable), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: (0, $1MNmN.cx)($d2225780a4332ffe$var$styles.root, $d2225780a4332ffe$var$styles[appearance]),
        onClick: onClick || done,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
            as: "span",
            children: children
        })
    });
});

});

parcelRegister("bEy1I", function(module, exports) {
$parcel$export(module.exports, "SpotlightSecondaryAction", () => $f2272cefac637f0a$export$869dfff69399fe87);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $6mEZn = parcelRequire("6mEZn");
var $8Sdzy = parcelRequire("8Sdzy");

var $2voEL = parcelRequire("2voEL");
const $f2272cefac637f0a$var$styles = {
    root: "_0bjKvDKxmn _23rrnHyKLB _1UtDYze5R3 _0KLXrugozt _1eOmH6kTlo _3sFUREiSCN _3gzVzLVbka",
    rootMotion: "_0bjKvDKxmn _23rrnHyKLB _1UtDYze5R3 _0KLXrugozt _1eOmH6kTlo _3sFUREiSCN _3gzVzLVbka"
};
const $f2272cefac637f0a$export$869dfff69399fe87 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId }, ref)=>{
    const { secondaryAction: secondaryAction } = (0, $euxye.useContext)((0, $2voEL.SpotlightContext));
    const back = (event)=>{
        secondaryAction.action.current(event);
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.Pressable), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: (0, $iqfTZ.fg)('platform-dst-motion-uplift-custom-button') ? $f2272cefac637f0a$var$styles.rootMotion : $f2272cefac637f0a$var$styles.root,
        onClick: onClick || back,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
            as: "span",
            children: children
        })
    });
});

});

parcelRegister("7Bcvd", function(module, exports) {
$parcel$export(module.exports, "SpotlightStepCount", () => $0559987c6c2a1b4f$export$f4d9def8bfebca);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2XXtG = parcelRequire("2XXtG");
var $8Sdzy = parcelRequire("8Sdzy");

var $apUrw = parcelRequire("apUrw");
const $0559987c6c2a1b4f$var$styles = {
    root: "_4ouGXIW9qI"
};
const $0559987c6c2a1b4f$export$f4d9def8bfebca = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2XXtG.Flex), {
        xcss: $0559987c6c2a1b4f$var$styles.root,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $8Sdzy.Text), {
            ref: ref,
            testId: testId,
            children: [
                children,
                " ",
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apUrw.default), {
                    children: "steps"
                })
            ]
        })
    });
});

});

parcelRegister("8jEW8", function(module, exports) {
$parcel$export(module.exports, "default", () => $a998c846d301d85b$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $kDKsJ = parcelRequire("kDKsJ");

var $jyUW8 = parcelRequire("jyUW8");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $a998c846d301d85b$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $jyUW8.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kDKsJ.default), {
                name: name,
                hasNodeResolver: !(0, $iqfTZ.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$a998c846d301d85b$var$SpotlightTarget.displayName = "SpotlightTarget";
$a998c846d301d85b$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $a998c846d301d85b$export$2e2bcd8739ae039 = $a998c846d301d85b$var$SpotlightTarget;

});
parcelRegister("kDKsJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $668c803af62b73b9$export$2e2bcd8739ae039);
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $4C2iR = parcelRequire("4C2iR");
const $668c803af62b73b9$var$spanStyles = null;
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {string} props.name - The name to reference from Spotlight.
 * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $668c803af62b73b9$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4C2iR))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        ref: divRef,
        className: (0, $4jQY2.default)([
            "_3iDTPbcK7c"
        ]),
        children: children
    });
};
$668c803af62b73b9$var$NodeResolverSpotlightTarget.displayName = "NodeResolverSpotlightTarget";
$668c803af62b73b9$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $668c803af62b73b9$export$2e2bcd8739ae039 = $668c803af62b73b9$var$NodeResolverSpotlightTarget;

});


parcelRegister("c69sa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Box", () => $41c94d79c707c742$export$e71c4d32a2263218);
$parcel$export(module.exports, "default", () => $41c94d79c707c742$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $142Tc = parcelRequire("142Tc");

var $9yerk = parcelRequire("9yerk");

var $dt7pj = parcelRequire("dt7pj");

var $7vAAT = parcelRequire("7vAAT");

var $f7B36 = parcelRequire("f7B36");

var $6sazY = parcelRequire("6sazY");
function $41c94d79c707c742$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $41c94d79c707c742$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $f7B36.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, $hStPE.jsx)(Component, {
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        css: [
            $41c94d79c707c742$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $9yerk.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $dt7pj.isSurfaceColorToken)(backgroundColor) && (0, $6sazY.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $7vAAT.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $7vAAT.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $7vAAT.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $7vAAT.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $7vAAT.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $7vAAT.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $7vAAT.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
    return backgroundColor ? /*#__PURE__*/ (0, $hStPE.jsx)((0, $142Tc.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$41c94d79c707c742$export$2e2bcd8739ae039 = $41c94d79c707c742$export$e71c4d32a2263218;
const $41c94d79c707c742$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};

});
parcelRegister("9yerk", function(module, exports) {
$parcel$export(module.exports, "backgroundColorStylesMap", () => $143479dfe016eb32$export$e7af83bafe7f9e63);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $j88bo = parcelRequire("j88bo");

var $fuZop = parcelRequire("fuZop");
const $143479dfe016eb32$export$e7af83bafe7f9e63 = (0, $fuZop.getSerializedStylesMap)('backgroundColor', (0, $j88bo.backgroundColorMap));

});
parcelRegister("j88bo", function(module, exports) {
$parcel$export(module.exports, "backgroundColorMap", () => $c9a40271ea3d3bb9$export$d1d79bf68ac056bd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::96b9f393520fd437c1cb43d5fdfe3746>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ const $c9a40271ea3d3bb9$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.code.added.highlight': "var(--ds-background-code-added-highlight, #DCFFF1)",
    'color.background.code.added.line': "var(--ds-background-code-added-line, #BAF3DB66)",
    'color.background.code.default': "var(--ds-background-code-default, #FFFFFF)",
    'color.background.code.gutter': "var(--ds-background-code-gutter, #F0F1F2)",
    'color.background.code.highlight': "var(--ds-background-code-highlight, #F0F1F2)",
    'color.background.code.removed.highlight': "var(--ds-background-code-removed-highlight, #FFECEB)",
    'color.background.code.removed.line': "var(--ds-background-code-removed-line, #FFD5D266)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};

});

parcelRegister("fuZop", function(module, exports) {
$parcel$export(module.exports, "getSerializedStylesMap", () => $0c99d907b5934300$export$ca0f9c2de39ffed7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hStPE = parcelRequire("hStPE");
const $0c99d907b5934300$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, tokenName)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[tokenName] = /*#__PURE__*/ (0, $hStPE.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[tokenName]
        });
        return emotionSpacingMap;
    }, {});
};

});


parcelRegister("dt7pj", function(module, exports) {
$parcel$export(module.exports, "isSurfaceColorToken", () => $56e259207e3efb5a$export$5e65a44e5b6ecadb);

var $lPFpV = parcelRequire("lPFpV");
const $56e259207e3efb5a$export$5e65a44e5b6ecadb = (color)=>(0, $lPFpV.surfaceColorMap)[color] !== undefined;

});
parcelRegister("lPFpV", function(module, exports) {
$parcel$export(module.exports, "surfaceColorMap", () => $3b00f460968863bc$export$41a358c9c2356760);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13d3c71585857e2f6e4e4d97bf3c5d3c>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ const $3b00f460968863bc$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};

});


parcelRegister("7vAAT", function(module, exports) {
$parcel$export(module.exports, "paddingStylesMap", () => $539a66eee5a41630$export$e615f061ca585a6c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $eB2Za = parcelRequire("eB2Za");

var $kEbCQ = parcelRequire("kEbCQ");
const $539a66eee5a41630$export$e615f061ca585a6c = (0, $eB2Za.createSpacingStylesMap)((0, $kEbCQ.positiveSpaceMap));

});
parcelRegister("eB2Za", function(module, exports) {
$parcel$export(module.exports, "createSpacingStylesMap", () => $69930ecbbc4138d3$export$f2bee1f59203ac70);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $fuZop = parcelRequire("fuZop");
const $69930ecbbc4138d3$var$spacingProperties = [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'gap',
    'rowGap',
    'columnGap'
];
const $69930ecbbc4138d3$export$f2bee1f59203ac70 = (tokenMap)=>{
    return $69930ecbbc4138d3$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
        styleMap[spacingProperty] = (0, $fuZop.getSerializedStylesMap)(spacingProperty, tokenMap);
        return styleMap;
    }, {});
};

});

parcelRegister("kEbCQ", function(module, exports) {
$parcel$export(module.exports, "positiveSpaceMap", () => $78d514c46a10baf6$export$958d0ae7f2977ae4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74c97360a54b82f4dbd5ad077e96aba6>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::535518e7add48ef24f526d0904f70060>>
 */ const $78d514c46a10baf6$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};

});


parcelRegister("f7B36", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $263301f4d9ff7036$export$a9c84988c8f81f2d);
/* parse-xcss.tsx generated by @compiled/babel-plugin v3.0.2 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("euxye");

var $4VvV3 = parcelRequire("4VvV3");
const $263301f4d9ff7036$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $263301f4d9ff7036$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [(0, $4VvV3.uniqueSymbol)]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};

});
parcelRegister("4VvV3", function(module, exports) {
$parcel$export(module.exports, "uniqueSymbol", () => $f80324d0afd36e7b$export$43e479c916cb4ada);
const $f80324d0afd36e7b$export$43e479c916cb4ada = Symbol('UNSAFE_INTERNAL_styles');

});


parcelRegister("6sazY", function(module, exports) {
$parcel$export(module.exports, "surfaceColorStylesMap", () => $6dbf0e34d61b74c3$export$ff257d957d48c421);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $6er1G = parcelRequire("6er1G");

var $fuZop = parcelRequire("fuZop");

var $lPFpV = parcelRequire("lPFpV");
const $6dbf0e34d61b74c3$export$ff257d957d48c421 = (0, $fuZop.getSerializedStylesMap)((0, $6er1G.CURRENT_SURFACE_CSS_VAR), (0, $lPFpV.surfaceColorMap));

});


parcelRegister("fbAgj", function(module, exports) {
$parcel$export(module.exports, "xcss", () => $56b6837b44b3239a$export$f6c783d06584602c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hStPE = parcelRequire("hStPE");

var $jUfv4 = parcelRequire("jUfv4");

var $4VvV3 = parcelRequire("4VvV3");

var $gIMgJ = parcelRequire("gIMgJ");
const $56b6837b44b3239a$var$isSafeEnvToThrow = ()=>typeof $gIMgJ === 'object' && typeof $gIMgJ.env === 'object' && false;
const $56b6837b44b3239a$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $56b6837b44b3239a$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $56b6837b44b3239a$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
     // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($56b6837b44b3239a$var$transformStyles);
     // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $56b6837b44b3239a$var$safeSelectors.test(key)) {
            styleObj[key] = $56b6837b44b3239a$var$transformStyles(value);
            return;
        }
        if ($56b6837b44b3239a$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($56b6837b44b3239a$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        } // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in (0, $jUfv4.tokensMap))) return;
        const tokenValue = (0, $jUfv4.tokensMap)[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $56b6837b44b3239a$var$baseXcss = (style)=>{
    const transformedStyles = $56b6837b44b3239a$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [(0, $4VvV3.uniqueSymbol)]: /*#__PURE__*/ (0, $hStPE.css)(transformedStyles)
    };
};
function $56b6837b44b3239a$export$f6c783d06584602c(style) {
    return $56b6837b44b3239a$var$baseXcss(style);
}

});
parcelRegister("jUfv4", function(module, exports) {
$parcel$export(module.exports, "tokensMap", () => $9604027f9cdb149a$export$9a199fbafee0014e);

var $6sH38 = parcelRequire("6sH38");

var $j88bo = parcelRequire("j88bo");

var $eqqK5 = parcelRequire("eqqK5");

var $3NDSk = parcelRequire("3NDSk");

var $7olFJ = parcelRequire("7olFJ");

var $5kyFl = parcelRequire("5kyFl");

var $c5Z2m = parcelRequire("c5Z2m");

var $8ddiY = parcelRequire("8ddiY");

var $6EHXw = parcelRequire("6EHXw");

var $68YMg = parcelRequire("68YMg");

var $ivj3H = parcelRequire("ivj3H");

var $kEbCQ = parcelRequire("kEbCQ");

var $lHN6U = parcelRequire("lHN6U");

var $cYnVK = parcelRequire("cYnVK");
const $9604027f9cdb149a$export$9a199fbafee0014e = {
    backgroundColor: (0, $j88bo.backgroundColorMap),
    blockSize: (0, $5kyFl.dimensionMap),
    borderBlockColor: (0, $eqqK5.borderColorMap),
    borderBlockEndColor: (0, $eqqK5.borderColorMap),
    borderBlockEndWidth: (0, $7olFJ.borderWidthMap),
    borderBlockStartColor: (0, $eqqK5.borderColorMap),
    borderBlockStartWidth: (0, $7olFJ.borderWidthMap),
    borderBlockWidth: (0, $7olFJ.borderWidthMap),
    borderBottomColor: (0, $eqqK5.borderColorMap),
    borderBottomLeftRadius: (0, $3NDSk.borderRadiusMap),
    borderBottomRightRadius: (0, $3NDSk.borderRadiusMap),
    borderBottomWidth: (0, $7olFJ.borderWidthMap),
    borderColor: (0, $eqqK5.borderColorMap),
    borderEndEndRadius: (0, $3NDSk.borderRadiusMap),
    borderEndStartRadius: (0, $3NDSk.borderRadiusMap),
    borderInlineColor: (0, $eqqK5.borderColorMap),
    borderInlineEndColor: (0, $eqqK5.borderColorMap),
    borderInlineEndWidth: (0, $7olFJ.borderWidthMap),
    borderInlineStartColor: (0, $eqqK5.borderColorMap),
    borderInlineStartWidth: (0, $7olFJ.borderWidthMap),
    borderInlineWidth: (0, $7olFJ.borderWidthMap),
    borderLeftColor: (0, $eqqK5.borderColorMap),
    borderLeftWidth: (0, $7olFJ.borderWidthMap),
    borderRadius: (0, $3NDSk.borderRadiusMap),
    borderRightColor: (0, $eqqK5.borderColorMap),
    borderRightWidth: (0, $7olFJ.borderWidthMap),
    borderStartEndRadius: (0, $3NDSk.borderRadiusMap),
    borderStartStartRadius: (0, $3NDSk.borderRadiusMap),
    borderTopColor: (0, $eqqK5.borderColorMap),
    borderTopLeftRadius: (0, $3NDSk.borderRadiusMap),
    borderTopRightRadius: (0, $3NDSk.borderRadiusMap),
    borderTopWidth: (0, $7olFJ.borderWidthMap),
    borderWidth: (0, $7olFJ.borderWidthMap),
    bottom: (0, $6sH38.allSpaceMap),
    boxShadow: (0, $lHN6U.shadowMap),
    color: (0, $cYnVK.textColorMap),
    columnGap: (0, $kEbCQ.positiveSpaceMap),
    font: (0, $c5Z2m.fontMap),
    fontFamily: (0, $8ddiY.fontFamilyMap),
    fontWeight: (0, $6EHXw.fontWeightMap),
    gap: (0, $kEbCQ.positiveSpaceMap),
    height: (0, $5kyFl.dimensionMap),
    inlineSize: (0, $5kyFl.dimensionMap),
    inset: (0, $6sH38.allSpaceMap),
    insetBlock: (0, $6sH38.allSpaceMap),
    insetBlockEnd: (0, $6sH38.allSpaceMap),
    insetBlockStart: (0, $6sH38.allSpaceMap),
    insetInline: (0, $6sH38.allSpaceMap),
    insetInlineEnd: (0, $6sH38.allSpaceMap),
    insetInlineStart: (0, $6sH38.allSpaceMap),
    left: (0, $6sH38.allSpaceMap),
    margin: (0, $6sH38.allSpaceMap),
    marginBlock: (0, $6sH38.allSpaceMap),
    marginBlockEnd: (0, $6sH38.allSpaceMap),
    marginBlockStart: (0, $6sH38.allSpaceMap),
    marginBottom: (0, $6sH38.allSpaceMap),
    marginInline: (0, $6sH38.allSpaceMap),
    marginInlineEnd: (0, $6sH38.allSpaceMap),
    marginInlineStart: (0, $6sH38.allSpaceMap),
    marginLeft: (0, $6sH38.allSpaceMap),
    marginRight: (0, $6sH38.allSpaceMap),
    marginTop: (0, $6sH38.allSpaceMap),
    maxBlockSize: (0, $5kyFl.dimensionMap),
    maxHeight: (0, $5kyFl.dimensionMap),
    maxInlineSize: (0, $5kyFl.dimensionMap),
    maxWidth: (0, $5kyFl.dimensionMap),
    minBlockSize: (0, $5kyFl.dimensionMap),
    minHeight: (0, $5kyFl.dimensionMap),
    minInlineSize: (0, $5kyFl.dimensionMap),
    minWidth: (0, $5kyFl.dimensionMap),
    opacity: (0, $ivj3H.opacityMap),
    outlineColor: (0, $eqqK5.borderColorMap),
    outlineOffset: (0, $6sH38.allSpaceMap),
    outlineWidth: (0, $7olFJ.borderWidthMap),
    padding: (0, $kEbCQ.positiveSpaceMap),
    paddingBlock: (0, $kEbCQ.positiveSpaceMap),
    paddingBlockEnd: (0, $kEbCQ.positiveSpaceMap),
    paddingBlockStart: (0, $kEbCQ.positiveSpaceMap),
    paddingBottom: (0, $kEbCQ.positiveSpaceMap),
    paddingInline: (0, $kEbCQ.positiveSpaceMap),
    paddingInlineEnd: (0, $kEbCQ.positiveSpaceMap),
    paddingInlineStart: (0, $kEbCQ.positiveSpaceMap),
    paddingLeft: (0, $kEbCQ.positiveSpaceMap),
    paddingRight: (0, $kEbCQ.positiveSpaceMap),
    paddingTop: (0, $kEbCQ.positiveSpaceMap),
    right: (0, $6sH38.allSpaceMap),
    rowGap: (0, $kEbCQ.positiveSpaceMap),
    top: (0, $6sH38.allSpaceMap),
    width: (0, $5kyFl.dimensionMap),
    zIndex: (0, $68YMg.layerMap)
};

});
parcelRegister("6sH38", function(module, exports) {
$parcel$export(module.exports, "allSpaceMap", () => $a73d6cea96fcfd37$export$632685d741f3dbbf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::94bb7ad218078fc2cc90ea62a0140ae3>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::535518e7add48ef24f526d0904f70060>>
 */ const $a73d6cea96fcfd37$export$632685d741f3dbbf = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)",
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};

});

parcelRegister("eqqK5", function(module, exports) {
$parcel$export(module.exports, "borderColorMap", () => $70648264fb678b98$export$1531ad5bb3fbedac);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ef63ba8f83d883326f33eea24d6a13fe>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ const $70648264fb678b98$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.code': "var(--ds-border-code, #0B120E24)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.input.search': "var(--ds-border-input-search, #0B120E24)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};

});

parcelRegister("3NDSk", function(module, exports) {
$parcel$export(module.exports, "borderRadiusMap", () => $9eb54e254eb8bc49$export$3c0a6c3e64bb180d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::64bf0f735ca61c977fe42d0b404ae683>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::8817f4073995e5dc9c2bb766316632d6>>
 */ const $9eb54e254eb8bc49$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};

});

parcelRegister("7olFJ", function(module, exports) {
$parcel$export(module.exports, "borderWidthMap", () => $a837dc7d6eb821a3$export$e1b83c5210c471b8);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9cc07267bf53de18206960d38ce91e77>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::8817f4073995e5dc9c2bb766316632d6>>
 */ const $a837dc7d6eb821a3$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};

});

parcelRegister("5kyFl", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $48aec4bd65a15938$export$6ccdbebca2ee545f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e4616710c813452a5dda10e6c422716>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 */ const $48aec4bd65a15938$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};

});

parcelRegister("c5Z2m", function(module, exports) {
$parcel$export(module.exports, "fontMap", () => $2f6019250eb623c4$export$6ffa317d5e70375);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9dc903b89132658c3e8db351b3cf92f>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $2f6019250eb623c4$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("8ddiY", function(module, exports) {
$parcel$export(module.exports, "fontFamilyMap", () => $b164bbf3de2da60d$export$3c7e9587132614b4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1bd05ea1282426e07fb0ae630b07823d>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $b164bbf3de2da60d$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("6EHXw", function(module, exports) {
$parcel$export(module.exports, "fontWeightMap", () => $a478123d9d21feb1$export$303e322c6b1ed114);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::709c4cdac6e8ef806ec1e227c3e362d1>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $a478123d9d21feb1$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};

});

parcelRegister("68YMg", function(module, exports) {
$parcel$export(module.exports, "layerMap", () => $46edc3ee72aa7f7e$export$b5f31a7e431d2eab);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10940883f780b624bff6c0029b7ac6fd>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $46edc3ee72aa7f7e$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};

});

parcelRegister("ivj3H", function(module, exports) {
$parcel$export(module.exports, "opacityMap", () => $9dee5cf018e0577a$export$daf94a976c798b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dd2c45abe6b4fad449cf3f1f465ae0c7>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ const $9dee5cf018e0577a$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};

});

parcelRegister("lHN6U", function(module, exports) {
$parcel$export(module.exports, "shadowMap", () => $95cf03f304a38047$export$7aff6e7ba39bb774);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ef716a134bf8e20bada34c22bbe79f4e>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ const $95cf03f304a38047$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};

});

parcelRegister("cYnVK", function(module, exports) {
$parcel$export(module.exports, "textColorMap", () => $7da4269e25929f8c$export$8473307aa00d6ea1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28b9ad0abf39b10f1551913e577ded9c>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d88dceee1459b4e9e492bb497e903575>>
 */ const $7da4269e25929f8c$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.code.accent.1': "var(--ds-text-code-accent-1, #943D73)",
    'color.text.code.accent.2': "var(--ds-text-code-accent-2, #1558BC)",
    'color.text.code.comments': "var(--ds-text-code-comments, #505258)",
    'color.text.code.default': "var(--ds-text-code-default, #505258)",
    'color.text.code.functions': "var(--ds-text-code-functions, #216E4E)",
    'color.text.code.gutter': "var(--ds-text-code-gutter, #6B6E76)",
    'color.text.code.keywords': "var(--ds-text-code-keywords, #AE2E24)",
    'color.text.code.numbers': "var(--ds-text-code-numbers, #7F5F01)",
    'color.text.code.operators': "var(--ds-text-code-operators, #292A2E)",
    'color.text.code.strings': "var(--ds-text-code-strings, #4C6B1F)",
    'color.text.code.tags': "var(--ds-text-code-tags, #9E4C00)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};

});



parcelRegister("iOfms", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca0ac5a157643e8d$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $lTw6o = parcelRequire("lTw6o");

var $9Yy3v = parcelRequire("9Yy3v");

var $fYjvD = parcelRequire("fYjvD");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $ca0ac5a157643e8d$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $lTw6o.default), {
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName,
        ...saferRest,
        children: [
            iconBefore && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9Yy3v.default), {
                type: "icon",
                position: "before",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fYjvD.default), {
                    icon: iconBefore
                })
            }),
            children && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9Yy3v.default), {
                isLoading: isLoading,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9Yy3v.default), {
                type: "icon",
                position: "after",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fYjvD.default), {
                    icon: iconAfter
                })
            })
        ]
    });
}));
$ca0ac5a157643e8d$var$Button.displayName = 'Button';
var $ca0ac5a157643e8d$export$2e2bcd8739ae039 = $ca0ac5a157643e8d$var$Button;

});

parcelRegister("6Elhl", function(module, exports) {
$parcel$export(module.exports, "Flex", () => $ca4838a6086e8df2$export$f51f4c4ede09e011);
$parcel$export(module.exports, "default", () => $ca4838a6086e8df2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $f7B36 = parcelRequire("f7B36");

var $9g2ml = parcelRequire("9g2ml");
function $ca4838a6086e8df2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ca4838a6086e8df2$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $ca4838a6086e8df2$var$flexDirectionMap = {
    column: {
        name: "qdeacm",
        styles: "flex-direction:column"
    },
    row: {
        name: "mcnhyd",
        styles: "flex-direction:row"
    }
};
const $ca4838a6086e8df2$var$flexWrapMap = {
    wrap: {
        name: "1qemjat",
        styles: "flex-wrap:wrap"
    },
    nowrap: {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    }
};
const $ca4838a6086e8df2$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    },
    stretch: {
        name: "1ikgkii",
        styles: "align-items:stretch"
    }
};
const $ca4838a6086e8df2$var$baseStyles = {
    name: "kxpnum",
    styles: "display:flex;box-sizing:border-box"
};
const $ca4838a6086e8df2$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, id: id }, ref)=>{
    const resolvedStyles = (0, $f7B36.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $hStPE.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $ca4838a6086e8df2$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $9g2ml.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $9g2ml.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $9g2ml.spaceStylesMap).rowGap[rowGap],
            alignItems && $ca4838a6086e8df2$var$alignItemsMap[alignItems],
            direction && $ca4838a6086e8df2$var$flexDirectionMap[direction],
            justifyContent && $ca4838a6086e8df2$var$justifyContentMap[justifyContent],
            wrap && $ca4838a6086e8df2$var$flexWrapMap[wrap],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$ca4838a6086e8df2$export$f51f4c4ede09e011.displayName = 'Flex';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ca4838a6086e8df2$export$2e2bcd8739ae039 = $ca4838a6086e8df2$export$f51f4c4ede09e011;

});
parcelRegister("9g2ml", function(module, exports) {
$parcel$export(module.exports, "spaceStylesMap", () => $2fd5bea34e3b3aad$export$bf46c3f9eeafc71f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $eB2Za = parcelRequire("eB2Za");

var $kEbCQ = parcelRequire("kEbCQ");
const $2fd5bea34e3b3aad$export$bf46c3f9eeafc71f = (0, $eB2Za.createSpacingStylesMap)((0, $kEbCQ.positiveSpaceMap));

});


parcelRegister("bgHVp", function(module, exports) {
$parcel$export(module.exports, "getTokenValue", () => $f6a1402d187ec89b$export$37e2c47c7e49c28a);
$parcel$export(module.exports, "default", () => $f6a1402d187ec89b$export$2e2bcd8739ae039);


var $2AJY0 = parcelRequire("2AJY0");

var $gIMgJ = parcelRequire("gIMgJ");
function $f6a1402d187ec89b$export$37e2c47c7e49c28a(tokenId, fallback = '') {
    let token = (0, $2AJY0.default)[tokenId];
    let tokenValue = fallback;
    typeof $gIMgJ;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $f6a1402d187ec89b$export$2e2bcd8739ae039 = $f6a1402d187ec89b$export$37e2c47c7e49c28a;

});

parcelRegister("e3neg", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e0935c8a3019fd8$export$2e2bcd8739ae039);
/* badge-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $8Sdzy = parcelRequire("8Sdzy");

var $4C7HL = parcelRequire("4C7HL");

var $lzwXk = parcelRequire("lzwXk");
// Nested selectors with data attributes are required for theme switching
const $8e0935c8a3019fd8$var$stylesNew = {
    root: "_0bjKvDcjp5 _2Y7lL41Y8M _4c065UdnbC _3iDTPbccYA _24h04i2Njc _4ouGXINHnM _37wbyuDIqT _3YEZNOdnbC _3L9DPXBY1A",
    success: "_1UtDYzM9Wa _0KLXruQuCm",
    danger: "_1UtDYzOZ2O _0KLXruJXmd",
    warning: "_1UtDYzVRW9 _0KLXru2bwY",
    information: "_1UtDYzdx2f _0KLXru9V7L",
    discovery: "_1UtDYzAGgF _0KLXruZB9y",
    neutral: "_1UtDYzy7kJ _0KLXruG6qS",
    inverse: "_0KLXrulfZc _1UtDYzy7kJ",
    informationBold: "_1UtDYzdx2f _0KLXruJVoT",
    successBold: "_1UtDYzM9Wa _0KLXruX1bq",
    dangerBold: "_1UtDYzOZ2O _0KLXrug6EK",
    warningBold: "_1UtDYzVRW9 _0KLXruKLKE",
    warningBoldDark: "_1UtDYzVRW9 _0KLXruDh4Z",
    discoveryBold: "_1UtDYzAGgF _0KLXruXfaS"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ const $8e0935c8a3019fd8$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && max ? (0, $lzwXk.formatValue)(children, max) : children;
}; /**
    * __BadgeNew__
    *
    * New visual refresh implementation of Badge component for the labelling system.
    *
    * Uses new appearance naming convention:
    * - success (green)
    * - danger (red)
    * - neutral (gray)
    * - information (blue)
    * - inverse (inverted colors)
    * - warning (orange/yellow)
    * - discovery (purple)
    * - informationBold (bold blue, color.background.information.subtle)
    * - successBold (bold green, color.background.success.subtle)
    * - dangerBold (bold red, color.background.danger.subtle)
    * - warningBold (bold warning, color.background.warning.bold)
    * - discoveryBold (bold purple, color.background.discovery.subtle)
    */ 
const $8e0935c8a3019fd8$var$BadgeNew = /*#__PURE__*/ (0, $euxye.memo)(function BadgeNew({ appearance: appearance = 'neutral', children: children = 0, max: max = 99, style: style, testId: testId }) {
    const { colorMode: colorMode } = (0, $4C7HL.useThemeObserver)(); // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    const resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $4jQY2.default)([
            $8e0935c8a3019fd8$var$stylesNew.root,
            $8e0935c8a3019fd8$var$stylesNew[resolvedAppearance]
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $8e0935c8a3019fd8$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
var $8e0935c8a3019fd8$export$2e2bcd8739ae039 = $8e0935c8a3019fd8$var$BadgeNew;

});
parcelRegister("lzwXk", function(module, exports) {
$parcel$export(module.exports, "formatValue", () => $f6eeaa7a82db6196$export$7c4d25c0c3217d8c);
function $f6eeaa7a82db6196$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $f6eeaa7a82db6196$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $f6eeaa7a82db6196$var$getSafeValue(value);
    const safeMax = $f6eeaa7a82db6196$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("890Pg", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $b20cf30788f3b5f2$export$e5c5a5f917a5871c);

var $euxye = parcelRequire("euxye");
const $b20cf30788f3b5f2$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $euxye.useEffect) : (0, $euxye.useLayoutEffect);

});

parcelRegister("jYEcG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Pressable", () => $bf0056bec9aeae05$export$27c701ed9e449e99);
$parcel$export(module.exports, "default", () => $bf0056bec9aeae05$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $aZBDA = parcelRequire("aZBDA");

var $2oRWW = parcelRequire("2oRWW");

var $Cs8MU = parcelRequire("Cs8MU");

var $9yerk = parcelRequire("9yerk");

var $eqqK5 = parcelRequire("eqqK5");

var $7olFJ = parcelRequire("7olFJ");

var $7vAAT = parcelRequire("7vAAT");

var $f7B36 = parcelRequire("f7B36");

var $kEbCQ = parcelRequire("kEbCQ");
function $bf0056bec9aeae05$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $bf0056bec9aeae05$var$focusRingStyles = /*#__PURE__*/ (0, $hStPE.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $eqqK5.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $kEbCQ.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $7olFJ.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $7olFJ.borderWidthMap)['border.width']} solid`
        }
    }
});
const $bf0056bec9aeae05$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};
const $bf0056bec9aeae05$var$enabledStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $bf0056bec9aeae05$var$disabledStyles = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
const $bf0056bec9aeae05$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $2oRWW.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $euxye.useContext)((0, $Cs8MU.default));
    const handleClick = (0, $euxye.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $f7B36.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $hStPE.jsx)("button", {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $bf0056bec9aeae05$var$baseStyles,
            $bf0056bec9aeae05$var$focusRingStyles,
            isDisabled ? $bf0056bec9aeae05$var$disabledStyles : $bf0056bec9aeae05$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $9yerk.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $7vAAT.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $7vAAT.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $7vAAT.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $7vAAT.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $7vAAT.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $7vAAT.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $7vAAT.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId
    }, children);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$bf0056bec9aeae05$export$2e2bcd8739ae039 = $bf0056bec9aeae05$export$27c701ed9e449e99;

});

parcelRegister("jaPl6", function(module, exports) {
$parcel$export(module.exports, "default", () => $684e875f80090208$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $iOfms = parcelRequire("iOfms");


var $ljVHR = parcelRequire("ljVHR");

var $2oRWW = parcelRequire("2oRWW");

var $540vN = parcelRequire("540vN");

var $8xAgn = parcelRequire("8xAgn");

var $ld25x = parcelRequire("ld25x");

var $fe5lW = parcelRequire("fe5lW");

var $iqfTZ = parcelRequire("iqfTZ");

var $4QBVk = parcelRequire("4QBVk");

var $akMu8 = parcelRequire("akMu8");

var $7cUuc = parcelRequire("7cUuc");

var $gSKa9 = parcelRequire("gSKa9");

var $Cca5P = parcelRequire("Cca5P");

var $fbg0X = parcelRequire("fbg0X");

var $eY5Ho = parcelRequire("eY5Ho");

var $1wU5E = parcelRequire("1wU5E");
const $684e875f80090208$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $684e875f80090208$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $684e875f80090208$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$684e875f80090208$var$opposites[crossAxis]}`,
            `${$684e875f80090208$var$opposites[mainAxis]}-${crossAxis}`,
            `${$684e875f80090208$var$opposites[mainAxis]}`,
            `${$684e875f80090208$var$opposites[mainAxis]}-${$684e875f80090208$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$684e875f80090208$var$opposites[mainAxis]}`,
        `${$684e875f80090208$var$opposites[mainAxis]}-start`,
        `${$684e875f80090208$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $684e875f80090208$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ function $684e875f80090208$var$DropdownMenuLegacy({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $2oRWW.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $akMu8.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $540vN.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $euxye.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $euxye.useState)(false);
    const id = (0, $1wU5E.default)();
    const itemRef = (0, $eY5Ho.default)();
    const { currentLevel: currentLevel } = (0, $fe5lW.useLayering)();
    const fallbackPlacements = (0, $euxye.useMemo)(()=>$684e875f80090208$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $euxye.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $euxye.useCallback)((event, currentLevel)=>{
        const isTabLeftOrEscapeKey = $684e875f80090208$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $48dedd10700aff3c$export$fc4577f2a2af0ae3));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $684e875f80090208$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $48dedd10700aff3c$export$fc4577f2a2af0ae3))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && event.target.closest?.((0, $iqfTZ.fg)('platform_dst-a11y_modal-trigger-haspopup') ? `[id^=${0, $1wU5E.PREFIX}] [aria-haspopup="menu"], [id^=${0, $1wU5E.PREFIX}] [aria-haspopup="true"]` : `[id^=${0, $1wU5E.PREFIX}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($684e875f80090208$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $48dedd10700aff3c$export$fc4577f2a2af0ae3))) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event?.target instanceof HTMLElement && event.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $8xAgn.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $euxye.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $2oRWW.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $2oRWW.default;
        return (0, $glbdM.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest((0, $iqfTZ.fg)('platform_dst-a11y_modal-trigger-haspopup') ? `[id^=${0, $1wU5E.PREFIX}] [aria-haspopup="menu"], [id^=${0, $1wU5E.PREFIX}] [aria-haspopup="true"]` : `[id^=${0, $1wU5E.PREFIX}] [aria-haspopup]`);
                if (e.key === (0, $48dedd10700aff3c$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $48dedd10700aff3c$export$e51a3576c045c8d5) || e.key === (0, $48dedd10700aff3c$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $48dedd10700aff3c$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fbg0X.default), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4QBVk.Popup), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $ljVHR.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iOfms.default), {
                    ...bindFocus,
                    ref: (0, $ljVHR.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld25x))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $gSKa9.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $Cca5P.default), {
                        spacing: spacing,
                        maxHeight: $684e875f80090208$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
}
$684e875f80090208$var$DropdownMenuLegacy.displayName = "DropdownMenuLegacy";
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $684e875f80090208$var$DropdownMenu = (props)=>{
    const { autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading, isOpen: isOpen, onOpenChange: onOpenChange = (0, $2oRWW.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    if ((0, $iqfTZ.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7cUuc.default), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, $e79Pd.jsx)($684e875f80090208$var$DropdownMenuLegacy, {
        ...props
    });
};
$684e875f80090208$var$DropdownMenu.displayName = "DropdownMenu";
var $684e875f80090208$export$2e2bcd8739ae039 = $684e875f80090208$var$DropdownMenu;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $48dedd10700aff3c$export$390330c10ff2b9a1 = 'ArrowUp';
const $48dedd10700aff3c$export$a80636c6f41931fe = 'ArrowDown';
const $48dedd10700aff3c$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $48dedd10700aff3c$export$c40f9845adc73fb5 = 'ArrowRight';
const $48dedd10700aff3c$export$4af703091671bc = 'Home';
const $48dedd10700aff3c$export$e2bc30913faa5db7 = 'End';
const $48dedd10700aff3c$export$10f6869ed0a7d75b = 'Tab';
const $48dedd10700aff3c$export$8152f929a25a0ff4 = 'Enter';
const $48dedd10700aff3c$export$e51a3576c045c8d5 = 'Space';
const $48dedd10700aff3c$export$2bb790b9008907b4 = 'Escape';

parcelRegister("540vN", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ba328d777e1eb3a$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
function $3ba328d777e1eb3a$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $euxye.useState)(getDefaultPropValue);
    const isControlledRef = (0, $euxye.useRef)(isControlled);
    (0, $euxye.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $euxye.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("8xAgn", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2ef48a7df002b70$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
function $b2ef48a7df002b70$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $euxye.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $euxye.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $euxye.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("7cUuc", function(module, exports) {
$parcel$export(module.exports, "default", () => $42c7598284560bcb$export$2e2bcd8739ae039);
/* dropdown-menu-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $glbdM = parcelRequire("glbdM");

var $iOfms = parcelRequire("iOfms");


var $2oRWW = parcelRequire("2oRWW");

var $540vN = parcelRequire("540vN");

var $8xAgn = parcelRequire("8xAgn");

var $ld25x = parcelRequire("ld25x");

var $72ldR = parcelRequire("72ldR");

var $iqfTZ = parcelRequire("iqfTZ");

var $abhF2 = parcelRequire("abhF2");

var $gD1FN = parcelRequire("gD1FN");

var $blhfr = parcelRequire("blhfr");

var $gkWVj = parcelRequire("gkWVj");

var $j0Y0H = parcelRequire("j0Y0H");

var $Yce2Z = parcelRequire("Yce2Z");

var $4uAo9 = parcelRequire("4uAo9");

var $lEgz2 = parcelRequire("lEgz2");

var $kUmcP = parcelRequire("kUmcP");

var $fbg0X = parcelRequire("fbg0X");
const $42c7598284560bcb$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $42c7598284560bcb$var$styles = {
    spinnerContainer: "_3iDTPbQ4SZ _4ouGXIoaux _37wbyuDIqT _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W"
};
function $42c7598284560bcb$var$getRootMenuPopover({ menu: menu }) {
    const parentMenu = menu.parentElement?.closest('[popover][role="menu"]');
    if (!parentMenu) return menu;
    return $42c7598284560bcb$var$getRootMenuPopover({
        menu: parentMenu
    });
}
/**
 * Loading indicator for the dropdown menu.
 */ function $42c7598284560bcb$var$LoadingIndicator({ statusLabel: statusLabel = 'Loading', testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        role: "menuitem",
        className: (0, $4jQY2.default)([
            $42c7598284560bcb$var$styles.spinnerContainer
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $abhF2.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
}
$42c7598284560bcb$var$LoadingIndicator.displayName = "LoadingIndicator";
/**
 * Top-layer implementation of DropdownMenu.
 *
 * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
 * with the native Popover API via `@atlaskit/top-layer`.
 *
 * What is no longer needed:
 * - Portal: top layer handles stacking natively
 * - FocusLock / react-focus-lock: popover=auto provides light dismiss
 * - z-index: top layer is always above everything
 * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
 * - handle-focus.tsx: replaced by `useArrowNavigation`
 * - Layering context: top layer nesting is handled by the browser
 * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
 */ function $42c7598284560bcb$var$DropdownMenuTopLayer({ children: children, defaultOpen: defaultOpen = false, isLoading: isLoading, isOpen: isOpenProp, onOpenChange: onOpenChange = (0, $2oRWW.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $540vN.default)(isOpenProp, ()=>defaultOpen);
    const triggerRef = (0, $euxye.useRef)(null);
    const popoverRef = (0, $euxye.useRef)(null);
    const setPopoverRef = (0, $euxye.useCallback)((element)=>{
        popoverRef.current = element;
        // Leave untouched menus without a busy state; retain false once it has been set.
        if (isLoading !== undefined || element?.hasAttribute('aria-busy')) element?.setAttribute('aria-busy', String(Boolean(isLoading)));
    }, [
        isLoading
    ]);
    const popoverId = (0, $kUmcP.usePopoverId)();
    const topLayerPlacement = (0, $euxye.useMemo)(()=>(0, $gkWVj.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]);
    // DropdownMenu has no `shouldFitViewport` equivalent, so neither axis ever
    // fits and `blockSize` stays `'content'` - `MenuGroup`'s `maxHeight` owns the
    // block axis.
    (0, $4uAo9.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isLocalOpen,
        inlineSize: shouldFitContainer ? 'min-anchor' : 'content'
    });
    // Close handling.
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration, effectively overriding it.
    const handleOnClose = (0, $euxye.useCallback)(()=>{
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    // Trigger click handling.
    const handleTriggerClicked = (0, $euxye.useCallback)((event)=>{
        const nextIsOpen = !isLocalOpen;
        setLocalIsOpen(nextIsOpen);
        // Extract the native DOM event for onOpenChange
        const nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: nextIsOpen,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $8xAgn.default)();
    // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $euxye.useEffect)(()=>{
        if (!isFocused || isLocalOpen) return;
        // Do not open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        const isNestedTrigger = Boolean(triggerRef.current?.closest('[role="menu"]'));
        return (0, $glbdM.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $48dedd10700aff3c$export$a80636c6f41931fe) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]);
    const handleNestedOpen = (0, $euxye.useCallback)(({ trigger: trigger })=>{
        if ((0, $iqfTZ.fg)('platform_dst-a11y_modal-trigger-haspopup') && !trigger.matches('[aria-haspopup="menu"], [aria-haspopup="true"]')) return;
        trigger.click();
    }, []);
    const handleTabClose = (0, $euxye.useCallback)(()=>{
        const currentMenu = popoverRef.current;
        if (!currentMenu) return;
        // Hiding the root native popover synchronously closes its descendant popovers and restores
        // focus to the root trigger. The browser can then perform the Tab default action from there.
        $42c7598284560bcb$var$getRootMenuPopover({
            menu: currentMenu
        }).hidePopover();
    }, []);
    (0, $lEgz2.useArrowNavigation)({
        containerRef: popoverRef,
        onClose: handleTabClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleOnClose,
        isEnabled: isLocalOpen,
        filter: (0, $blhfr.isAtCurrentMenuLevel)
    });
    // Close on menu item click.
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested submenu triggers.
    const handleMenuClick = (0, $euxye.useCallback)((e)=>{
        if (!(e.target instanceof Element)) return;
        const menuItem = e.target.closest?.('[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        const isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio';
        // With dialog semantics enabled, only menu/true popup values identify submenus.
        // The nested dropdown will handle its own open/close.
        const isNestedTrigger = (0, $iqfTZ.fg)('platform_dst-a11y_modal-trigger-haspopup') ? menuItem.matches('[aria-haspopup="menu"], [aria-haspopup="true"]') : menuItem.hasAttribute('aria-haspopup');
        if (!isCheckboxOrRadio && !isNestedTrigger) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    const ariaAttributes = (0, $gD1FN.getAriaForTrigger)({
        role: 'menu',
        isOpen: isLocalOpen,
        popoverId: popoverId
    });
    /**
   * Custom trigger consumers historically receive a callback ref,
   * and their code assumes it is one.
   * Using this wrapper for compatibility...
   */ const setTriggerRef = (0, $euxye.useCallback)((node)=>{
        triggerRef.current = node;
    }, []);
    const renderTrigger = ()=>{
        if (typeof trigger === 'function') return trigger({
            ...ariaAttributes,
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            triggerRef: setTriggerRef,
            isSelected: isLocalOpen,
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`
        });
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iOfms.default), {
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            ref: setTriggerRef,
            ...ariaAttributes,
            isSelected: isLocalOpen,
            iconAfter: (iconProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld25x))), {
                    ...iconProps,
                    size: "small"
                }),
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`,
            "aria-label": label,
            interactionName: interactionName,
            children: trigger
        });
    };
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $fbg0X.default), {
        children: [
            renderTrigger(),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $Yce2Z.Popover), {
                ref: setPopoverRef,
                id: popoverId,
                role: "menu",
                label: menuLabel ?? label ?? (typeof trigger === 'string' ? trigger : 'Menu'),
                isOpen: isLocalOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--content`,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $j0Y0H.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $72ldR.default), {
                        maxHeight: $42c7598284560bcb$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClick: handleMenuClick,
                        spacing: spacing,
                        testId: testId && `${testId}--menu-wrapper--menu-group`,
                        children: isLoading ? /*#__PURE__*/ (0, $e79Pd.jsx)($42c7598284560bcb$var$LoadingIndicator, {
                            statusLabel: statusLabel,
                            testId: testId && `${testId}--menu-wrapper--loading-indicator`
                        }) : children
                    })
                })
            })
        ]
    });
}
$42c7598284560bcb$var$DropdownMenuTopLayer.displayName = "DropdownMenuTopLayer";
var $42c7598284560bcb$export$2e2bcd8739ae039 = $42c7598284560bcb$var$DropdownMenuTopLayer;

});
parcelRegister("72ldR", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2f5dd2d32e5dfcc$export$2e2bcd8739ae039);
/* menu-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $hb5XE = parcelRequire("hb5XE");

var $6VbJ7 = parcelRequire("6VbJ7");
const $a2f5dd2d32e5dfcc$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $a2f5dd2d32e5dfcc$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', menuLabel: menuLabel, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $hb5XE.SpacingContext).Provider, {
        value: spacing,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6VbJ7.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "border",
            children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                "aria-busy": isLoading,
                style: {
                    minWidth: minWidth,
                    maxWidth: maxWidth,
                    minHeight: minHeight,
                    maxHeight: maxHeight
                },
                "data-testid": testId,
                role: role,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $4jQY2.default)([
                    "_4bt5LAIZbP _2WAcuGIZbP _3iDTPbQ4SZ _1mT5xd5HSx _0aFT5vbt8w",
                    UNSAFE_className
                ]),
                "aria-label": menuLabel,
                ...rest
            })
        })
    });
$a2f5dd2d32e5dfcc$var$MenuGroup.displayName = "MenuGroup";
var $a2f5dd2d32e5dfcc$export$2e2bcd8739ae039 = $a2f5dd2d32e5dfcc$var$MenuGroup;

});
parcelRegister("hb5XE", function(module, exports) {
$parcel$export(module.exports, "SpacingContext", () => $9e32141cd5d70445$export$443076ec7ebce042);

var $euxye = parcelRequire("euxye");
const $9e32141cd5d70445$export$443076ec7ebce042 = /*#__PURE__*/ (0, $euxye.createContext)('cozy');

});

parcelRegister("6VbJ7", function(module, exports) {
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", () => $783384851104dcfb$export$9ca534b70725964d);

var $euxye = parcelRequire("euxye");
const $783384851104dcfb$export$9ca534b70725964d = /*#__PURE__*/ (0, $euxye.createContext)('border');

});


parcelRegister("blhfr", function(module, exports) {
$parcel$export(module.exports, "isAtCurrentMenuLevel", () => $143455946b95bafc$export$f1bba0ef464d60af);
const $143455946b95bafc$var$menuScope = '[role="menu"]';
/**
 * Recursively walks from `node` toward `container`, returning `true` when
 * `container` is reached without crossing another `role="menu"` ancestor.
 *
 * Used by `isAtCurrentMenuLevel` (pattern 2) to determine if the
 * `closestMenu` is owned by the wrapper container directly. Recursion
 * avoids a mutable `let parent` walk and keeps the function body linear.
 */ function $143455946b95bafc$var$reachesContainerWithoutNestedMenu(node, container) {
    if (!node || node === container) return node === container;
    if (node.getAttribute('role') === 'menu') return false;
    return $143455946b95bafc$var$reachesContainerWithoutNestedMenu(node.parentElement, container);
}
function $143455946b95bafc$export$f1bba0ef464d60af(element, container) {
    const closestMenu = element.closest($143455946b95bafc$var$menuScope);
    // Container itself has role="menu". Element belongs to this level
    // if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Container is a wrapper without role="menu" (e.g. dropdown-menu
    // wraps a MenuGroup). The element belongs to the top level if its
    // closest role="menu" ancestor is a direct child of the container,
    // i.e. there is no nested role="menu" between them.
    if (closestMenu === null) return true;
    // Walk up from the closest menu to see if it is "owned" by this
    // container without passing through another role="menu" first.
    return $143455946b95bafc$var$reachesContainerWithoutNestedMenu(closestMenu.parentElement, container);
}

});

parcelRegister("lEgz2", function(module, exports) {
$parcel$export(module.exports, "useArrowNavigation", () => $12de6a43134d95d6$export$23dfbae28e0cc453);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");


var $42lUo = parcelRequire("42lUo");

var $1ExBq = parcelRequire("1ExBq");

var $1it5j = parcelRequire("1it5j");
const $12de6a43134d95d6$var$menuScope = '[role="menu"]';
function $12de6a43134d95d6$export$23dfbae28e0cc453({ containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: isEnabled = true, filter: filter }) {
    const handleKeyDown = (0, $euxye.useCallback)((event)=>{
        const container = containerRef.current;
        if (!container) return;
        // Guard: only handle the event if the currently focused element
        // belongs to this menu level. The focused element's closest
        // [role="menu"] must be this container (not a nested sub-menu).
        // When no filter is provided, fall back to the closest-menu check
        // if the container has role="menu".
        const focused = container.ownerDocument.activeElement;
        if (focused instanceof HTMLElement) {
            if (filter) {
                if (!filter(focused, container)) return;
            }
            if (!filter && container.getAttribute('role') === 'menu' && focused.closest($12de6a43134d95d6$var$menuScope) !== container) return;
        }
        if (event.key === (0, $48dedd10700aff3c$export$a80636c6f41931fe)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $1it5j.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $48dedd10700aff3c$export$390330c10ff2b9a1)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $1it5j.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $48dedd10700aff3c$export$4af703091671bc)) {
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (0, $42lUo.getFirstFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $48dedd10700aff3c$export$e2bc30913faa5db7)) {
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (0, $1ExBq.getLastFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $48dedd10700aff3c$export$10f6869ed0a7d75b)) {
            onClose();
            return;
        }
        // ── Nested menu navigation (WAI-ARIA menu pattern) ──
        // ArrowRight on a menuitem with aria-haspopup opens the submenu.
        if (event.key === 'ArrowRight') {
            if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focused
                });
            }
            return;
        }
        // ArrowLeft closes the current menu if it is nested inside a parent menu.
        if (event.key === 'ArrowLeft') {
            if (onNestedClose) {
                // Only close if this container is inside another role="menu"
                // (i.e. it is a submenu, not the top-level menu).
                // Walk up from the parent to avoid matching the container itself.
                const isNested = Boolean(container.parentElement?.closest($12de6a43134d95d6$var$menuScope));
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $euxye.useEffect)(()=>{
        const container = containerRef.current;
        if (!container || !isEnabled) return;
        return (0, $glbdM.bind)(container, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
}

});

parcelRegister("fbg0X", function(module, exports) {
$parcel$export(module.exports, "default", () => $70e2e29d9f604102$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1vaVt = parcelRequire("1vaVt");
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $70e2e29d9f604102$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $euxye.useRef)({});
    const context = (0, $euxye.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1vaVt.SelectionStoreContext).Provider, {
        value: context,
        children: children
    });
};
$70e2e29d9f604102$var$SelectionStore.displayName = "SelectionStore";
var $70e2e29d9f604102$export$2e2bcd8739ae039 = $70e2e29d9f604102$var$SelectionStore;

});
parcelRegister("1vaVt", function(module, exports) {
$parcel$export(module.exports, "SelectionStoreContext", () => $d833963c94d39032$export$756f795847463ebd);

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");
const $d833963c94d39032$export$756f795847463ebd = /*#__PURE__*/ (0, $euxye.createContext)({
    setItemState: (0, $2oRWW.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $2oRWW.default),
    getGroupState: ()=>({})
});

});



parcelRegister("gSKa9", function(module, exports) {
$parcel$export(module.exports, "default", () => $01b4dd60fad03ad9$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $fe5lW = parcelRequire("fe5lW");

var $9cMYi = parcelRequire("9cMYi");

var $4tzdI = parcelRequire("4tzdI");
/**
 * Focus manager logic.
 */ const $01b4dd60fad03ad9$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $euxye.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $euxye.useState)(0);
    const registerMode = (0, $euxye.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $euxye.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $fe5lW.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $euxye.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $euxye.useEffect)(()=>(0, $glbdM.bind)(window, {
            type: 'keydown',
            listener: (0, $9cMYi.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4tzdI.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
$01b4dd60fad03ad9$var$FocusManager.displayName = "FocusManager";
var $01b4dd60fad03ad9$export$2e2bcd8739ae039 = $01b4dd60fad03ad9$var$FocusManager;

});
parcelRegister("9cMYi", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a63e06c00acd169$export$2e2bcd8739ae039);


var $iqfTZ = parcelRequire("iqfTZ");

var $1wU5E = parcelRequire("1wU5E");
const $5a63e06c00acd169$var$actionMap = {
    [(0, $48dedd10700aff3c$export$a80636c6f41931fe)]: 'next',
    [(0, $48dedd10700aff3c$export$390330c10ff2b9a1)]: 'prev',
    [(0, $48dedd10700aff3c$export$4af703091671bc)]: 'first',
    [(0, $48dedd10700aff3c$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $5a63e06c00acd169$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $5a63e06c00acd169$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $5a63e06c00acd169$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $iqfTZ.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $1wU5E.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $48dedd10700aff3c$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $48dedd10700aff3c$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $48dedd10700aff3c$export$fc4577f2a2af0ae3)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $48dedd10700aff3c$export$c40f9845adc73fb5)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $5a63e06c00acd169$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $5a63e06c00acd169$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $5a63e06c00acd169$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $5a63e06c00acd169$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $5a63e06c00acd169$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("1wU5E", function(module, exports) {
$parcel$export(module.exports, "PREFIX", () => $736d2075b443dbea$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $736d2075b443dbea$export$2e2bcd8739ae039);

var $gUxVT = parcelRequire("gUxVT");
const $736d2075b443dbea$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $736d2075b443dbea$export$2e2bcd8739ae039() {
    const id = (0, $gUxVT.useId)();
    return `${$736d2075b443dbea$export$8a682ae47622dbb9}${id}`;
}

});


parcelRegister("4tzdI", function(module, exports) {
$parcel$export(module.exports, "FocusManagerContext", () => $89651e9afb5e7fd7$export$f18c1d4fc7326096);

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");
const $89651e9afb5e7fd7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $euxye.createContext)({
    menuItemRefs: [],
    registerRef: (0, $2oRWW.default)
});

});


parcelRegister("Cca5P", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c3aae41b86df0fa$export$2e2bcd8739ae039);
/* menu-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $72ldR = parcelRequire("72ldR");

var $iqfTZ = parcelRequire("iqfTZ");

var $ihEDU = parcelRequire("ihEDU");

var $abhF2 = parcelRequire("abhF2");

var $dygci = parcelRequire("dygci");

var $9pfoO = parcelRequire("9pfoO");

var $4tzdI = parcelRequire("4tzdI");
const $0c3aae41b86df0fa$var$styles = {
    spinnerContainer: "_3iDTPbQ4SZ _4ouGXIoaux _37wbyuDIqT _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W"
};
const $0c3aae41b86df0fa$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        xcss: $0c3aae41b86df0fa$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $abhF2.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
$0c3aae41b86df0fa$var$LoadingIndicator.displayName = "LoadingIndicator";
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $0c3aae41b86df0fa$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $euxye.useContext)((0, $4tzdI.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $dygci.default)(menuItem) || (0, $9pfoO.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $euxye.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $euxye.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $iqfTZ.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $72ldR.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $e79Pd.jsx)($0c3aae41b86df0fa$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
$0c3aae41b86df0fa$var$MenuWrapper.displayName = "MenuWrapper";
var $0c3aae41b86df0fa$export$2e2bcd8739ae039 = $0c3aae41b86df0fa$var$MenuWrapper;

});
parcelRegister("dygci", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf8578c6544557f4$export$2e2bcd8739ae039);
function $cf8578c6544557f4$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("9pfoO", function(module, exports) {
$parcel$export(module.exports, "default", () => $1afdbf236e9ce2d3$export$2e2bcd8739ae039);
function $1afdbf236e9ce2d3$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("eY5Ho", function(module, exports) {
$parcel$export(module.exports, "default", () => $0fef179dd6ae079f$export$2e2bcd8739ae039);
// eslint-disable-next-line sort-imports

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $4tzdI = parcelRequire("4tzdI");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $0fef179dd6ae079f$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $euxye.useContext)((0, $4tzdI.FocusManagerContext));
    const itemRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        if (hasPopup && (0, $iqfTZ.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $0fef179dd6ae079f$export$2e2bcd8739ae039 = $0fef179dd6ae079f$var$useRegisterItemWithFocusManager;

});


parcelRegister("bcqL7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28569a1ba0e49d9b1ede9e97db5921f7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8275927b92cae0d1$var$_react = $8275927b92cae0d1$var$_interopRequireDefault((parcelRequire("euxye")));

var $8275927b92cae0d1$var$_iconNew = $8275927b92cae0d1$var$_interopRequireDefault((parcelRequire("52mjj")));
function $8275927b92cae0d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiSearch".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-search
 * Usage guidance:
 * Reserved for search interactions powered by Rovo/AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8275927b92cae0d1$var$AiSearchIcon = (props)=>/*#__PURE__*/ $8275927b92cae0d1$var$_react.default.createElement($8275927b92cae0d1$var$_iconNew.default, Object.assign({
        name: "AiSearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 2.612A4.501 4.501 0 0 0 7 11.5a4.48 4.48 0 0 0 3.182-1.318A4.5 4.5 0 0 0 11.387 8h1.53a6 6 0 0 1-1.179 2.678l3.292 3.292-1.06 1.06-3.292-3.292A6 6 0 1 1 6 1.084z"/><path fill="currentcolor" d="M14 3.25a.75.75 0 0 1-.493.705l-1.285.469a.5.5 0 0 0-.298.298l-.469 1.285a.75.75 0 0 1-1.41 0l-.469-1.285a.5.5 0 0 0-.298-.298l-1.285-.469a.75.75 0 0 1-.484-.589L7.5 3.25l.009-.116a.75.75 0 0 1 .484-.59l1.285-.468a.5.5 0 0 0 .298-.298l.469-1.285.049-.106A.75.75 0 0 1 10.749 0l.116.009a.75.75 0 0 1 .541.378l.05.106.468 1.285a.5.5 0 0 0 .298.298l1.285.469A.75.75 0 0 1 14 3.25"/>`
    }, props));
$8275927b92cae0d1$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $8275927b92cae0d1$var$_default = module.exports.default = $8275927b92cae0d1$var$AiSearchIcon;

});

parcelRegister("2iKt6", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", () => $df01af48a2d7ab34$export$e23ae35269442b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4ebbb5ba469a9ff5e91d5204f2f881d>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ed9Xn = parcelRequire("ed9Xn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $df01af48a2d7ab34$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
function $df01af48a2d7ab34$export$e23ae35269442b4f({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ed9Xn.IconWrapper), {
        svg: $df01af48a2d7ab34$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$df01af48a2d7ab34$export$e23ae35269442b4f.displayName = "RovoIcon";

});

parcelRegister("lMezl", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb0af1433c4de5f8$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1MNmN = parcelRequire("1MNmN");

var $ljVHR = parcelRequire("ljVHR");

var $4jiTv = parcelRequire("4jiTv");

var $iqfTZ = parcelRequire("iqfTZ");

var $9MWap = parcelRequire("9MWap");

var $hZDXn = parcelRequire("hZDXn");

var $apUrw = parcelRequire("apUrw");

var $9Yy3v = parcelRequire("9Yy3v");

var $fYjvD = parcelRequire("fYjvD");
const $fb0af1433c4de5f8$var$styles = {
    base: "_0bjKvDKTcp _2sNsIgmnOE _23rrnHoacQ _2V7sgOdnbC _4c065UgVvo _3iDTPbccYA _24h04i2Njc _39xV02IZbP _1EqgXlN91d _1mT5xdRAKS _0hPCNLQame _37wbyuDIqT _17lj8p1Y8M _3YEZNOdnbC _0jFU0VZ49V _1kk5Tkf7mX _03SyCP8HPE _0LQT5E8HPE _2fwxA5DIqT _1RrJLit2nV _2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _2tbAUcYbGa _2WYcYGWVPG",
    interactiveMotion: "_23rrnHyKLB _3sFUREiSCN",
    linkDecorationUnset: "_00uqCYIoZn _3xtjKNOiJt _0H9qDFp3yX _32C2rkyL8i _0i9AWAYbGa _0mm6KQ6wH8 _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8",
    disabled: "_0wOv4Qsyl5 _0KLXruVrZW _1UtDYzot27 _0GBAIrYbGa _1eOmH6VrZW _0clgaMot27 _3gzVzLVrZW _0CMRbkot27",
    spacingCompact: "_4c065UFQfX _17lj8p1Y8M _03SyCP8HPE _0LQT5E8HPE _1RrJLit2nV _0jFU0V9DVM _39xV029DVM",
    iconButton: "_0jFU0VZ49V _39xV02Z49V _03SyCPPgdg _0LQT5EPgdg",
    circle: "_0bjKvDS5Zs"
};
const $fb0af1433c4de5f8$var$defaultStyles = {
    root: "_0KLXru5FNy _1UtDYzZpcK _0z8nYC9r67 _0GBAIrogpp _2nTuUYZpcK _10n1R5ZpcK _1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK"
};
const $fb0af1433c4de5f8$var$primaryStyles = {
    root: "_0KLXruDM2k _1UtDYze5R3 _2nTuUYe5R3 _0clgaMe5R3 _1eOmH6hmrj _0CMRbke5R3 _3gzVzLczkD"
};
const $fb0af1433c4de5f8$var$rovoStyles = {
    root: "_0KLXruWwnm _1UtDYze5R3 _2nTuUYe5R3 _1eOmH63nEM _3gzVzLjYGY"
};
const $fb0af1433c4de5f8$var$discoveryStyles = {
    root: "_0KLXruqjHC _1UtDYze5R3 _2nTuUYe5R3 _0clgaMe5R3 _1eOmH6nIkF _0CMRbke5R3 _3gzVzLSHT5"
};
const $fb0af1433c4de5f8$var$subtleStyles = {
    root: "_0KLXru5FNy _1UtDYzZpcK _2nTuUYZpcK _10n1R5zfdP _1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK"
};
const $fb0af1433c4de5f8$var$selectedStyles = {
    root: "_0KLXruY9q9 _1UtDYzjTy9 _0z8nYCrzt2 _0GBAIrogpp _2nTuUYjTy9 _10n1R5jTy9 _0clgaMjTy9 _0CMRbkjTy9",
    discovery: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9"
};
const $fb0af1433c4de5f8$var$LinkIconButtonBase = ({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, newWindowLabel: newWindowLabel, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const localRef = (0, $euxye.useRef)(null);
    (0, $4jiTv.default)(localRef, autoFocus);
    if (!isTooltipDisabled) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        hasNewContentOnTriggerClick: tooltip?.hasNewContentOnTriggerClick,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        children: (triggerProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $9MWap.Anchor), {
                ...saferRest,
                "aria-labelledby": ariaLabelledBy,
                newWindowLabel: newWindowLabel,
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                // Shared between tooltip and native props
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                // Shared between tooltip and base props
                onClick: (event, analyticsEvent)=>{
                    onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                ref: (0, $ljVHR.default)([
                    localRef,
                    ref,
                    triggerProps.ref
                ].filter(Boolean)),
                // Base props only
                xcss: (0, $1MNmN.cx)($fb0af1433c4de5f8$var$styles.base, !isDisabled && (0, $iqfTZ.fg)('platform-dst-motion-uplift-button') && $fb0af1433c4de5f8$var$styles.interactiveMotion, appearance === 'default' && $fb0af1433c4de5f8$var$defaultStyles.root, appearance === 'primary' && $fb0af1433c4de5f8$var$primaryStyles.root, appearance === 'rovo' && $fb0af1433c4de5f8$var$rovoStyles.root, appearance === 'discovery' && $fb0af1433c4de5f8$var$discoveryStyles.root, appearance === 'subtle' && $fb0af1433c4de5f8$var$subtleStyles.root, $fb0af1433c4de5f8$var$styles.linkDecorationUnset, isSelected && $fb0af1433c4de5f8$var$selectedStyles.root, isSelected && appearance === 'discovery' && $fb0af1433c4de5f8$var$selectedStyles.discovery, isDisabled && $fb0af1433c4de5f8$var$styles.disabled, $fb0af1433c4de5f8$var$styles.iconButton, spacing === 'compact' && $fb0af1433c4de5f8$var$styles.spacingCompact, shape === 'circle' && $fb0af1433c4de5f8$var$styles.circle),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                /**
       * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
       * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
       */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
                href: isDisabled ? undefined : href,
                role: isDisabled ? 'link' : undefined,
                "aria-disabled": isDisabled === true ? true : undefined,
                children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $9Yy3v.default), {
                    type: "icon",
                    isLoading: false,
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fYjvD.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apUrw.default), {
                            children: label
                        })
                    ]
                })
            })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9MWap.Anchor), {
        ...saferRest,
        // aria-label={preventedAriaLabel}
        "aria-labelledby": ariaLabelledBy,
        newWindowLabel: newWindowLabel,
        ref: (0, $ljVHR.default)([
            localRef,
            ref
        ]),
        xcss: (0, $1MNmN.cx)($fb0af1433c4de5f8$var$styles.base, !isDisabled && (0, $iqfTZ.fg)('platform-dst-motion-uplift-button') && $fb0af1433c4de5f8$var$styles.interactiveMotion, appearance === 'default' && $fb0af1433c4de5f8$var$defaultStyles.root, appearance === 'primary' && $fb0af1433c4de5f8$var$primaryStyles.root, appearance === 'rovo' && $fb0af1433c4de5f8$var$rovoStyles.root, appearance === 'discovery' && $fb0af1433c4de5f8$var$discoveryStyles.root, appearance === 'subtle' && $fb0af1433c4de5f8$var$subtleStyles.root, $fb0af1433c4de5f8$var$styles.linkDecorationUnset, isSelected && $fb0af1433c4de5f8$var$selectedStyles.root, isSelected && appearance === 'discovery' && $fb0af1433c4de5f8$var$selectedStyles.discovery, isDisabled && $fb0af1433c4de5f8$var$styles.disabled, $fb0af1433c4de5f8$var$styles.iconButton, spacing === 'compact' && $fb0af1433c4de5f8$var$styles.spacingCompact, shape === 'circle' && $fb0af1433c4de5f8$var$styles.circle),
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        testId: testId,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $9Yy3v.default), {
            type: "icon",
            isLoading: false,
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fYjvD.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apUrw.default), {
                    children: label
                })
            ]
        })
    });
};
$fb0af1433c4de5f8$var$LinkIconButtonBase.displayName = "LinkIconButtonBase";
// Workarounds to support generic types with forwardRef + memo
const $fb0af1433c4de5f8$var$WithRef = /*#__PURE__*/ (0, $euxye.forwardRef)($fb0af1433c4de5f8$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ const $fb0af1433c4de5f8$var$LinkIconButton = /*#__PURE__*/ (0, $euxye.memo)($fb0af1433c4de5f8$var$WithRef);
var $fb0af1433c4de5f8$export$2e2bcd8739ae039 = $fb0af1433c4de5f8$var$LinkIconButton;

});

parcelRegister("9ufM9", function(module, exports) {
$parcel$export(module.exports, "default", () => $3be14343f82d9092$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1MNmN = parcelRequire("1MNmN");

var $ljVHR = parcelRequire("ljVHR");

var $4jiTv = parcelRequire("4jiTv");

var $iqfTZ = parcelRequire("iqfTZ");

var $9MWap = parcelRequire("9MWap");

var $9Yy3v = parcelRequire("9Yy3v");

var $fYjvD = parcelRequire("fYjvD");
const $3be14343f82d9092$var$styles = {
    base: "_0bjKvDKTcp _2sNsIgmnOE _23rrnHoacQ _2V7sgOdnbC _4c065UgVvo _3iDTPbccYA _24h04i2Njc _39xV02IZbP _1EqgXlN91d _1mT5xdRAKS _0hPCNLQame _37wbyuDIqT _17lj8p1Y8M _3YEZNOdnbC _0jFU0VZ49V _1kk5Tkf7mX _03SyCP8HPE _0LQT5E8HPE _2fwxA5DIqT _1RrJLit2nV _2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _2tbAUcYbGa _2WYcYGWVPG",
    interactiveMotion: "_23rrnHyKLB _3sFUREiSCN",
    linkDecorationUnset: "_00uqCYIoZn _3xtjKNOiJt _0H9qDFp3yX _32C2rkyL8i _0i9AWAYbGa _0mm6KQ6wH8 _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8",
    disabled: "_0wOv4Qsyl5 _0KLXruVrZW _1UtDYzot27 _0GBAIrYbGa _1eOmH6VrZW _0clgaMot27 _3gzVzLVrZW _0CMRbkot27",
    spacingCompact: "_4c065UFQfX _17lj8p1Y8M _0jFU0V9DVM _03SyCP8HPE _0LQT5E8HPE _1RrJLit2nV",
    buttonIconBefore: "_0LQT5E8HPE _17lj8pgVvo",
    buttonIconAfter: "_03SyCP8HPE _17lj8pgVvo",
    fullWidth: "_39xV02N91d"
};
const $3be14343f82d9092$var$defaultStyles = {
    root: "_0KLXru5FNy _1UtDYzZpcK _0z8nYC9r67 _0GBAIrogpp _2nTuUYZpcK _10n1R5ZpcK _1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK"
};
const $3be14343f82d9092$var$primaryStyles = {
    root: "_0KLXruDM2k _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _1eOmH6hmrj _0CMRbke5R3 _3gzVzLczkD"
};
const $3be14343f82d9092$var$rovoStyles = {
    root: "_0KLXruWwnm _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _1eOmH63nEM _3gzVzLjYGY"
};
const $3be14343f82d9092$var$warningStyles = {
    root: "_0KLXruKLKE _1UtDYzVW6T _2nTuUYVW6T _10n1R5VW6T _0clgaMVW6T _1eOmH6OCpk _0CMRbkVW6T _3gzVzLSN2W"
};
const $3be14343f82d9092$var$dangerStyles = {
    root: "_0KLXruqsXs _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _1eOmH6EISo _0CMRbke5R3 _3gzVzLL5fL"
};
const $3be14343f82d9092$var$discoveryStyles = {
    root: "_0KLXruqjHC _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _1eOmH6nIkF _0CMRbke5R3 _3gzVzLSHT5"
};
const $3be14343f82d9092$var$subtleStyles = {
    root: "_0KLXru5FNy _1UtDYzZpcK _2nTuUYZpcK _10n1R5zfdP _1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK"
};
const $3be14343f82d9092$var$selectedStyles = {
    root: "_0KLXruY9q9 _1UtDYzjTy9 _0z8nYCrzt2 _0GBAIrogpp _2nTuUYjTy9 _10n1R5jTy9 _0clgaMjTy9 _0CMRbkjTy9",
    warning: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9",
    danger: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9",
    discovery: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $3be14343f82d9092$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance = 'default', 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus = false, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const hasIconAfter = Boolean(iconAfter);
    const hasIconBefore = Boolean(iconBefore);
    const localRef = (0, $euxye.useRef)(null);
    (0, $4jiTv.default)(localRef, autoFocus);
    const combinedRef = (0, $ljVHR.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $9MWap.Anchor), {
        analyticsContext: analyticsContext,
        ref: combinedRef,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName,
        ...saferRest,
        xcss: (0, $1MNmN.cx)($3be14343f82d9092$var$styles.base, !isDisabled && (0, $iqfTZ.fg)('platform-dst-motion-uplift-button') && $3be14343f82d9092$var$styles.interactiveMotion, appearance === 'default' && $3be14343f82d9092$var$defaultStyles.root, appearance === 'primary' && $3be14343f82d9092$var$primaryStyles.root, appearance === 'rovo' && $3be14343f82d9092$var$rovoStyles.root, appearance === 'warning' && $3be14343f82d9092$var$warningStyles.root, appearance === 'danger' && $3be14343f82d9092$var$dangerStyles.root, appearance === 'discovery' && $3be14343f82d9092$var$discoveryStyles.root, appearance === 'subtle' && $3be14343f82d9092$var$subtleStyles.root, $3be14343f82d9092$var$styles.linkDecorationUnset, isSelected && $3be14343f82d9092$var$selectedStyles.root, isSelected && appearance === 'danger' && $3be14343f82d9092$var$selectedStyles.danger, isSelected && appearance === 'warning' && $3be14343f82d9092$var$selectedStyles.warning, isSelected && appearance === 'discovery' && $3be14343f82d9092$var$selectedStyles.discovery, isDisabled && $3be14343f82d9092$var$styles.disabled, spacing === 'compact' && $3be14343f82d9092$var$styles.spacingCompact, hasIconBefore && $3be14343f82d9092$var$styles.buttonIconBefore, hasIconAfter && $3be14343f82d9092$var$styles.buttonIconAfter, shouldFitContainer && $3be14343f82d9092$var$styles.fullWidth),
        children: [
            iconBefore && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9Yy3v.default), {
                type: "icon",
                position: "before",
                isLoading: false,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fYjvD.default), {
                    icon: iconBefore
                })
            }),
            children && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9Yy3v.default), {
                isLoading: false,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9Yy3v.default), {
                type: "icon",
                position: "after",
                isLoading: false,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fYjvD.default), {
                    icon: iconAfter
                })
            })
        ]
    });
};
$3be14343f82d9092$var$LinkButtonBase.displayName = "LinkButtonBase";
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $3be14343f82d9092$var$LinkButton = /*#__PURE__*/ (0, $euxye.forwardRef)($3be14343f82d9092$var$LinkButtonBase);
$3be14343f82d9092$var$LinkButton.displayName = 'LinkButton';
var $3be14343f82d9092$export$2e2bcd8739ae039 = $3be14343f82d9092$var$LinkButton;

});

parcelRegister("2YPKP", function(module, exports) {
$parcel$export(module.exports, "default", () => $09757c48f40b0ffe$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $ljVHR = parcelRequire("ljVHR");

var $ceqcm = parcelRequire("ceqcm");

var $3HgHS = parcelRequire("3HgHS");

var $cSR11 = parcelRequire("cSR11");

var $iqfTZ = parcelRequire("iqfTZ");

var $eY5Ho = parcelRequire("eY5Ho");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $09757c48f40b0ffe$var$DropdownMenuItem = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // Nested submenu triggers register with the focus manager inside DropdownMenu.
    // Dialog triggers must register here so arrow navigation can reach them.
    const isNestedTrigger = (0, $iqfTZ.fg)('platform_dst-a11y_modal-trigger-haspopup') ? !!rest['aria-haspopup'] && rest['aria-haspopup'] !== 'dialog' : !!rest['aria-haspopup'];
    const itemRef = (0, $eY5Ho.default)(isNestedTrigger);
    const handleItemClick = (0, $euxye.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3HgHS.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $ljVHR.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cSR11.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $ljVHR.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ceqcm.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $ljVHR.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        ...isNestedTrigger && (0, $iqfTZ.fg)('platform_dst_dropdown_nested_trigger_aria_current') ? {
            'aria-current': undefined
        } : {},
        children: children
    });
});
var $09757c48f40b0ffe$export$2e2bcd8739ae039 = $09757c48f40b0ffe$var$DropdownMenuItem;

});
parcelRegister("ceqcm", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fd6ad0aaff2e9ea$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $Cs8MU = parcelRequire("Cs8MU");

var $fsBHR = parcelRequire("fsBHR");
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $9fd6ad0aaff2e9ea$var$ButtonItem = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const { children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $euxye.useContext)((0, $Cs8MU.default));
    const handleClick = (0, $euxye.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fsBHR.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $e79Pd.jsx)("button", {
                "data-testid": testId,
                // This is intentionally placed before the `...rest` spread to prevent overriding existing usages of `aria-current`,
                // which are already being passed to the button element.
                "aria-current": isSelected ? 'true' : undefined,
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref,
                disabled: isDisabled,
                onClick: handleClick,
                onMouseDown: onMouseDownHandler,
                type: "button",
                children: children
            })
    });
}));
var $9fd6ad0aaff2e9ea$export$2e2bcd8739ae039 = $9fd6ad0aaff2e9ea$var$ButtonItem;

});
parcelRegister("fsBHR", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbb8793b0ba6b8fa$export$2e2bcd8739ae039);
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $iqfTZ = parcelRequire("iqfTZ");

var $defJG = parcelRequire("defJG");

var $hb5XE = parcelRequire("hb5XE");

var $6VbJ7 = parcelRequire("6VbJ7");
const $cbb8793b0ba6b8fa$var$renderTitle = (Component, props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
        ...props
    });
const $cbb8793b0ba6b8fa$var$styles = {
    root: "_30huDKdnbC _2xIroY98eZ _497WNwYbGa _2zndICdnbC _00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _1mT5xdRAKS _3iDTPbQ4SZ _24h04i2Njc _39xV02N91d _4kiQYAUF4f _43nrzTPgdg _2xTnZxPgdg _0rIjykPgdg _0GTcwRPgdg _0hPCNLDIqT _20VacPYbGa _0wOv4Q7zJH _2hGPVj98eZ _2i3C1kYbGa _2kH23qT6kp _1zr6DcnXvL _1ubuxonXvL _38a67RZPSy _34b3D2ZPSy _0htemX6wH8 _1NDpvb6wH8 _067Lcevc3e _2wtOC9vc3e _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _3e11vU6wH8 _0hSAgbHZdu",
    beforeAfterElement: "_3iDTPbQ4SZ _4ouGXIoWWg _4kiQYAoWWg _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
    content: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _2O5Vij7dHp _2fwxA5ecOK",
    truncate: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _39HuIbz8Lp _1ANEUSLRg7",
    title: "_2sNsIgmnOE",
    wordBreak: "_3W2Oc8wPeg",
    description: "_2sNsIg7NXe _1UtDYzKGUX",
    disabledDescription: "_1UtDYzot27",
    unselected: "_0KLXru5FNy _1UtDYz98eZ _2nTuUY98eZ _1eOmH6o126 _0clgaM98eZ _3gzVzLo126 _0CMRbk98eZ",
    disabled: "_0wOv4Qsyl5 _0KLXru5FNy _1UtDYzot27 _1eOmH65FNy _0clgaMot27 _3gzVzL5FNy _0CMRbkot27",
    selectedBorder: "_3ScelF4Jdh _3dCYwDWVPG _4diMdqrzt2 _3Ku51Iogpp _3p3AmIPgdg _1cR5ZLPgdg _2jTvwtPgdg",
    selectedNotch: "_1OimfuMLSV _3ScelFUNDJ _3dCYwDWVPG _4diMdqrzt2 _3Ku51Iogpp _3p3AmI8HPE _1cR5ZL8HPE _2jTvwtPgdg",
    selected: "_0KLXruY9q9 _1UtDYzjTy9 _2nTuUYjTy9 _1eOmH6sumd _0clgaM866Z _3gzVzLXsxn _0CMRbkjTy9",
    selectedOld: "_0clgaMjTy9",
    motionUnselected: "_23rrnHo10F _1B4rbIo10F _3sFUREDdj4",
    motionSelected: "_23rrnHWE38 _1B4rbIo10F"
};
const $cbb8793b0ba6b8fa$var$spacingMapStyles = {
    cozy: "_4c065U2ADO _2Y7lL45zaO",
    compact: "_4c065U1Y8M _2Y7lL48HPE _4kiQYAUofl"
};
const $cbb8793b0ba6b8fa$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ const $cbb8793b0ba6b8fa$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, testId: testId })=>{
    const spacing = (0, $euxye.useContext)((0, $hb5XE.SpacingContext));
    const selectionStyle = (0, $euxye.useContext)((0, $6VbJ7.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const UNSAFE_className = UNSAFE_externalClassName;
    return (()=>{
        return children({
            className: (0, $4jQY2.default)([
                (0, $4jQY2.default)([
                    $cbb8793b0ba6b8fa$var$styles.root,
                    $cbb8793b0ba6b8fa$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $cbb8793b0ba6b8fa$var$styles.unselected,
                    !isDisabled && !isSelected && (0, $iqfTZ.fg)('platform-dst-motion-uplift-list-item') && $cbb8793b0ba6b8fa$var$styles.motionUnselected,
                    !isDisabled && isSelected && $cbb8793b0ba6b8fa$var$styles.selected,
                    !isDisabled && isSelected && (0, $iqfTZ.fg)('platform-dst-motion-uplift-list-item') && $cbb8793b0ba6b8fa$var$styles.motionSelected,
                    !isDisabled && isSelected && $cbb8793b0ba6b8fa$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $cbb8793b0ba6b8fa$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $cbb8793b0ba6b8fa$var$styles.selectedNotch,
                    isDisabled && $cbb8793b0ba6b8fa$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.Inline), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $cbb8793b0ba6b8fa$var$gapMap[spacing],
                grow: "fill",
                testId: testId && `${testId}--container`,
                children: [
                    iconBefore && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        "data-item-elem-before": true,
                        "data-testid": testId && `${testId}--icon-before`,
                        className: (0, $4jQY2.default)([
                            $cbb8793b0ba6b8fa$var$styles.beforeAfterElement
                        ]),
                        children: iconBefore
                    }),
                    title && /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
                        className: (0, $4jQY2.default)([
                            $cbb8793b0ba6b8fa$var$styles.content
                        ]),
                        children: [
                            $cbb8793b0ba6b8fa$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                                children: title,
                                className: (0, $4jQY2.default)([
                                    $cbb8793b0ba6b8fa$var$styles.title,
                                    shouldTitleWrap ? $cbb8793b0ba6b8fa$var$styles.wordBreak : $cbb8793b0ba6b8fa$var$styles.truncate
                                ]),
                                'data-item-title': true
                            }),
                            description && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                                "data-item-description": true,
                                className: (0, $4jQY2.default)([
                                    $cbb8793b0ba6b8fa$var$styles.description,
                                    isDisabled && $cbb8793b0ba6b8fa$var$styles.disabledDescription,
                                    shouldDescriptionWrap && $cbb8793b0ba6b8fa$var$styles.wordBreak,
                                    !shouldDescriptionWrap && $cbb8793b0ba6b8fa$var$styles.truncate
                                ]),
                                children: description
                            })
                        ]
                    }),
                    iconAfter && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        "data-item-elem-after": true,
                        "data-testid": testId && `${testId}--icon-after`,
                        className: (0, $4jQY2.default)([
                            $cbb8793b0ba6b8fa$var$styles.beforeAfterElement
                        ]),
                        children: iconAfter
                    })
                ]
            })
        });
    })();
};
$cbb8793b0ba6b8fa$var$MenuItemPrimitive.displayName = "MenuItemPrimitive";
var $cbb8793b0ba6b8fa$export$2e2bcd8739ae039 = $cbb8793b0ba6b8fa$var$MenuItemPrimitive;

});


parcelRegister("3HgHS", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c4da7737481c100$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $Cs8MU = parcelRequire("Cs8MU");

var $fsBHR = parcelRequire("fsBHR");
const $1c4da7737481c100$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Custom item__
 *
 * @deprecated
 * CustomItem must not be used and will be deleted soon. Custom menu items are not supported.
 * Use ButtonItem or LinkItem instead. If you need a custom list item, do not use `@atlaskit/menu`.
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $1c4da7737481c100$var$CustomItem = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(({ component: Component, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest }, ref)=>{
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $euxye.useContext)((0, $Cs8MU.default));
    const handleClick = (0, $euxye.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fsBHR.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                "data-testid": testId,
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $1c4da7737481c100$var$preventEvent
                },
                onMouseDown: isDisabled ? $1c4da7737481c100$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $1c4da7737481c100$var$preventEvent : handleClick,
                tabIndex: isDisabled ? -1 : undefined,
                "aria-disabled": isDisabled || undefined,
                children: children
            })
    });
}));
var $1c4da7737481c100$export$2e2bcd8739ae039 = $1c4da7737481c100$var$CustomItem;

});

parcelRegister("cSR11", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee8a14c116e571f7$export$2e2bcd8739ae039);
/* link-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $5atpW = parcelRequire("5atpW");

var $Cs8MU = parcelRequire("Cs8MU");

var $fsBHR = parcelRequire("fsBHR");
const $ee8a14c116e571f7$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $ee8a14c116e571f7$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
const $ee8a14c116e571f7$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $ee8a14c116e571f7$var$LinkItem = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const { children: children, href: href, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const RouterLink = (0, $5atpW.useRouterLink)();
    const interactionContext = (0, $euxye.useContext)((0, $Cs8MU.default));
    const handleClick = (0, $euxye.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    const isExternal = typeof href === 'string' && $ee8a14c116e571f7$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $ee8a14c116e571f7$var$IS_NON_HTTP_BASED.test(href);
    const isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fsBHR.default), {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                "data-testid": testId,
                "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
                "data-vc": "link-item",
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // @ts-expect-error
                href: isDisabled ? undefined : href,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $ee8a14c116e571f7$var$preventEvent
                },
                onMouseDown: isDisabled ? $ee8a14c116e571f7$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $ee8a14c116e571f7$var$preventEvent : handleClick,
                "aria-current": isSelected ? 'page' : undefined,
                "aria-disabled": isDisabled || undefined,
                ref: ref,
                children: children
            })
    });
}));
var $ee8a14c116e571f7$export$2e2bcd8739ae039 = $ee8a14c116e571f7$var$LinkItem;

});


parcelRegister("lpQqY", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c7d0a314d715684$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $3c7d0a314d715684$export$2e2bcd8739ae039 = (0, $euxye.forwardRef);

});

parcelRegister("8z2GW", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b816aae7207b9c3$export$2e2bcd8739ae039);
/* avatar.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $inMxE = parcelRequire("inMxE");

var $gUxVT = parcelRequire("gUxVT");

var $iqfTZ = parcelRequire("iqfTZ");

var $jduYm = parcelRequire("jduYm");

var $cVtI9 = parcelRequire("cVtI9");

var $lRlhy = parcelRequire("lRlhy");

var $gSNUD = parcelRequire("gSNUD");

var $e8p5g = parcelRequire("e8p5g");

var $bEA8k = parcelRequire("bEA8k");

var $cvjY0 = parcelRequire("cvjY0");

var $lbwTq = parcelRequire("lbwTq");
const $0b816aae7207b9c3$var$packageName = "platform-pkg";
const $0b816aae7207b9c3$var$packageVersion = "0.0.0-use.local";
const $0b816aae7207b9c3$var$containerStyles = null;
const $0b816aae7207b9c3$var$updatedHexagonNegativeMarginMap = {
    xxsmall: "_0rIjykJnIq _43nrzTJnIq",
    small: "_0rIjykwUPW _43nrzTwUPW",
    medium: "_0rIjykP0CX _43nrzTP0CX",
    large: "_0rIjykO0L5 _43nrzTO0L5",
    xlarge: "_0rIjykFQC7 _43nrzTFQC7",
    xxlarge: "_0rIjykaf0R _43nrzTaf0R"
};
const $0b816aae7207b9c3$var$normalizeAvatarSize = (size)=>size === 'xsmall' && !(0, $iqfTZ.fg)('platform_design-system-team_avatar-remove-xsmall') ? 'xxsmall' : size; /**
                                                                                                                                                            * Popup trigger ARIA attributes are optional. Use `aria-controls` to identify
                                                                                                                                                            * the popup and `aria-expanded` to announce whether it is open. An
                                                                                                                                                            * `aria-haspopup` value indicating a popup renders Avatar as a button,
                                                                                                                                                            * even when `onClick` is absent.
                                                                                                                                                            */ 
const $0b816aae7207b9c3$var$Avatar = /*#__PURE__*/ (0, $euxye.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div', imgLoading: imgLoading, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const context = (0, $lbwTq.useAvatarContext)();
    const size = $0b816aae7207b9c3$var$normalizeAvatarSize(sizeProp || context?.size || 'medium');
    const isUpdatedHexagonGeometry = appearance === 'hexagon' && Boolean(UNSAFE_isUpdatedGeometry) && size !== 'UNSAFE_xsmall';
    const customPresenceNode = /*#__PURE__*/ (0, $euxye.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $euxye.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xxsmall' && size !== 'xsmall'; // Presence/status indicators are only defined for `IndicatorSizeType`
    // (small, medium, large, xlarge). Compute `indicatorSize` only for sizes
    // that support an indicator (`isValidIconSize`), so the value is
    // structurally guaranteed to be a valid `IndicatorSizeType` rather than
    // relying on the guard at each call site. The `UNSAFE_xsmall` (20px) size
    // reuses the `small` indicator sizing as its nearest supported neighbor;
    // unsupported sizes (`xxsmall`/`xsmall`/`xxlarge`) fall back to `small` and are never
    // actually rendered because `isPresence`/`isStatus` also guard on
    // `isValidIconSize`.
    const indicatorSize = !isValidIconSize ? 'small' : size === 'UNSAFE_xsmall' ? 'small' : size;
    const lastAnalytics = (0, $euxye.useRef)(analyticsContext);
    const labelId = (0, $gUxVT.useId)();
    (0, $euxye.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $euxye.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $0b816aae7207b9c3$var$packageName,
                packageVersion: $0b816aae7207b9c3$var$packageVersion
            }
        }); /**
         * To avoid wrapping this component in AnalyticsContext we manually
         * push the parent context's meta data into the context.
         */ 
        const context = {
            componentName: 'avatar',
            packageName: $0b816aae7207b9c3$var$packageName,
            packageVersion: $0b816aae7207b9c3$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context); /**
                                           * Replicating the logic in the `withAnalyticsEvents` HOC.
                                           */ 
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status; // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled || ariaHasPopup;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gSNUD.EnsureIsInsideAvatarContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)(AvatarContainer, {
            "data-testid": testId,
            role: containerShouldBeImage ? 'img' : undefined,
            "aria-labelledby": containerShouldBeImage ? labelId : undefined,
            style: {
                zIndex: stackIndex
            },
            className: (0, $4jQY2.default)([
                "_2xIroY98eZ _497WNwYbGa _2zndICdnbC _3iDTPbvbI6 _1mT5xdRAKS",
                isUpdatedHexagonGeometry && $0b816aae7207b9c3$var$updatedHexagonNegativeMarginMap[size]
            ]),
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lRlhy.AvatarContentContext).Provider, {
                    value: {
                        as: (0, $e8p5g.default)(isDisabled, href, onClick, ariaHasPopup),
                        appearance: appearance,
                        UNSAFE_isUpdatedGeometry: isUpdatedHexagonGeometry,
                        borderColor: borderColor,
                        href: href,
                        isDisabled: isDisabled,
                        label: label || defaultLabel,
                        onClick: isInteractive ? onClickHandler : undefined,
                        ref: ref,
                        size: size,
                        stackIndex: stackIndex,
                        target: target,
                        testId: testId ? `${testId}--inner` : undefined,
                        'aria-controls': ariaControls,
                        'aria-expanded': ariaExpanded,
                        'aria-haspopup': ariaHasPopup,
                        avatarImage: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cVtI9.default), {
                            alt: !containerShouldBeImage && src ? name : undefined,
                            src: src,
                            appearance: appearance,
                            UNSAFE_isUpdatedGeometry: isUpdatedHexagonGeometry,
                            size: size,
                            testId: testId,
                            imgLoading: imgLoading
                        })
                    },
                    children: children || /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jduYm.AvatarContent), {})
                }),
                isPresence && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bEA8k.default), {
                    appearance: appearance,
                    size: indicatorSize,
                    presence: typeof presence === 'string' ? presence : undefined,
                    testId: testId,
                    children: customPresenceNode
                }),
                isStatus && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cvjY0.default), {
                    appearance: appearance,
                    size: indicatorSize,
                    borderColor: borderColor,
                    status: typeof status === 'string' ? status : undefined,
                    testId: testId,
                    children: customStatusNode
                }),
                containerShouldBeImage ? /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                    "data-testid": testId && `${testId}--label`,
                    id: labelId,
                    hidden: true,
                    children: defaultLabel
                }) : undefined
            ]
        })
    });
});
$0b816aae7207b9c3$var$Avatar.displayName = 'Avatar';
var $0b816aae7207b9c3$export$2e2bcd8739ae039 = $0b816aae7207b9c3$var$Avatar;

});
parcelRegister("jduYm", function(module, exports) {
$parcel$export(module.exports, "AvatarContent", () => $f4c5d8504e95c950$export$47fbc0b44cae5559);
/* avatar-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $iqfTZ = parcelRequire("iqfTZ");

var $lRlhy = parcelRequire("lRlhy");

var $l4Okw = parcelRequire("l4Okw");
const $f4c5d8504e95c950$var$boxShadowCssVar = '--avatar-box-shadow';
const $f4c5d8504e95c950$var$bgColorCssVar = '--avatar-bg-color';
const $f4c5d8504e95c950$var$styles = {
    root: "_30huDKYbGa _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAnQyn _2WAcuGnQyn _23rrnHiNRm _3iDTPbQ4SZ _1mT5xd5HSx _0hPCNLFlnN _37wbyuDIqT _0aFT5vbt8w _0wOv4QOLYo _0rIjykFQfX _43nrzTFQfX _2xTnZxFQfX _0GTcwRFQfX _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _1VJPcaeKTE _0EnhYgPgdg _1JM8vv4Jcb _2jfUf9N91d _2WYcYGWVPG _3wEj0XyL8i _0GBAIrJ5bs _43i6GSdnbC _2tbAUcYbGa _3kPd40YbGa _1ubuxonXvL _34b3D2FQfX _1NDpvb6wH8 _2wtOC9vc3e _0hSAgbNvrM",
    circle: "_0bjKvDaaQb _2Gfj6iaaQb",
    square: "_0bjKvD0O7w",
    positionRelative: "_1mT5xdRAKS",
    disabled: "_0wOv4Qsyl5 _3wEj0XlfZc _43i6GSVx3j"
};
const $f4c5d8504e95c950$var$unboundStyles = {
    root: "_2uo31fVZWJ _24h04iyL8i _2OUyjtrcoi",
    hexagonFocusContainer: "_4c065U9E27 _2Y7lL42M4S _3SamIHoYZL _2YLqiKnBff _0KLXruyL8i _1uo2ZfTcEg _3YCJEinXvL",
    updatedHexagonClipPath: "_1uo2ZfEXe0",
    hexagonBorderContainer: "_2uo31fVZWJ _4c065U7oRc _2Y7lL4Aa7o _3SamIHzX4W _2YLqiKTz7d _1uo2ZfOLYo _3YCJEilfZc",
    hexagon: "_0bjKvDdnbC _1uo2ZfOLYo _2OUyjtZqHV _2Gfj6idnbC _3kPd40ZqHV _2wtOC9dnbC _0hSAgbdnbC",
    interactive: "_0wOv4Q7zJH _0jKh9gMC01 _0ZgYXI7dHp _14Uf36qui9 _0WVYA37dHp _1if2KaHZdu",
    interactiveMotion: "_23rrnHimX9 _1sLQ8qC67X _3NJLv82rpu"
};
const $f4c5d8504e95c950$var$hexagonBorderFixStyles = {
    hexagonBorderContainer: "_0xmtkoUduD _46hvQmUduD _03SyCPUduD _0LQT5EUduD _0rIjykPM89 _43nrzTPM89 _2xTnZxPM89 _0GTcwRPM89",
    hexagonFocusContainer: "_0xmtko7SV6 _46hvQm7SV6 _03SyCP7SV6 _0LQT5E7SV6 _0rIjykAoU6 _43nrzTAoU6 _2xTnZxAoU6 _0GTcwRAoU6"
};
// See https://hello.atlassian.net/wiki/spaces/DST/pages/7432283012
const $f4c5d8504e95c950$var$updatedHexagonBorderFixStyles = {
    hexagonBorderContainer: "_0xmtkofkS7 _46hvQmfkS7 _03SyCPdnbC _0LQT5EdnbC _0rIjyk5hfz _43nrzT5hfz _2xTnZxdnbC _0GTcwRdnbC",
    hexagonFocusContainer: "_0xmtkoQVeh _46hvQmQVeh _03SyCP2M4S _0LQT5E2M4S _0rIjyk59JZ _43nrzT59JZ _2xTnZxnBff _0GTcwRnBff"
};
const $f4c5d8504e95c950$var$widthHeightMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02ey7F _0jFU0Vey7F",
    UNSAFE_xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f",
    xlarge: "_39xV02JgOI _0jFU0VJgOI",
    xxlarge: "_39xV02NNui _0jFU0VNNui"
};
// The sole source of truth for the updated hexagon width/height geometry (per size).
const $f4c5d8504e95c950$var$updatedHexagonDimensionMap = {
    xxsmall: "_39xV02EGCh _0jFU0VQSd4",
    small: "_39xV021R6D _0jFU0V7qhK",
    medium: "_39xV02U2XU _0jFU0VRlO4",
    large: "_39xV02s3iu _0jFU0VNmyB",
    xlarge: "_39xV02OhVQ _0jFU0VHWFU",
    xxlarge: "_39xV02c73x _0jFU0VSk01"
};
const $f4c5d8504e95c950$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children }, ref)=>{
    (0, $l4Okw.useEnsureIsInsideAvatar)();
    const { as: Container, appearance: appearance, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, avatarImage: avatarImage, borderColor: borderColor = "var(--ds-surface, #FFFFFF)", href: href, isDisabled: isDisabled, label: label, onClick: onClick, ref: contextRef, tabIndex: tabIndex, target: target, testId: testId, size: size, stackIndex: stackIndex, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup } = (0, $euxye.useContext)((0, $lRlhy.AvatarContentContext));
    const isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    const renderedContent = /*#__PURE__*/ (0, $e79Pd.jsx)(Container, {
        style: {
            [$f4c5d8504e95c950$var$bgColorCssVar]: borderColor,
            [$f4c5d8504e95c950$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $4jQY2.default)([
            $f4c5d8504e95c950$var$unboundStyles.root,
            $f4c5d8504e95c950$var$styles.root,
            appearance === 'square' && $f4c5d8504e95c950$var$styles.square,
            appearance === 'circle' && $f4c5d8504e95c950$var$styles.circle,
            appearance === 'hexagon' && $f4c5d8504e95c950$var$unboundStyles.hexagon,
            $f4c5d8504e95c950$var$widthHeightMap[size],
            UNSAFE_isUpdatedGeometry && $f4c5d8504e95c950$var$updatedHexagonDimensionMap[size],
            stackIndex !== undefined && $f4c5d8504e95c950$var$styles.positionRelative,
            isInteractive && !isDisabled && $f4c5d8504e95c950$var$unboundStyles.interactive,
            isInteractive && !isDisabled && appearance !== 'hexagon' && (0, $iqfTZ.fg)('platform-dst-motion-uplift') && $f4c5d8504e95c950$var$unboundStyles.interactiveMotion,
            isDisabled && $f4c5d8504e95c950$var$styles.disabled
        ]),
        children: children || avatarImage
    });
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        style: {
            [$f4c5d8504e95c950$var$bgColorCssVar]: borderColor,
            [$f4c5d8504e95c950$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        "data-testid": testId ? `${testId}-hexagon-focus-container` : 'hexagon-focus-container',
        className: (0, $4jQY2.default)([
            $f4c5d8504e95c950$var$unboundStyles.hexagonFocusContainer,
            UNSAFE_isUpdatedGeometry && $f4c5d8504e95c950$var$unboundStyles.updatedHexagonClipPath,
            isInteractive && !isDisabled && (0, $iqfTZ.fg)('platform-dst-motion-uplift') && $f4c5d8504e95c950$var$unboundStyles.interactiveMotion,
            UNSAFE_isUpdatedGeometry && $f4c5d8504e95c950$var$updatedHexagonBorderFixStyles.hexagonFocusContainer,
            (0, $iqfTZ.fg)('platform_editor_agent_mentions_drop_one_fixes') && !UNSAFE_isUpdatedGeometry && $f4c5d8504e95c950$var$hexagonBorderFixStyles.hexagonFocusContainer
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            "data-testid": testId ? `${testId}-hexagon-border-container` : 'hexagon-border-container',
            className: (0, $4jQY2.default)([
                $f4c5d8504e95c950$var$unboundStyles.hexagonBorderContainer,
                UNSAFE_isUpdatedGeometry && $f4c5d8504e95c950$var$updatedHexagonBorderFixStyles.hexagonBorderContainer,
                (0, $iqfTZ.fg)('platform_editor_agent_mentions_drop_one_fixes') && !UNSAFE_isUpdatedGeometry && $f4c5d8504e95c950$var$hexagonBorderFixStyles.hexagonBorderContainer
            ]),
            children: renderedContent
        })
    });
});

});
parcelRegister("lRlhy", function(module, exports) {
$parcel$export(module.exports, "AvatarContentContext", () => $79fd6727f16fdcbf$export$b983474ddd0b6d28);

var $euxye = parcelRequire("euxye");
const $79fd6727f16fdcbf$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
const $79fd6727f16fdcbf$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $euxye.createContext)($79fd6727f16fdcbf$var$defaultAvatarContentProps);

});

parcelRegister("l4Okw", function(module, exports) {
$parcel$export(module.exports, "useEnsureIsInsideAvatar", () => $98502925200eaa36$export$7db5c57474082dd9);

var $euxye = parcelRequire("euxye");

var $gSNUD = parcelRequire("gSNUD");
const $98502925200eaa36$export$7db5c57474082dd9 = ()=>{
    const context = (0, $euxye.useContext)((0, $gSNUD.EnsureIsInsideAvatarContext));
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});
parcelRegister("gSNUD", function(module, exports) {
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", () => $7387f2ccca7ad2ca$export$6b4cbd90d24955ad);

var $euxye = parcelRequire("euxye");
const $7387f2ccca7ad2ca$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $euxye.createContext)(false);

});



parcelRegister("cVtI9", function(module, exports) {
$parcel$export(module.exports, "default", () => $730cd8c53aa2629f$export$2e2bcd8739ae039);
/* avatar-image.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $jRVsm = parcelRequire("jRVsm");

var $lWRvF = parcelRequire("lWRvF");

var $dSCsJ = parcelRequire("dSCsJ");
const $730cd8c53aa2629f$var$styles = {
    image: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d",
    icon: "_3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d _0KLXruG6qS",
    circle: "_0bjKvDS5Zs",
    hexagon: "_1uo2ZfTcEg",
    updatedHexagonIcon: "_0hPCNLDIqT _37wbyuDIqT",
    updatedHexagonImage: "_1uo2ZfOLYo _00EA0eiObl _3IONCnIZbP"
};
const $730cd8c53aa2629f$var$borderRadiusMap = {
    xxsmall: "_0bjKvDcjp5",
    xsmall: "_0bjKvDcjp5",
    UNSAFE_xsmall: "_0bjKvDcjp5",
    small: "_0bjKvDcjp5",
    medium: "_0bjKvDKxmn",
    large: "_0bjKvDKxmn",
    xlarge: "_0bjKvDKTcp",
    xxlarge: "_0bjKvDyzSk"
};
const $730cd8c53aa2629f$var$nestedSvgStylesMap = {
    xxsmall: "_27VeLCey7F _2Qxi4ney7F",
    xsmall: "_27VeLCey7F _2Qxi4ney7F",
    UNSAFE_xsmall: "_27VeLCSPN1 _2Qxi4nSPN1",
    small: "_27VeLCoWWg _2Qxi4noWWg",
    medium: "_27VeLCUofl _2Qxi4nUofl",
    large: "_27VeLCUF4f _2Qxi4nUF4f",
    xlarge: "_27VeLCJgOI _2Qxi4nJgOI",
    xxlarge: "_27VeLCNNui _2Qxi4nNNui"
};
// NOTE: Must mirror `updatedHexagonDimensionMap` in `../avatar-content.tsx`.
const $730cd8c53aa2629f$var$updatedHexagonNestedSvgStylesMap = {
    xxsmall: "_27VeLCEGCh _2Qxi4nQSd4",
    small: "_27VeLC1R6D _2Qxi4n7qhK",
    medium: "_27VeLCU2XU _2Qxi4nRlO4",
    large: "_27VeLCs3iu _2Qxi4nNmyB",
    xlarge: "_27VeLCOhVQ _2Qxi4nHWFU",
    xxlarge: "_27VeLCc73x _2Qxi4nSk01"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const $730cd8c53aa2629f$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, size: size, testId: testId, imgLoading: imgLoading })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $euxye.useState)(false);
    // If src changes, reset state
    (0, $euxye.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        let renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lWRvF))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--person`,
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jRVsm))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--agent`,
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dSCsJ))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--ship`,
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
            className: (0, $4jQY2.default)([
                $730cd8c53aa2629f$var$styles.icon,
                UNSAFE_isUpdatedGeometry ? $730cd8c53aa2629f$var$updatedHexagonNestedSvgStylesMap[size] : $730cd8c53aa2629f$var$nestedSvgStylesMap[size],
                UNSAFE_isUpdatedGeometry && $730cd8c53aa2629f$var$styles.updatedHexagonIcon
            ]),
            children: renderedIcon
        });
    }
    return /*#__PURE__*/ (0, $e79Pd.jsx)("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? `${testId}--image` : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $4jQY2.default)([
            $730cd8c53aa2629f$var$styles.image,
            $730cd8c53aa2629f$var$borderRadiusMap[size],
            appearance === 'circle' && $730cd8c53aa2629f$var$styles.circle,
            appearance === 'hexagon' && $730cd8c53aa2629f$var$styles.hexagon,
            UNSAFE_isUpdatedGeometry && $730cd8c53aa2629f$var$styles.updatedHexagonImage
        ])
    });
};
$730cd8c53aa2629f$var$AvatarImage.displayName = "AvatarImage";
var $730cd8c53aa2629f$export$2e2bcd8739ae039 = $730cd8c53aa2629f$var$AvatarImage;

});

parcelRegister("e8p5g", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c13694f69ab4b68$export$2e2bcd8739ae039);
const $9c13694f69ab4b68$var$getCustomElement = (isDisabled, href, onClick, ariaHasPopup)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled || ariaHasPopup) return 'button';
    return 'span';
};
var $9c13694f69ab4b68$export$2e2bcd8739ae039 = $9c13694f69ab4b68$var$getCustomElement;

});

parcelRegister("bEA8k", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3ac3759f2f8076f$export$2e2bcd8739ae039);
/* presence-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $fB86C = parcelRequire("fB86C");
const $e3ac3759f2f8076f$var$styles = {
    root: "_1mT5xdWVPG _1pp6NdYbGa"
};
const $e3ac3759f2f8076f$var$iconSizeMap = {
    small: "_0jFU0VxpxF _39xV02xpxF",
    medium: "_0jFU0VEbN9 _39xV02EbN9",
    large: "_0jFU0V2sAl _39xV022sAl",
    xlarge: "_0jFU0V70UD _39xV0270UD"
};
const $e3ac3759f2f8076f$var$circleIconOffsetMap = {
    small: "_0Bm75GdnbC _4ApkO2dnbC",
    medium: "_0Bm75GdnbC _4ApkO2dnbC",
    large: "_0Bm75GHZdu _4ApkO2HZdu",
    xlarge: "_0Bm75GXJux _4ApkO2XJux"
};
const $e3ac3759f2f8076f$var$squareIconOffsetMap = {
    root: "_0Bm75GVo9d _4ApkO2Vo9d"
};
const $e3ac3759f2f8076f$var$hexagonIconOffsetMap = {
    small: "_0Bm75GA17z _4ApkO2A17z",
    medium: "_0Bm75GA17z _4ApkO2A17z",
    large: "_0Bm75GUNDJ _4ApkO2Vo9d",
    xlarge: "_0Bm75GvFgp _4ApkO28e2l"
};
/**
 * __Presence wrapper__
 *
 * A presence wrapper is used internally to position presence ontop of the avatar.
 */ const $e3ac3759f2f8076f$var$PresenceWrapper = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        className: (0, $4jQY2.default)([
            $e3ac3759f2f8076f$var$styles.root,
            $e3ac3759f2f8076f$var$iconSizeMap[size],
            $e3ac3759f2f8076f$var$circleIconOffsetMap[size],
            appearance === 'square' && $e3ac3759f2f8076f$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $e3ac3759f2f8076f$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fB86C.default), {
            borderColor: borderColor,
            presence: !children ? presence : undefined,
            children: children
        })
    });
};
$e3ac3759f2f8076f$var$PresenceWrapper.displayName = "PresenceWrapper";
var $e3ac3759f2f8076f$export$2e2bcd8739ae039 = $e3ac3759f2f8076f$var$PresenceWrapper;

});
parcelRegister("fB86C", function(module, exports) {
$parcel$export(module.exports, "default", () => $8742fee92ed714ba$export$2e2bcd8739ae039);
/* presence.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $eZdpU = parcelRequire("eZdpU");
const $8742fee92ed714ba$var$BusyIndicator = /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
    children: [
        /*#__PURE__*/ (0, $e79Pd.jsx)("circle", {
            fill: "var(--ds-icon-danger, #C9372C)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
        })
    ]
});
const $8742fee92ed714ba$var$FocusIndicator = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Fragment), {
    children: /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
        fill: "var(--ds-icon-discovery, #AF59E1)",
        d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
    })
});
const $8742fee92ed714ba$var$OfflineIndicator = /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
    children: [
        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
            fill: "var(--ds-text-subtlest, #6B6E76)",
            d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        }),
        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        })
    ]
});
const $8742fee92ed714ba$var$OnlineIndicator = /*#__PURE__*/ (0, $e79Pd.jsx)("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
});
function $8742fee92ed714ba$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $8742fee92ed714ba$var$BusyIndicator;
        case 'focus':
            return $8742fee92ed714ba$var$FocusIndicator;
        case 'offline':
            return $8742fee92ed714ba$var$OfflineIndicator;
        case 'online':
            return $8742fee92ed714ba$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ const $8742fee92ed714ba$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $eZdpU.default), {
        bgColor: borderColor,
        children: presence ? /*#__PURE__*/ (0, $e79Pd.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $8742fee92ed714ba$var$getPresence(presence)
        }) : children
    });
$8742fee92ed714ba$var$AvatarPresence.displayName = "AvatarPresence";
var $8742fee92ed714ba$export$2e2bcd8739ae039 = $8742fee92ed714ba$var$AvatarPresence;

});
parcelRegister("eZdpU", function(module, exports) {
$parcel$export(module.exports, "default", () => $dadd186e6dd2a704$export$2e2bcd8739ae039);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $dadd186e6dd2a704$var$styles = {
    root: "_0bjKvDaaQb _4bt5LAnQyn _2WAcuGnQyn _2V7sgO2M4S _3hxITi6wH8 _3iDTPbQ4SZ _24h04i2Njc _39xV02N91d _0jFU0VN91d _0hPCNLDIqT _0GwItXDIqT _0KLXruoI2d"
};
const $dadd186e6dd2a704$var$unboundStyles = {
    root: "_3vBAKHoI2d"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ const $dadd186e6dd2a704$var$IconWrapper = ({ bgColor: bgColor, children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $4jQY2.default)([
            $dadd186e6dd2a704$var$styles.root,
            $dadd186e6dd2a704$var$unboundStyles.root
        ]),
        children: children
    });
$dadd186e6dd2a704$var$IconWrapper.displayName = "IconWrapper";
var $dadd186e6dd2a704$export$2e2bcd8739ae039 = $dadd186e6dd2a704$var$IconWrapper;

});



parcelRegister("cvjY0", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fc361b3fc30dd96$export$2e2bcd8739ae039);
/* status-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $hVMWO = parcelRequire("hVMWO");
const $6fc361b3fc30dd96$var$styles = {
    root: "_1mT5xdWVPG"
};
const $6fc361b3fc30dd96$var$iconSizeMap = {
    small: "_0jFU0VxpxF _39xV02xpxF",
    medium: "_0jFU0VEbN9 _39xV02EbN9",
    large: "_0jFU0V2sAl _39xV022sAl",
    xlarge: "_0jFU0V70UD _39xV0270UD"
};
const $6fc361b3fc30dd96$var$circleIconOffsetMap = {
    small: "_1OKFqYdnbC _2I62gzdnbC",
    medium: "_1OKFqYdnbC _2I62gzdnbC",
    large: "_1OKFqYHZdu _2I62gzHZdu",
    xlarge: "_1OKFqYXJux _2I62gzXJux"
};
const $6fc361b3fc30dd96$var$squareIconOffsetMap = {
    root: "_1OKFqYdnbC _2I62gzdnbC"
};
const $6fc361b3fc30dd96$var$hexagonIconOffsetMap = {
    small: "_1OKFqYA17z _2I62gzA17z",
    medium: "_1OKFqYA17z _2I62gzA17z",
    large: "_1OKFqYVo9d _2I62gzUNDJ",
    xlarge: "_1OKFqY8e2l _2I62gzvFgp"
};
/**
 * __Status wrapper__
 *
 * A status wrapper is used internally to position status on top of the avatar.
 */ const $6fc361b3fc30dd96$var$StatusWrapper = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        className: (0, $4jQY2.default)([
            $6fc361b3fc30dd96$var$styles.root,
            $6fc361b3fc30dd96$var$iconSizeMap[size],
            $6fc361b3fc30dd96$var$circleIconOffsetMap[size],
            appearance === 'square' && $6fc361b3fc30dd96$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $6fc361b3fc30dd96$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hVMWO.default), {
            borderColor: borderColor,
            status: !children ? status : undefined,
            children: children
        })
    });
};
$6fc361b3fc30dd96$var$StatusWrapper.displayName = "StatusWrapper";
var $6fc361b3fc30dd96$export$2e2bcd8739ae039 = $6fc361b3fc30dd96$var$StatusWrapper;

});
parcelRegister("hVMWO", function(module, exports) {
$parcel$export(module.exports, "default", () => $48fffd4d10f7a629$export$2e2bcd8739ae039);
/* status.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $eZdpU = parcelRequire("eZdpU");
const $48fffd4d10f7a629$var$ApprovedIndicator = /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
    children: [
        /*#__PURE__*/ (0, $e79Pd.jsx)("circle", {
            fill: "var(--ds-icon-success, #6A9A23)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
        })
    ]
});
const $48fffd4d10f7a629$var$DeclinedIndicator = /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
    children: [
        /*#__PURE__*/ (0, $e79Pd.jsx)("circle", {
            fill: "var(--ds-icon-danger, #C9372C)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
        })
    ]
});
const $48fffd4d10f7a629$var$LockedIndicator = /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
    children: [
        /*#__PURE__*/ (0, $e79Pd.jsx)("circle", {
            fill: "var(--ds-text-subtlest, #6B6E76)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
        })
    ]
});
const $48fffd4d10f7a629$var$WarningIndicator = /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
    children: [
        /*#__PURE__*/ (0, $e79Pd.jsx)("circle", {
            fill: "var(--ds-icon-warning, #E06C00)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4,1.33333333 C4.36918944,1.33333333 4.66666667,1.63081056 4.66666667,2 L4.66666667,4 C4.66666667,4.36918944 4.36918944,4.66666667 4,4.66666667 C3.63081056,4.66666667 3.33333333,4.36918944 3.33333333,4 L3.33333333,2 C3.33333333,1.63081056 3.63081056,1.33333333 4,1.33333333 Z M4,5.33333333 C4.36918944,5.33333333 4.66666667,5.63081056 4.66666667,6 C4.66666667,6.36918944 4.36918944,6.66666667 4,6.66666667 C3.63081056,6.66666667 3.33333333,6.36918944 3.33333333,6 C3.33333333,5.63081056 3.63081056,5.33333333 4,5.33333333 Z"
        })
    ]
});
function $48fffd4d10f7a629$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $48fffd4d10f7a629$var$ApprovedIndicator;
        case 'declined':
            return $48fffd4d10f7a629$var$DeclinedIndicator;
        case 'locked':
            return $48fffd4d10f7a629$var$LockedIndicator;
        case 'warning':
            return $48fffd4d10f7a629$var$WarningIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ const $48fffd4d10f7a629$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $eZdpU.default), {
        bgColor: borderColor,
        children: status ? /*#__PURE__*/ (0, $e79Pd.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $48fffd4d10f7a629$var$getStatus(status)
        }) : children
    });
$48fffd4d10f7a629$var$AvatarStatus.displayName = "AvatarStatus";
var $48fffd4d10f7a629$export$2e2bcd8739ae039 = $48fffd4d10f7a629$var$AvatarStatus;

});


parcelRegister("lbwTq", function(module, exports) {
$parcel$export(module.exports, "useAvatarContext", () => $8b0c9b51b919c2e3$export$b50b87a1c4086b23);

var $euxye = parcelRequire("euxye");

var $hAt2p = parcelRequire("hAt2p");
const $8b0c9b51b919c2e3$export$b50b87a1c4086b23 = ()=>(0, $euxye.useContext)((0, $hAt2p.AvatarContext));

});
parcelRegister("hAt2p", function(module, exports) {
$parcel$export(module.exports, "AvatarContext", () => $37cd039016da14b7$export$a20dad690e1279e2);

var $euxye = parcelRequire("euxye");
const $37cd039016da14b7$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $euxye.createContext)(undefined);

});



parcelRegister("g36LP", function(module, exports) {
$parcel$export(module.exports, "default", () => $49f75ec07c85ad1f$export$2e2bcd8739ae039);
/* section.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $kcgsX = parcelRequire("kcgsX");
const $49f75ec07c85ad1f$var$itemHeadingTopMargin = 20;
const $49f75ec07c85ad1f$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $49f75ec07c85ad1f$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
const $49f75ec07c85ad1f$var$skeletonHeadingHeight = 8;
const $49f75ec07c85ad1f$var$skeletonHeadingMarginOffset = 3;
const $49f75ec07c85ad1f$var$skeletonHeadingTopMargin = $49f75ec07c85ad1f$var$itemHeadingTopMargin + ($49f75ec07c85ad1f$var$itemHeadingContentHeight - $49f75ec07c85ad1f$var$skeletonHeadingHeight) - $49f75ec07c85ad1f$var$skeletonHeadingMarginOffset;
const $49f75ec07c85ad1f$var$sectionPaddingTopBottom = 6;
const $49f75ec07c85ad1f$var$styles = {
    root: "_4Gb5FivLZJ _0OU75rvLZJ _47eTBtZimw _1lBcDcZimw _0GBAIrogpp _3Ku51Iogpp _420PbdZimw _3LXXKoSPN1 _1DqDD4EbN9 _0Ipfpy2AF2 _1apEF8fFOW _3R93WOXCiO _38a67RA17z",
    scrollable: "_4bt5LAIZbP _2WAcuGIZbP _3YEZNO7dHp",
    unscrollable: "_3YEZNOdnbC",
    thinSeparator: "_1v3aPqo71H",
    noSeparator: "_1wX8q6mW1D",
    sideNavSectionHeading: "_2Y7lL42ADO"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $49f75ec07c85ad1f$var$Section = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, isSideNavSection: isSideNavSection = false, label: label, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    const content = isList ? /*#__PURE__*/ (0, $e79Pd.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        },
        children: (0, $euxye.Children).map((0, $euxye.Children).toArray(children), (child, index)=>/*#__PURE__*/ (0, $e79Pd.jsx)("li", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    listStyleType: 'none',
                    margin: 0,
                    padding: 0
                },
                children: child
            }, index))
    }) : children;
    const childrenMarkup = title !== undefined ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kcgsX.default), {
                testId: testId && `${testId}--heading`,
                "aria-hidden": true,
                // @ts-expect-error
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                className: (0, $4jQY2.default)([
                    isSideNavSection && $49f75ec07c85ad1f$var$styles.sideNavSectionHeading
                ]),
                children: title
            }),
            content
        ]
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Fragment), {
        children: content
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $4jQY2.default)([
            $49f75ec07c85ad1f$var$styles.root,
            isScrollable ? $49f75ec07c85ad1f$var$styles.scrollable : $49f75ec07c85ad1f$var$styles.unscrollable,
            hasSeparator ? $49f75ec07c85ad1f$var$styles.thinSeparator : $49f75ec07c85ad1f$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref,
        children: childrenMarkup
    });
});
var $49f75ec07c85ad1f$export$2e2bcd8739ae039 = $49f75ec07c85ad1f$var$Section;

});
parcelRegister("kcgsX", function(module, exports) {
$parcel$export(module.exports, "default", () => $774ef636aa221835$export$2e2bcd8739ae039);
/* heading-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $774ef636aa221835$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $774ef636aa221835$var$HeadingItem = /*#__PURE__*/ (0, $euxye.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $4jQY2.default)([
            "_2sNsIgd8bj _4c065UPgdg _2Y7lL45zaO _1UtDYzZpcK",
            UNSAFE_className
        ]),
        ...rest,
        children: children
    });
});
var $774ef636aa221835$export$2e2bcd8739ae039 = $774ef636aa221835$var$HeadingItem;

});


parcelRegister("2Xkyn", function(module, exports) {
$parcel$export(module.exports, "default", () => $3213cf329f9dddea$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $gUxVT = parcelRequire("gUxVT");

var $g36LP = parcelRequire("g36LP");

var $jqOWI = parcelRequire("jqOWI");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $3213cf329f9dddea$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $gUxVT.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $g36LP.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jqOWI.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $3213cf329f9dddea$export$2e2bcd8739ae039 = $3213cf329f9dddea$var$DropdownMenuItemGroup;

});
parcelRegister("jqOWI", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d68b9d81d55a7d8$export$2e2bcd8739ae039);
/* group-title.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");
const $2d68b9d81d55a7d8$var$styles = {
    heading: "_2sNsIgd8bj _4c065UPgdg _2Y7lL45zaO _1UtDYzZpcK"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ const $2d68b9d81d55a7d8$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.Box), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $2d68b9d81d55a7d8$var$styles.heading,
        children: title
    });
$2d68b9d81d55a7d8$var$GroupTitle.displayName = "GroupTitle";
var $2d68b9d81d55a7d8$export$2e2bcd8739ae039 = $2d68b9d81d55a7d8$var$GroupTitle;

});


parcelRegister("htkxY", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fbab244be2ea62f$export$2e2bcd8739ae039);
/* badge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $hpylC = parcelRequire("hpylC");

var $e3neg = parcelRequire("e3neg");

var $aR2ZR = parcelRequire("aR2ZR");
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in `children`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $9fbab244be2ea62f$var$Badge = /*#__PURE__*/ (0, $euxye.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    // Map old appearance names to new ones
    const newAppearance = (0, $hpylC.appearanceMapping)[appearance];
    // Pre-format the value using the backward-compatible formatter (supports negative numbers)
    // then pass max={false} to BadgeNew so it doesn't apply its own (clamping) formatting.
    const formattedValue = typeof children === 'number' && typeof max === 'number' ? (0, $aR2ZR.formatValueWithNegativeSupport)(children, max) : children;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e3neg.default), {
        appearance: newAppearance,
        max: false,
        style: style,
        testId: testId,
        children: formattedValue
    });
});
var $9fbab244be2ea62f$export$2e2bcd8739ae039 = $9fbab244be2ea62f$var$Badge;

});
parcelRegister("hpylC", function(module, exports) {
$parcel$export(module.exports, "appearanceMapping", () => $a4b9d2cc54692269$export$d21bba0569254935);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $a4b9d2cc54692269$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral',
    informationBold: 'informationBold',
    successBold: 'successBold',
    dangerBold: 'dangerBold',
    warningBold: 'warningBold',
    discoveryBold: 'discoveryBold'
};

});

parcelRegister("aR2ZR", function(module, exports) {
$parcel$export(module.exports, "formatValueWithNegativeSupport", () => $85933aa900aa4d56$export$4b844743568d5983);
function $85933aa900aa4d56$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $85933aa900aa4d56$export$4b844743568d5983(value, max) {
    const safeValue = $85933aa900aa4d56$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $85933aa900aa4d56$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("3NRLa", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea5d7cba409bfb9d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $Cs8MU = parcelRequire("Cs8MU");

var $iqfTZ = parcelRequire("iqfTZ");
const $ea5d7cba409bfb9d$var$shimmerKeyframes = null;
const $ea5d7cba409bfb9d$var$skeletonStyles = null;
const $ea5d7cba409bfb9d$var$activeShimmerStyles = null; /**
                                   * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                   * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                   * which makes things simpler than doing an `isServer` check or a `null` check.
                                   *
                                   * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                   */ 
const $ea5d7cba409bfb9d$var$useLayoutEffect = typeof window === 'undefined' ? (0, $euxye.useEffect) : (0, $euxye.useLayoutEffect); /**
                                                                                          * __Skeleton__
                                                                                          *
                                                                                          * A skeleton acts as a placeholder for content, usually while the content loads.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/skeleton/examples)
                                                                                          * - [Code](https://atlassian.design/components/skeleton/code)
                                                                                          */ 
const $ea5d7cba409bfb9d$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $euxye.useContext)((0, $Cs8MU.default));
    $ea5d7cba409bfb9d$var$useLayoutEffect(()=>{
        if (context != null && (0, $iqfTZ.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $4jQY2.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            isShimmering && "",
            isShimmering && "_1gBibyKB6V"
        ])
    });
};
$ea5d7cba409bfb9d$var$Skeleton.displayName = "Skeleton";
var $ea5d7cba409bfb9d$export$2e2bcd8739ae039 = $ea5d7cba409bfb9d$var$Skeleton;

});

parcelRegister("c4ROd", function(module, exports) {
$parcel$export(module.exports, "ProjectsIcon", () => $10e0c446ba39a229$export$5ed3e1bb3b04fc02);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8862141676163c22cf5b4279aef2ba3>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ed9Xn = parcelRequire("ed9Xn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $10e0c446ba39a229$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546" clip-rule="evenodd"/>
</svg>
`;
function $10e0c446ba39a229$export$5ed3e1bb3b04fc02({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Projects', testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ed9Xn.IconWrapper), {
        svg: $10e0c446ba39a229$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$10e0c446ba39a229$export$5ed3e1bb3b04fc02.displayName = "ProjectsIcon";

});

parcelRegister("iqcOC", function(module, exports) {
$parcel$export(module.exports, "AssetsIcon", () => $c95082a9792d484e$export$d89497e7f33ca6f5);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::505dbad49a3dfa1729f04b26edcebd32>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ed9Xn = parcelRequire("ed9Xn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $c95082a9792d484e$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"/>
</svg>
`;
const $c95082a9792d484e$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729"/>
</svg>
`;
function $c95082a9792d484e$export$d89497e7f33ca6f5({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Assets', testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ed9Xn.IconWrapper), {
        svg: $c95082a9792d484e$var$svg,
        customThemeSvg: $c95082a9792d484e$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$c95082a9792d484e$export$d89497e7f33ca6f5.displayName = "AssetsIcon";

});

parcelRegister("7HLLB", function(module, exports) {
$parcel$export(module.exports, "SplitButton", () => $bc8e587d339d018a$export$651ad66661acd392);
/* split-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $8jyh4 = parcelRequire("8jyh4");

var $fqp3W = parcelRequire("fqp3W");

var $1WOZN = parcelRequire("1WOZN");

var $axu9I = parcelRequire("axu9I");
const $bc8e587d339d018a$var$buttonStyles = {
    primaryButton: "_3rzkiodnbC _1kWzVtdnbC _0uVYyIdnbC _2qDbL0dnbC",
    secondaryButton: "_1jomYRdnbC _4oPZ7ddnbC _2kv5QsdnbC _0geU8cdnbC"
};
const $bc8e587d339d018a$export$651ad66661acd392 = ({ children: children, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    const { PrimaryAction: PrimaryAction, SecondaryAction: SecondaryAction } = (0, $axu9I.getActions)(children);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fqp3W.SplitButtonContainer), {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $1WOZN.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $bc8e587d339d018a$var$buttonStyles.primaryButton
                    ]),
                    children: PrimaryAction
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8jyh4.Divider), {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $bc8e587d339d018a$var$buttonStyles.secondaryButton
                    ]),
                    children: SecondaryAction
                })
            ]
        })
    });
};
$bc8e587d339d018a$export$651ad66661acd392.displayName = "SplitButton";

});
parcelRegister("8jyh4", function(module, exports) {
$parcel$export(module.exports, "Divider", () => $5d5711b4c05c0cbb$export$2e0a83ec2e27ecbb);
/* divider.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $5d5711b4c05c0cbb$var$dividerStyles = {
    baseDivider: "_39xV02NvrM _1mT5xdRAKS _42Yu6B7dHp",
    dividerDisabled: "_0KLXruhQC5 _0wOv4Qsyl5",
    dividerOffset: "_2YLqiKA17z"
};
const $5d5711b4c05c0cbb$var$dividerAppearanceStyles = {
    default: "_0KLXru9r67",
    primary: "_0KLXruxCOs _1YKVNsjLrf",
    navigation: "_3SamIH2ADO _2YLqiKwmY0 _0jFU0Vey7F _0KLXruZpcK _1YKVNsCfZC"
};
const $5d5711b4c05c0cbb$var$dividerHeightStyles = {
    default: "_0jFU0VZ49V",
    compact: "_0jFU0V9DVM"
};
const $5d5711b4c05c0cbb$var$defaultDividerHeightStyles = {
    default: "_0jFU0Vbu0M",
    compact: "_0jFU0Vv8uz"
};
const $5d5711b4c05c0cbb$export$2e0a83ec2e27ecbb = ({ appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    const isDefaultDivider = appearance === 'default' && !isDisabled;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $5d5711b4c05c0cbb$var$dividerStyles.baseDivider,
            isDefaultDivider && $5d5711b4c05c0cbb$var$defaultDividerHeightStyles[spacing],
            !isDefaultDivider && $5d5711b4c05c0cbb$var$dividerHeightStyles[spacing],
            isDisabled && $5d5711b4c05c0cbb$var$dividerStyles.dividerDisabled,
            !isDisabled && $5d5711b4c05c0cbb$var$dividerAppearanceStyles[appearance],
            $5d5711b4c05c0cbb$var$dividerStyles.dividerOffset
        ])
    });
};
$5d5711b4c05c0cbb$export$2e0a83ec2e27ecbb.displayName = "Divider";

});

parcelRegister("fqp3W", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContainer", () => $d2472753396434dd$export$994ba1b4c598f7);
/* split-button-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $d2472753396434dd$var$buttonStyles = {
    splitButton: "_3iDTPbccYA _1mT5xdRAKS _0hPCNLDIqT _1ANEUSLRg7",
    defaultAppearanceContainer: "_0bjKvDKTcp _2xIroY9r67 _3e6OgrA17z _497WNw6wH8 _2zndICHZdu",
    defaultAppearanceDisabledContainer: "_2xIroYhQC5"
};
const $d2472753396434dd$export$994ba1b4c598f7 = ({ appearance: appearance, children: children, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            appearance === 'default' && $d2472753396434dd$var$buttonStyles.defaultAppearanceContainer,
            appearance === 'default' && isDisabled && $d2472753396434dd$var$buttonStyles.defaultAppearanceDisabledContainer,
            $d2472753396434dd$var$buttonStyles.splitButton
        ]),
        children: children
    });
$d2472753396434dd$export$994ba1b4c598f7.displayName = "SplitButtonContainer";

});

parcelRegister("axu9I", function(module, exports) {
$parcel$export(module.exports, "getActions", () => $3a3893c80c312682$export$fe3955935f564b31);

var $euxye = parcelRequire("euxye");

var $gIMgJ = parcelRequire("gIMgJ");
const $3a3893c80c312682$export$fe3955935f564b31 = (children)=>{
    const [PrimaryAction, SecondaryAction] = (0, $euxye.Children).toArray(children);
    typeof $gIMgJ;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});


parcelRegister("kcJbW", function(module, exports) {
$parcel$export(module.exports, "Grid", () => $c7ff7d234bf3b390$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $f7B36 = parcelRequire("f7B36");

var $9g2ml = parcelRequire("9g2ml");
function $c7ff7d234bf3b390$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c7ff7d234bf3b390$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $c7ff7d234bf3b390$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $c7ff7d234bf3b390$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $c7ff7d234bf3b390$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $c7ff7d234bf3b390$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $c7ff7d234bf3b390$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $c7ff7d234bf3b390$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $c7ff7d234bf3b390$var$baseStyles = /*#__PURE__*/ (0, $hStPE.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$c7ff7d234bf3b390$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$c7ff7d234bf3b390$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$c7ff7d234bf3b390$var$gridTemplateRowsVar})`
});
const $c7ff7d234bf3b390$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
const $c7ff7d234bf3b390$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $f7B36.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $euxye.useMemo)(()=>({
            [$c7ff7d234bf3b390$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$c7ff7d234bf3b390$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$c7ff7d234bf3b390$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $hStPE.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $c7ff7d234bf3b390$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $9g2ml.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $9g2ml.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $9g2ml.spaceStylesMap).rowGap[rowGap],
            alignItems && $c7ff7d234bf3b390$var$alignItemsMap[alignItems],
            alignContent && $c7ff7d234bf3b390$var$alignContentMap[alignContent],
            justifyContent && $c7ff7d234bf3b390$var$justifyContentMap[justifyContent],
            autoFlow && $c7ff7d234bf3b390$var$gridAutoFlowMap[autoFlow],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$c7ff7d234bf3b390$export$ef2184bd89960b14.displayName = 'Grid';

});

parcelRegister("kENFC", function(module, exports) {
$parcel$export(module.exports, "default", () => $52cd1de7352a16c5$export$2e2bcd8739ae039);
/* skeleton-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $52cd1de7352a16c5$var$skeletonItemElemSize = 20;
const $52cd1de7352a16c5$var$styles = {
    root: "_4c065UPgdg _2Y7lL4kG2W _3iDTPbQ4SZ _4kiQYAUF4f _0hPCNLDIqT _1pp6NdYbGa _2Gfj6iQEt6 _47eTBt2AF2 _3wEj0XGsB2 _0GBAIrogpp _0eSLDaHZdu",
    defaultWidth: "_1ShRFFoBHb _0jufqb715P _0KfecEygnw _1v7p3wE1Ft _0pFvyeR1Le _1n9qNYrXaT",
    customWidth: "_2v4nLRyRC6",
    beforeElement: "_3ScelFSPN1 _1lBcDcSPN1 _0tXlYZdnbC _4diMdqGsB2 _3Ku51Iogpp _3QFY1HEbN9 _4bQ7pPFQfX",
    avatar: "_1OimfuS5Zs",
    icon: "_1OimfuzXzM",
    sideNavSkeleton: "_2Y7lL42ADO _1lBcDc9DVM _3QFY1H5zaO _3ScelF9DVM"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ const $52cd1de7352a16c5$var$shimmerKeyframes = null;
/**
 * These styles are defined using `css` rather than `cssMap` as there is a bug when using
 * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
 */ const $52cd1de7352a16c5$var$shimmerStyles = null;
/**
 * __Skeleton item__
 *
 * A skeleton item is used in place of an item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $52cd1de7352a16c5$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, isSideNavSkeleton: isSideNavSkeleton = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $52cd1de7352a16c5$var$styles.root,
            (hasAvatar || hasIcon) && $52cd1de7352a16c5$var$styles.beforeElement,
            hasAvatar && $52cd1de7352a16c5$var$styles.avatar,
            hasIcon && $52cd1de7352a16c5$var$styles.icon,
            width ? $52cd1de7352a16c5$var$styles.customWidth : $52cd1de7352a16c5$var$styles.defaultWidth,
            isSideNavSkeleton && $52cd1de7352a16c5$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_21qtfOkSs3 _0160FKkSs3 _1nw4qxfONH _1iAcE9fONH _2VLDZtSHWH _0YTlblSHWH _30VpOT55dm _2ofBtg55dm _2WuqwLHVQb _2lXp1JHVQb _3wEj0XGsB2 _4diMdqGsB2",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
$52cd1de7352a16c5$var$SkeletonItem.displayName = "SkeletonItem";
var $52cd1de7352a16c5$export$2e2bcd8739ae039 = $52cd1de7352a16c5$var$SkeletonItem;

});

parcelRegister("iCK9i", function(module, exports) {
$parcel$export(module.exports, "getWorkspaceThemePreference", () => $aeeb3db325324ca9$export$8a05dde4568766d5);
$parcel$export(module.exports, "updateWorkspaceThemePreference", () => $aeeb3db325324ca9$export$21a54a869d2847fd);

var $bIDWE = parcelRequire("bIDWE");

var $8AVGw = parcelRequire("8AVGw");

var $n67Vb = parcelRequire("n67Vb");

var $iqfTZ = parcelRequire("iqfTZ");

var $eqG5e = parcelRequire("eqG5e");

var $koK88 = parcelRequire("koK88");
const $aeeb3db325324ca9$export$8a05dde4568766d5 = async (environment, workspaceAri, accountId)=>{
    if (!(0, $iqfTZ.fg)('shared-user-preferences')) return undefined;
    const response = await (0, $n67Vb.fetchQuery)(environment, (0, $8AVGw.default), {
        workspaceAri: workspaceAri,
        accountId: accountId
    }).toPromise();
    const themeString = response?.settings_userPreferencesResolved?.theme;
    if (!themeString) return undefined;
    return (0, $koK88.updateThemeWithDefaultValues)(themeString);
};
const $aeeb3db325324ca9$export$21a54a869d2847fd = async (environment, workspaceAri, accountId, themeState)=>{
    if (!(0, $iqfTZ.fg)('shared-user-preferences')) return;
    // Serialize theme object to string for GraphQL
    const themeString = (0, $eqG5e.themeObjectToString)(themeState);
    // Shared cache updater function for both optimistic and confirmed updates
    const updateCache = (store)=>{
        const root = store.getRoot();
        const resolvedPreferences = root.getLinkedRecord('settings_userPreferencesResolved', {
            workspaceAri: workspaceAri,
            accountId: accountId
        });
        if (resolvedPreferences) resolvedPreferences.setValue(themeString, 'theme');
    };
    return new Promise((resolve, reject)=>{
        (0, $n67Vb.commitMutation)(environment, {
            mutation: (0, $bIDWE.default),
            variables: {
                workspaceAri: workspaceAri,
                accountId: accountId,
                theme: themeString
            },
            // Optimistically update the cache for immediate UI feedback
            // Relay automatically reverts this if the mutation fails
            optimisticUpdater: updateCache,
            // Apply the confirmed server response to the cache
            updater: updateCache,
            onCompleted: (_, errors)=>{
                if (errors && errors.length > 0) reject(new Error(errors.map((e)=>e.message).join('; ')));
                else resolve();
            },
            onError: (error)=>{
                reject(error);
            }
        });
    });
};

});
parcelRegister("bIDWE", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a3c39cdeff6d05a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<987867774544e4f15c78f3627b3a8203>>
 * @relayHash ced2fc19e942c004393c066bef43384d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2d8511617c2ae739deca629af208d0c0aff791868ae7f06fd41f3bca8189b104
const $6a3c39cdeff6d05a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "theme"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                },
                {
                    "kind": "Variable",
                    "name": "theme",
                    "variableName": "theme"
                },
                {
                    "kind": "Variable",
                    "name": "workspaceAri",
                    "variableName": "workspaceAri"
                }
            ],
            "concreteType": "SettingsUserPreferences",
            "kind": "LinkedField",
            "name": "settings_updateUserPreferencesWorkspace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "theme"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "workspaceThemeManagementSetWorkspaceThemePreferenceMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "workspaceThemeManagementSetWorkspaceThemePreferenceMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "2d8511617c2ae739deca629af208d0c0aff791868ae7f06fd41f3bca8189b104",
            "metadata": {},
            "name": "workspaceThemeManagementSetWorkspaceThemePreferenceMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$6a3c39cdeff6d05a$var$node.hash = "a59aa9b6da224d8962255852220e8493";
var $6a3c39cdeff6d05a$export$2e2bcd8739ae039 = $6a3c39cdeff6d05a$var$node;

});

parcelRegister("8AVGw", function(module, exports) {
$parcel$export(module.exports, "default", () => $81a21f93b1b0602a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f3d7efe2efb8521ac39409b96cee46e7>>
 * @relayHash 62e15c72deef7eaf4c9035e5e1976db0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 58bfe0135afad3b1d316f22b2877ad9574655e849a508aebd203bfbc9e5828dc
const $81a21f93b1b0602a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                },
                {
                    "kind": "Variable",
                    "name": "workspaceAri",
                    "variableName": "workspaceAri"
                }
            ],
            "concreteType": "SettingsUserPreferences",
            "kind": "LinkedField",
            "name": "settings_userPreferencesResolved",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "theme"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "workspaceThemeManagementGetWorkspaceThemePreferenceQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "workspaceThemeManagementGetWorkspaceThemePreferenceQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "58bfe0135afad3b1d316f22b2877ad9574655e849a508aebd203bfbc9e5828dc",
            "metadata": {},
            "name": "workspaceThemeManagementGetWorkspaceThemePreferenceQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$81a21f93b1b0602a$var$node.hash = "3f7fd599e886181a5359ad8f6fbe4487";
var $81a21f93b1b0602a$export$2e2bcd8739ae039 = $81a21f93b1b0602a$var$node;

});

parcelRegister("koK88", function(module, exports) {
$parcel$export(module.exports, "updateThemeWithDefaultValues", () => $359ab08349a7adc9$export$bc77b52491b156d8);

var $fCKGX = parcelRequire("fCKGX");

var $b8bnd = parcelRequire("b8bnd");
const $359ab08349a7adc9$export$bc77b52491b156d8 = (themeString)=>(0, $b8bnd.updateThemeObjectWithDefaultValues)((0, $fCKGX.themeStringToObject)(themeString));

});
parcelRegister("b8bnd", function(module, exports) {
$parcel$export(module.exports, "updateThemeObjectWithDefaultValues", () => $ed2d14f9929e05a4$export$830acc849806885d);

var $fqdCd = parcelRequire("fqdCd");
const $ed2d14f9929e05a4$export$830acc849806885d = (themeObject)=>({
        ...(0, $fqdCd.DEFAULT_THEME),
        ...themeObject
    });

});
parcelRegister("fqdCd", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_THEME", () => $58e3963f04c1bca1$export$2faeed762aac6741);
const $58e3963f04c1bca1$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
const $58e3963f04c1bca1$export$854b45b62d1eb6d4 = 'auto';
const $58e3963f04c1bca1$export$2faeed762aac6741 = {
    dark: 'dark',
    light: 'light',
    colorMode: $58e3963f04c1bca1$export$854b45b62d1eb6d4,
    typography: 'typography'
};

});




parcelRegister("lMW3p", function(module, exports) {
$parcel$export(module.exports, "SideNav", () => (parcelRequire("cOqoy")).SideNav);
$parcel$export(module.exports, "SideNavHeader", () => (parcelRequire("fVNT1")).SideNavHeader);
$parcel$export(module.exports, "SideNavBody", () => (parcelRequire("eal2a")).SideNavBody);
$parcel$export(module.exports, "SideNavFooter", () => (parcelRequire("2ysb2")).SideNavFooter);
$parcel$export(module.exports, "SideNavToggleButton", () => (parcelRequire("9R2G9")).SideNavToggleButton);
$parcel$export(module.exports, "useToggleSideNav", () => (parcelRequire("1xXI9")).useToggleSideNav);
$parcel$export(module.exports, "useExpandSideNav", () => (parcelRequire("kLm3T")).useExpandSideNav);
$parcel$export(module.exports, "useSideNavRef", () => (parcelRequire("l0LPS")).useSideNavRef);
$parcel$export(module.exports, "SideNavPanelSplitter", () => (parcelRequire("JEEbX")).SideNavPanelSplitter);

var $cOqoy = parcelRequire("cOqoy");

var $fVNT1 = parcelRequire("fVNT1");

var $eal2a = parcelRequire("eal2a");

var $2ysb2 = parcelRequire("2ysb2");

var $9R2G9 = parcelRequire("9R2G9");

var $1xXI9 = parcelRequire("1xXI9");

var $kLm3T = parcelRequire("kLm3T");

var $l0LPS = parcelRequire("l0LPS");

var $JEEbX = parcelRequire("JEEbX");

});
parcelRegister("cOqoy", function(module, exports) {
$parcel$export(module.exports, "SideNav", () => $55a94bcab42d3622$export$1a35787d6353cf6a);
/* side-nav.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $fZb1b = parcelRequire("fZb1b");

var $glbdM = parcelRequire("glbdM");

var $inMxE = parcelRequire("inMxE");

var $ljVHR = parcelRequire("ljVHR");

var $dZr3Z = parcelRequire("dZr3Z");

var $k3NXE = parcelRequire("k3NXE");

var $dfO5T = parcelRequire("dfO5T");

var $iqfTZ = parcelRequire("iqfTZ");

var $gOKKd = parcelRequire("gOKKd");

var $dS3O2 = parcelRequire("dS3O2");

var $9fYEM = parcelRequire("9fYEM");

var $av7P9 = parcelRequire("av7P9");

var $iFrrF = parcelRequire("iFrrF");

var $iFgsS = parcelRequire("iFgsS");

var $ccSgQ = parcelRequire("ccSgQ");

var $2NXvw = parcelRequire("2NXvw");

var $jqXzh = parcelRequire("jqXzh");

var $2OF47 = parcelRequire("2OF47");

var $cJ0Vk = parcelRequire("cJ0Vk");

var $gBHrf = parcelRequire("gBHrf");

var $baSqD = parcelRequire("baSqD");

var $2q8Af = parcelRequire("2q8Af");


var $cq1Hj = parcelRequire("cq1Hj");

var $7eybO = parcelRequire("7eybO");

var $az3Fy = parcelRequire("az3Fy");

var $hNf54 = parcelRequire("hNf54");

var $kLm3T = parcelRequire("kLm3T");

var $8gkNi = parcelRequire("8gkNi");

var $l0LPS = parcelRequire("l0LPS");

var $kIm7C = parcelRequire("kIm7C");

var $kmjbD = parcelRequire("kmjbD");

var $8hevw = parcelRequire("8hevw");

var $1xXI9 = parcelRequire("1xXI9");
const $55a94bcab42d3622$var$panelSplitterResizingVar = '--n_snvRsz';
// Used to share the side nav width with the panel splitter, which is rendered outside the side nav element
// but positioned to stay at its right edge.
const $55a94bcab42d3622$var$sideNavClampedWidthVar = '--n_snvW';
const $55a94bcab42d3622$var$fallbackMinWidth = '240px';
function $55a94bcab42d3622$var$getPixelCustomProperty(element, propertyName, fallback) {
    const raw = getComputedStyle(element).getPropertyValue(propertyName).trim();
    const value = Number.parseFloat(raw);
    return Number.isFinite(value) ? (0, $2OF47.resolveLayoutWidth)(raw.endsWith('vw') ? `${value}vw` : value, window.innerWidth) : fallback;
}
/**
 * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
 * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
 * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
 */ const $55a94bcab42d3622$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $55a94bcab42d3622$var$panelSplitterPortalTargetStyles = {
    root: "_1mT5xdy1CL _42Yu6B8OLE _1ZB6UydnbC _1VJPca4Hw8 _0jFU0VlOMI _2MwU8rfsLy _1EkTBE4L7p"
};
const $55a94bcab42d3622$var$styles = {
    root: "_2YmqfPYbGa _1VfddaYbGa _0KLXruoI2d _2OUyjtGk8v _24h04i2Njc _0jFU0VlOMI _2I62gzgiHs _1mT5xdHE3j _39xV02uZus _42Yu6BiZR3 _2EWYUbX3P0 _1KvygPUzyj _1EUs3cOeNX _0hAebtlfZc _1RYJRxYbGa _0xO92q39pk",
    chatPanelSizing: "_39xV02X3P0",
    managedOverlay: "_0PZ8vNOQJL _0qV2O6YbGa _27XaGGoI2d _3GwBusGk8v",
    flyoutOpen: "_1KvygPOQJL _1EUs3cYbGa _0hAebtoI2d _1RYJRxGk8v _2AFbI1Rodp _4kVtJl2HTN _1UvFJ1ThaV _1E7uFmIt9z",
    flyoutAnimateClosed: "_3iDTPbYbGa _1KvygPOQJL _2AFbI1Rodp _4kVtJl2HTN _1UvFJ1ThaV _4pNSLEIt9z",
    animationRTLSupport: "_2LGtmL7dHp _0pbPskvQQr",
    flyoutBaseStylesFullHeightSidebar: "_1KvygPOQJL _1EUs3cYbGa _0hAebtoI2d _1RYJRxGk8v _2SsmzmRodp _2QPceGThaV",
    flyoutOpenFullHeightSidebar: "_19NLAJ2HTN _03zLI5AYH4 _1QQNNIJF1Y",
    flyoutAnimateClosedFullHeightSidebar: "_0THHewYbGa _19NLAJ2HTN _03zLI5ROYS _19veLJJF1Y",
    flexContainer: "_0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuI7V3",
    hiddenMobileAndDesktop: "_3iDTPbYbGa",
    hiddenMobileOnly: "_3iDTPbYbGa _0THHewyL8i",
    hiddenDesktopOnly: "_0THHewYbGa",
    animationBaseStyles: "_2qDx9mRodp _4tikTSThaV _03Q0ee2HTN",
    expandAnimationMobile: "_4BklsuAYH4 _3WRiEcJF1Y",
    collapseAnimationMobile: "_3NcSKiOQJL _4BklsuROYS _0G6dy0JF1Y",
    expandAnimationDesktop: "_4fJQ5SUzyj _03zLI5AYH4 _1QQNNIJF1Y",
    collapseAnimationDesktop: "_4fJQ5SOQJL _03zLI5ROYS _19veLJJF1Y"
};
/**
 * Styles for the side nav enter/exit animations when `platform-dst-motion-uplift-sidenav` is enabled.
 *
 * These use the `motion.sidenav.*` tokens (keyframe animations) instead of the `transform` transitions
 * with `@starting-style` used by `styles`.
 *
 * ⚠️ The `transition-duration` values below need to stay in sync with the duration baked into the tokens
 * (`motion.sidenav.enter.*` is 250ms, `motion.sidenav.exit.*` is 200ms). The `display` property is
 * transitioned (with `allow-discrete`) so the element stays rendered for the length of the exit animation —
 * if the transition is shorter than the animation, `display: none` applies early and the exit animation
 * never runs.
 */ const $55a94bcab42d3622$var$motionUpliftStyles = {
    animationRTLSupport: "_0PlsTg2NCt _41VWnOVFMz _3G2eGnoK2N _0bboGQuqca",
    animationBaseStyles: "_2qDx9m4Gny _4tikTSThaV _03Q0eeLrT7",
    expandAnimationMobile: "_1jZhRJWRfq",
    collapseAnimationMobile: "_3NcSKiOQJL _1jZhRJTRd8",
    flyoutOpen: "_1KvygPOQJL _1EUs3cYbGa _0hAebtoI2d _1RYJRxGk8v _0k9R9aWRfq _4kVtJlqvoi _1UvFJ1ThaV",
    flyoutAnimateClosed: "_3iDTPbYbGa _1KvygPOQJL _0k9R9aTRd8 _4kVtJlLrT7 _1UvFJ1ThaV",
    flyoutOpenFullHeightSidebar: "_1wp4FmWRfq _19NLAJqvoi",
    flyoutAnimateClosedFullHeightSidebar: "_0THHewYbGa _1wp4FmTRd8 _19NLAJLrT7",
    expandAnimationDesktop: "_4fJQ5SUzyj _1wp4FmWRfq _4Bj9bNOQJL _2SsmzmIE5y _19NLAJxlqh _4y5EJLCT93",
    collapseAnimationDesktop: "_4fJQ5SOQJL _1wp4FmTRd8 _2SsmzmjYL6 _19NLAJw3oi _4y5EJLxGIf"
};
const $55a94bcab42d3622$var$fallbackDefaultWidth = 320;
const $55a94bcab42d3622$export$c735dc1c21910e21 = 500;
/**
 * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
 * context value.
 */ function $55a94bcab42d3622$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidthProp = $55a94bcab42d3622$var$fallbackDefaultWidth, minWidth: minWidth = $55a94bcab42d3622$var$fallbackMinWidth, maxWidth: maxWidth, testId: testId, label: label = 'Sidebar', skipLinkLabel: skipLinkLabel = label, onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, id: providedId, canToggleWithShortcut: canToggleWithShortcut }) {
    const isChatPanelLayoutEnabled = (0, $iqfTZ.fg)('platform-dst-chat-panel-layout');
    const isFhsEnabled = (0, $av7P9.useIsFhsEnabled)();
    const id = (0, $gBHrf.useLayoutId)({
        providedId: providedId
    });
    const expandAndFocusSideNav = (0, $kLm3T.useExpandSideNav)({
        trigger: 'skip-link'
    });
    /**
   * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
   *
   * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
   *
   * Only used when `platform_dst_nav4_skip_link_a11y_1` is OFF; can be removed on gate cleanup.
   */ const synchronouslyExpandSideNav = (0, $euxye.useCallback)(()=>{
        (0, $fZb1b.flushSync)(()=>{
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandAndFocusSideNav` makes.
       */ expandAndFocusSideNav();
        });
    }, [
        expandAndFocusSideNav
    ]);
    (0, $dS3O2.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        /**
     * `navigate` is the gate-on contract: it owns expanding the side nav AND moving
     * focus to the first nav item, atomically (via `useExpandSideNav`'s `flushSync`).
     *
     * `onBeforeNavigate` is the legacy contract used only when the gate is OFF.
     * On gate cleanup, drop `onBeforeNavigate` and `synchronouslyExpandSideNav` here.
     */ navigate: (0, $iqfTZ.fg)('platform_dst_nav4_skip_link_a11y_1') ? expandAndFocusSideNav : undefined,
        onBeforeNavigate: (0, $iqfTZ.fg)('platform_dst_nav4_skip_link_a11y_1') ? undefined : synchronouslyExpandSideNav
    });
    const sideNavState = (0, $euxye.useContext)((0, $hNf54.SideNavVisibilityState));
    const setSideNavState = (0, $euxye.useContext)((0, $cq1Hj.SetSideNavVisibilityState));
    const { isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile } = (0, $kmjbD.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    const [initialDefaultCollapsed] = (0, $euxye.useState)(defaultCollapsed);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [initialIsExpandedOnDesktop] = (0, $euxye.useState)(isExpandedOnDesktop);
    /**
   * Captures the initial collapsed/expanded state of the side nav.
   *
   * Only firing on desktop because the nav is never open by default on mobile.
   */ (0, $euxye.useEffect)(()=>{
        if (initialIsExpandedOnDesktop) {
            const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
            if (isDesktop) {
                const navigationAnalyticsEvent = createAnalyticsEvent({
                    source: 'topNav',
                    actionSubject: 'sideNav',
                    action: 'viewedOnLoad',
                    actionSubjectId: 'sideNavMenu',
                    attributes: {
                        screen: 'desktop'
                    }
                });
                navigationAnalyticsEvent.fire('navigation');
            }
        }
    }, [
        createAnalyticsEvent,
        initialIsExpandedOnDesktop
    ]);
    const defaultWidth = (0, $2q8Af.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $55a94bcab42d3622$var$fallbackDefaultWidth,
        slotName: 'SideNav'
    });
    const [inlineWidth, setInlineWidth] = (0, $euxye.useState)(defaultWidth);
    const [overlayWidth, setOverlayWidth] = (0, $euxye.useState)(defaultWidth);
    const [isInline, setIsInline] = (0, $euxye.useState)(false);
    (0, $euxye.useEffect)(()=>{
        if (!isChatPanelLayoutEnabled) return;
        const mediaQuery = window.matchMedia('(min-width: 64rem)');
        setIsInline(mediaQuery.matches);
        const onChange = (event)=>setIsInline(event.matches);
        return (0, $glbdM.bind)(mediaQuery, {
            type: 'change',
            listener: onChange
        });
    }, [
        isChatPanelLayoutEnabled
    ]);
    const toggleVisibilityForChatPanel = (0, $1xXI9.useToggleSideNav)({
        trigger: 'programmatic'
    });
    const closeOverlayForChatPanel = (0, $euxye.useCallback)(()=>{
        // Allocation can overlay an expanded desktop nav when other slots consume
        // its space. Dismiss the visibility state selected by the viewport, not the mode.
        const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
        if (isDesktop ? isExpandedOnDesktop : isExpandedOnMobile) toggleVisibilityForChatPanel();
    }, [
        isExpandedOnDesktop,
        isExpandedOnMobile,
        toggleVisibilityForChatPanel
    ]);
    const { state: managedSizing, getResizeBounds: getManagedResizeBounds, startResize: startResize, resize: resize, completeResize: completeResize } = (0, $cJ0Vk.useLayoutAreaSizing)({
        area: 'side-nav',
        config: {
            defaultWidth: defaultWidth,
            minWidth: minWidth,
            maxWidth: maxWidth,
            isOpen: isInline ? isExpandedOnDesktop : isExpandedOnMobile,
            onRequestClose: closeOverlayForChatPanel
        }
    });
    const mode = managedSizing?.mode ?? (isInline ? 'inline' : 'overlay');
    const renderedWidth = isChatPanelLayoutEnabled ? managedSizing?.width ?? (mode === 'inline' ? inlineWidth : overlayWidth) : inlineWidth;
    const configuredMaxWidth = maxWidth ?? '100vw';
    const clampedWidth = !isChatPanelLayoutEnabled ? `clamp(240px, ${inlineWidth}px, 50vw)` : managedSizing ? `${renderedWidth}px` : `clamp(${minWidth}, ${renderedWidth}px, ${configuredMaxWidth})`;
    const dangerouslyHoistSlotSizes = (0, $euxye.useContext)((0, $ccSgQ.DangerouslyHoistSlotSizes));
    const navRef = (0, $euxye.useRef)(null);
    const panelSplitterPortalTargetRef = (0, $euxye.useRef)(null);
    const getResizeBounds = (0, $euxye.useCallback)(()=>{
        if (!isChatPanelLayoutEnabled) return {
            min: '240px',
            max: '50vw'
        };
        const managedBounds = getManagedResizeBounds();
        if (managedBounds) return managedBounds;
        const sideNav = navRef.current;
        const layoutRoot = sideNav?.parentElement;
        const main = layoutRoot?.querySelector(':scope > [data-layout-slot][role="main"]');
        const fallbackMaxWidth = maxWidth ?? (mode === 'inline' ? '100vw' : '90vw');
        if (!sideNav || mode === 'overlay') {
            const chatPanel = layoutRoot?.querySelector(':scope > [data-layout-chat-panel]');
            const inlineChatPanelWidth = chatPanel && getComputedStyle(chatPanel).gridArea === 'chat-panel' ? chatPanel.getBoundingClientRect().width : 0;
            const overlayMaxWidth = Math.floor((window.innerWidth - inlineChatPanelWidth) * 0.9);
            const constrainedMaxWidth = maxWidth ? Math.min((0, $2NXvw.convertResizeBoundToPixels)(maxWidth), overlayMaxWidth) : overlayMaxWidth;
            return {
                min: minWidth,
                max: `${Math.max((0, $2NXvw.convertResizeBoundToPixels)(minWidth), constrainedMaxWidth)}px`
            };
        }
        if (!main) return {
            min: minWidth,
            max: fallbackMaxWidth
        };
        const sideNavWidth = sideNav.getBoundingClientRect().width;
        const mainWidth = main.getBoundingClientRect().width;
        // JSDOM does not perform layout, so retain the static fallback in unit tests and other
        // environments where used widths cannot be measured.
        if (sideNavWidth === 0 || mainWidth === 0) return {
            min: minWidth,
            max: fallbackMaxWidth
        };
        const localPanel = main.querySelector('[data-layout-with-panel-slot]');
        const isLocalPanelInline = localPanel && getComputedStyle(localPanel).gridArea === 'panel';
        const localPanelWidth = isLocalPanelInline ? localPanel.getBoundingClientRect().width : 0;
        const mainContentWidth = mainWidth - localPanelWidth;
        const mainMinimumWidth = $55a94bcab42d3622$var$getPixelCustomProperty(main, (0, $iFrrF.mainMinimumWidthVar), 320);
        const availableWidth = Math.max(0, mainContentWidth - mainMinimumWidth);
        const availableInlineWidth = Math.floor(sideNavWidth + availableWidth);
        const constrainedMaxWidth = maxWidth ? Math.min((0, $2NXvw.convertResizeBoundToPixels)(maxWidth), availableInlineWidth) : availableInlineWidth;
        return {
            min: minWidth,
            max: `${Math.max((0, $2NXvw.convertResizeBoundToPixels)(minWidth), constrainedMaxWidth)}px`
        };
    }, [
        getManagedResizeBounds,
        isChatPanelLayoutEnabled,
        maxWidth,
        minWidth,
        mode
    ]);
    /**
   * Used to share the side nav element with the `Panel`,
   * which observes the side nav to determine its maximum width.
   */ const sharedRef = (0, $l0LPS.useSideNavRef)();
    const mergedRef = (0, $ljVHR.default)([
        navRef,
        sharedRef
    ]);
    const onCompleteResize = (0, $euxye.useCallback)((finalWidth)=>{
        if (!isChatPanelLayoutEnabled) {
            setInlineWidth(finalWidth);
            return;
        }
        if (mode === 'inline') setInlineWidth(finalWidth);
        else setOverlayWidth(finalWidth);
        completeResize(mode, finalWidth);
    }, [
        completeResize,
        isChatPanelLayoutEnabled,
        mode
    ]);
    const onResizeStartInternal = (0, $euxye.useCallback)(()=>{
        startResize(mode);
    }, [
        mode,
        startResize
    ]);
    const onResizeInternal = (0, $euxye.useCallback)((width)=>resize(mode, width), [
        mode,
        resize
    ]);
    const toggleButtonElement = (0, $euxye.useContext)((0, $7eybO.SideNavToggleButtonElement));
    const topNavStartElement = (0, $euxye.useContext)((0, $9fYEM.TopNavStartElement));
    const devTimeOnlyAttributes = {};
    const openLayerObserver = (0, $dfO5T.useOpenLayerObserver)();
    const flyoutStateRef = (0, $euxye.useRef)({
        type: 'not-active'
    });
    const isFlyoutVisible = sideNavState?.flyout === 'open';
    const isExpandedOnDesktopRef = (0, $dZr3Z.default)(isExpandedOnDesktop);
    const hasPeekStartedRef = (0, $euxye.useRef)(false);
    const onPeekStartRef = (0, $dZr3Z.default)(onPeekStart);
    const onPeekEndRef = (0, $dZr3Z.default)(onPeekEnd);
    const onPeekStartTimeoutIdRef = (0, $euxye.useRef)(undefined);
    (0, $euxye.useEffect)(()=>{
        return ()=>{
            clearTimeout(onPeekStartTimeoutIdRef.current);
        };
    }, []);
    const updateFlyoutState = (0, $euxye.useMemo)(()=>{
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            // Prevent the flyout from being opened if there are any open layers in the top nav start
            if (openLayerObserver && openLayerObserver.getCount({
                namespace: (0, $iFrrF.openLayerObserverTopNavStartNamespace),
                type: 'popup'
            }) > 0) return;
            const prevFlyoutState = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout !== 'open') return {
                    ...currentState,
                    flyout: 'open'
                };
                return currentState;
            });
            // Avoid redundant calls to `onPeekStart()`
            if (prevFlyoutState.type === 'not-active') {
                clearTimeout(onPeekStartTimeoutIdRef.current);
                onPeekStartTimeoutIdRef.current = setTimeout(()=>{
                    // If the flyout isn't still open after ~500ms then we won't count the peek
                    // As we want to track user intention rather than all hovers
                    if (isExpandedOnDesktopRef.current || flyoutStateRef.current.type !== 'open') return;
                    hasPeekStartedRef.current = true;
                    onPeekStartRef.current?.();
                }, $55a94bcab42d3622$export$c735dc1c21910e21);
            }
        }
        function close() {
            const prevFlyoutState = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout === 'open') return {
                    ...currentState,
                    flyout: 'triggered-animate-close'
                };
                return currentState;
            });
            // Avoid redundant calls to `onPeekEnd()`
            if (prevFlyoutState.type !== 'not-active' && hasPeekStartedRef.current) {
                hasPeekStartedRef.current = false;
                onPeekEndRef.current?.({
                    trigger: isExpandedOnDesktopRef.current ? 'side-nav-expand' : 'mouse-leave'
                });
            }
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            }
            // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, (0, $9575501c176c2705$export$a7801e29f563faad));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver?.getCount({
                    namespace: (0, $iFrrF.openLayerObserverSideNavNamespace)
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        isExpandedOnDesktopRef,
        onPeekEndRef,
        onPeekStartRef,
        openLayerObserver,
        setSideNavState
    ]);
    const toggleVisibilityByScreenResize = (0, $1xXI9.useToggleSideNav)({
        trigger: 'screen-resize'
    });
    const toggleVisibilityByClickOutsideOnMobile = (0, $1xXI9.useToggleSideNav)({
        trigger: 'click-outside-on-mobile'
    });
    // Using `useLayoutEffect` so that there's no visual shift in non-SSR environments when using legacy API
    // For SSR the new API is still necessary
    (0, $euxye.useLayoutEffect)(()=>{
        if (sideNavState !== null) // Only need to do an initial sync if it hasn't been initialized from Root
        return;
        // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        (0, $euxye.startTransition)(()=>{
            setSideNavState({
                desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
                mobile: 'collapsed',
                flyout: 'closed',
                lastTrigger: null
            });
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState,
        sideNavState
    ]);
    const handleExpand = (0, $euxye.useCallback)(({ screen: screen, trigger: trigger })=>{
        onExpand?.({
            screen: screen,
            trigger: trigger
        });
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'expanded',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger
            }
        });
        navigationAnalyticsEvent.fire('navigation');
        // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    const handleCollapse = (0, $euxye.useCallback)(({ screen: screen, trigger: trigger })=>{
        onCollapse?.({
            screen: screen,
            trigger: trigger
        });
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'collapsed',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger
            }
        });
        navigationAnalyticsEvent.fire('navigation');
        // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    (0, $8hevw.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile,
        lastTrigger: sideNavState?.lastTrigger ?? null
    });
    (0, $euxye.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $glbdM.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibilityByScreenResize();
                }
            }
        });
    }, [
        toggleVisibilityByScreenResize,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]);
    /**
   * Close the mobile side nav if there is a click outside.
   *
   * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
   * If we listened to window size changes we'd need nested `bind()` calls.
   */ (0, $euxye.useEffect)(()=>{
        if (!isExpandedOnMobile) return;
        /**
     * The expected URL fragment used by the side nav skip link.
     */ const skipLinkUrlFragment = `#${id}`;
        return (0, $glbdM.bind)(window, {
            type: 'click',
            listener (event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                const sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (!event.target.isConnected) /**
           * If the element that was clicked is no longer in the document, we should not collapse the side nav.
           * This can happen when the user clicks on a dropdown menu item (such as one used in a `...` More menu),
           * as the dropdown menu will close after being clicked. By the time this event listener runs, the clicked
           * element will no longer be in the document, so the check below for `sideNav.contains(event.target)` will fail.
           */ return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement?.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                if (event.target instanceof HTMLAnchorElement && /**
         * Intentionally using `.getAttribute()` for simplicity to match exactly what we expect
         * for skip links.
         *
         * Alternatives considered:
         *
         * - Using `.href` returns a full URL, which would then require extra parsing.
         * - Using `.hash` could incorrectly capture `<a href="/another-page#skip-link-id>` so we'd need extra checks.
         *
         * This approach has an edge case of `<a href="/same-page#skip-link-id>` not being captured,
         * but we are okay with that trade-off.
         */ event.target.getAttribute('href') === skipLinkUrlFragment) // This was a click on a link to the side nav, so we shouldn't try to collapse the SideNav.
                // It was most likely the skip link, although anyone can render a link with the ID.
                // In either case keeping the SideNav expanded makes sense.
                return;
                toggleVisibilityByClickOutsideOnMobile();
            }
        });
    }, [
        id,
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibilityByClickOutsideOnMobile
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $glbdM.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $glbdM.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $glbdM.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $glbdM.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $euxye.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
        // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $gOKKd.monitorForElements)({
            canMonitor ({ source: source }) {
                return nav.contains(source.element);
            },
            onGenerateDragPreview () {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop ({ location: location }) {
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished');
                // If the user dropped outside of the flyout, we will close the flyout
                const underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!topNavStartElement || !toggleButtonElement) return;
        return (0, $glbdM.bind)(topNavStartElement, {
            type: 'mouseover',
            listener (event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event.target === topNavStartElement) {
                    // The mouse is directly over the TopNavStart element, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                // The user has moused over a child element of the TopNavStart element that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!topNavStartElement) return;
        return (0, $glbdM.bind)(topNavStartElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                // The mouse has left the TopNavStart element, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $euxye.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, TopNavStart element)
        return openLayerObserver?.onChange(({ count: count })=>{
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: (0, $iFrrF.openLayerObserverSideNavNamespace)
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $euxye.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    (0, $kIm7C.useSideNavToggleKeyboardShortcut)({
        canToggleWithShortcut: canToggleWithShortcut
    });
    // Used to conditionally display the keyboard shortcut in the SideNavPanelSplitter tooltip.
    const isShortcutEnabled = (0, $8gkNi.useIsSideNavShortcutEnabled)();
    (0, $baSqD.useResizingWidthCssVarOnRootElement)({
        isEnabled: !isChatPanelLayoutEnabled || !managedSizing,
        cssVar: $55a94bcab42d3622$var$panelSplitterResizingVar,
        panelId: (0, $iFrrF.sideNavPanelSplitterId)
    });
    const isExpandedStateDifferentFromInitial = isExpandedOnMobile || isExpandedOnDesktop !== initialIsExpandedOnDesktop;
    /**
   * Used to track (between renders) if the expanded state of the side nav has ever changed since mount.
   *
   * Cannot rely solely on `isExpandedStateDifferentFromInitial` because the expanded state can go back to the initial state.
   */ const hasExpandedStateChangedRef = (0, $euxye.useRef)(false);
    (0, $euxye.useEffect)(()=>{
        if (hasExpandedStateChangedRef.current) return;
        if (isExpandedStateDifferentFromInitial) hasExpandedStateChangedRef.current = true;
    }, [
        isExpandedStateDifferentFromInitial
    ]);
    /**
   * If the expanded state of the side nav has ever changed since mount.
   *
   * Used to prevent sidebar expand animations from running on the initial load.
   * Otherwise, the `@starting-style` rule will cause the sidebar to slide in initially.
   */ const hasExpandedStateChanged = isExpandedStateDifferentFromInitial || hasExpandedStateChangedRef.current;
    const isMotionUpliftEnabled = (0, $iqfTZ.fg)('platform-dst-motion-uplift-sidenav');
    // This is only used for the regular expand and collapse animations, not the flyout animations.
    const shouldShowSidebarToggleAnimation = (isMotionUpliftEnabled || isFhsEnabled) && // We do not apply the animation styles on the initial render, as the `@starting-style` rule will cause the sidebar to
    // slide in initially.
    hasExpandedStateChanged && // We also do not apply the animation styles if the side nav is in flyout mode to make sure we don't override flyout styles.
    // If we instead try to unset the `transform` property in the flyout styles using `transform: initial`, it results in the entire
    // flyout animation being disabled.
    !isFlyoutVisible && /**
   * Disabling animations for Firefox, as it doesn't support animating the `display` property:
   * https://caniuse.com/mdn-css_properties_display_is_transitionable
   *
   * As of October 2025, Firefox supports the expand animation, but not the collapse animation (it instantly changes to `display: none`).
   * Because of this, we are disabling all sidebar animations for Firefox so it doesn't look like a bug.
   *
   * Unfortunately we cannot use `@supports` to target the support of `transition-behavior: allow-discrete` specifically
   * for the `display` property. And `@supports at-rule(@starting-style)` is also not ready for browser use yet.
   *
   * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
   * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
   * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
   */ !$55a94bcab42d3622$var$isFirefox;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsxs)("nav", {
                id: id,
                ...devTimeOnlyAttributes,
                "data-layout-slot": true,
                "aria-label": label,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
                    [(0, $iFrrF.sideNavVar)]: clampedWidth
                },
                ref: mergedRef,
                "data-testid": testId,
                className: (0, $4jQY2.default)([
                    $55a94bcab42d3622$var$styles.root,
                    isChatPanelLayoutEnabled && $55a94bcab42d3622$var$styles.chatPanelSizing,
                    isChatPanelLayoutEnabled && managedSizing?.mode === 'overlay' && $55a94bcab42d3622$var$styles.managedOverlay,
                    isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $55a94bcab42d3622$var$styles.hiddenMobileOnly,
                    !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $55a94bcab42d3622$var$styles.hiddenDesktopOnly,
                    !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $55a94bcab42d3622$var$styles.hiddenMobileAndDesktop,
                    isMotionUpliftEnabled && $55a94bcab42d3622$var$motionUpliftStyles.animationRTLSupport,
                    !isMotionUpliftEnabled && isFhsEnabled && $55a94bcab42d3622$var$styles.animationRTLSupport,
                    shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $55a94bcab42d3622$var$motionUpliftStyles.animationBaseStyles,
                    shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $55a94bcab42d3622$var$styles.animationBaseStyles,
                    isExpandedOnMobile && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $55a94bcab42d3622$var$motionUpliftStyles.expandAnimationMobile,
                    isExpandedOnMobile && shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $55a94bcab42d3622$var$styles.expandAnimationMobile,
                    !isExpandedOnMobile && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $55a94bcab42d3622$var$motionUpliftStyles.collapseAnimationMobile,
                    !isExpandedOnMobile && shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $55a94bcab42d3622$var$styles.collapseAnimationMobile,
                    isExpandedOnDesktop && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $55a94bcab42d3622$var$motionUpliftStyles.expandAnimationDesktop,
                    isExpandedOnDesktop && shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $55a94bcab42d3622$var$styles.expandAnimationDesktop,
                    !isExpandedOnDesktop && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $55a94bcab42d3622$var$motionUpliftStyles.collapseAnimationDesktop,
                    !isExpandedOnDesktop && shouldShowSidebarToggleAnimation && !isMotionUpliftEnabled && $55a94bcab42d3622$var$styles.collapseAnimationDesktop,
                    sideNavState?.flyout === 'open' && !isFhsEnabled && isMotionUpliftEnabled && $55a94bcab42d3622$var$motionUpliftStyles.flyoutOpen,
                    sideNavState?.flyout === 'open' && !isFhsEnabled && !isMotionUpliftEnabled && $55a94bcab42d3622$var$styles.flyoutOpen,
                    sideNavState?.flyout === 'triggered-animate-close' && !isFhsEnabled && isMotionUpliftEnabled && $55a94bcab42d3622$var$motionUpliftStyles.flyoutAnimateClosed,
                    sideNavState?.flyout === 'triggered-animate-close' && !isFhsEnabled && !isMotionUpliftEnabled && $55a94bcab42d3622$var$styles.flyoutAnimateClosed,
                    (sideNavState?.flyout === 'open' || sideNavState?.flyout === 'triggered-animate-close') && !$55a94bcab42d3622$var$isFirefox && isFhsEnabled && $55a94bcab42d3622$var$styles.flyoutBaseStylesFullHeightSidebar,
                    sideNavState?.flyout === 'open' && !$55a94bcab42d3622$var$isFirefox && isFhsEnabled && isMotionUpliftEnabled && $55a94bcab42d3622$var$motionUpliftStyles.flyoutOpenFullHeightSidebar,
                    sideNavState?.flyout === 'open' && !$55a94bcab42d3622$var$isFirefox && isFhsEnabled && !isMotionUpliftEnabled && $55a94bcab42d3622$var$styles.flyoutOpenFullHeightSidebar,
                    sideNavState?.flyout === 'triggered-animate-close' && !$55a94bcab42d3622$var$isFirefox && isFhsEnabled && isMotionUpliftEnabled && $55a94bcab42d3622$var$motionUpliftStyles.flyoutAnimateClosedFullHeightSidebar,
                    sideNavState?.flyout === 'triggered-animate-close' && !$55a94bcab42d3622$var$isFirefox && isFhsEnabled && !isMotionUpliftEnabled && $55a94bcab42d3622$var$styles.flyoutAnimateClosedFullHeightSidebar
                ]),
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iFgsS.DangerouslyHoistCssVarToDocumentRoot), {
                        variableName: (0, $iFrrF.sideNavLiveWidthVar),
                        value: "0px",
                        mediaQuery: '@media (min-width: 64rem)',
                        responsiveValue: isExpandedOnDesktop ? `var(${$55a94bcab42d3622$var$panelSplitterResizingVar}, ${clampedWidth})` : 0
                    }),
                    dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                    // When they aren't needed anymore we can delete them wholesale.
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iFgsS.DangerouslyHoistCssVarToDocumentRoot), {
                        variableName: (0, $iFrrF.UNSAFE_sideNavLayoutVar),
                        value: `var(${(0, $iFrrF.sideNavLiveWidthVar)})`
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jqXzh.PanelSplitterProvider), {
                        panelId: (0, $iFrrF.sideNavPanelSplitterId),
                        panelRef: navRef,
                        portalRef: isFhsEnabled ? panelSplitterPortalTargetRef : undefined,
                        panelWidth: renderedWidth,
                        onCompleteResize: onCompleteResize,
                        onResizeStartInternal: isChatPanelLayoutEnabled && managedSizing ? onResizeStartInternal : undefined,
                        onResizeInternal: isChatPanelLayoutEnabled && managedSizing ? onResizeInternal : undefined,
                        getResizeBounds: getResizeBounds,
                        resizingCssVar: $55a94bcab42d3622$var$panelSplitterResizingVar,
                        // Not resizable when in peek (flyout) mode.
                        isEnabled: !isFlyoutVisible,
                        shortcut: isShortcutEnabled ? (0, $az3Fy.sideNavToggleTooltipKeyboardShortcut) : undefined,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                            className: (0, $4jQY2.default)([
                                $55a94bcab42d3622$var$styles.flexContainer
                            ]),
                            children: children
                        })
                    })
                ]
            }),
            isFhsEnabled && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                ref: panelSplitterPortalTargetRef,
                "data-layout-slot": true,
                style: {
                    // We need to use an inline style here to share the side nav width to position the panel splitter.
                    // We can't use the existing --n_sNvlw variable (sideNavLiveWidthVar) because it is set to 0 when the side nav is collapsed on desktop,
                    // however the panel splitter is still visible and usable on small viewports until 48rem.
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    [$55a94bcab42d3622$var$sideNavClampedWidthVar]: clampedWidth
                },
                className: (0, $4jQY2.default)([
                    $55a94bcab42d3622$var$panelSplitterPortalTargetStyles.root,
                    isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $55a94bcab42d3622$var$styles.hiddenMobileOnly,
                    !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $55a94bcab42d3622$var$styles.hiddenDesktopOnly,
                    !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $55a94bcab42d3622$var$styles.hiddenMobileAndDesktop
                ])
            })
        ]
    });
}
$55a94bcab42d3622$var$SideNavInternal.displayName = "SideNavInternal";
function $55a94bcab42d3622$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, minWidth: minWidth, maxWidth: maxWidth, testId: testId, label: label, skipLinkLabel: // Default value is defined in `SideNavInternal`
skipLinkLabel = label, onExpand: // Default value is defined in `SideNavInternal`
onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, canToggleWithShortcut: canToggleWithShortcut, id: id }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $k3NXE.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $iFrrF.openLayerObserverSideNavNamespace),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($55a94bcab42d3622$var$SideNavInternal, {
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            minWidth: minWidth,
            maxWidth: maxWidth,
            testId: testId,
            label: label,
            skipLinkLabel: skipLinkLabel,
            onExpand: onExpand,
            onCollapse: onCollapse,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            id: id,
            canToggleWithShortcut: canToggleWithShortcut,
            children: children
        })
    });
}
$55a94bcab42d3622$export$1a35787d6353cf6a.displayName = "SideNav";

});
parcelRegister("k3NXE", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceProvider", () => $98d18b5df26349b3$export$327d0d2a7ae6f7cc);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");

var $9vDkH = parcelRequire("9vDkH");

var $1xyNg = parcelRequire("1xyNg");
function $98d18b5df26349b3$export$327d0d2a7ae6f7cc({ children: children, namespace: namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, $1xyNg.useOpenLayerObserverNamespace)();
    (0, $euxye.useEffect)(()=>{
        (0, $jiTLE.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9vDkH.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace,
        children: children
    });
}
$98d18b5df26349b3$export$327d0d2a7ae6f7cc.displayName = "OpenLayerObserverNamespaceProvider";

});

parcelRegister("dfO5T", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserver", () => $3248ea3b9a226d58$export$750f5b0d6c51617e);

var $euxye = parcelRequire("euxye");

var $jAinK = parcelRequire("jAinK");
function $3248ea3b9a226d58$export$750f5b0d6c51617e() {
    const context = (0, $euxye.useContext)((0, $jAinK.OpenLayerObserverContext));
    const publicAPI = (0, $euxye.useMemo)(()=>{
        if (context === null) return null;
        return {
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        };
    }, [
        context
    ]);
    return publicAPI;
}

});

parcelRegister("dS3O2", function(module, exports) {
$parcel$export(module.exports, "useSkipLinkInternal", () => $b6e01b071531ddc9$export$707b94c26b8b75aa);

var $euxye = parcelRequire("euxye");

var $buY4I = parcelRequire("buY4I");
const $b6e01b071531ddc9$export$707b94c26b8b75aa = ({ id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, navigate: navigate, isHidden: isHidden })=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $euxye.useContext)((0, $buY4I.SkipLinksContext));
    (0, $euxye.useEffect)(()=>{
        if (isHidden) /**
			 * Skip links are hidden for slots with 0 height or width.
			 * They should not be registered.
			 */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            navigate: navigate,
            isHidden: isHidden
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        navigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});
parcelRegister("buY4I", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContext", () => $64df95514aa099ee$export$4c5cc3b14c7678a);

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");
const $64df95514aa099ee$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $euxye.createContext)({
    registerSkipLink: (0, $2oRWW.default),
    unregisterSkipLink: (0, $2oRWW.default)
});

});


parcelRegister("9fYEM", function(module, exports) {
$parcel$export(module.exports, "TopNavStartElement", () => $ab5504bfc49adc8d$export$e9e5087bd319cc8c);

var $euxye = parcelRequire("euxye");
const $ab5504bfc49adc8d$export$e9e5087bd319cc8c = /*#__PURE__*/ (0, $euxye.createContext)(null);

});

parcelRegister("av7P9", function(module, exports) {
$parcel$export(module.exports, "useIsFhsEnabled", () => $8e96a5dc7d05d9f5$export$8b40a725a91166de);

var $euxye = parcelRequire("euxye");

var $ltR6m = parcelRequire("ltR6m");
const $8e96a5dc7d05d9f5$export$8b40a725a91166de = ()=>{
    const isFhsEnabled = (0, $euxye.useContext)((0, $ltR6m.IsFhsEnabledContext));
    return typeof isFhsEnabled === 'boolean' ? isFhsEnabled : isFhsEnabled();
};

});
parcelRegister("ltR6m", function(module, exports) {
$parcel$export(module.exports, "IsFhsEnabledContext", () => $cd3e0b1e57185391$export$1e91b29ada71c32a);

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");
const $cd3e0b1e57185391$export$1e91b29ada71c32a = /*#__PURE__*/ (0, $euxye.createContext)(()=>(0, $iqfTZ.fg)('navx-full-height-sidebar'));

});


parcelRegister("iFrrF", function(module, exports) {
$parcel$export(module.exports, "sideNavVar", () => $b5289abb83d11deb$export$951bf5156e86d974);
$parcel$export(module.exports, "asideVar", () => $b5289abb83d11deb$export$594e6a30db7c057e);
$parcel$export(module.exports, "panelVar", () => $b5289abb83d11deb$export$db0c2e1d744fb281);
$parcel$export(module.exports, "mainMinimumWidthVar", () => $b5289abb83d11deb$export$c331a3472b90c7fa);
$parcel$export(module.exports, "bannerMountedVar", () => $b5289abb83d11deb$export$515a0b1baafe906c);
$parcel$export(module.exports, "topNavMountedVar", () => $b5289abb83d11deb$export$60ef3a7b1ed42328);
$parcel$export(module.exports, "sideNavLiveWidthVar", () => $b5289abb83d11deb$export$1216dacffd1e9e65);
$parcel$export(module.exports, "sideNavPanelSplitterId", () => $b5289abb83d11deb$export$5db28b16b6e686bc);
$parcel$export(module.exports, "asidePanelSplitterId", () => $b5289abb83d11deb$export$de580d653bac8ad9);
$parcel$export(module.exports, "panelPanelSplitterId", () => $b5289abb83d11deb$export$3452dcb65711af44);
$parcel$export(module.exports, "contentInsetBlockStart", () => $b5289abb83d11deb$export$bfabd8c2c572ad29);
$parcel$export(module.exports, "UNSAFE_topNavVar", () => $b5289abb83d11deb$export$855f5a09f5c99ac);
$parcel$export(module.exports, "UNSAFE_bannerVar", () => $b5289abb83d11deb$export$26354f9814213292);
$parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", () => $b5289abb83d11deb$export$6bfc931a04ec5741);
$parcel$export(module.exports, "UNSAFE_asideLayoutVar", () => $b5289abb83d11deb$export$bbbace2ff0c7ae1b);
$parcel$export(module.exports, "UNSAFE_panelLayoutVar", () => $b5289abb83d11deb$export$753bf7651b25db91);
$parcel$export(module.exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", () => $b5289abb83d11deb$export$6460bd6a2446260);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY", () => $b5289abb83d11deb$export$3055529fab2b4edf);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY", () => $b5289abb83d11deb$export$166d8fd766c3eb92);
$parcel$export(module.exports, "openLayerObserverSideNavNamespace", () => $b5289abb83d11deb$export$876effa8b02edc2f);
$parcel$export(module.exports, "openLayerObserverTopNavStartNamespace", () => $b5289abb83d11deb$export$a6be839a92c90df7);
$parcel$export(module.exports, "openLayerObserverTopNavMiddleNamespace", () => $b5289abb83d11deb$export$762ad20d97870b35);
$parcel$export(module.exports, "openLayerObserverTopNavEndNamespace", () => $b5289abb83d11deb$export$8dd71e8a7db48024);
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $b5289abb83d11deb$export$951bf5156e86d974 = '--n_sNvw';
const $b5289abb83d11deb$export$594e6a30db7c057e = '--n_asDw';
const $b5289abb83d11deb$export$db0c2e1d744fb281 = '--n_pnlW';
const $b5289abb83d11deb$export$8b0055855c9c088f = '--n_cPnlW';
const $b5289abb83d11deb$export$c80e4a9eb4c90d80 = '--n_cPnlLw';
const $b5289abb83d11deb$export$c331a3472b90c7fa = '--n_mainMinW';
const $b5289abb83d11deb$export$515a0b1baafe906c = '--n_bnrM';
const $b5289abb83d11deb$export$60ef3a7b1ed42328 = '--n_tNvM';
const $b5289abb83d11deb$export$a16bbd599f6269e7 = '--n_rbnW';
const $b5289abb83d11deb$export$1216dacffd1e9e65 = '--n_sNvlw';
const $b5289abb83d11deb$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
const $b5289abb83d11deb$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
const $b5289abb83d11deb$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
const $b5289abb83d11deb$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))`;
const $b5289abb83d11deb$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))`;
const $b5289abb83d11deb$export$855f5a09f5c99ac = '--topNavigationHeight';
const $b5289abb83d11deb$export$26354f9814213292 = '--bannerHeight';
const $b5289abb83d11deb$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $b5289abb83d11deb$export$58de0a46980ca7f4 = '--leftPanelWidth';
const $b5289abb83d11deb$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $b5289abb83d11deb$export$753bf7651b25db91 = '--rightPanelWidth';
const $b5289abb83d11deb$export$6460bd6a2446260 = `calc(var(${$b5289abb83d11deb$export$26354f9814213292}, 0px) + var(${$b5289abb83d11deb$export$855f5a09f5c99ac}, 0px))`;
const $b5289abb83d11deb$export$3055529fab2b4edf = `calc(var(${$b5289abb83d11deb$export$58de0a46980ca7f4}, 0px) + var(${$b5289abb83d11deb$export$6bfc931a04ec5741}, 0px))`;
const $b5289abb83d11deb$export$166d8fd766c3eb92 = `calc(var(${$b5289abb83d11deb$export$bbbace2ff0c7ae1b}, 0px) + var(${$b5289abb83d11deb$export$753bf7651b25db91}, 0px))`;
const $b5289abb83d11deb$export$61156ceb1a99f6a0 = {
    // Chat overlays the app, including TopNav and SideNav, below the banner.
    chatPanelOverlay: 5,
    ribbon: 4,
    // The side nav panel splitter is layered above the top nav when FHS is enabled.
    // It has the same z-index value, but is rendered after the top nav in the DOM so is stacked above.
    sideNavPanelSplitterFHS: 4,
    topBar: 4,
    banner: 4,
    // When FHS is enabled, the side nav is layered below the top nav,
    // but above the panel
    bannerFHS: 3,
    topNavFHS: 3,
    sideNav: 2,
    panelSmallViewports: 1
};
const $b5289abb83d11deb$export$876effa8b02edc2f = 'side-nav';
const $b5289abb83d11deb$export$a6be839a92c90df7 = 'top-nav-start';
const $b5289abb83d11deb$export$762ad20d97870b35 = 'top-nav-middle';
const $b5289abb83d11deb$export$8dd71e8a7db48024 = 'top-nav-end';

});

parcelRegister("iFgsS", function(module, exports) {
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $fcb6f14fb2f04478$export$9f45a1325e3cdfb8);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");
const $fcb6f14fb2f04478$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $fcb6f14fb2f04478$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root { ${variableName}: ${$fcb6f14fb2f04478$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$fcb6f14fb2f04478$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, $e79Pd.jsx)("style", {
        children: style
    }));
};
$fcb6f14fb2f04478$export$9f45a1325e3cdfb8.displayName = "DangerouslyHoistCssVarToDocumentRoot";

});

parcelRegister("ccSgQ", function(module, exports) {
$parcel$export(module.exports, "DangerouslyHoistSlotSizes", () => $254bda64f72bd3d6$export$66e2c1a0115af861);

var $euxye = parcelRequire("euxye");
const $254bda64f72bd3d6$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $euxye.createContext)(false);

});

parcelRegister("2NXvw", function(module, exports) {
$parcel$export(module.exports, "convertResizeBoundToPixels", () => $33374e7d5f8c64d0$export$3d412b3011b66f82);
function $33374e7d5f8c64d0$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith('vw')) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        const maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}

});

parcelRegister("jqXzh", function(module, exports) {
$parcel$export(module.exports, "PanelSplitterProvider", () => $82f3055f2688018c$export$f662bfb764348932);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $3fvZF = parcelRequire("3fvZF");
const $82f3055f2688018c$export$f662bfb764348932 = ({ panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, onResizeStartInternal: onResizeStartInternal, onResizeInternal: onResizeInternal, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, resizingElementRef: resizingElementRef, portalRef: providedPortalRef, position: position = 'end', isEnabled: isEnabled = true, shortcut: shortcut, children: children })=>{
    const portalRef = (0, $euxye.useRef)(null);
    const context = (0, $euxye.useMemo)(()=>({
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            onResizeStartInternal: onResizeStartInternal,
            onResizeInternal: onResizeInternal,
            getResizeBounds: getResizeBounds,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            resizingElementRef: resizingElementRef,
            isEnabled: isEnabled,
            portalRef: typeof providedPortalRef !== 'undefined' ? providedPortalRef : portalRef,
            shortcut: shortcut
        }), [
        panelId,
        panelWidth,
        onCompleteResize,
        onResizeStartInternal,
        onResizeInternal,
        getResizeBounds,
        resizingCssVar,
        position,
        panelRef,
        resizingElementRef,
        isEnabled,
        providedPortalRef,
        shortcut
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3fvZF.PanelSplitterContext).Provider, {
                value: context,
                children: children
            }),
            typeof providedPortalRef !== 'undefined' ? null : /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                ref: portalRef
            })
        ]
    });
};
$82f3055f2688018c$export$f662bfb764348932.displayName = "PanelSplitterProvider";

});
parcelRegister("3fvZF", function(module, exports) {
$parcel$export(module.exports, "PanelSplitterContext", () => $931202c03b267a97$export$7a4054f2c546f2cd);

var $euxye = parcelRequire("euxye");
const $931202c03b267a97$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $euxye.createContext)(null);

});


parcelRegister("2OF47", function(module, exports) {
$parcel$export(module.exports, "resolveLayoutWidth", () => $77f3fa4f689a37ee$export$fca44cc45c9c7d43);
function $77f3fa4f689a37ee$export$fca44cc45c9c7d43(bound, viewportWidth) {
    if (typeof bound === 'number') return bound;
    const value = Number.parseFloat(bound);
    return bound.endsWith('vw') ? viewportWidth * value / 100 : value;
}

});

parcelRegister("cJ0Vk", function(module, exports) {
$parcel$export(module.exports, "useLayoutAreaSizing", () => $48ebcd7495989430$export$f7d96a85aaf64f7c);

var $euxye = parcelRequire("euxye");

var $h8CBd = parcelRequire("h8CBd");

var $hlSlc = parcelRequire("hlSlc");
function $48ebcd7495989430$export$f7d96a85aaf64f7c({ area: area, config: config }) {
    const context = (0, $euxye.useContext)((0, $h8CBd.LayoutAreaSizingContext));
    const { requestedWidth: requestedWidth, defaultWidth: defaultWidth, compactDefaultWidth: compactDefaultWidth, minWidth: minWidth, maxWidth: maxWidth, isOpen: isOpen, onRequestClose: onRequestClose } = config;
    const registerArea = context?.registerArea;
    const unregisterArea = context?.unregisterArea;
    const startAreaResize = context?.startResize;
    const resizeArea = context?.resize;
    const completeAreaResize = context?.completeResize;
    const getAreaResizeBounds = context?.getResizeBounds;
    const state = (0, $euxye.useContext)((0, $hlSlc.layoutAreaStateContexts)[area]);
    // Dismissal is not a sizing input. Register a stable delegate while keeping
    // the consumer's latest committed callback outside allocation state.
    const onRequestCloseRef = (0, $euxye.useRef)(onRequestClose);
    (0, $euxye.useEffect)(()=>{
        onRequestCloseRef.current = onRequestClose;
    }, [
        onRequestClose
    ]);
    const requestClose = (0, $euxye.useCallback)(()=>onRequestCloseRef.current?.(), []);
    (0, $euxye.useEffect)(()=>{
        registerArea?.(area, {
            requestedWidth: requestedWidth,
            defaultWidth: defaultWidth,
            compactDefaultWidth: compactDefaultWidth,
            minWidth: minWidth,
            maxWidth: maxWidth,
            isOpen: isOpen,
            onRequestClose: requestClose
        });
    }, [
        area,
        compactDefaultWidth,
        defaultWidth,
        isOpen,
        maxWidth,
        minWidth,
        registerArea,
        requestClose,
        requestedWidth
    ]);
    (0, $euxye.useEffect)(()=>()=>unregisterArea?.(area), [
        area,
        unregisterArea
    ]);
    const startResize = (0, $euxye.useCallback)((mode)=>startAreaResize?.(area, mode), [
        area,
        startAreaResize
    ]);
    const resize = (0, $euxye.useCallback)((mode, width)=>resizeArea?.(area, mode, width), [
        area,
        resizeArea
    ]);
    const completeResize = (0, $euxye.useCallback)((mode, width)=>completeAreaResize?.(area, mode, width), [
        area,
        completeAreaResize
    ]);
    const getResizeBounds = (0, $euxye.useCallback)(()=>getAreaResizeBounds?.(area), [
        area,
        getAreaResizeBounds
    ]);
    return {
        state: state,
        startResize: startResize,
        resize: resize,
        completeResize: completeResize,
        getResizeBounds: getResizeBounds
    };
}

});
parcelRegister("h8CBd", function(module, exports) {
$parcel$export(module.exports, "LayoutAreaSizingContext", () => $2e46adc5a0476d17$export$bbdf82f5436c2324);

var $euxye = parcelRequire("euxye");
const $2e46adc5a0476d17$export$bbdf82f5436c2324 = /*#__PURE__*/ (0, $euxye.createContext)(null);

});

parcelRegister("hlSlc", function(module, exports) {
$parcel$export(module.exports, "layoutAreaStateContexts", () => $73d42ce5a03d0f52$export$c272236272fe50dc);

var $euxye = parcelRequire("euxye");
const $73d42ce5a03d0f52$export$c272236272fe50dc = {
    'side-nav': /*#__PURE__*/ (0, $euxye.createContext)(undefined),
    panel: /*#__PURE__*/ (0, $euxye.createContext)(undefined),
    'chat-panel': /*#__PURE__*/ (0, $euxye.createContext)(undefined)
};

});


parcelRegister("gBHrf", function(module, exports) {
$parcel$export(module.exports, "useLayoutId", () => $38b44199f1d23b40$export$110c3550c7c1c9aa);

var $cuipu = parcelRequire("cuipu");
function $38b44199f1d23b40$export$110c3550c7c1c9aa({ providedId: providedId } = {}) {
    const uniqueId = (0, $cuipu.useSkipLinkId)();
    const id = providedId ? providedId : uniqueId;
    return id;
}

});
parcelRegister("cuipu", function(module, exports) {
$parcel$export(module.exports, "useSkipLinkId", () => $f9c3a45f952e06df$export$fa3cfac0c8e29c5c);

var $gUxVT = parcelRequire("gUxVT");
function $f9c3a45f952e06df$export$fa3cfac0c8e29c5c() {
    const uniqueId = (0, $gUxVT.useId)();
    return uniqueId;
}

});


parcelRegister("baSqD", function(module, exports) {
$parcel$export(module.exports, "useResizingWidthCssVarOnRootElement", () => $d72ee2fb46034a49$export$d4931ecf0fbcc8fc);

var $euxye = parcelRequire("euxye");

var $gOKKd = parcelRequire("gOKKd");

var $7aH0o = parcelRequire("7aH0o");

var $i7CEc = parcelRequire("i7CEc");
function $d72ee2fb46034a49$export$d4931ecf0fbcc8fc({ isEnabled: isEnabled = true, cssVar: cssVar, panelId: panelId }) {
    (0, $euxye.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $7aH0o.combine)((0, $gOKKd.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.panelId === panelId;
            },
            onDrag ({ source: source }) {
                if (!(0, $i7CEc.isPanelSplitterDragData)(source.data)) return;
                /**
					 * Copies the resizing width value to the `<html>` element.
					 *
					 * Required to reflect the live width of the side navigation.
					 *
					 * Used by:
					 *   - Legacy `--leftSidebarWidth` variable
					 *   - Panel slot max-width constraint
					 *
					 * When the legacy `--leftSidebarWidth` variable is no longer needed,
					 * we could consider writing to the `Panel` element instead.
					 */ document.documentElement.style.setProperty(cssVar, source.data.resizingWidth);
            },
            onDrop () {
                document.documentElement.style.removeProperty(cssVar);
            }
        }));
    }, [
        cssVar,
        isEnabled,
        panelId
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!isEnabled) return;
        /**
		 * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
		 * if the component unmounts during a drag.
		 */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty(cssVar);
        };
    }, [
        cssVar,
        isEnabled
    ]);
}

});
parcelRegister("i7CEc", function(module, exports) {
$parcel$export(module.exports, "isPanelSplitterDragData", () => $5549cc3fd506e34f$export$e239b3966b677000);

var $fyrNG = parcelRequire("fyrNG");
function $5549cc3fd506e34f$export$e239b3966b677000(data) {
    return data[0, $fyrNG.panelSplitterDragDataSymbol] === true;
}

});
parcelRegister("fyrNG", function(module, exports) {
$parcel$export(module.exports, "panelSplitterDragDataSymbol", () => $ea1922b931cd7624$export$64f49ceb7f6e9a23);
const $ea1922b931cd7624$export$64f49ceb7f6e9a23 = Symbol('panel-splitter-drag-data');

});



parcelRegister("2q8Af", function(module, exports) {
$parcel$export(module.exports, "useSafeDefaultWidth", () => $707142f3fb06e502$export$cff429d7d83ba1f0);
/**
 * Returns the `fallbackWidth` if the provided `defaultWidthProp` is not an integer value.
 */ function $707142f3fb06e502$export$cff429d7d83ba1f0({ defaultWidthProp: defaultWidthProp, fallbackDefaultWidth: fallbackDefaultWidth, slotName: slotName }) {
    // If the provided `defaultWidth` is invalid then we use our fallback.
    // We are using a runtime check because some invalid numbers like `NaN` are not caught by types,
    // and we saw some issues in products where our experience broke due to this.
    if (!Number.isInteger(defaultWidthProp)) return fallbackDefaultWidth;
    return defaultWidthProp;
}

});

// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $9575501c176c2705$export$a7801e29f563faad = 400;

parcelRegister("cq1Hj", function(module, exports) {
$parcel$export(module.exports, "SetSideNavVisibilityState", () => $464e7d031b287baf$export$f6b496b07d1ea493);

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");
const $464e7d031b287baf$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $euxye.createContext)((0, $2oRWW.default));

});

parcelRegister("7eybO", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonElement", () => $5947a2d883651172$export$9c1768094bef896);

var $euxye = parcelRequire("euxye");
const $5947a2d883651172$export$9c1768094bef896 = /*#__PURE__*/ (0, $euxye.createContext)(null);

});

parcelRegister("az3Fy", function(module, exports) {
$parcel$export(module.exports, "sideNavToggleTooltipKeyboardShortcut", () => $e83805671025e8a6$export$bcd616a79072c3e4);
/**
 * The keyboard shortcut used in tooltips for indicating how to toggle the side nav.
 *
 * Used in `SideNavToggleButton` and `SideNavPanelSplitter` tooltips.
 */ const $e83805671025e8a6$export$bcd616a79072c3e4 = [
    'Ctrl',
    '['
];

});

parcelRegister("hNf54", function(module, exports) {
$parcel$export(module.exports, "SideNavVisibilityState", () => $c14597ae99a8aaea$export$eb04201bb6dd1e4e);

var $euxye = parcelRequire("euxye");
const $c14597ae99a8aaea$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $euxye.createContext)(null);

});

parcelRegister("kLm3T", function(module, exports) {
$parcel$export(module.exports, "useExpandSideNav", () => $4281bbe5b82ce369$export$e44b4744d8ff971a);

var $euxye = parcelRequire("euxye");

var $fZb1b = parcelRequire("fZb1b");

var $glbdM = parcelRequire("glbdM");

var $iqfTZ = parcelRequire("iqfTZ");

var $cq1Hj = parcelRequire("cq1Hj");

var $l0LPS = parcelRequire("l0LPS");
/**
 * Moves focus to the first focusable item in the side nav, or the side nav element itself as a fallback.
 */ function $4281bbe5b82ce369$var$focusFirstNavItem(sideNavElement) {
    /**
	 * Try to get the first focusable item in the side nav.
	 * The selector is not very broad, but should be appropriate for items from this package.
	 */ const firstNavItem = sideNavElement.querySelector('a, button');
    const isFirstNavItemVisible = firstNavItem !== null && (firstNavItem.checkVisibility?.() ?? false);
    const itemToFocus = isFirstNavItemVisible ? firstNavItem : sideNavElement;
    if (itemToFocus === sideNavElement) {
        /**
		 * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
		 * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
		 *
		 * Our slots are not interactive, so this is required.
		 *
		 * In the future we may want to check if there is an existing `tabindex` attribute,
		 * as custom skip linked elements might already have one.
		 */ sideNavElement.setAttribute('tabindex', '-1');
        /**
		 * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
		 *
		 * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
		 *
		 * - mess with click events
		 * - potentially cause a focus ring to be always visible
		 */ (0, $glbdM.bind)(sideNavElement, {
            type: 'blur',
            listener () {
                sideNavElement.removeAttribute('tabindex');
            },
            options: {
                once: true
            }
        });
    }
    /**
	 * Not using `focusVisible` option because we don't want clicks on the toggle button to show a focus ring.
	 */ itemToFocus.focus();
}
const $4281bbe5b82ce369$var$triggersWithFocusOnExpand = new Set([
    'toggle-button',
    'skip-link'
]);
function $4281bbe5b82ce369$export$e44b4744d8ff971a({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $euxye.useContext)((0, $cq1Hj.SetSideNavVisibilityState));
    const sideNavRef = (0, $l0LPS.useSideNavRef)();
    const expandSideNav = (0, $euxye.useCallback)(()=>{
        const { matches: isDesktop } = window.matchMedia('(min-width: 64rem)');
        const runUpdate = ()=>{
            if (isDesktop) setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                // Skip the re-render if it's a no-op change
                if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
                return {
                    mobile: currentState.mobile,
                    desktop: 'expanded',
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
            else setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                // Skip the re-render if it's a no-op change
                if (currentState.mobile === 'expanded' && currentState.flyout === 'closed') return currentState;
                return {
                    desktop: currentState.desktop,
                    mobile: 'expanded',
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
        };
        if ($4281bbe5b82ce369$var$triggersWithFocusOnExpand.has(trigger) && (0, $iqfTZ.fg)('platform_dst_nav4_skip_link_a11y_1')) {
            (0, $fZb1b.flushSync)(runUpdate);
            const sideNavElement = sideNavRef.current;
            if (sideNavElement) $4281bbe5b82ce369$var$focusFirstNavItem(sideNavElement);
        } else runUpdate();
    }, [
        setSideNavState,
        sideNavRef,
        trigger
    ]);
    return expandSideNav;
}

});
parcelRegister("l0LPS", function(module, exports) {
$parcel$export(module.exports, "useSideNavRef", () => $489b3327326ea3a8$export$fa4d0cff03b1ea4f);

var $euxye = parcelRequire("euxye");

var $cnrX7 = parcelRequire("cnrX7");
function $489b3327326ea3a8$export$fa4d0cff03b1ea4f() {
    return (0, $euxye.useContext)((0, $cnrX7.SideNavRefContext));
}

});
parcelRegister("cnrX7", function(module, exports) {
$parcel$export(module.exports, "SideNavRefContext", () => $3579d3eead8ed670$export$1cd490805a3a9874);

var $euxye = parcelRequire("euxye");
const $3579d3eead8ed670$export$1cd490805a3a9874 = /*#__PURE__*/ (0, $euxye.createContext)({
    current: null
});

});



parcelRegister("8gkNi", function(module, exports) {
$parcel$export(module.exports, "useIsSideNavShortcutEnabled", () => $f81c47b5ed8707e1$export$be30cdcd17f95ec7);

var $euxye = parcelRequire("euxye");

var $hGQM9 = parcelRequire("hGQM9");
function $f81c47b5ed8707e1$export$be30cdcd17f95ec7() {
    return (0, $euxye.useContext)((0, $hGQM9.IsSideNavShortcutEnabledContext));
}

});
parcelRegister("hGQM9", function(module, exports) {
$parcel$export(module.exports, "IsSideNavShortcutEnabledContext", () => $85d2a01c9684f232$export$c41e1ac5602bc8d5);

var $euxye = parcelRequire("euxye");
const $85d2a01c9684f232$export$c41e1ac5602bc8d5 = /*#__PURE__*/ (0, $euxye.createContext)(false);

});


parcelRegister("kIm7C", function(module, exports) {
$parcel$export(module.exports, "useSideNavToggleKeyboardShortcut", () => $7b9dfccb64fe151e$export$f762e7ac9d86adb0);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $dZr3Z = parcelRequire("dZr3Z");

var $dfO5T = parcelRequire("dfO5T");

var $8gkNi = parcelRequire("8gkNi");

var $1xXI9 = parcelRequire("1xXI9");
function $7b9dfccb64fe151e$export$f762e7ac9d86adb0({ canToggleWithShortcut: canToggleWithShortcut }) {
    const openLayerObserver = (0, $dfO5T.useOpenLayerObserver)();
    const toggleVisibilityByShortcut = (0, $1xXI9.useToggleSideNav)({
        trigger: 'keyboard'
    });
    const canToggleWithShortcutStableRef = (0, $dZr3Z.default)(canToggleWithShortcut);
    const isSideNavShortcutEnabled = (0, $8gkNi.useIsSideNavShortcutEnabled)();
    (0, $euxye.useEffect)(()=>{
        if (!isSideNavShortcutEnabled) return;
        return (0, $glbdM.bind)(window, {
            type: 'keydown',
            listener (event) {
                if (event.ctrlKey && event.key === '[') {
                    if (canToggleWithShortcutStableRef.current && !canToggleWithShortcutStableRef.current()) // Return early if the callback returns false.
                    // If the callback is not provided, we assume the shortcut is enabled.
                    return;
                    if (event.repeat) // Ignore repeated keydown events from holding down the keys
                    return;
                    if (openLayerObserver && openLayerObserver.getCount({
                        type: 'modal'
                    }) > 0) // Return early if there are any open modals
                    return;
                    openLayerObserver?.closeLayers();
                    toggleVisibilityByShortcut();
                }
            }
        });
    }, [
        canToggleWithShortcutStableRef,
        isSideNavShortcutEnabled,
        openLayerObserver,
        toggleVisibilityByShortcut
    ]);
}

});
parcelRegister("1xXI9", function(module, exports) {
$parcel$export(module.exports, "useToggleSideNav", () => $26b86395479f4f35$export$477ee35601a0a8ce);

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $cq1Hj = parcelRequire("cq1Hj");

var $hNf54 = parcelRequire("hNf54");

var $kLm3T = parcelRequire("kLm3T");
function $26b86395479f4f35$export$477ee35601a0a8ce({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $euxye.useContext)((0, $cq1Hj.SetSideNavVisibilityState));
    const sideNavState = (0, $euxye.useContext)((0, $hNf54.SideNavVisibilityState));
    const expandSideNav = (0, $kLm3T.useExpandSideNav)({
        trigger: trigger
    });
    const isCollapsedOnDesktop = sideNavState?.desktop === 'collapsed';
    const isCollapsedOnMobile = sideNavState?.mobile === 'collapsed';
    const toggleSideNav = (0, $euxye.useCallback)(()=>{
        const { matches: isDesktop } = window.matchMedia('(min-width: 64rem)');
        if ((0, $iqfTZ.fg)('platform_dst_nav4_skip_link_a11y_1')) {
            const isExpanding = isDesktop ? isCollapsedOnDesktop : isCollapsedOnMobile;
            if (isExpanding) expandSideNav();
            else setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                return {
                    mobile: isDesktop ? currentState.mobile : 'collapsed',
                    desktop: isDesktop ? 'collapsed' : currentState.desktop,
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
            return;
        }
        if (isDesktop) setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            return {
                mobile: currentState.mobile,
                desktop: currentState.desktop === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
        else setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            return {
                desktop: currentState.desktop,
                mobile: currentState.mobile === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
    }, [
        expandSideNav,
        isCollapsedOnDesktop,
        isCollapsedOnMobile,
        setSideNavState,
        trigger
    ]);
    return toggleSideNav;
}

});


parcelRegister("kmjbD", function(module, exports) {
$parcel$export(module.exports, "useSideNavVisibility", () => $4cee2f2963c4533c$export$4a602ad7e09bdb2c);

var $euxye = parcelRequire("euxye");

var $hNf54 = parcelRequire("hNf54");
const $4cee2f2963c4533c$export$4a602ad7e09bdb2c = ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
    const sideNavState = (0, $euxye.useContext)((0, $hNf54.SideNavVisibilityState));
    // If the context value is `null`, it means we are still in SSR, and should use the default values.
    // For desktop, it comes from the `defaultCollapsed` prop, and for mobile, it is always `false`.
    if (sideNavState === null) return {
        isExpandedOnDesktop: !defaultCollapsed,
        isExpandedOnMobile: false
    };
    return {
        isExpandedOnDesktop: sideNavState.desktop === 'expanded',
        isExpandedOnMobile: sideNavState.mobile === 'expanded'
    };
};

});

parcelRegister("8hevw", function(module, exports) {
$parcel$export(module.exports, "useSideNavVisibilityCallbacks", () => $1cf948ca012729cc$export$1904b8f2577aba9a);

var $euxye = parcelRequire("euxye");

var $gQ56h = parcelRequire("gQ56h");
function $1cf948ca012729cc$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile, lastTrigger: lastTrigger }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $euxye.useRef)(onExpand);
    const onCollapseRef = (0, $euxye.useRef)(onCollapse);
    (0, $euxye.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousIsExpandedOnDesktop = (0, $gQ56h.default)(isExpandedOnDesktop);
    (0, $euxye.useEffect)(()=>{
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnDesktop) onExpandRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop,
        lastTrigger
    ]);
    const previousIsExpandedOnMobile = (0, $gQ56h.default)(isExpandedOnMobile);
    (0, $euxye.useEffect)(()=>{
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnMobile) onExpandRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile,
        lastTrigger
    ]);
}

});


parcelRegister("fVNT1", function(module, exports) {
$parcel$export(module.exports, "SideNavHeader", () => $f1e0f574e9b5783f$export$9d28ff3a0d89869c);
/* side-nav-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $f1e0f574e9b5783f$var$styles = {
    root: "_2Y7lL48HPE _46hvQm8HPE _0xmtko1Y8M"
};
const $f1e0f574e9b5783f$export$9d28ff3a0d89869c = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $f1e0f574e9b5783f$var$styles.root
        ]),
        children: children
    });
};
$f1e0f574e9b5783f$export$9d28ff3a0d89869c.displayName = "SideNavHeader";

});

parcelRegister("eal2a", function(module, exports) {
$parcel$export(module.exports, "SideNavBody", () => $bf5bc5a01c9d769b$export$28f21f3651df4fa1);
/* side-nav-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $ljVHR = parcelRequire("ljVHR");

var $av7P9 = parcelRequire("av7P9");
const $bf5bc5a01c9d769b$export$28f21f3651df4fa1 = /*#__PURE__*/ (0, $euxye.forwardRef)($bf5bc5a01c9d769b$var$_SideNavContent);
// Placing this const below the function breaks Compiled!
const $bf5bc5a01c9d769b$var$styles = {
    scrollContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAIZbP _2WAcuGIZbP",
    paddingContainer: "_46hvQm8HPE _03SyCP8HPE _0xmtko8HPE _0LQT5E8HPE"
};
function $bf5bc5a01c9d769b$var$_SideNavContent({ children: children, testId: testId }, forwardedRef) {
    const isFhsEnabled = (0, $av7P9.useIsFhsEnabled)();
    const internalRef = (0, $euxye.useRef)(null);
    const mergedRef = (0, $euxye.useMemo)(()=>(0, $ljVHR.default)([
            internalRef,
            forwardedRef
        ]), [
        forwardedRef
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: isFhsEnabled ? mergedRef : forwardedRef,
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            $bf5bc5a01c9d769b$var$styles.scrollContainer
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            className: (0, $4jQY2.default)([
                $bf5bc5a01c9d769b$var$styles.paddingContainer
            ]),
            children: children
        })
    });
}

});

parcelRegister("2ysb2", function(module, exports) {
$parcel$export(module.exports, "SideNavFooter", () => $3feed3e535c074ca$export$b773c4c9cf740fbe);
/* side-nav-footer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $3feed3e535c074ca$var$styles = {
    root: "_46hvQm8HPE _03SyCP8HPE _0xmtko8HPE _0LQT5E8HPE _0vfIXINvrM _4hyvPa6wH8 _1KhSQW9r67"
};
const $3feed3e535c074ca$export$b773c4c9cf740fbe = ({ children: /**
   * The content of the layout area.
   */ children, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $3feed3e535c074ca$var$styles.root,
            xcss
        ]),
        children: children
    });
};
$3feed3e535c074ca$export$b773c4c9cf740fbe.displayName = "SideNavFooter";

});

parcelRegister("9R2G9", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButton", () => $26f4dcefc2f65068$export$8bd77667631fec25);
/* toggle-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $inMxE = parcelRequire("inMxE");

var $aeUJp = parcelRequire("aeUJp");

var $b7KOW = parcelRequire("b7KOW");

var $dfO5T = parcelRequire("dfO5T");

var $fX8LH = parcelRequire("fX8LH");

var $ghrOZ = parcelRequire("ghrOZ");

var $az3Fy = parcelRequire("az3Fy");

var $hNf54 = parcelRequire("hNf54");

var $8gkNi = parcelRequire("8gkNi");

var $kmjbD = parcelRequire("kmjbD");

var $1xXI9 = parcelRequire("1xXI9");
const $26f4dcefc2f65068$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true,
    // A press swaps the label between `collapseLabel` and `expandLabel`, so keep the
    // tooltip open to show the new label.
    hasNewContentOnTriggerClick: true
};
// For duplicate "mouseenter" issue when changing icons (see below)
const $26f4dcefc2f65068$var$silentIconStyles = null;
const $26f4dcefc2f65068$export$8bd77667631fec25 = ({ defaultCollapsed: defaultCollapsed = false, expandLabel: expandLabel, collapseLabel: collapseLabel, testId: testId, interactionName: interactionName, onClick: onClick })=>{
    const { isExpandedOnDesktop: isSideNavExpandedOnDesktop, isExpandedOnMobile: isSideNavExpandedOnMobile } = (0, $kmjbD.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    const sideNavState = (0, $euxye.useContext)((0, $hNf54.SideNavVisibilityState));
    // When default state is provided to `Root` the state in context will already be
    // initialized in SSR
    const [isSideNavExpanded, setIsSideNavExpanded] = (0, $euxye.useState)(sideNavState === null ? !defaultCollapsed : isSideNavExpandedOnDesktop);
    const ref = (0, $euxye.useContext)((0, $ghrOZ.SideNavToggleButtonAttachRef));
    /**
   * Addresses HOT-121458 by ensuring that the toggle button element in context is always up to date.
   *
   * My theory is that something to do with SSR, hydration and suspense was causing the
   * underlying HTML element to change but without causing the toggle button to remount.
   *
   * This meant the effect calling `ref()` did not re-run, and the value in context became stale.
   */ const [element, setElement] = (0, $euxye.useState)(null);
    (0, $euxye.useEffect)(()=>{
        ref(element);
    }, [
        element,
        ref
    ]);
    (0, $euxye.useEffect)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    (0, $euxye.useEffect)(()=>{
        // When screen size changes, ensure we use the correct visibility state
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $glbdM.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
            }
        });
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    const toggleVisibility = (0, $1xXI9.useToggleSideNav)({
        trigger: 'toggle-button'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const openLayerObserver = (0, $dfO5T.useOpenLayerObserver)();
    const handleClick = (0, $euxye.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent, {
            isSideNavVisible: isSideNavExpanded
        });
        toggleVisibility();
        openLayerObserver?.closeLayers();
    }, [
        isSideNavExpanded,
        onClick,
        openLayerObserver,
        toggleVisibility
    ]);
    const handlePointerEnter = (0, $euxye.useCallback)(()=>{
        // Hovers don't do anything on mobile, so not capturing
        const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
        if (!isDesktop) return;
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'hovered',
            actionSubjectId: 'sideNavButton',
            attributes: {
                itemState: isSideNavExpanded ? 'expanded' : 'collapsed',
                screen: 'desktop'
            }
        });
        navigationAnalyticsEvent.fire('navigation');
    }, [
        createAnalyticsEvent,
        isSideNavExpanded
    ]);
    /**
   * ## Behaviour
   * It is intentional that collapse icon will be used while the flyout is open.
   * The icon is tied to the expanded / collapse state, and not the flyout state.
   *
   * ## Why a function?
   * Unfortunately, changing the icon inside an <IconButton> when the user is over
   * the button will cause the svg element to be replaced, which can trigger a
   * "mouseenter" event. This is problematic when the user is already over the button,
   * as it can result in a "mouseenter" event after the user manually entered the button.
   *
   * `icon` accepts a function for the `icon` prop (ie a render prop), so we don't need to
   * memoize it, or pull it out into a new function
   */ const icon = (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)("span", {
            className: (0, $4jQY2.default)([
                "_3iDTPbcK7c _1pp6NdYbGa"
            ]),
            children: isSideNavExpanded ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aeUJp))), {
                ...props
            }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b7KOW))), {
                ...props
            })
        });
    const isShortcutEnabled = (0, $8gkNi.useIsSideNavShortcutEnabled)();
    const tooltipProps = (0, $euxye.useMemo)(()=>({
            ...$26f4dcefc2f65068$var$toggleButtonTooltipOptions,
            shortcut: isShortcutEnabled ? (0, $az3Fy.sideNavToggleTooltipKeyboardShortcut) : undefined
        }), [
        isShortcutEnabled
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fX8LH.IconButton), {
        appearance: "subtle",
        label: isSideNavExpanded ? collapseLabel : expandLabel,
        icon: icon,
        onClick: handleClick,
        onPointerEnter: handlePointerEnter,
        testId: testId,
        isTooltipDisabled: false,
        interactionName: interactionName,
        ref: setElement,
        tooltip: tooltipProps
    });
};
$26f4dcefc2f65068$export$8bd77667631fec25.displayName = "SideNavToggleButton";

});
parcelRegister("fX8LH", function(module, exports) {
$parcel$export(module.exports, "IconButton", () => $ccb2b3d5c3acfebd$export$c25acd513dcc8062);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");

var $d7tnL = parcelRequire("d7tnL");

var $bacQd = parcelRequire("bacQd");
const $ccb2b3d5c3acfebd$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $d7tnL.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $bacQd.ThemedIconButton) : (0, $m9iwH.default);
    return /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("d7tnL", function(module, exports) {
$parcel$export(module.exports, "HasCustomThemeContext", () => $48588cc69bed29b1$export$d158fa15757a1890);
$parcel$export(module.exports, "useHasCustomTheme", () => $48588cc69bed29b1$export$abfcaeeca4ae7a55);

var $euxye = parcelRequire("euxye");
const $48588cc69bed29b1$export$d158fa15757a1890 = /*#__PURE__*/ (0, $euxye.createContext)(false);
function $48588cc69bed29b1$export$abfcaeeca4ae7a55() {
    return (0, $euxye.useContext)($48588cc69bed29b1$export$d158fa15757a1890);
}

});

parcelRegister("bacQd", function(module, exports) {
$parcel$export(module.exports, "ThemedIconButton", () => $b75577c6275fbcf4$export$d9c2d067feb61447);
/* themed-icon-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $ljVHR = parcelRequire("ljVHR");

var $hZDXn = parcelRequire("hZDXn");

var $apUrw = parcelRequire("apUrw");

var $7cylN = parcelRequire("7cylN");

var $gjrQa = parcelRequire("gjrQa");
const $b75577c6275fbcf4$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $euxye.forwardRef)(function ThemedIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $gjrQa.ThemedPressable), {
                ...props,
                shape: "square",
                ref: (0, $ljVHR.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7cylN.default), {
                        icon: Icon
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apUrw.default), {
                        children: label
                    })
                ]
            })
    });
});

});
parcelRegister("7cylN", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2bf7a5a0e1969dc$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");
function $e2bf7a5a0e1969dc$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 * This is copied from @atlaskit/button to render IconButtons. Some IconButton's DOM element
 * will be re-created during SSR -> SPA hydration without using this, which delays TTVC. As
 * IconRenderer is already used in @atlaskit/button to mitigate this issue, add it here to
 * mitigate the same issue for IconButtons in navigation-system, especially for ThemedIconButton.
 *
 */ const $e2bf7a5a0e1969dc$var$IconRenderer = ({ icon: Icon })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = $e2bf7a5a0e1969dc$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $iqfTZ.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, $e79Pd.jsx)(Icon, {
            ...iconProps
        })
    });
};
$e2bf7a5a0e1969dc$var$IconRenderer.displayName = "IconRenderer";
var $e2bf7a5a0e1969dc$export$2e2bcd8739ae039 = $e2bf7a5a0e1969dc$var$IconRenderer;

});

parcelRegister("gjrQa", function(module, exports) {
$parcel$export(module.exports, "ThemedPressable", () => $4e4a0c037477e2ff$export$66240319f1f78d74);
/* themed-pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $9S1b6 = parcelRequire("9S1b6");

var $iqfTZ = parcelRequire("iqfTZ");

var $6mEZn = parcelRequire("6mEZn");

var $7ZlHM = parcelRequire("7ZlHM");
const $4e4a0c037477e2ff$var$styles = {
    root: "_2mHwu8gVvo _2sNsIgmnOE _0bjKvDKTcp _23rrnHoacQ _00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _4c065UPgdg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VymQ6 _1mT5xdRAKS _3WzCGiyL8i _32C2rkyL8i _0DCa9DyL8i _0NqVRtYbGa _0i9AWAYbGa _3932vvYbGa _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8",
    interactiveMotion: "_23rrnHyKLB _3sFUREiSCN",
    border: "_2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _0GBAIrogpp _2WYcYGWVPG",
    selected: "_2uo31fhe06 _1UtDYzysOt _0z8nYC0GCl _10n1R5ysOt _2nTuUYysOt _30zrXRUQDy _0clgaMysOt _1gxogc4k8R _0CMRbkysOt",
    disabled: "_2uo31ftHCb _1UtDYzn3Ip _0z8nYCs4Fm _10n1R5n3Ip _2nTuUYn3Ip _30zrXRtHCb _0clgaMn3Ip _1gxogctHCb _0CMRbkn3Ip"
};
const $4e4a0c037477e2ff$var$shapeStyles = {
    default: "_2Y7lL48HPE",
    square: "_2Y7lL4Pgdg _39xV02ymQ6 _26BoRwdnbC"
};
const $4e4a0c037477e2ff$var$appearanceStyles = {
    default: "_2uo31fGfro _1UtDYz98eZ _0z8nYCQMmr _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    subtle: "_2uo31fGfro _1UtDYz98eZ _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    primary: "_2uo31fxjIo _1UtDYzwGpT _10n1R5wGpT _2nTuUYwGpT _30zrXR2rJx _0clgaMwGpT _1gxogcHVA2 _0CMRbkwGpT"
};
const $4e4a0c037477e2ff$export$66240319f1f78d74 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref)=>{
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.Pressable), {
        ...(0, $7ZlHM.getPrimitiveSpreadProps)(props),
        ref: ref,
        type: "button",
        /**
   * We are using some style values that are outside of the strict
   * `@atlaskit/css` types.
   */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $9S1b6.cx)($4e4a0c037477e2ff$var$styles.root, $4e4a0c037477e2ff$var$shapeStyles[shape], hasBorder && $4e4a0c037477e2ff$var$styles.border, $4e4a0c037477e2ff$var$appearanceStyles[appearance], isSelected && $4e4a0c037477e2ff$var$styles.selected, isDisabled && $4e4a0c037477e2ff$var$styles.disabled, (0, $iqfTZ.fg)('platform-dst-motion-uplift-button') && $4e4a0c037477e2ff$var$styles.interactiveMotion),
        isDisabled: isDisabled
    });
});

});
parcelRegister("7ZlHM", function(module, exports) {
$parcel$export(module.exports, "getPrimitiveSpreadProps", () => $51c337ad32a48a00$export$e4c95325a21f9785);
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ function $51c337ad32a48a00$export$e4c95325a21f9785({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
}

});




parcelRegister("ghrOZ", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonAttachRef", () => $35f9d523951483a3$export$fb8fa9a80240785e);

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");
const $35f9d523951483a3$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $euxye.createContext)((0, $2oRWW.default));

});


parcelRegister("JEEbX", function(module, exports) {
$parcel$export(module.exports, "SideNavPanelSplitter", () => $80eb832b271ba530$export$5f595addf4e50d58);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");

var $dfO5T = parcelRequire("dfO5T");

var $av7P9 = parcelRequire("av7P9");

var $iFrrF = parcelRequire("iFrrF");

var $1xXI9 = parcelRequire("1xXI9");

var $2gxpn = parcelRequire("2gxpn");

var $4MYRQ = parcelRequire("4MYRQ");

var $3fvZF = parcelRequire("3fvZF");
/**
 * Namespaces to check for open layers that would interfere with the panel splitter.
 *
 * Placed outside the component for stability, as the list is used as an effect dependency.
 */ const $80eb832b271ba530$var$openLayerNamespacesToCheck = [
    // The side nav panel splitter is layered above the side nav, so needs to be disabled when there are open popups in the side nav.
    (0, $iFrrF.openLayerObserverSideNavNamespace),
    // The side nav panel splitter is layered above the top nav, so needs to be disabled when there are open popups in the top nav.
    (0, $iFrrF.openLayerObserverTopNavStartNamespace),
    (0, $iFrrF.openLayerObserverTopNavMiddleNamespace),
    (0, $iFrrF.openLayerObserverTopNavEndNamespace)
];
/**
 * Returns whether there are any open popups in the side nav or top nav
 */ function $80eb832b271ba530$var$useHasOpenPopupsInSideNavOrTopNav() {
    const isFhsEnabled = (0, $av7P9.useIsFhsEnabled)();
    const openLayerObserver = (0, $dfO5T.useOpenLayerObserver)();
    // Setting the initial state to false, as it is unlikely that there would be any open popups when the app starts.
    const [hasOpenPopups, setHasOpenPopups] = (0, $euxye.useState)(false);
    (0, $euxye.useEffect)(()=>{
        if (!openLayerObserver || !isFhsEnabled) return;
        function updateState() {
            if (!openLayerObserver) return;
            const hasAnyOpenLayers = $80eb832b271ba530$var$openLayerNamespacesToCheck.some((namespace)=>openLayerObserver.getCount({
                    namespace: namespace,
                    type: 'popup'
                }) > 0);
            setHasOpenPopups(hasAnyOpenLayers);
        }
        // Initial check. We do this _in case_ a popup is already open when the component mounts.
        updateState();
        // Subscribe to each namespace
        const cleanups = $80eb832b271ba530$var$openLayerNamespacesToCheck.map((namespace)=>openLayerObserver.onChange(updateState, {
                namespace: namespace
            }));
        return function cleanupHook() {
            cleanups.forEach((cleanup)=>cleanup());
        };
    }, [
        isFhsEnabled,
        openLayerObserver
    ]);
    return hasOpenPopups;
}
const $80eb832b271ba530$export$5f595addf4e50d58 = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, shouldCollapseOnDoubleClick: shouldCollapseOnDoubleClick = true, tooltipContent: tooltipContent })=>{
    const context = (0, $euxye.useContext)((0, $3fvZF.PanelSplitterContext));
    (0, $jiTLE.default)(context?.panelId === (0, $iFrrF.sideNavPanelSplitterId), 'SideNavPanelSplitter must be rendered as a child of <SideNav />.');
    const toggleSideNav = (0, $1xXI9.useToggleSideNav)({
        trigger: 'double-click'
    });
    const isFhsEnabled = (0, $av7P9.useIsFhsEnabled)();
    // The logic and state for disabling the panel splitter when there are open popups
    // in the side nav or top nav is being placed here, instead of in `SideNav`, to prevent
    // re-rendering the side nav anytime the number of open popups changes.
    const hasOpenLayersInSideNavOrTopNav = $80eb832b271ba530$var$useHasOpenPopupsInSideNavOrTopNav();
    if (hasOpenLayersInSideNavOrTopNav && isFhsEnabled) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2gxpn.OnDoubleClickContext).Provider, {
        value: shouldCollapseOnDoubleClick ? toggleSideNav : undefined,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4MYRQ.PanelSplitter), {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            testId: testId,
            tooltipContent: // Only displaying the tooltip if double click to collapse is enabled.
            // Otherwise, we would be displaying a tooltip with "Double click to collapse", when it actually won't.
            shouldCollapseOnDoubleClick ? tooltipContent : undefined
        })
    });
};
$80eb832b271ba530$export$5f595addf4e50d58.displayName = "SideNavPanelSplitter";

});
parcelRegister("2gxpn", function(module, exports) {
$parcel$export(module.exports, "OnDoubleClickContext", () => $eba166e30ced233a$export$e253efba824eceb);

var $euxye = parcelRequire("euxye");
const $eba166e30ced233a$export$e253efba824eceb = /*#__PURE__*/ (0, $euxye.createContext)(undefined);

});

parcelRegister("4MYRQ", function(module, exports) {
$parcel$export(module.exports, "PanelSplitter", () => $1677a4dabc88cee2$export$db67e3f8d3d6da0f);
/* panel-splitter.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $fZb1b = parcelRequire("fZb1b");

var $glbdM = parcelRequire("glbdM");

var $jiTLE = parcelRequire("jiTLE");

var $gUxVT = parcelRequire("gUxVT");

var $dZr3Z = parcelRequire("dZr3Z");

var $dfO5T = parcelRequire("dfO5T");

var $iqfTZ = parcelRequire("iqfTZ");

var $gOKKd = parcelRequire("gOKKd");

var $daypx = parcelRequire("daypx");

var $7aH0o = parcelRequire("7aH0o");

var $kPaOg = parcelRequire("kPaOg");

var $bZgd3 = parcelRequire("bZgd3");

var $hZDXn = parcelRequire("hZDXn");

var $1FucB = parcelRequire("1FucB");

var $apUrw = parcelRequire("apUrw");

var $av7P9 = parcelRequire("av7P9");

var $iFrrF = parcelRequire("iFrrF");

var $2NXvw = parcelRequire("2NXvw");

var $4CqMo = parcelRequire("4CqMo");

var $8PsRn = parcelRequire("8PsRn");

var $kFqs3 = parcelRequire("kFqs3");

var $i7CEc = parcelRequire("i7CEc");

var $8ouQF = parcelRequire("8ouQF");

var $2gxpn = parcelRequire("2gxpn");

var $3fvZF = parcelRequire("3fvZF");

var $fyrNG = parcelRequire("fyrNG");
function $1677a4dabc88cee2$var$signPanelSplitterDragData(data) {
    return {
        ...data,
        [(0, $fyrNG.panelSplitterDragDataSymbol)]: true
    };
}
const $1677a4dabc88cee2$var$containerStyles = {
    root: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _3iDTPbYbGa _1mT5xdWVPG _1ZB6UydnbC _2I62gzdnbC _42Yu6B7dHp _2UeR8bvLZJ",
    positionEnd: "_1OKFqYJg58",
    positionStart: "_3iC0zd1x6F"
};
const $1677a4dabc88cee2$var$grabAreaStyles = {
    root: "_39xV02vFgp _0jFU0VN91d _1mT5xdWVPG _46hvQmPgdg _03SyCPPgdg _0xmtkoPgdg _0LQT5EPgdg _1UtDYzs4Fm _0KLXruyL8i _3Z9K0wb8VS _3OZqoK0jWM _0qk6IKN8t6 _1kOSYtWkA1 _0ReiIHuudW _25IEJJjTy9 _0clgaMjTy9 _3sFUREYbGa _0CMRbkAwSC",
    rootFinesse: "_25IEJJWkXl _0clgaMWkXl _0CMRbkrzt2",
    fullHeightSidebar: "_0ReiIHYNYw"
};
const $1677a4dabc88cee2$var$lineStyles = {
    root: "_1mT5xdWVPG _3iDTPbvLZJ _39xV024Y4b _0jFU0VN91d _1UtDYzOLYo _0KLXru98eZ _3iC0zdXJux"
};
const $1677a4dabc88cee2$var$tooltipStyles = {
    root: "_0GTcwRTUhv _39xV02W9qI"
};
const $1677a4dabc88cee2$var$PanelSplitterTooltip = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, className: className, ...props }, ref)=>{
    const style = (0, $euxye.useMemo)(()=>{
        if (!props.style || !props.style.transform) return props.style;
        // We cannot just match against integers safely, as browsers may introduce non-integer values due to scaling
        // In the future we can probably use `CSSStyleValue.parse()` to get the browser to handle parsing for us,
        // but there's no Firefox support yet.
        const [translateX, translateY] = props.style.transform.matchAll(/(?:-|\+)?\d*\.?\d+px/g);
        if (!translateY) // If we can't extract the translateY value we bail out and return the original style
        return props.style;
        /**
     * Adjusts the translate Y to keep the tooltip within the main content area,
     * so that it does not appear over the banner or top navigation.
     */ const newTranslateY = `max(calc(${(0, $iFrrF.contentInsetBlockStart)} + ${"var(--ds-space-100, 8px)"}), ${translateY})`;
        const newTransform = `translate3d(${translateX}, ${newTranslateY}, 0)`;
        return {
            ...props.style,
            transform: newTransform
        };
    }, [
        props.style
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1FucB.default), {
        ...props,
        ref: ref,
        // Must be statically passed
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $4jQY2.default)([
            $1677a4dabc88cee2$var$tooltipStyles.root,
            className
        ]),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: children
    });
});
/**
 * A wrapper component that renders a tooltip if the tooltipContent or shortcut is provided.
 */ const $1677a4dabc88cee2$var$MaybeTooltip = ({ tooltipContent: tooltipContent, shortcut: shortcut, children: children, testId: testId })=>{
    if (tooltipContent) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
        testId: testId,
        content: tooltipContent,
        shortcut: shortcut,
        position: "mouse-y",
        mousePosition: "right",
        isScreenReaderAnnouncementDisabled: true,
        component: $1677a4dabc88cee2$var$PanelSplitterTooltip,
        shouldAlwaysFadeIn: true,
        shouldRenderToParent: true,
        children: children
    });
    return children;
};
$1677a4dabc88cee2$var$MaybeTooltip.displayName = "MaybeTooltip";
function $1677a4dabc88cee2$var$getTextDirection(element) {
    const { direction: direction } = window.getComputedStyle(element);
    return direction === 'rtl' ? 'rtl' : 'ltr';
}
const $1677a4dabc88cee2$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, onResizeStartInternal: onResizeStartInternal, onResizeInternal: onResizeInternal, getResizeBounds: getResizeBounds, panel: panel, portal: portal, resizingCssVar: resizingCssVar, resizingElementRef: resizingElementRef, position: position, tooltipContent: tooltipContent, shortcut: shortcut })=>{
    const isFhsEnabled = (0, $av7P9.useIsFhsEnabled)();
    const splitterRef = (0, $euxye.useRef)(null);
    const labelId = (0, $gUxVT.useId)();
    // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    const [rangeInputValue, setRangeInputValue] = (0, $euxye.useState)(panelWidth);
    /**
   * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
   * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
   * when the user tries to resize using the keyboard.
   */ const [rangeInputBounds, setRangeInputBounds] = (0, $euxye.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    });
    const openLayerObserver = (0, $dfO5T.useOpenLayerObserver)();
    /**
   * This is a temporary workaround to enable the `SideNavPanelSplitter` component
   * to collapse the side nav on double click, without exposing the `onDoubleClick` prop on `PanelSplitter`.
   * Once `PanelSplitter` supports an `onDoubleClick` prop directly, this context can be removed.
   */ const onDoubleClick = (0, $euxye.useContext)((0, $2gxpn.OnDoubleClickContext));
    // Storing the initial `clientX` on `mousedown` events, to workaround a bug caused by some browser extensions
    // where the `dragstart` event incorrectly returns `0` for the `clientX` location.
    const initialClientXRef = (0, $euxye.useRef)(null);
    // Live allocation changes panelWidth on every frame. Only the legacy path should
    // rebind the drag listeners when this value changes.
    const legacyPanelWidth = (0, $iqfTZ.fg)('platform-dst-chat-panel-layout') ? undefined : panelWidth;
    (0, $euxye.useEffect)(()=>{
        const splitter = splitterRef.current;
        (0, $jiTLE.default)(splitter, 'Splitter ref must be set');
        let lastManagedResizeWidth;
        return (0, $7aH0o.combine)((0, $daypx.blockDraggingToIFrames)({
            element: splitter
        }), /**
     * Capturing the initial `clientX` from the mousedown, before the drag starts.
     *
     * ⚠️ Note: We are not using pragmatic-drag-and-drop's `onDragStart` for this as some browser
     * extensions can cause the client location (e.g. clientX) to incorrectly return 0 during the `dragstart` event.
     *
     * We are also not using pragmatic-drag-and-drop's `onDrag` here as it is throttled, which means
     * fast mouse movements can cause the real first drag event to be missed, causing a different clientX
     * to be captured.
     *
     * I also tried only binding an event listener inside pragmatic-drag-and-drop's `onDragStart`, which seemd to work
     * but did not feel as robust, and might have timing issues as it happens slightly later.
     */ (0, $glbdM.bind)(splitter, {
            type: 'mousedown',
            listener: (event)=>{
                initialClientXRef.current = event.clientX;
            }
        }), (0, $gOKKd.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $kPaOg.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $bZgd3.preventUnhandled).start();
            },
            getInitialData () {
                const initialWidth = (0, $8PsRn.getPixelWidth)(panel);
                /**
         * The drag calculations require the actual computed width of the element
         * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
         * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
         */ return $1677a4dabc88cee2$var$signPanelSplitterDragData({
                    panelId: panelId,
                    initialWidth: initialWidth,
                    resizingWidth: `${initialWidth}px`,
                    resizeBounds: getResizeBounds(),
                    // Only computing text direction when we need it, just as the drag is starting.
                    // Recomputing text direction on each new drag in case the text direction
                    // has changed. This is unlikely, but being safe.
                    direction: $1677a4dabc88cee2$var$getTextDirection(panel)
                });
            },
            onDragStart ({ source: source }) {
                /**
         * ⚠️ Note: We are not using the client locations (e.g. clientX) during `onDragStart`
         * because some browser extensions can cause the event properties to incorrectly return 0.
         */ (0, $jiTLE.default)((0, $i7CEc.isPanelSplitterDragData)(source.data));
                const resizeStartData = {
                    initialWidth: source.data.initialWidth
                };
                // The layout allocation system needs to know which area is actively being
                // resized before the first drag update. Committing this synchronously keeps
                // the actively dragged area protected from automatic compression.
                if (onResizeStartInternal) (0, $fZb1b.flushSync)(()=>onResizeStartInternal(resizeStartData));
                onResizeStart?.(resizeStartData);
                // Close any open layers when the user starts resizing
                openLayerObserver?.closeLayers();
            },
            onDrag ({ location: location, source: source }) {
                /**
         * ⚠️ Note: We are not using the location.initial.input client locations because some browser extensions
         * can cause the client locations (e.g. clientX) in the `dragstart` event to incorrectly return 0.
         */ (0, $jiTLE.default)((0, $i7CEc.isPanelSplitterDragData)(source.data));
                const { initialWidth: initialWidth, resizeBounds: resizeBounds, direction: direction } = source.data;
                (0, $jiTLE.default)(initialClientXRef.current !== null, 'initialClientX must be set');
                /**
         * How wide the element would be if there were no width constraints,
         * based on the pointer's position.
         */ const targetWidth = (0, $kFqs3.getWidthFromDragLocation)({
                    initialWidth: initialWidth,
                    location: location,
                    // The fallback of 0 won't be used due to the invariant, however we require one to satisfy the type.
                    initialClientX: initialClientXRef.current ?? 0,
                    direction: direction,
                    position: position
                });
                const resizingWidth = `clamp(${resizeBounds.min}, ${targetWidth}px, ${resizeBounds.max})`;
                if ((0, $iqfTZ.fg)('platform-dst-chat-panel-layout') && onResizeInternal) {
                    // Let the sizing provider constrain the width against Main's available space.
                    const width = Math.max((0, $2NXvw.convertResizeBoundToPixels)(resizeBounds.min), Math.min(targetWidth, (0, $2NXvw.convertResizeBoundToPixels)(resizeBounds.max)));
                    if (width !== lastManagedResizeWidth) {
                        lastManagedResizeWidth = width;
                        onResizeInternal(width);
                    }
                } else {
                    panel.style.setProperty(resizingCssVar, resizingWidth);
                    resizingElementRef?.current?.style.setProperty(resizingCssVar, resizingWidth);
                }
                source.data.resizingWidth = resizingWidth;
            },
            onDrop ({ source: source }) {
                (0, $jiTLE.default)((0, $i7CEc.isPanelSplitterDragData)(source.data));
                (0, $bZgd3.preventUnhandled).stop();
                // PDD may deliver its final throttled drag update immediately before drop.
                // Commit that update once before measuring; do not persist a previous frame.
                if (onResizeInternal && lastManagedResizeWidth !== undefined) {
                    const width = lastManagedResizeWidth;
                    (0, $fZb1b.flushSync)(()=>onResizeInternal(width));
                    lastManagedResizeWidth = undefined;
                }
                const finalWidth = (0, $8PsRn.getPixelWidth)(panel);
                // Persist the final preferred width before removing the imperative drag
                // variable, so the rendered width is continuous across pointer release.
                if ((0, $iqfTZ.fg)('platform-dst-chat-panel-layout')) (0, $fZb1b.flushSync)(()=>onCompleteResize(finalWidth));
                else onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source.data.initialWidth,
                    finalWidth: finalWidth
                });
                panel.style.removeProperty(resizingCssVar);
                resizingElementRef?.current?.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStartInternal,
        onResizeInternal,
        onResizeStart,
        onResizeEnd,
        panel,
        resizingCssVar,
        resizingElementRef,
        legacyPanelWidth,
        position,
        openLayerObserver,
        panelId,
        getResizeBounds
    ]);
    const onResizeStartStableRef = (0, $dZr3Z.default)(onResizeStart);
    const onResizeEndStableRef = (0, $dZr3Z.default)(onResizeEnd);
    const [keyboardResizeManager] = (0, $euxye.useState)(()=>(0, $8ouQF.createKeyboardResizeManager)({
            onResizeStart: (...args)=>{
                // Close any open layers when the user starts resizing with keyboard
                openLayerObserver?.closeLayers();
                onResizeStartStableRef.current?.(...args);
            },
            onResizeEnd: (...args)=>onResizeEndStableRef.current?.(...args)
        }));
    const handleSliderInputChange = (0, $euxye.useCallback)((event)=>{
        const isManagedResize = (0, $iqfTZ.fg)('platform-dst-chat-panel-layout') && onResizeInternal;
        let value = isManagedResize ? parseFloat(event.target.value) : parseInt(event.target.value);
        if (isManagedResize) {
            // The available region may have changed since focus, including without a
            // window resize. Use the allocator's current bounds for the public payload.
            const bounds = getResizeBounds();
            const min = (0, $2NXvw.convertResizeBoundToPixels)(bounds.min);
            const max = (0, $2NXvw.convertResizeBoundToPixels)(bounds.max);
            value = Math.max(min, Math.min(value, max));
            setRangeInputBounds({
                min: min,
                max: max
            });
        }
        setRangeInputValue(value);
        /**
     * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
     * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
     */ onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        getResizeBounds,
        onCompleteResize,
        onResizeInternal,
        panelWidth,
        keyboardResizeManager
    ]);
    const resizeEventListenerCleanupFn = (0, $euxye.useRef)(null);
    const handleSliderFocus = (0, $euxye.useCallback)(()=>{
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        resizeEventListenerCleanupFn.current?.();
        // Update the range input value to match the current panel width.
        setRangeInputValue(panelWidth);
        const resizeBounds = getResizeBounds();
        // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $2NXvw.convertResizeBoundToPixels)(resizeBounds.min),
            max: (0, $2NXvw.convertResizeBoundToPixels)(resizeBounds.max)
        });
        /**
     * _While the slider element is focused_, add a window resize event listener to update the range input bounds
     * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
     * size - in case they are provided in vw units.
     *
     * This listener is cleaned up when the element is blurred.
     */ resizeEventListenerCleanupFn.current = (0, $glbdM.bind)(window, {
            type: 'resize',
            listener: function updateState() {
                const resizeBounds = getResizeBounds();
                setRangeInputBounds({
                    min: (0, $2NXvw.convertResizeBoundToPixels)(resizeBounds.min),
                    max: (0, $2NXvw.convertResizeBoundToPixels)(resizeBounds.max)
                });
            }
        });
    }, [
        panelWidth,
        getResizeBounds
    ]);
    const handleSliderBlur = (0, $euxye.useCallback)(()=>{
        // Remove the resize event listener when the range input is blurred.
        resizeEventListenerCleanupFn.current?.();
    }, []);
    (0, $euxye.useEffect)(()=>{
        return function cleanup() {
            // Cleanup the resize event listener when the component is unmounted.
            resizeEventListenerCleanupFn.current?.();
        };
    }, []);
    const ariaValueText = (0, $euxye.useMemo)(()=>`${(0, $4CqMo.getPercentageWithinPixelBounds)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        })}% width`, [
        rangeInputValue,
        rangeInputBounds
    ]);
    return /*#__PURE__*/ (0, $fZb1b.createPortal)(/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $4jQY2.default)([
            $1677a4dabc88cee2$var$containerStyles.root,
            position === 'start' && $1677a4dabc88cee2$var$containerStyles.positionStart,
            position === 'end' && $1677a4dabc88cee2$var$containerStyles.positionEnd
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($1677a4dabc88cee2$var$MaybeTooltip, {
            tooltipContent: tooltipContent,
            shortcut: shortcut,
            testId: testId ? `${testId}-tooltip` : undefined,
            children: /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
                ref: splitterRef,
                "data-testid": testId,
                onDoubleClick: onDoubleClick,
                className: (0, $4jQY2.default)([
                    $1677a4dabc88cee2$var$grabAreaStyles.root,
                    (0, $iqfTZ.fg)('platform-dst-tokens-finesse') && $1677a4dabc88cee2$var$grabAreaStyles.rootFinesse,
                    isFhsEnabled && $1677a4dabc88cee2$var$grabAreaStyles.fullHeightSidebar
                ]),
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $apUrw.default), {
                        children: [
                            /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
                                type: "range",
                                value: rangeInputValue,
                                step: 20,
                                min: rangeInputBounds.min,
                                max: rangeInputBounds.max,
                                "aria-valuetext": ariaValueText,
                                "aria-labelledby": labelId,
                                onChange: handleSliderInputChange,
                                onFocus: handleSliderFocus,
                                onBlur: handleSliderBlur
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                                id: labelId,
                                children: label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        className: (0, $4jQY2.default)([
                            $1677a4dabc88cee2$var$lineStyles.root
                        ])
                    })
                ]
            })
        })
    }), portal);
};
$1677a4dabc88cee2$var$PortaledPanelSplitter.displayName = "PortaledPanelSplitter";
const $1677a4dabc88cee2$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, tooltipContent: tooltipContent })=>{
    const [panel, setPanel] = (0, $euxye.useState)(null);
    const [portal, setPortal] = (0, $euxye.useState)(null);
    const context = (0, $euxye.useContext)((0, $3fvZF.PanelSplitterContext));
    (0, $jiTLE.default)(context, 'Panel splitter context not set');
    const { panelRef: panelRef, portalRef: portalRef, isEnabled: isEnabled, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, onResizeStartInternal: onResizeStartInternal, onResizeInternal: onResizeInternal, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, resizingElementRef: resizingElementRef, position: position, shortcut: shortcut } = context;
    /**
   * **Explanation**
   *
   * _How React Suspense works_
   *
   * When a component is suspended:
   *
   * - it is _not_ "unmounted" and effects are _not_ cleaned up
   * - refs to react managed elements are cleared
   * - react adds `display:none !important` as an inline style to hide the element
   * - state is preserved
   *
   * When a suspended component is resumed:
   * - `display:none !important` inline style is removed
   * - it will re-render (without the refs set)
   * - refs will be set
   * - `useEffect` will _not_ re-run
   *
   * [More details](https://x.com/alexandereardon/status/1944617494569992440)
   *
   * _What does this mean for the panel splitter?_
   *
   * - The panel splitter renders into content into a react managed element (eg managed by Aside)
   * - When UI is suspended the portal ref is cleared
   * - After a suspense, we will get a render with cleared refs
   * - 🔥 This is problematic if we want to portal into that ref during the render
   *
   * _Approach: initial render_
   *
   * - We cannot portal the panel splitter until after the refs are initially set
   * - Effects run after refs being set. In an effect we set the ref values (which are populated),
   *   trigger a re-render and then portal into the refs.
   *
   * _Approach: suspense_
   *
   * - We put the refs into react `state` after every render
   * - The refs in `state` will not be cleared by suspending as effects are not run, or cleaned up,
   *   when components are suspended / resumed.
   * - After the post suspense render, we can use the `portalRef` (which was captured in an effect)
   *   to continue to portal into.
   *
   * _Why not store `portalRef` in `state` in `<PanelSplitterProvider>`?_
   *
   * - The `portalRef` is set high in the tree, so a re-render will cause a
   *   large amount of components to re-render (eg the whole sidebar)
   * - After a suspense, we would need to do _another_ large re-render to propagate the new refs
   * - With our current approach, any changes to `portalRef` will cause a re-render low in the tree
   *   (just in the `<PanelSplitter>`)
   */ // We want this effect to run after each render (see above)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $euxye.useEffect)(()=>{
        // Don't need to do anything
        if (!isEnabled) return;
        // It is safe to access refs in useEffect, even with Suspense
        const panelEl = panelRef.current;
        const portalEl = portalRef.current;
        (0, $jiTLE.default)(panelEl, 'panelRef not set');
        (0, $jiTLE.default)(portalEl, 'portal element not set');
        // Doing our own check, as this results in fewer re-renders than react
        // (which also does it's own checks to see if a re-render should occur)
        if (panelEl === panel && portalEl === portal) return;
        // If refs don't change, react won't cause infinite loops
        setPanel(panelEl);
        setPortal(portalEl);
    });
    if (!isEnabled) return null;
    if (!portal || !panel) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)($1677a4dabc88cee2$var$PortaledPanelSplitter, {
        label: label,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        testId: testId,
        panelId: panelId,
        panel: panel,
        portal: portal,
        panelWidth: panelWidth,
        onCompleteResize: onCompleteResize,
        onResizeStartInternal: onResizeStartInternal,
        onResizeInternal: onResizeInternal,
        getResizeBounds: getResizeBounds,
        resizingCssVar: resizingCssVar,
        resizingElementRef: resizingElementRef,
        position: position,
        tooltipContent: tooltipContent,
        shortcut: shortcut
    });
};
$1677a4dabc88cee2$export$db67e3f8d3d6da0f.displayName = "PanelSplitter";

});
parcelRegister("4CqMo", function(module, exports) {
$parcel$export(module.exports, "getPercentageWithinPixelBounds", () => $005e40ae28d7c2fe$export$b5423678cdf09f5);
function $005e40ae28d7c2fe$export$b5423678cdf09f5({ currentWidth: currentWidth, resizeBounds: resizeBounds }) {
    const resizeRange = resizeBounds.max - resizeBounds.min;
    const widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("8PsRn", function(module, exports) {
$parcel$export(module.exports, "getPixelWidth", () => $e189fd2c0709e33f$export$d942790ad00c41f9);
/**
 * Returns the computed width of an element in pixels.
 */ const $e189fd2c0709e33f$export$d942790ad00c41f9 = (element)=>{
    // Always returns an integer. Returns 0 if element is hidden / removed.
    return element.offsetWidth;
};

});

parcelRegister("kFqs3", function(module, exports) {
$parcel$export(module.exports, "getWidthFromDragLocation", () => $cdf23b068c0847b7$export$e360234971cb95b8);
const $cdf23b068c0847b7$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, initialClientX: initialClientX, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - initialClientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};

});

parcelRegister("8ouQF", function(module, exports) {
$parcel$export(module.exports, "createKeyboardResizeManager", () => $00ef0a35e7af0992$export$f7d3d5dae65f74aa);
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $00ef0a35e7af0992$var$resizeCallbackDebounceTimeMs = 500;
function $00ef0a35e7af0992$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
	 * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
	 */ function startResizeEndTimer({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: 'idle'
            };
        }, $00ef0a35e7af0992$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: initialWidth,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}

});




parcelRegister("7I1eK", function(module, exports) {
$parcel$export(module.exports, "TopNavEnd", () => $6ebbe28c16aa699d$export$8b7a38b70a3c9839);
/* top-nav-end.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $9S1b6 = parcelRequire("9S1b6");

var $890Pg = parcelRequire("890Pg");

var $7Fzpe = parcelRequire("7Fzpe");

var $k3NXE = parcelRequire("k3NXE");

var $iqfTZ = parcelRequire("iqfTZ");

var $4QBVk = parcelRequire("4QBVk");

var $h07LC = parcelRequire("h07LC");

var $kpwu4 = parcelRequire("kpwu4");

var $av7P9 = parcelRequire("av7P9");

var $d7tnL = parcelRequire("d7tnL");

var $fX8LH = parcelRequire("fX8LH");

var $iFrrF = parcelRequire("iFrrF");
const $6ebbe28c16aa699d$var$containerStyles = {
    root: "_2j3gqA7LI7 _3iDTPbQ4SZ _37wbyuF05b _4ouGXIUofl _3eQEqqW9qI _15X6MhW9qI _04KkHPBmSS _3tZeuj2Njc _1xHhlhF05b",
    withPersistentItems: "_2mHwu81Y8M _0hPCNLDIqT",
    fullHeightSidebar: "_03SyCP8HPE"
};
const $6ebbe28c16aa699d$var$listStyles = {
    root: "_2mHwu81Y8M _0hPCNLDIqT _3iDTPbQ4SZ",
    hideOnSmallViewport: "_3iDTPbYbGa _2UeR8bQ4SZ",
    popupContainer: "_4FKVYE2ADO"
};
function $6ebbe28c16aa699d$export$8b7a38b70a3c9839({ children: children, persistentItems: persistentItems, label: label = 'Actions', showMoreButtonLabel: showMoreButtonLabel = 'Show more' }) {
    const hasPersistentItems = (0, $iqfTZ.fg)('platform-dst-chat-panel-layout') && persistentItems != null;
    const isFhsEnabled = (0, $av7P9.useIsFhsEnabled)();
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    // Always setting to `false` for the initial render (will flip in an effect for mobile)
    const [isMobile, setIsMobile] = (0, $euxye.useState)(false);
    // Note: `query` is a stable value between renders
    const query = (0, $h07LC.UNSAFE_useMediaQuery)('below.sm', function onChange(event) {
        setIsMobile(event.matches);
        // Any time we shift between mobile and desktop
        // We always close the popup
        setIsOpen(false);
    });
    (0, $890Pg.useLayoutEffect)(()=>{
        // The default is `false`, and desktop will remain as `false` (no re-render).
        // Mobile will flip from `false` to `true`.
        setIsMobile(query?.matches ?? false);
    }, [
        query
    ]);
    // The shared provider also covers the mobile overflow popup itself. Keep the
    // previous content-only namespace coverage when the layout gate is disabled.
    const actions = (0, $iqfTZ.fg)('platform-dst-chat-panel-layout') ? children : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $k3NXE.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $iFrrF.openLayerObserverTopNavEndNamespace),
        children: children
    });
    const content = /*#__PURE__*/ (0, $e79Pd.jsxs)("nav", {
        "aria-label": label,
        className: (0, $4jQY2.default)([
            $6ebbe28c16aa699d$var$containerStyles.root,
            hasPersistentItems && $6ebbe28c16aa699d$var$containerStyles.withPersistentItems,
            isFhsEnabled && $6ebbe28c16aa699d$var$containerStyles.fullHeightSidebar
        ]),
        children: [
            isMobile ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4QBVk.Popup), {
                isOpen: isOpen,
                onClose: ()=>setIsOpen(false),
                // Top-layer popups need a role to register as a popup with the layer observer.
                role: (0, $iqfTZ.fg)('platform-dst-chat-panel-layout') ? 'dialog' : undefined,
                label: (0, $iqfTZ.fg)('platform-dst-chat-panel-layout') ? label : undefined,
                placement: "bottom-start",
                shouldRenderToParent: true,
                content: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $d7tnL.HasCustomThemeContext).Provider, {
                        value: false,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kpwu4.List), {
                            xcss: (0, $9S1b6.cx)($6ebbe28c16aa699d$var$listStyles.root, $6ebbe28c16aa699d$var$listStyles.popupContainer),
                            children: actions
                        })
                    }),
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $fX8LH.IconButton), {
                        ...triggerProps,
                        label: showMoreButtonLabel,
                        isSelected: isOpen,
                        onClick: ()=>setIsOpen(!isOpen),
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Fzpe))),
                        isTooltipDisabled: false
                    })
            }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kpwu4.List), {
                xcss: (0, $9S1b6.cx)($6ebbe28c16aa699d$var$listStyles.root, $6ebbe28c16aa699d$var$listStyles.hideOnSmallViewport),
                children: actions
            }),
            hasPersistentItems && persistentItems
        ]
    });
    return (0, $iqfTZ.fg)('platform-dst-chat-panel-layout') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $k3NXE.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $iFrrF.openLayerObserverTopNavEndNamespace),
        children: content
    }) : content;
}
$6ebbe28c16aa699d$export$8b7a38b70a3c9839.displayName = "TopNavEnd";

});
parcelRegister("kpwu4", function(module, exports) {
$parcel$export(module.exports, "List", () => $e117b94d6b43186e$export$54c2e3dc7acea9f5);
/* list.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
function $e117b94d6b43186e$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId,
        children: children
    }));
}
const $e117b94d6b43186e$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $euxye.forwardRef)($e117b94d6b43186e$var$_List);

});


parcelRegister("eLpG2", function(module, exports) {
$parcel$export(module.exports, "TopNavMiddle", () => $f6397fe4744fecf7$export$88836ac6da0f492f);
/* top-nav-middle.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");
parcelRequire("euxye");

var $k3NXE = parcelRequire("k3NXE");

var $iFrrF = parcelRequire("iFrrF");
const $f6397fe4744fecf7$var$styles = {
    root: "_2mHwu82ADO _2j3gqAiZR3 _39xV02N91d _0hPCNLDIqT _3iDTPbQ4SZ _37wbyuF05b _2UeR8bgBM8 _3E0AG21EBl _1p7Awjbt8w _4itPyXW9qI _2x7hvAF05b"
};
function $f6397fe4744fecf7$export$88836ac6da0f492f({ children: children }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $f6397fe4744fecf7$var$styles.root
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $k3NXE.OpenLayerObserverNamespaceProvider), {
            namespace: (0, $iFrrF.openLayerObserverTopNavMiddleNamespace),
            children: children
        })
    });
}
$f6397fe4744fecf7$export$88836ac6da0f492f.displayName = "TopNavMiddle";

});

parcelRegister("2pWfK", function(module, exports) {
$parcel$export(module.exports, "TopNavStart", () => $9cba0a86d9cc07c8$export$4c15269b98c5129);
/* top-nav-start.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $dZr3Z = parcelRequire("dZr3Z");

var $k3NXE = parcelRequire("k3NXE");

var $iqfTZ = parcelRequire("iqfTZ");

var $h07LC = parcelRequire("h07LC");

var $1R7xO = parcelRequire("1R7xO");

var $av7P9 = parcelRequire("av7P9");

var $d7tnL = parcelRequire("d7tnL");

var $hdQPQ = parcelRequire("hdQPQ");

var $iFrrF = parcelRequire("iFrrF");

var $hNf54 = parcelRequire("hNf54");

var $kmjbD = parcelRequire("kmjbD");
/**
 * Firefox does support these reorder animations, but only partially enabling layout animations would look odd.
 *
 * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
 * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
 * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
 */ let $9cba0a86d9cc07c8$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
// Placed in a variable, as the value is used in the translateX value for the children wrapper animation.
const $9cba0a86d9cc07c8$var$flexGap = "var(--ds-space-050, 4px)";
/**
 * Styles for the TopNavStart element.
 *
 * When `useIsFhsEnabled` is true this is the styling for the inner element,
 * which re-enables pointer events.
 */ const $9cba0a86d9cc07c8$var$innerStyles = {
    root: "_2mHwu81Y8M _2j3gqA7dHp _0jFU0VN91d _0hPCNLDIqT _3iDTPbQ4SZ _15X6MhW9qI _04KkHPBmSS _3tZeuj2Njc",
    fullHeightSidebarExpanded: "_04KkHPZqHV _15X6MhN91d"
};
/**
 * Styles for the outer element, that does not have re-enabled pointer events and spans the entire
 * width of the TopNavStart area.
 *
 * This wrapper element is only rendered when `useIsFhsEnabled` is true.
 */ const $9cba0a86d9cc07c8$var$wrapperStyles = {
    root: "_24h04i2Njc _0LQT5E8HPE _0jFU0VN91d _2DiRUzRAKS _3LGMrXogpp _1jgrOPWVPG _4si1UwdnbC _2Q6odvdnbC _0W5cBndnbC _3L4Jl0NvrM _0hPRjj6wH8 _0gJ73r9r67 _1sRjPqdnbC",
    fullHeightSidebarExpanded: "_15X6MheXXS _0Z95yk8HPE _0hAebtlfZc _1sRjPq7dHp",
    fullHeightSidebarBorderTransition: "_1x6R3U9v2r _28kFy52HTN _1ga5wYDgop",
    fullHeightSidebarCustomTheming: "_0hAebtDHe6 _3PYyoLYbGa"
};
/**
 * We use a fixed translateX offset for the slide animation (used when the TopNavStart children elements are reordered).
 * This fixed offset makes the elements appear to animate smoothly from the old to the new position.
 * This offset is calculated based on:
 * - 32px (2rem) width of the side nav toggle button (IconButton)
 * - 4px gap ('space.050' token) of the flex container
 *
 * The benefit of hardcoding this offset is that we don't need to calculate it using JS each time the sidebar is toggled.
 * However, it could become out of sync if the width of IconButton changes.
 *
 * The alternative is using JS to store the previous position of the children wrapper element, and calculate the offset based on
 * the new position, and then transforming using that offset. This would prevent the animation from going out of sync.
 */ const $9cba0a86d9cc07c8$var$childrenWrapperAnimationOffset = `calc(2rem + ${$9cba0a86d9cc07c8$var$flexGap})`;
const $9cba0a86d9cc07c8$var$childrenWrapperStyles = {
    root: "_2mHwu8OLYo _3iDTPbOLYo _0hPCNLDIqT _4ouGXIdnbC _2LGtmL7dHp _0pbPskvQQr",
    animationBaseStyles: "_2qDx9mC67X",
    finalPosition: "_1uhENMlna5 _03Q0ee2HTN",
    expandAnimationStartPosition: "_1uhENMghmk",
    collapseAnimationStartPosition: "_1uhENMgZsO"
};
/**
 * We use a fixed translateX offset for the toggle button slide animation (used when the TopNavStart children elements are reordered).
 * The specific value doesn't matter too much for the toggle button animation, so we are using `100%`, which will match the toggle button width.
 *
 * By combining the `translateX` animation with an `opacity` fade, the feel and experience is actually quite similar to animating the
 * element from the exact old position (offset), and it avoids the additional complexity of needing to track and calculate the exact offset.
 */ const $9cba0a86d9cc07c8$var$toggleButtonWrapperStyles = {
    root: "_2LGtmL7dHp _0pbPskvQQr _2qDx9m0a1V",
    finalPosition: "_1uhENMlna5 _03Q0ee2HTN _0KUEEl7dHp",
    expandAnimationStartPosition: "_1uhENMJF1Y _0KUEEldnbC",
    collapseAnimationStartPosition: "_1uhENMpSHp _0KUEEldnbC",
    expandAnimationTimingFunction: "_4BklsuN8t6",
    collapseAnimationTimingFunction: "_4BklsuUtCU",
    alignEnd: "_0GTcwRIZbP"
};
/**
 * The consistent key used for the side nav toggle button to ensure it does not get remounted
 * when it is reordered.
 *
 * This ensures we get focus restoration for free.
 */ const $9cba0a86d9cc07c8$var$sideNavToggleButtonKey = 'side-nav-toggle-button';
const $9cba0a86d9cc07c8$var$TopNavStartInnerOld = /*#__PURE__*/ (0, $euxye.forwardRef)(function TopNavStartInner({ children: children, testId: testId }, ref) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            $9cba0a86d9cc07c8$var$innerStyles.root
        ]),
        children: children
    });
});
const $9cba0a86d9cc07c8$var$TopNavStartInnerFHS = /*#__PURE__*/ (0, $euxye.forwardRef)(function TopNavStartInnerFHS({ children: children, testId: testId }, ref) {
    // This needs the real `defaultCollapsed` state or will not SSR properly
    // TODO: lift `defaultCollapsed` state to `Root` (DSP-23683)
    // then context value will be correct in SSR / from initial render
    const { isExpandedOnDesktop: isExpandedOnDesktop } = (0, $kmjbD.useSideNavVisibility)({
        defaultCollapsed: true
    });
    const sideNavState = (0, $euxye.useContext)((0, $hNf54.SideNavVisibilityState));
    const isFirstRenderRef = (0, $euxye.useRef)(true);
    (0, $euxye.useEffect)(()=>{
        // Ignore renders until the side nav state is initialized
        // So that apps using the legacy API for setting side nav default state do not see
        // animations when they shouldn't
        if (sideNavState === null) return;
        if (isFirstRenderRef.current) isFirstRenderRef.current = false;
    }, [
        sideNavState
    ]);
    const hasCustomTheme = (0, $d7tnL.useHasCustomTheme)();
    const hasDefaultBackgroundColor = (0, $euxye.useContext)((0, $hdQPQ.HasDefaultBackgroundColorContext));
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $9cba0a86d9cc07c8$var$wrapperStyles.root,
            isExpandedOnDesktop && $9cba0a86d9cc07c8$var$wrapperStyles.fullHeightSidebarExpanded,
            !isFirstRenderRef.current && isExpandedOnDesktop && $9cba0a86d9cc07c8$var$wrapperStyles.fullHeightSidebarBorderTransition,
            hasCustomTheme && !hasDefaultBackgroundColor && (0, $iqfTZ.fg)('platform_dst_nav4_custom_theming_fhs_1') && $9cba0a86d9cc07c8$var$wrapperStyles.fullHeightSidebarCustomTheming
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            ref: ref,
            "data-testid": testId,
            className: (0, $4jQY2.default)([
                $9cba0a86d9cc07c8$var$innerStyles.root,
                isExpandedOnDesktop && $9cba0a86d9cc07c8$var$innerStyles.fullHeightSidebarExpanded
            ]),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $k3NXE.OpenLayerObserverNamespaceProvider), {
                namespace: (0, $iFrrF.openLayerObserverTopNavStartNamespace),
                children: children
            })
        })
    });
});
function $9cba0a86d9cc07c8$export$4c15269b98c5129({ children: children, testId: testId, sideNavToggleButton: sideNavToggleButton }) {
    const isFhsEnabled = (0, $av7P9.useIsFhsEnabled)();
    const ref = (0, $euxye.useContext)((0, $1R7xO.TopNavStartAttachRef));
    const elementRef = (0, $euxye.useRef)(null);
    // FIXME: unsafe pattern with Suspense, should use callback ref / store in state
    // Should handle the underlying HTMLElement changing without a remount
    (0, $euxye.useEffect)(()=>{
        ref(elementRef.current);
    }, [
        elementRef,
        ref
    ]);
    // This needs the real `defaultCollapsed` state or will not SSR properly
    // TODO: lift `defaultCollapsed` state to `Root` (DSP-23683)
    // then context value will be correct in SSR / from initial render
    const { isExpandedOnDesktop: isExpandedOnDesktop } = (0, $kmjbD.useSideNavVisibility)({
        defaultCollapsed: true
    });
    // For SSR assume desktop
    const [isDesktop, setIsDesktop] = (0, $euxye.useState)(true);
    // Set state to real value on client
    // This could result in some visible shift on mobile when hydrating SSR
    // TODO: review and improve SSR behavior as necessary (DSP-23817)
    (0, $euxye.useLayoutEffect)(()=>{
        // Checking this to avoid breaking tests when `matchMedia` is not mocked
        // Ideally we wouldn't cater to test environments, but this avoids introducing unnecessary friction
        if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') setIsDesktop(window.matchMedia('(min-width: 64rem)').matches);
    }, []);
    (0, $h07LC.UNSAFE_useMediaQuery)('above.md', (event)=>{
        setIsDesktop(event.matches);
    });
    const [animationState, setAnimationState] = (0, $euxye.useState)({
        type: 'idle'
    });
    // Used to prevent the reorder animations from running on the initial render.
    const isFirstRenderRef = (0, $euxye.useRef)(true);
    const sideNavState = (0, $euxye.useContext)((0, $hNf54.SideNavVisibilityState));
    (0, $euxye.useEffect)(()=>{
        if (!isFhsEnabled) return;
        // Ignore renders until the side nav state is initialized
        // So that apps using the legacy API for setting side nav default state do not see
        // animations when they shouldn't
        if (sideNavState === null) return;
        if (isFirstRenderRef.current) isFirstRenderRef.current = false;
    }, [
        isFhsEnabled,
        sideNavState
    ]);
    // Using a stable ref to avoid re-running the animation layout effect when the toggle button prop value changes, which
    // can happen a lot (e.g. if the parent re-renders)
    const sideNavToggleButtonStableRef = (0, $dZr3Z.default)(sideNavToggleButton);
    (0, $euxye.useLayoutEffect)(()=>{
        if (!isFhsEnabled) return;
        /**
     * This layout effect is used to animate the TopNavStart children elements to their new position after being reordered.
     * It is called when the sidebar's desktop expansion state changes.
     *
     * It works by first setting a translateX offset on the elements, used as the start position of the slide animation.
     * - For the toggle button, it's a fixed offset. It's combined with an opacity, so the exact offset doesn't matter too much.
     * - For the children wrapper (wrapping everything except the toggle button), an offset was chosen to make the animation
     * start position the exact same as the element's old position. See comments for `childrenWrapperStyles` for more details.
     *
     * On the next frame, the translateX offset is cleared, triggering the animation to the new position.
     */ if (isFirstRenderRef.current) // No animations on initial render.
        return;
        if (!sideNavToggleButtonStableRef.current) // If there is no toggle button, there should be no re-order animations.
        return;
        // Set the translateX offsets so elements are ready to animate to their actual new position after being reordered
        setAnimationState({
            type: isExpandedOnDesktop ? 'expand' : 'collapse'
        });
        requestAnimationFrame(()=>{
            // Clear translateX offsets on next frame to trigger animation to new position in a re-render
            setAnimationState({
                type: 'idle'
            });
        });
    // This layout effect is called when the sidebar's desktop expansion state changes.
    }, [
        isExpandedOnDesktop,
        isFhsEnabled,
        sideNavToggleButtonStableRef
    ]);
    const TopNavStartInner = isFhsEnabled ? $9cba0a86d9cc07c8$var$TopNavStartInnerFHS : $9cba0a86d9cc07c8$var$TopNavStartInnerOld;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)(TopNavStartInner, {
        ref: elementRef,
        testId: testId,
        children: [
            !isFhsEnabled && sideNavToggleButton,
            sideNavToggleButton && (!isDesktop || !isExpandedOnDesktop) && isFhsEnabled && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    !$9cba0a86d9cc07c8$var$isFirefox && $9cba0a86d9cc07c8$var$toggleButtonWrapperStyles.root,
                    !$9cba0a86d9cc07c8$var$isFirefox && animationState.type === 'idle' && $9cba0a86d9cc07c8$var$toggleButtonWrapperStyles.finalPosition,
                    !$9cba0a86d9cc07c8$var$isFirefox && // Timing function is applied when the browser animates to the idle position.
                    animationState.type === 'idle' && $9cba0a86d9cc07c8$var$toggleButtonWrapperStyles.collapseAnimationTimingFunction,
                    !$9cba0a86d9cc07c8$var$isFirefox && animationState.type === 'collapse' && $9cba0a86d9cc07c8$var$toggleButtonWrapperStyles.collapseAnimationStartPosition
                ]),
                children: sideNavToggleButton
            }, $9cba0a86d9cc07c8$var$sideNavToggleButtonKey),
            isFhsEnabled ? /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    $9cba0a86d9cc07c8$var$childrenWrapperStyles.root,
                    !$9cba0a86d9cc07c8$var$isFirefox && $9cba0a86d9cc07c8$var$childrenWrapperStyles.animationBaseStyles,
                    !$9cba0a86d9cc07c8$var$isFirefox && animationState.type === 'idle' && $9cba0a86d9cc07c8$var$childrenWrapperStyles.finalPosition,
                    !$9cba0a86d9cc07c8$var$isFirefox && animationState.type === 'expand' && $9cba0a86d9cc07c8$var$childrenWrapperStyles.expandAnimationStartPosition,
                    !$9cba0a86d9cc07c8$var$isFirefox && animationState.type === 'collapse' && $9cba0a86d9cc07c8$var$childrenWrapperStyles.collapseAnimationStartPosition
                ]),
                children: children
            }) : children,
            sideNavToggleButton && isDesktop && isExpandedOnDesktop && isFhsEnabled && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    !$9cba0a86d9cc07c8$var$isFirefox && $9cba0a86d9cc07c8$var$toggleButtonWrapperStyles.root,
                    $9cba0a86d9cc07c8$var$toggleButtonWrapperStyles.alignEnd,
                    !$9cba0a86d9cc07c8$var$isFirefox && animationState.type === 'idle' && $9cba0a86d9cc07c8$var$toggleButtonWrapperStyles.finalPosition,
                    !$9cba0a86d9cc07c8$var$isFirefox && // Timing function is applied when the browser animates to the idle position.
                    animationState.type === 'idle' && $9cba0a86d9cc07c8$var$toggleButtonWrapperStyles.expandAnimationTimingFunction,
                    !$9cba0a86d9cc07c8$var$isFirefox && animationState.type === 'expand' && $9cba0a86d9cc07c8$var$toggleButtonWrapperStyles.expandAnimationStartPosition
                ]),
                children: sideNavToggleButton
            }, $9cba0a86d9cc07c8$var$sideNavToggleButtonKey)
        ]
    });
}
$9cba0a86d9cc07c8$export$4c15269b98c5129.displayName = "TopNavStart";

});
parcelRegister("1R7xO", function(module, exports) {
$parcel$export(module.exports, "TopNavStartAttachRef", () => $1eac3a0359b6cb05$export$55f0a642b785fb1f);

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");
const $1eac3a0359b6cb05$export$55f0a642b785fb1f = /*#__PURE__*/ (0, $euxye.createContext)((0, $2oRWW.default));

});

parcelRegister("hdQPQ", function(module, exports) {
$parcel$export(module.exports, "HasDefaultBackgroundColorContext", () => $5bff64f83a39e27d$export$e4314fea1a98d918);

var $euxye = parcelRequire("euxye");
const $5bff64f83a39e27d$export$e4314fea1a98d918 = /*#__PURE__*/ (0, $euxye.createContext)(true);

});


parcelRegister("1Pip6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b7ce0838881bb0eb6f29b86e8b3a459>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1548d480989c35be$var$_react = $1548d480989c35be$var$_interopRequireDefault((parcelRequire("euxye")));

var $1548d480989c35be$var$_iconNew = $1548d480989c35be$var$_interopRequireDefault((parcelRequire("52mjj")));
function $1548d480989c35be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/editions
 * Usage guidance:
 * Reserved for representing premium features in upsell experiences. The Editions gem icon has officially replaced the sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1548d480989c35be$var$EditionsIcon = (props)=>/*#__PURE__*/ $1548d480989c35be$var$_react.default.createElement($1548d480989c35be$var$_iconNew.default, Object.assign({
        name: "EditionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.75 1 .096.006a.75.75 0 0 1 .54.347l2.5 4a.75.75 0 0 1-.066.883l-7.25 8.5a.75.75 0 0 1-1.14 0l-7.25-8.5a.75.75 0 0 1-.066-.883l2.5-4 .056-.079A.75.75 0 0 1 3.25 1zM8 11.813 9.719 6.5H6.28zm-1.873-.914L4.704 6.5H2.375zm3.745 0L13.625 6.5h-2.33zM11.302 5h2.596l-1.563-2.5H10.52zM6.27 5h3.46l-.782-2.5H7.052zM2.103 5h2.595l.781-2.5H3.665z"/>`
    }, props));
$1548d480989c35be$var$EditionsIcon.displayName = 'EditionsIcon';
var $1548d480989c35be$var$_default = module.exports.default = $1548d480989c35be$var$EditionsIcon;

});

parcelRegister("8a8ab", function(module, exports) {
$parcel$export(module.exports, "Button", () => $7aec46c0e73d6c51$export$353f5b6fc5456de1);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iOfms = parcelRequire("iOfms");

var $d7tnL = parcelRequire("d7tnL");

var $e0kq5 = parcelRequire("e0kq5");
const $7aec46c0e73d6c51$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $d7tnL.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $e0kq5.ThemedButton) : (0, $iOfms.default);
    return /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("e0kq5", function(module, exports) {
$parcel$export(module.exports, "ThemedButton", () => $4bae57f7ced7cae4$export$f67fb575035cc7d0);
/* themed-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $7cylN = parcelRequire("7cylN");

var $gjrQa = parcelRequire("gjrQa");
const $4bae57f7ced7cae4$var$textButtonStyles = {
    iconBefore: "_26BoRwdnbC",
    text: "_1kk5Tkf7mX"
};
const $4bae57f7ced7cae4$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $euxye.forwardRef)(function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $gjrQa.ThemedPressable), {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                className: (0, $4jQY2.default)([
                    $4bae57f7ced7cae4$var$textButtonStyles.iconBefore
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7cylN.default), {
                    icon: IconBefore
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                className: (0, $4jQY2.default)([
                    $4bae57f7ced7cae4$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    });
});

});


parcelRegister("aUup4", function(module, exports) {
$parcel$export(module.exports, "Hide", () => $be5a4f012c3bdf5c$export$bed28288a051538);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $hStPE = parcelRequire("hStPE");

var $f7B36 = parcelRequire("f7B36");

var $gm9iJ = parcelRequire("gm9iJ");

var $VQV2y = parcelRequire("VQV2y");
const $be5a4f012c3bdf5c$var$hideAboveQueries = (0, $gm9iJ.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $be5a4f012c3bdf5c$var$hideBelowQueries = (0, $VQV2y.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $be5a4f012c3bdf5c$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $f7B36.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $hStPE.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $be5a4f012c3bdf5c$var$hideAboveQueries[above],
            below && $be5a4f012c3bdf5c$var$hideBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
$be5a4f012c3bdf5c$export$bed28288a051538.displayName = "Hide";

});
parcelRegister("gm9iJ", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $573902c398668c5b$export$918f8818cfbbeb2c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $hStPE = parcelRequire("hStPE");

var $hyoYJ = parcelRequire("hyoYJ");

var $fEaYp = parcelRequire("fEaYp");
const $573902c398668c5b$export$918f8818cfbbeb2c = (input)=>{
    return (0, $hyoYJ.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $hStPE.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $fEaYp.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};

});
parcelRegister("hyoYJ", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_CONFIG", () => $5db3e7c8ed838a89$export$e5ee4fe8b989fd09);
$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $5db3e7c8ed838a89$export$2d293d9871c38e91);
const $5db3e7c8ed838a89$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $5db3e7c8ed838a89$export$2d293d9871c38e91 = Object.keys($5db3e7c8ed838a89$export$e5ee4fe8b989fd09);
const $5db3e7c8ed838a89$export$b7ed752a57b4177b = $5db3e7c8ed838a89$export$2d293d9871c38e91[0];

});

parcelRegister("fEaYp", function(module, exports) {
$parcel$export(module.exports, "media", () => $8f05869e2a0b83a2$export$987d49ffe1b0900f);
const $8f05869e2a0b83a2$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});


parcelRegister("VQV2y", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $b242948dea0f8393$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $hStPE = parcelRequire("hStPE");

var $hyoYJ = parcelRequire("hyoYJ");

var $48Ol3 = parcelRequire("48Ol3");
const $b242948dea0f8393$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $hyoYJ.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $hStPE.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $48Ol3.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("48Ol3", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_media", () => $1089b2f540fed448$export$c881183ca713c214);

var $fEaYp = parcelRequire("fEaYp");
const $1089b2f540fed448$export$c881183ca713c214 = (0, $fEaYp.media);

});



parcelRegister("hpxWX", function(module, exports) {
$parcel$export(module.exports, "Show", () => $f297445e5cbade08$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $hStPE = parcelRequire("hStPE");

var $f7B36 = parcelRequire("f7B36");

var $gm9iJ = parcelRequire("gm9iJ");

var $VQV2y = parcelRequire("VQV2y");
function $f297445e5cbade08$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f297445e5cbade08$var$showAboveQueries = (0, $gm9iJ.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $f297445e5cbade08$var$showBelowQueries = (0, $VQV2y.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $f297445e5cbade08$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $f297445e5cbade08$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $f7B36.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $hStPE.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $f297445e5cbade08$var$defaultHiddenStyles,
            above && $f297445e5cbade08$var$showAboveQueries[above],
            below && $f297445e5cbade08$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
$f297445e5cbade08$export$f6a3d19be20f5819.displayName = "Show";

});

parcelRegister("lNuFs", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $12920a1a48f6f986$export$49e55ae2c03d6045);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $890Pg = parcelRequire("890Pg");

var $48Ol3 = parcelRequire("48Ol3");
const $12920a1a48f6f986$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $48Ol3.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $48Ol3.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $48Ol3.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $48Ol3.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $48Ol3.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $48Ol3.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $48Ol3.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $48Ol3.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $48Ol3.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $48Ol3.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $48Ol3.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $12920a1a48f6f986$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $euxye.useRef)(listener);
    (0, $euxye.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $12920a1a48f6f986$var$queries[queryString];
    (0, $890Pg.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $glbdM.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};
$12920a1a48f6f986$export$49e55ae2c03d6045.displayName = "UNSAFE_useMediaQuery";

});

parcelRegister("fnihK", function(module, exports) {
$parcel$export(module.exports, "ModalContextProvider", () => $2d30efe8ef7c398e$export$7c9538f5f3c365e9);

var $euxye = parcelRequire("euxye");

var $9imxF = parcelRequire("9imxF");

var $jp9KZ = parcelRequire("jp9KZ");
const $2d30efe8ef7c398e$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $euxye.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $euxye.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
$2d30efe8ef7c398e$var$RenderModal.displayName = "RenderModal";
function $2d30efe8ef7c398e$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $euxye.useRef)(1);
    const [modals, setModals] = (0, $euxye.useState)([]);
    const modalContext = (0, $euxye.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jp9KZ.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9imxF.default), null, modals.map((modal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($2d30efe8ef7c398e$var$RenderModal, {
            key: modal.key,
            modal: modal
        }))));
}
$2d30efe8ef7c398e$export$7c9538f5f3c365e9.displayName = "ModalContextProvider";

});
parcelRegister("jp9KZ", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $9f443dd2fee58c43$export$ab57792b9b6974a6);

var $euxye = parcelRequire("euxye");
const $9f443dd2fee58c43$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $euxye.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';");
    }
});

});


parcelRegister("ikm5U", function(module, exports) {
$parcel$export(module.exports, "ModalTrigger", () => $023f551efaf7b877$export$fb10b32cfe19f1e);

var $euxye = parcelRequire("euxye");

var $1uH7N = parcelRequire("1uH7N");

var $n67Vb = parcelRequire("n67Vb");

var $fsEVO = parcelRequire("fsEVO");

var $7tY81 = parcelRequire("7tY81");

var $iqfTZ = parcelRequire("iqfTZ");

var $63Rm5 = parcelRequire("63Rm5");

var $8EpkY = parcelRequire("8EpkY");

var $gAEFP = parcelRequire("gAEFP");

var $cxpqA = parcelRequire("cxpqA");

var $jp9KZ = parcelRequire("jp9KZ");

var $5nUIh = parcelRequire("5nUIh");

var $75ag9 = parcelRequire("75ag9");

var $kvOpQ = parcelRequire("kvOpQ");
const $023f551efaf7b877$var$emptyEntryPointParams = {};
const $023f551efaf7b877$var$emptyEntryPointProps = {};
function $023f551efaf7b877$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, preloadOnFocus: preloadOnFocus = true, loadingText: loadingText }) {
    (0, $1uH7N.di)((0, $n67Vb.loadEntryPoint));
    const { openModal: openModal } = (0, $euxye.useContext)((0, $jp9KZ.ModalContext));
    const environmentProvider = (0, $cxpqA.useRelayEnvironmentProvider)();
    const { GlobalModalErrorFallback: GlobalModalErrorFallback } = (0, $63Rm5.useEntryPointConfig)();
    const modalRef = (0, $euxye.useRef)(null);
    const metricName = (0, $euxye.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $euxye.useCallback)(()=>(0, $n67Vb.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $023f551efaf7b877$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $euxye.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                entryPointProps?.onClose?.(extraInformation);
                closeModal();
                dispose();
            };
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gAEFP.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(GlobalModalErrorFallback, {
                        error: error,
                        closeModal: closeModal,
                        fallback: (0, $iqfTZ.fg)('platform_dst-a11y_accessible-error-modal') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5nUIh.ErrorFallback), {
                            error: error,
                            closeModal: onClose
                        }) : undefined
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                },
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Fallback, {
                    onClose: closeModal
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kvOpQ.Loading), {
                    title: title,
                    loadingText: loadingText
                }),
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $023f551efaf7b877$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return(// eslint-disable-next-line @atlaskit/design-system/use-modal-dialog-close-button
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7tY81.default), {
                ...modalProps,
                ref: modalRef,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress
            }, container, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $75ag9.FocusInsideOnLoad), {
                entryPointReference: entryPointReference,
                autoFocusRef: modalProps?.autoFocus,
                modalRef: modalRef
            })));
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        GlobalModalErrorFallback,
        onError,
        loadingText
    ]);
    const triggerRef = (0, $8EpkY.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $fsEVO.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    if ((0, $iqfTZ.fg)('platform_dst-a11y_modal-trigger-haspopup')) return children({
        ref: mergedRef,
        'aria-haspopup': 'dialog'
    });
    return children({
        ref: mergedRef
    });
}
$023f551efaf7b877$export$fb10b32cfe19f1e.displayName = "ModalTrigger";

});
parcelRegister("5nUIh", function(module, exports) {
$parcel$export(module.exports, "ErrorFallback", () => $47856f383a0b48e4$export$8a7ad05c3ee0c78a);
/* error-fallback.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $euxye = parcelRequire("euxye");

var $iOfms = parcelRequire("iOfms");

var $keJFr = parcelRequire("keJFr");

var $2v3yi = parcelRequire("2v3yi");

var $4vluQ = parcelRequire("4vluQ");

var $gpyJM = parcelRequire("gpyJM");

var $dNPnD = parcelRequire("dNPnD");

var $2XXtG = parcelRequire("2XXtG");

var $8Sdzy = parcelRequire("8Sdzy");
const $47856f383a0b48e4$var$styles = {
    flex: "_0aFT5vf5Xk _39xV02N91d"
};
const $47856f383a0b48e4$export$8a7ad05c3ee0c78a = ({ error: _, closeModal: closeModal })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gpyJM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.Flex), {
        gap: "space.200",
        justifyContent: "space-between",
        xcss: $47856f383a0b48e4$var$styles.flex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.Flex), {
        justifyContent: "end"
    }, closeModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $keJFr.CloseButton), {
        onClick: closeModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dNPnD.default), {
        appearance: "danger"
    }, "Couldn't load dialog content"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v3yi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
        as: "p"
    }, "Something went wrong while loading the dialog content. Dismiss to go back")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4vluQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
        appearance: "primary",
        onClick: closeModal
    }, "Close")));
};
$47856f383a0b48e4$export$8a7ad05c3ee0c78a.displayName = "ErrorFallback";

});

parcelRegister("75ag9", function(module, exports) {
$parcel$export(module.exports, "FocusInsideOnLoad", () => $dc359d73584e4381$export$eb58c1f6b41ee511);

var $euxye = parcelRequire("euxye");

var $42lUo = parcelRequire("42lUo");

var $gRxRH = parcelRequire("gRxRH");
function $dc359d73584e4381$var$FocusInsideOnLoadInner({ autoFocusRef: autoFocusRef, modalRef: modalRef }) {
    (0, $euxye.useEffect)(()=>{
        // Fence for if container element doesn't exist, but this is effectively not
        // possible.
        if (!modalRef.current) return;
        // If ref provided, use that first. Else find first focusable element or
        // container if not exists
        if (autoFocusRef?.current) {
            autoFocusRef.current.focus();
            return;
        }
        const firstFocusable = (0, $42lUo.getFirstFocusable)({
            container: modalRef.current
        });
        if (firstFocusable) {
            firstFocusable.focus();
            return;
        }
        modalRef.current.focus();
    }, [
        autoFocusRef,
        modalRef
    ]);
    return null;
}
$dc359d73584e4381$var$FocusInsideOnLoadInner.displayName = "FocusInsideOnLoadInner";
function $dc359d73584e4381$export$eb58c1f6b41ee511({ entryPointReference: entryPointReference, autoFocusRef: autoFocusRef, modalRef: modalRef }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gRxRH.WaitForEntryPointLoad), {
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($dc359d73584e4381$var$FocusInsideOnLoadInner, {
        autoFocusRef: autoFocusRef,
        modalRef: modalRef
    }));
}
$dc359d73584e4381$export$eb58c1f6b41ee511.displayName = "FocusInsideOnLoad";

});
parcelRegister("gRxRH", function(module, exports) {
$parcel$export(module.exports, "WaitForEntryPointLoad", () => $c7e83b941890aec5$export$ed96a854f3831b66);

var $euxye = parcelRequire("euxye");

var $kYpum = parcelRequire("kYpum");

var $2oRWW = parcelRequire("2oRWW");
function $c7e83b941890aec5$var$SuspendUntilLoaded({ entryPointReference: entryPointReference, children: children }) {
    // The result is intentionally unused — this call exists purely to gate
    // the mount of children on the load completing.
    entryPointReference.getComponent();
    return children;
}
const $c7e83b941890aec5$var$renderNothing = ()=>null;
function $c7e83b941890aec5$export$ed96a854f3831b66({ entryPointReference: entryPointReference, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kYpum.ErrorBoundary), {
        FallbackComponent: $c7e83b941890aec5$var$renderNothing,
        onError: (0, $2oRWW.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c7e83b941890aec5$var$SuspendUntilLoaded, {
        entryPointReference: entryPointReference
    }, children)));
}
$c7e83b941890aec5$export$ed96a854f3831b66.displayName = "WaitForEntryPointLoad";

});


parcelRegister("kvOpQ", function(module, exports) {
$parcel$export(module.exports, "Loading", () => $d543229088f4c4f3$export$669f6ea7d267feaf);

var $euxye = parcelRequire("euxye");

var $2v3yi = parcelRequire("2v3yi");

var $4vluQ = parcelRequire("4vluQ");

var $gpyJM = parcelRequire("gpyJM");

var $dNPnD = parcelRequire("dNPnD");

var $3HFPs = parcelRequire("3HFPs");
const $d543229088f4c4f3$export$669f6ea7d267feaf = ({ loadingText: loadingText, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gpyJM.default), {
        hasCloseButton: true
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dNPnD.default), null, title) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v3yi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3HFPs.LoadingContent), {
        loadingText: loadingText ?? 'Loading dialog content...',
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4vluQ.default), null));
$d543229088f4c4f3$export$669f6ea7d267feaf.displayName = "Loading";

});
parcelRegister("3HFPs", function(module, exports) {
$parcel$export(module.exports, "LoadingContent", () => $1a74ed25c6e098f0$export$4ab3512e4872e6ff);

var $euxye = parcelRequire("euxye");

var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $abhF2 = parcelRequire("abhF2");
const $1a74ed25c6e098f0$export$4ab3512e4872e6ff = ({ loadingText: loadingText, size: size })=>{
    const stackSpace = size === 'large' ? 'space.400' : 'space.200';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        space: stackSpace,
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), {
        size: size,
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
        color: "color.text.subtle"
    }, loadingText));
};
$1a74ed25c6e098f0$export$4ab3512e4872e6ff.displayName = "LoadingContent";

});



parcelRegister("eoGQo", function(module, exports) {
$parcel$export(module.exports, "LinkButton", () => $cd0ddb2788f0d1da$export$29d11c0fe2fc51d8);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $9ufM9 = parcelRequire("9ufM9");

var $d7tnL = parcelRequire("d7tnL");

var $kYrX0 = parcelRequire("kYrX0");
const $cd0ddb2788f0d1da$export$29d11c0fe2fc51d8 = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $d7tnL.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $kYrX0.ThemedLinkButton) : (0, $9ufM9.default);
    return /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("kYrX0", function(module, exports) {
$parcel$export(module.exports, "ThemedLinkButton", () => $23a742a593306a4f$export$b0b5aeed52623827);
/* themed-link-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");
parcelRequire("euxye");

var $lpQqY = parcelRequire("lpQqY");

var $ffDyU = parcelRequire("ffDyU");
const $23a742a593306a4f$var$textButtonStyles = {
    iconBefore: "_26BoRwdnbC",
    text: "_1kk5Tkf7mX"
};
function $23a742a593306a4f$var$ThemedLinkButtonFn({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ffDyU.ThemedAnchor), {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                className: (0, $4jQY2.default)([
                    $23a742a593306a4f$var$textButtonStyles.iconBefore
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                className: (0, $4jQY2.default)([
                    $23a742a593306a4f$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    }));
}
$23a742a593306a4f$var$ThemedLinkButtonFn.displayName = "ThemedLinkButtonFn";
const $23a742a593306a4f$export$b0b5aeed52623827 = (0, $lpQqY.default)($23a742a593306a4f$var$ThemedLinkButtonFn);

});
parcelRegister("ffDyU", function(module, exports) {
$parcel$export(module.exports, "ThemedAnchor", () => $89f6695e3dcd4579$export$1b69d1a78614cc52);
/* themed-anchor.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $9S1b6 = parcelRequire("9S1b6");

var $lpQqY = parcelRequire("lpQqY");

var $iqfTZ = parcelRequire("iqfTZ");

var $9MWap = parcelRequire("9MWap");

var $7ZlHM = parcelRequire("7ZlHM");
const $89f6695e3dcd4579$var$styles = {
    root: "_2mHwu8gVvo _2sNsIgmnOE _0bjKvDKTcp _23rrnHoacQ _00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _4c065UPgdg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VymQ6 _1mT5xdRAKS _3WzCGiyL8i _32C2rkyL8i _0DCa9DyL8i _0NqVRtYbGa _0i9AWAYbGa _3932vvYbGa _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8",
    interactiveMotion: "_23rrnHyKLB _3sFUREiSCN",
    border: "_2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _0GBAIrogpp _2WYcYGWVPG",
    selected: "_2uo31fhe06 _1UtDYzysOt _0z8nYC0GCl _10n1R5ysOt _2nTuUYysOt _30zrXRUQDy _0clgaMysOt _1gxogc4k8R _0CMRbkysOt",
    disabled: "_2uo31ftHCb _1UtDYzn3Ip _0z8nYCs4Fm _10n1R5n3Ip _2nTuUYn3Ip _30zrXRtHCb _0clgaMn3Ip _1gxogctHCb _0CMRbkn3Ip"
};
const $89f6695e3dcd4579$var$appearanceStyles = {
    default: "_2uo31fGfro _1UtDYz98eZ _0z8nYCQMmr _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    subtle: "_2uo31fGfro _1UtDYz98eZ _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    primary: "_2uo31fxjIo _1UtDYzwGpT _10n1R5wGpT _2nTuUYwGpT _30zrXR2rJx _0clgaMwGpT _1gxogcHVA2 _0CMRbkwGpT"
};
const $89f6695e3dcd4579$var$shapeStyles = {
    default: "_2Y7lL48HPE",
    square: "_2Y7lL4Pgdg _39xV02ymQ6 _26BoRwdnbC"
};
function $89f6695e3dcd4579$var$ThemedAnchorFn({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9MWap.Anchor), {
        ...(0, $7ZlHM.getPrimitiveSpreadProps)(props),
        ref: ref,
        /**
   * We are using some style values that are outside of the strict
   * `@atlaskit/css` types.
   */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $9S1b6.cx)($89f6695e3dcd4579$var$styles.root, $89f6695e3dcd4579$var$shapeStyles[shape], hasBorder && $89f6695e3dcd4579$var$styles.border, $89f6695e3dcd4579$var$appearanceStyles[appearance], isSelected && $89f6695e3dcd4579$var$styles.selected, isDisabled && $89f6695e3dcd4579$var$styles.disabled, (0, $iqfTZ.fg)('platform-dst-motion-uplift-button') && $89f6695e3dcd4579$var$styles.interactiveMotion)
    });
}
$89f6695e3dcd4579$var$ThemedAnchorFn.displayName = "ThemedAnchorFn";
const $89f6695e3dcd4579$export$1b69d1a78614cc52 = (0, $lpQqY.default)($89f6695e3dcd4579$var$ThemedAnchorFn);

});



parcelRegister("ibF8a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b30a76b80c6ee3bf05427473bba7b309>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3d928c378081ad1$var$_react = $d3d928c378081ad1$var$_interopRequireDefault((parcelRequire("euxye")));

var $d3d928c378081ad1$var$_iconNew = $d3d928c378081ad1$var$_interopRequireDefault((parcelRequire("52mjj")));
function $d3d928c378081ad1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/arrow-up-circle
 * Usage guidance:
 * Known uses: upgrading to a paid plan
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d3d928c378081ad1$var$ArrowUpCircleIcon = (props)=>/*#__PURE__*/ $d3d928c378081ad1$var$_react.default.createElement($d3d928c378081ad1$var$_iconNew.default, Object.assign({
        name: "ArrowUpCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/><path fill="currentcolor" d="M7.526 4.168a.75.75 0 0 1 1.004.052l3.5 3.5-1.06 1.06-2.22-2.22v5.94h-1.5V6.56L5.03 8.78 3.97 7.72l3.5-3.5z"/>`
    }, props));
$d3d928c378081ad1$var$ArrowUpCircleIcon.displayName = 'ArrowUpCircleIcon';
var $d3d928c378081ad1$var$_default = module.exports.default = $d3d928c378081ad1$var$ArrowUpCircleIcon;

});

parcelRegister("gdvYt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::251f5452f3f0754765959a05130502fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bce6a9b57e8ad5fb$var$_react = $bce6a9b57e8ad5fb$var$_interopRequireDefault((parcelRequire("euxye")));

var $bce6a9b57e8ad5fb$var$_iconNew = $bce6a9b57e8ad5fb$var$_interopRequireDefault((parcelRequire("52mjj")));
function $bce6a9b57e8ad5fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/warning-outline
 * Usage guidance:
 * Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bce6a9b57e8ad5fb$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $bce6a9b57e8ad5fb$var$_react.default.createElement($bce6a9b57e8ad5fb$var$_iconNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$bce6a9b57e8ad5fb$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $bce6a9b57e8ad5fb$var$_default = module.exports.default = $bce6a9b57e8ad5fb$var$WarningOutlineIcon;

});

parcelRegister("3GAEe", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementIcon", () => $1a1b7be607039aa0$export$6da5aa77c402ba0f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b9c55c8ffa026c174f3b8612196e48f7>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ed9Xn = parcelRequire("ed9Xn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $1a1b7be607039aa0$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>
</svg>
`;
const $1a1b7be607039aa0$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5"/>
</svg>
`;
function $1a1b7be607039aa0$export$6da5aa77c402ba0f({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Customer Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ed9Xn.IconWrapper), {
        svg: $1a1b7be607039aa0$var$svg,
        customThemeSvg: $1a1b7be607039aa0$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$1a1b7be607039aa0$export$6da5aa77c402ba0f.displayName = "CustomerServiceManagementIcon";

});

parcelRegister("iJ2jp", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $d22fad4580012232$export$3c6158790f5e01c4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::018e1283e27acb8e799a70f211bb080a>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ed9Xn = parcelRequire("ed9Xn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $d22fad4580012232$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>
</svg>
`;
const $d22fad4580012232$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>
</svg>
`;
function $d22fad4580012232$export$3c6158790f5e01c4({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ed9Xn.IconWrapper), {
        svg: $d22fad4580012232$var$svg,
        customThemeSvg: $d22fad4580012232$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$d22fad4580012232$export$3c6158790f5e01c4.displayName = "JiraServiceManagementIcon";

});

parcelRegister("eUenY", function(module, exports) {
$parcel$export(module.exports, "PopupTrigger", () => $cec680bcf431381f$export$95d4acdbab2fc6ef);

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $50OIz = parcelRequire("50OIz");

var $iqfTZ = parcelRequire("iqfTZ");

var $4QBVk = parcelRequire("4QBVk");

var $8EpkY = parcelRequire("8EpkY");

var $gAEFP = parcelRequire("gAEFP");

var $cxpqA = parcelRequire("cxpqA");

var $7PkIs = parcelRequire("7PkIs");

var $2Fuzd = parcelRequire("2Fuzd");

var $5swv7 = parcelRequire("5swv7");


var $5eHXg = parcelRequire("5eHXg");

var $dqPCz = parcelRequire("dqPCz");

var $2dQZA = parcelRequire("2dQZA");

var $3tWDX = parcelRequire("3tWDX");
const $cec680bcf431381f$var$emptyEntryPointParams = {};
const $cec680bcf431381f$var$emptyEntryPointProps = {};
const $cec680bcf431381f$var$FallbackComponent = ({ fallback: fallback, loadingText: loadingText, onMount: onMount, onUnmount: onUnmount, shouldFocus: shouldFocus })=>{
    const ref = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        if (shouldFocus) ref.current?.focus();
        onMount();
        return ()=>onUnmount();
    }, [
        onMount,
        onUnmount,
        shouldFocus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("span", {
        ref: ref,
        tabIndex: shouldFocus ? -1 : undefined,
        "data-testid": "popup-trigger-loading"
    }, fallback || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2dQZA.Loading), {
        loadingText: loadingText
    }));
};
$cec680bcf431381f$var$FallbackComponent.displayName = "FallbackComponent";
function $cec680bcf431381f$export$95d4acdbab2fc6ef({ trigger: trigger, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, errorText: errorText, errorTitle: errorTitle, onError: onError, forcedReportErrorUFO: forcedReportErrorUFO, onClose: onClose, preloadOnFocus: preloadOnFocus = true, autoFocus: autoFocus, loadingText: loadingText = 'Loading popup...', loadingCompleteText: loadingCompleteText = 'Loading is complete.', ...popupProps }) {
    const environmentProvider = (0, $cxpqA.useRelayEnvironmentProvider)();
    const id = (0, $euxye.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    const [content, setContent] = (0, $euxye.useState)(null);
    const { statusText: statusText, announce: announce, cancelPendingAnnouncement: cancelPendingAnnouncement, resetStatus: resetStatus } = (0, $5swv7.useStatusAnnouncement)();
    const isOpenRef = (0, $euxye.useRef)(false);
    const hasErrorRef = (0, $euxye.useRef)(false);
    const updateRef = (0, $euxye.useRef)(null);
    const setInitialFocusRef = (0, $euxye.useRef)(null);
    const handleError = (0, $euxye.useCallback)((props)=>{
        if ((0, $iqfTZ.fg)('platform_dst-a11y_accessible-error-popup') && isOpenRef.current) {
            hasErrorRef.current = true;
            resetStatus();
            announce({
                text: errorText ?? (0, $ddafa1647a1f54ed$export$73e31d6dbeb74c41),
                clearAfter: 5000
            });
        }
        onError?.(props);
    }, [
        announce,
        errorText,
        onError,
        resetStatus
    ]);
    const handleOpen = (0, $euxye.useCallback)(()=>{
        isOpenRef.current = true;
        setIsOpen(true);
    }, []);
    const handleClose = (0, $euxye.useCallback)((event, currentLevel)=>{
        isOpenRef.current = false;
        setIsOpen(false);
        if ((0, $iqfTZ.fg)('platform_dst-accessible-popup-loading') || (0, $iqfTZ.fg)('platform_dst-a11y_accessible-error-popup')) resetStatus();
        onClose?.(event, currentLevel);
    }, [
        onClose,
        resetStatus
    ]);
    const triggerCloseRef = (0, $3tWDX.useClickToCloseRef)({
        isOpen: isOpen,
        handleClose: handleClose
    });
    const load = (0, $euxye.useCallback)(()=>(0, $n67Vb.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $cec680bcf431381f$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const popupSetInitialFocusRef = (0, $euxye.useRef)(null);
    const handleSetInitialFocusRef = (0, $euxye.useCallback)((el)=>{
        popupSetInitialFocusRef.current?.(el);
    }, []);
    const onLoad = (0, $euxye.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        hasErrorRef.current = false;
        handleOpen();
        setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gAEFP.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: // when the fallback is unmounted we want to trigger an update to the popup position
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($cec680bcf431381f$var$FallbackComponent, {
                fallback: fallback,
                loadingText: loadingText,
                onMount: ()=>{
                    if ((0, $iqfTZ.fg)('platform_dst-accessible-popup-loading')) announce({
                        text: loadingText,
                        delay: 100
                    });
                },
                onUnmount: ()=>{
                    if ((0, $iqfTZ.fg)('platform_dst-accessible-popup-loading') && !hasErrorRef.current) {
                        const wasPending = cancelPendingAnnouncement();
                        if (!wasPending && isOpenRef.current) announce({
                            text: loadingCompleteText,
                            clearAfter: 5000
                        });
                    }
                    return updateRef.current?.();
                },
                shouldFocus: autoFocus !== false
            }),
            errorFallback: (props)=>errorFallback ? errorFallback(props) : (0, $iqfTZ.fg)('platform_dst-a11y_accessible-error-popup') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7PkIs.ErrorContent), {
                    errorTitle: errorTitle,
                    errorText: errorText ?? (0, $ddafa1647a1f54ed$export$73e31d6dbeb74c41)
                }) : null,
            runtimeProps: {
                ...entryPointProps ?? $cec680bcf431381f$var$emptyEntryPointProps,
                onContentResized: ()=>{
                    updateRef.current?.();
                },
                onClose: handleClose,
                ...(0, $iqfTZ.fg)('platform_dst-popup-trigger-initial-focus-ref') ? {
                    setInitialFocusRef: handleSetInitialFocusRef
                } : {}
            },
            onError: handleError,
            forcedError: forcedReportErrorUFO
        }), autoFocus !== false && ((0, $iqfTZ.fg)('platform_dst-popup-trigger-focus-container') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dqPCz.FocusOnContainerOnLoad), {
            entryPointReference: entryPointReference,
            setInitialFocusRef: setInitialFocusRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5eHXg.FocusInsideOnLoad), {
            entryPointReference: entryPointReference,
            setInitialFocusRef: setInitialFocusRef
        }))));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        fallback,
        forcedReportErrorUFO,
        errorFallback,
        errorText,
        errorTitle,
        handleOpen,
        handleError,
        announce,
        cancelPendingAnnouncement,
        handleClose,
        handleSetInitialFocusRef,
        autoFocus,
        loadingCompleteText,
        loadingText
    ]);
    const triggerRef = (0, $8EpkY.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const popupTrigger = (0, $euxye.useCallback)((triggerProps)=>{
        const mergedRef = (0, $50OIz.mergeRefs)([
            triggerRef,
            triggerProps.ref,
            triggerCloseRef
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef
        });
    }, [
        trigger,
        triggerRef,
        triggerCloseRef
    ]);
    const popupContent = (0, $euxye.useCallback)(({ update: update, setInitialFocusRef: setInitialFocusRef })=>{
        updateRef.current = update;
        if ((0, $iqfTZ.fg)('platform_dst-popup-trigger-initial-focus-ref')) popupSetInitialFocusRef.current = setInitialFocusRef;
        return content;
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4QBVk.Popup), {
        ...popupProps,
        autoFocus: autoFocus,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent
    }), (0, $iqfTZ.fg)('platform_dst-accessible-popup-loading') || (0, $iqfTZ.fg)('platform_dst-a11y_accessible-error-popup') ? // This is required because focus will not necessarily move into the
    // popup on mount during load, and there is not necessarily a focus
    // trap. Because of this, we need to have a live region to ensure
    // messaging comes across to the user. It also must be added on page
    // load for it to be read properly.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2Fuzd.StatusAnnouncement), null, statusText) : null);
}
$cec680bcf431381f$export$95d4acdbab2fc6ef.displayName = "PopupTrigger";

});
parcelRegister("7PkIs", function(module, exports) {
$parcel$export(module.exports, "ErrorContent", () => $19a6d21398e420b2$export$a9f602ed820d9782);
/* error-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $euxye = parcelRequire("euxye");

var $2iotI = parcelRequire("2iotI");

var $ah9qo = parcelRequire("ah9qo");

var $2XXtG = parcelRequire("2XXtG");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");
const $19a6d21398e420b2$var$styles = {
    errorContainer: "_4ouGXIoaux _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W"
};
function $19a6d21398e420b2$export$a9f602ed820d9782({ errorText: errorText, errorTitle: errorTitle }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.Flex), {
        justifyContent: "center",
        xcss: $19a6d21398e420b2$var$styles.errorContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.Stack), {
        space: "space.200"
    }, errorTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.Flex), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ah9qo))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "small",
        as: "h2"
    }, errorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.Text), {
        as: "p"
    }, errorText)));
}
$19a6d21398e420b2$export$a9f602ed820d9782.displayName = "ErrorContent";

});

parcelRegister("2Fuzd", function(module, exports) {
$parcel$export(module.exports, "StatusAnnouncement", () => $da53a334b2825d55$export$1144e05dc01c8ac);
/* status-announcement.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");

var $apUrw = parcelRequire("apUrw");
const $da53a334b2825d55$var$styles = {
    container: "_1mT5xdy1CL _2I62gzdnbC _3iC0zddnbC _39xV02dnbC _0jFU0VdnbC _1pp6NdYbGa"
};
function $da53a334b2825d55$export$1144e05dc01c8ac({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.Box), {
        xcss: $da53a334b2825d55$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $apUrw.default), {
        role: "status"
    }, children));
}
$da53a334b2825d55$export$1144e05dc01c8ac.displayName = "StatusAnnouncement";

});

parcelRegister("5swv7", function(module, exports) {
$parcel$export(module.exports, "useStatusAnnouncement", () => $6f96d4bd9054206f$export$f2e04a9fdd1a3236);

var $euxye = parcelRequire("euxye");
function $6f96d4bd9054206f$export$f2e04a9fdd1a3236() {
    const [statusText, setStatusText] = (0, $euxye.useState)('');
    const announceTimeout = (0, $euxye.useRef)(null);
    const clearTimeoutRef = (0, $euxye.useRef)(null);
    const cancelPendingAnnouncement = (0, $euxye.useCallback)(()=>{
        if (announceTimeout.current === null) return false;
        clearTimeout(announceTimeout.current);
        announceTimeout.current = null;
        return true;
    }, []);
    const cancelClear = (0, $euxye.useCallback)(()=>{
        if (clearTimeoutRef.current !== null) {
            clearTimeout(clearTimeoutRef.current);
            clearTimeoutRef.current = null;
        }
    }, []);
    const resetStatus = (0, $euxye.useCallback)(()=>{
        cancelPendingAnnouncement();
        cancelClear();
        setStatusText('');
    }, [
        cancelPendingAnnouncement,
        cancelClear
    ]);
    const announce = (0, $euxye.useCallback)(({ text: text, delay: delay = 0, clearAfter: clearAfter })=>{
        cancelPendingAnnouncement();
        cancelClear();
        const publish = ()=>{
            announceTimeout.current = null;
            setStatusText(text);
            if (clearAfter !== undefined) clearTimeoutRef.current = setTimeout(()=>{
                setStatusText('');
                clearTimeoutRef.current = null;
            }, clearAfter);
        };
        if (delay === 0) publish();
        else announceTimeout.current = setTimeout(publish, delay);
    }, [
        cancelPendingAnnouncement,
        cancelClear
    ]);
    (0, $euxye.useEffect)(()=>()=>{
            cancelPendingAnnouncement();
            cancelClear();
        }, [
        cancelPendingAnnouncement,
        cancelClear
    ]);
    return {
        statusText: statusText,
        announce: announce,
        cancelPendingAnnouncement: cancelPendingAnnouncement,
        resetStatus: resetStatus
    };
}

});

const $ddafa1647a1f54ed$export$73e31d6dbeb74c41 = 'Something went wrong while loading the popup content.';

parcelRegister("5eHXg", function(module, exports) {
$parcel$export(module.exports, "FocusInsideOnLoad", () => $38f67fb6d3ed89df$export$eb58c1f6b41ee511);

var $euxye = parcelRequire("euxye");

var $42lUo = parcelRequire("42lUo");

var $6UWFa = parcelRequire("6UWFa");
function $38f67fb6d3ed89df$export$eb58c1f6b41ee511({ entryPointReference: entryPointReference, setInitialFocusRef: setInitialFocusRef }) {
    const handleLoad = (0, $euxye.useCallback)((container)=>{
        // Focus the first focusable element of the loaded experience, or the
        // popup itself when the experience has nothing focusable in it.
        const target = (0, $42lUo.getFirstFocusable)({
            container: container
        }) ?? container;
        // The popup focuses its initial target once, when it opens. If that has
        // not happened yet — because the entry point was already loaded — this
        // makes the popup focus the target instead of itself, avoiding focus
        // moving twice.
        setInitialFocusRef.current?.(target);
        target.focus();
    }, [
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6UWFa.FocusOnLoad), {
        entryPointReference: entryPointReference,
        onLoad: handleLoad
    });
}
$38f67fb6d3ed89df$export$eb58c1f6b41ee511.displayName = "FocusInsideOnLoad";

});
parcelRegister("6UWFa", function(module, exports) {
$parcel$export(module.exports, "FocusOnLoad", () => $56e0b88c482ee297$export$192b96059b53397f);

var $euxye = parcelRequire("euxye");

var $gRxRH = parcelRequire("gRxRH");
function $56e0b88c482ee297$var$FocusOnLoadInner({ onLoad: onLoad }) {
    const anchorRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        // `Popup` does not expose a ref to the element wrapping its content, so
        // it is resolved through this anchor, which renders as a sibling of the
        // loaded experience inside that element.
        const container = anchorRef.current?.parentElement;
        if (container) onLoad(container);
    }, [
        onLoad
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("span", {
        ref: anchorRef,
        hidden: true
    });
}
$56e0b88c482ee297$var$FocusOnLoadInner.displayName = "FocusOnLoadInner";
function $56e0b88c482ee297$export$192b96059b53397f({ entryPointReference: entryPointReference, onLoad: onLoad }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gRxRH.WaitForEntryPointLoad), {
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($56e0b88c482ee297$var$FocusOnLoadInner, {
        onLoad: onLoad
    }));
}
$56e0b88c482ee297$export$192b96059b53397f.displayName = "FocusOnLoad";

});


parcelRegister("dqPCz", function(module, exports) {
$parcel$export(module.exports, "FocusOnContainerOnLoad", () => $200cf2365cc7e45e$export$82324a1aa77ecbcc);

var $euxye = parcelRequire("euxye");

var $6UWFa = parcelRequire("6UWFa");
function $200cf2365cc7e45e$export$82324a1aa77ecbcc({ entryPointReference: entryPointReference, setInitialFocusRef: setInitialFocusRef }) {
    const handleLoad = (0, $euxye.useCallback)((container)=>{
        setInitialFocusRef.current?.(container);
        container.focus();
    }, [
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6UWFa.FocusOnLoad), {
        entryPointReference: entryPointReference,
        onLoad: handleLoad
    });
}
$200cf2365cc7e45e$export$82324a1aa77ecbcc.displayName = "FocusOnContainerOnLoad";

});

parcelRegister("2dQZA", function(module, exports) {
$parcel$export(module.exports, "Loading", () => $a5bd38766d3f80af$export$669f6ea7d267feaf);

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $c69sa = parcelRequire("c69sa");

var $fbAgj = parcelRequire("fbAgj");

var $abhF2 = parcelRequire("abhF2");

var $3HFPs = parcelRequire("3HFPs");
const $a5bd38766d3f80af$var$spinnerContainerStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
function $a5bd38766d3f80af$export$669f6ea7d267feaf({ loadingText: loadingText }) {
    if ((0, $iqfTZ.fg)('platform_dst-accessible-popup-loading')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.Box), {
        xcss: $a5bd38766d3f80af$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3HFPs.LoadingContent), {
        loadingText: loadingText ?? 'Loading popup...',
        size: "small"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), null);
}
$a5bd38766d3f80af$export$669f6ea7d267feaf.displayName = "Loading";

});

parcelRegister("3tWDX", function(module, exports) {
$parcel$export(module.exports, "useClickToCloseRef", () => $65276d78c7ab1cf7$export$46ec6629f411921d);

var $euxye = parcelRequire("euxye");
function $65276d78c7ab1cf7$export$46ec6629f411921d({ isOpen: isOpen, handleClose: handleClose }) {
    const ref = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const clickListener = ()=>{
            if (isOpen) handleClose(null);
        };
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('click', clickListener);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            el.removeEventListener('click', clickListener);
        };
    }, [
        isOpen,
        handleClose
    ]);
    return ref;
}

});


parcelRegister("dxwgr", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", () => $f46f2ff648a52daa$export$8d789f76fde3e05);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30c7e77d0c70a3a1f66632de11893604>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ed9Xn = parcelRequire("ed9Xn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $f46f2ff648a52daa$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
function $f46f2ff648a52daa$export$8d789f76fde3e05({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ed9Xn.IconWrapper), {
        svg: $f46f2ff648a52daa$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$f46f2ff648a52daa$export$8d789f76fde3e05.displayName = "LoomIcon";

});

parcelRegister("aej1R", function(module, exports) {
$parcel$export(module.exports, "generateTheme", () => $5410b6e05f234170$export$2e4ecffaca289a18);

var $2rchq = parcelRequire("2rchq");

var $lDm5j = parcelRequire("lDm5j");

var $ln8EF = parcelRequire("ln8EF");

var $4Y0yk = parcelRequire("4Y0yk");

var $fFefw = parcelRequire("fFefw");

var $2fTHB = parcelRequire("2fTHB");
const $5410b6e05f234170$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $5410b6e05f234170$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $5410b6e05f234170$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $2fTHB.hexToRGBA)(backgroundColor, 0.65) : (0, $fFefw.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $4Y0yk.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $4Y0yk.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $2fTHB.hexToRGBA)(backgroundColor, 0.8) : (0, $fFefw.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $4Y0yk.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $fFefw.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $4Y0yk.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $fFefw.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $4Y0yk.getBoxShadow)('transparent')
        }
    };
};
const $5410b6e05f234170$var$generateCreateButtonColors = (_themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $ln8EF.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $5410b6e05f234170$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $ln8EF.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $2rchq.DEFAULT_THEME_NAME)) return 0, $lDm5j.defaultThemeBrandRefresh;
    return {
        mode: {
            create: $5410b6e05f234170$var$generateButtonCSSStates($5410b6e05f234170$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $5410b6e05f234170$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $5410b6e05f234170$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: `${"var(--ds-border-width, 1px)"} solid ${(0, $2fTHB.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $2fTHB.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $2fTHB.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $4Y0yk.getBoxShadow)((0, $2fTHB.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $fFefw.getContrastColor)(0.1, $5410b6e05f234170$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};

});
parcelRegister("2rchq", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_THEME_NAME", () => $8eba6e021e06ad64$export$2491e13b198e597d);
$parcel$export(module.exports, "default", () => $8eba6e021e06ad64$export$2e2bcd8739ae039);
const $8eba6e021e06ad64$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $8eba6e021e06ad64$var$defaultThemeCopy = JSON.parse(JSON.stringify($8eba6e021e06ad64$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$8eba6e021e06ad64$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$8eba6e021e06ad64$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $8eba6e021e06ad64$export$2491e13b198e597d = 'atlassian';
var $8eba6e021e06ad64$export$2e2bcd8739ae039 = $8eba6e021e06ad64$var$defaultTheme;

});

parcelRegister("lDm5j", function(module, exports) {
$parcel$export(module.exports, "defaultThemeBrandRefresh", () => $120c54984b59046f$export$77823bc9863eaa03);

var $2rchq = parcelRequire("2rchq");
const $120c54984b59046f$var$defaultThemeCopy = JSON.parse(JSON.stringify((0, $2rchq.default)));
const $120c54984b59046f$export$77823bc9863eaa03 = $120c54984b59046f$var$defaultThemeCopy;

});

parcelRegister("ln8EF", function(module, exports) {
$parcel$export(module.exports, "generateTextColor", () => $1d9d28e4a98cfb16$export$10a10e7cd1193377);

var $38a02 = parcelRequire("38a02");

var $11a8C = parcelRequire("11a8C");
const $1d9d28e4a98cfb16$export$10a10e7cd1193377 = (color)=>{
    const converted = (0, $11a8C.convertHexShorthand)(color);
    return (0, $38a02.default).contrastRatio(converted).hex;
};

});
parcelRegister("11a8C", function(module, exports) {
$parcel$export(module.exports, "convertHexShorthand", () => $3e5b4f1674bc2a72$export$db8d2130677f868c);
const $3e5b4f1674bc2a72$var$hex = '[a-z0-9]';
const $3e5b4f1674bc2a72$var$shortHandHexColorPattern = new RegExp(`#(${$3e5b4f1674bc2a72$var$hex})(${$3e5b4f1674bc2a72$var$hex})(${$3e5b4f1674bc2a72$var$hex})`, 'i');
const $3e5b4f1674bc2a72$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $3e5b4f1674bc2a72$var$isShortHexColor = (color)=>color && color.length === 4;
const $3e5b4f1674bc2a72$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$3e5b4f1674bc2a72$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $3e5b4f1674bc2a72$var$completeTriplet = (colors)=>`#${$3e5b4f1674bc2a72$var$repeat(colors[1], 6)}`;
const $3e5b4f1674bc2a72$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $3e5b4f1674bc2a72$export$db8d2130677f868c = (color)=>{
    if ($3e5b4f1674bc2a72$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($3e5b4f1674bc2a72$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($3e5b4f1674bc2a72$var$isTriplet(colors)) return $3e5b4f1674bc2a72$var$completeTriplet(colors);
            else return $3e5b4f1674bc2a72$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};

});


parcelRegister("4Y0yk", function(module, exports) {
$parcel$export(module.exports, "getBoxShadow", () => $5aec68a74d238f83$export$bba5a971afe05444);
const $5aec68a74d238f83$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;

});

parcelRegister("fFefw", function(module, exports) {
$parcel$export(module.exports, "getContrastColor", () => $0358b89fd6306cc9$export$77a1051494882576);

var $38a02 = parcelRequire("38a02");

var $2fTHB = parcelRequire("2fTHB");
const $0358b89fd6306cc9$export$77a1051494882576 = (contrastValue, opacityValue, color)=>(0, $2fTHB.hexToRGBA)((0, $38a02.default).contrast(contrastValue, color).hex, opacityValue);

});
parcelRegister("2fTHB", function(module, exports) {
$parcel$export(module.exports, "hexToRGBA", () => $3952051747ca9ed6$export$7229be6d7219ee6a);

var $38a02 = parcelRequire("38a02");
const $3952051747ca9ed6$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $38a02.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};

});



parcelRegister("9iQvp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aff96bcfcadf44a79300107c56beac1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c5e86032283c821$var$_react = $6c5e86032283c821$var$_interopRequireDefault((parcelRequire("euxye")));

var $6c5e86032283c821$var$_iconNew = $6c5e86032283c821$var$_interopRequireDefault((parcelRequire("52mjj")));
function $6c5e86032283c821$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsGraph".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/assets-graph
 * Usage guidance:
 * Reserved for representing Assets graph
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6c5e86032283c821$var$AssetsGraphIcon = (props)=>/*#__PURE__*/ $6c5e86032283c821$var$_react.default.createElement($6c5e86032283c821$var$_iconNew.default, Object.assign({
        name: "AssetsGraphIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.78 4.28-1.833 1.832a3.5 3.5 0 0 1 0 3.774l1.833 1.834-1.06 1.06-1.833-1.833a3.5 3.5 0 0 1-3.775 0L4.28 12.78l-1.06-1.06 1.832-1.834a3.5 3.5 0 0 1 0-3.774L3.22 4.28l1.06-1.06 1.832 1.832a3.5 3.5 0 0 1 3.775 0l1.833-1.833zM9.414 6.586a2 2 0 1 0-2.828 2.827 2 2 0 0 0 2.828-2.827"/><path fill="currentcolor" d="M11.73.73a2.5 2.5 0 1 1 3.54 3.54A2.5 2.5 0 0 1 11.73.73m2.48 1.06A1 1 0 1 0 12.8 3.2a1 1 0 0 0 1.41-1.41m-2.48 9.94a2.5 2.5 0 1 1 3.54 3.54 2.5 2.5 0 0 1-3.54-3.53m2.48 1.06a1 1 0 1 0-1.41 1.42 1 1 0 0 0 1.41-1.41M.73.73a2.5 2.5 0 1 1 3.54 3.54A2.5 2.5 0 0 1 .73.73m2.48 1.06A1 1 0 1 0 1.8 3.21 1 1 0 0 0 3.21 1.8M.73 11.73a2.5 2.5 0 1 1 3.54 3.54 2.5 2.5 0 0 1-3.54-3.53m2.48 1.06a1 1 0 1 0-1.41 1.42 1 1 0 0 0 1.41-1.41"/>`
    }, props));
$6c5e86032283c821$var$AssetsGraphIcon.displayName = 'AssetsGraphIcon';
var $6c5e86032283c821$var$_default = module.exports.default = $6c5e86032283c821$var$AssetsGraphIcon;

});

parcelRegister("3Ihgk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::630f7862dea052120b01b06315f58212>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b42df1777396144$var$_react = $2b42df1777396144$var$_interopRequireDefault((parcelRequire("euxye")));

var $2b42df1777396144$var$_iconNew = $2b42df1777396144$var$_interopRequireDefault((parcelRequire("52mjj")));
function $2b42df1777396144$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/spaces
 * Usage guidance:
 * Reserved for use for Jira Projects for now. This will replace the Jira rocket.
 * 
 * More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2b42df1777396144$var$SpacesIcon = (props)=>/*#__PURE__*/ $2b42df1777396144$var$_react.default.createElement($2b42df1777396144$var$_iconNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.497A5.98 5.98 0 0 1 11 13.196a5.98 5.98 0 0 1-4.608.584 29.4 29.4 0 0 0 3.858-1.882 29.4 29.4 0 0 0 3.559-2.401"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.424 2.308-.447.377-.013.751.017 1.083.126.338.111.678.32.888.685.354.613.152 1.296-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.396c-.444.413-.954.837-1.517 1.263a29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.581c-.65.275-1.272.505-1.85.683h-.003q-.28.087-.548.158c-.783.206-1.511.318-2.116.288-.505-.024-1.114-.161-1.49-.63l-.052-.068-.07-.11-.07-.138a1.6 1.6 0 0 1-.078-.973c.071-.342.231-.68.431-1 .35-.56.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.5a6 6 0 0 0-.698.878c-.147.235-.213.407-.236.516l-.004.046c.048.022.155.056.37.066.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34a4.5 4.5 0 0 0 1.24 2.396C5.986 10.743 7.347 10.11 8.75 9.3s2.63-1.673 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36c-.306.01-.68.066-1.111.165q.233.306.432.648.196.341.342.695c.394-.424.665-.789.816-1.081.098-.192.121-.302.127-.355l-.041-.018c-.106-.035-.288-.063-.565-.054" clip-rule="evenodd"/>`
    }, props));
$2b42df1777396144$var$SpacesIcon.displayName = 'SpacesIcon';
var $2b42df1777396144$var$_default = module.exports.default = $2b42df1777396144$var$SpacesIcon;

});

parcelRegister("7ptGn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bbe3107b8dcb4caf83567322ed86022>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5651e483f1b5d4c0$var$_react = $5651e483f1b5d4c0$var$_interopRequireDefault((parcelRequire("euxye")));

var $5651e483f1b5d4c0$var$_iconNew = $5651e483f1b5d4c0$var$_interopRequireDefault((parcelRequire("52mjj")));
function $5651e483f1b5d4c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sunset".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/sunset
 * Usage guidance:
 * Farewell feed in hello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5651e483f1b5d4c0$var$SunsetIcon = (props)=>/*#__PURE__*/ $5651e483f1b5d4c0$var$_react.default.createElement($5651e483f1b5d4c0$var$_iconNew.default, Object.assign({
        name: "SunsetIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v2h-1.5V1zm3 2.845 1.414-1.415 1.06 1.061-1.413 1.414zm-8.586 1.07L1.75 3.5l1.06-1.06 1.415 1.414zM8 6a3 3 0 0 0-3 3H3.5a4.5 4.5 0 0 1 9 0H11a3 3 0 0 0-3-3M2 9H0V7.5h2zm14 0h-2V7.5h2zm-1 3H1v-1.5h14zm-4.5 1.5V15h-5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$5651e483f1b5d4c0$var$SunsetIcon.displayName = 'SunsetIcon';
var $5651e483f1b5d4c0$var$_default = module.exports.default = $5651e483f1b5d4c0$var$SunsetIcon;

});

parcelRegister("2DwQR", function(module, exports) {
$parcel$export(module.exports, "GoalsIcon", () => $f5d98936ef3f9f2f$export$9eb74917ea768ed4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c4362ec97402bb58da4aa4719b522f90>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ed9Xn = parcelRequire("ed9Xn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $f5d98936ef3f9f2f$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>
</svg>
`;
function $f5d98936ef3f9f2f$export$9eb74917ea768ed4({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Goals', testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ed9Xn.IconWrapper), {
        svg: $f5d98936ef3f9f2f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$f5d98936ef3f9f2f$export$9eb74917ea768ed4.displayName = "GoalsIcon";

});

parcelRegister("lukJ3", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", () => $cce7fc76c61ed65b$export$eeccc49dc7a12d9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97b6247692aeac56aeb21bd6a8750acc>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ed9Xn = parcelRequire("ed9Xn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $cce7fc76c61ed65b$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848"/>
</svg>
`;
function $cce7fc76c61ed65b$export$eeccc49dc7a12d9f({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Opsgenie', testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ed9Xn.IconWrapper), {
        svg: $cce7fc76c61ed65b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$cce7fc76c61ed65b$export$eeccc49dc7a12d9f.displayName = "OpsgenieIcon";

});

parcelRegister("luTry", function(module, exports) {
$parcel$export(module.exports, "TeamsIcon", () => $e11a1d1ec04ccd0b$export$1bcbc9c337da86da);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f5210074a380dcd268126674dc826a2>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ed9Xn = parcelRequire("ed9Xn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $e11a1d1ec04ccd0b$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63"/>
</svg>
`;
function $e11a1d1ec04ccd0b$export$1bcbc9c337da86da({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Teams', testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ed9Xn.IconWrapper), {
        svg: $e11a1d1ec04ccd0b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$e11a1d1ec04ccd0b$export$1bcbc9c337da86da.displayName = "TeamsIcon";

});

parcelRegister("egS0f", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $5bbebed71486529f$export$21bfbeb62fdcce8d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29e2c6af008db660c9f38b0bce4ff4cc>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ed9Xn = parcelRequire("ed9Xn");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $5bbebed71486529f$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>
</svg>
`;
const $5bbebed71486529f$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>
</svg>
`;
function $5bbebed71486529f$export$21bfbeb62fdcce8d({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Product Discovery', testId: testId }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ed9Xn.IconWrapper), {
        svg: $5bbebed71486529f$var$svg,
        customThemeSvg: $5bbebed71486529f$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$5bbebed71486529f$export$21bfbeb62fdcce8d.displayName = "JiraProductDiscoveryIcon";

});

parcelRegister("5GK0n", function(module, exports) {
$parcel$export(module.exports, "default", () => $0eebb608f59e2593$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $0eebb608f59e2593$var$bgColorCssVar = '--avatar-skeleton-background-color';
const $0eebb608f59e2593$var$styles = {
    root: "_0bjKvDaaQb _2V7sgO2M4S _3hxITi6wH8 _3vBAKHs4Fm _3iDTPbvbI6 _0KLXruNaal _1YKVNs4ERJ",
    square: "_0bjKvD0O7w",
    hexagon: "_1uo2ZfTcEg",
    strongOpacity: "_1YKVNsy8LG"
};
const $0eebb608f59e2593$var$sizeStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02ey7F _0jFU0Vey7F",
    UNSAFE_xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f",
    xlarge: "_39xV02JgOI _0jFU0VJgOI",
    xxlarge: "_39xV02NNui _0jFU0VNNui"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $0eebb608f59e2593$var$Skeleton = ({ size: size, appearance: appearance = 'circle', color: color, weight: weight })=>{
    const avatarSize = size ?? 'medium';
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        style: {
            [$0eebb608f59e2593$var$bgColorCssVar]: color ?? 'currentColor'
        },
        className: (0, $4jQY2.default)([
            $0eebb608f59e2593$var$styles.root,
            $0eebb608f59e2593$var$sizeStyles[avatarSize],
            appearance === 'square' && $0eebb608f59e2593$var$styles.square,
            appearance === 'hexagon' && $0eebb608f59e2593$var$styles.hexagon,
            weight === 'strong' && $0eebb608f59e2593$var$styles.strongOpacity
        ])
    });
};
$0eebb608f59e2593$var$Skeleton.displayName = "Skeleton";
var $0eebb608f59e2593$export$2e2bcd8739ae039 = $0eebb608f59e2593$var$Skeleton;

});

parcelRegister("fTB7r", function(module, exports) {
$parcel$export(module.exports, "useOverflowStatus", () => $6f18756749e9b937$export$3fcfc71fab3314f2);

var $euxye = parcelRequire("euxye");

var $edAW8 = parcelRequire("edAW8");
const $6f18756749e9b937$export$3fcfc71fab3314f2 = ()=>(0, $euxye.useContext)((0, $edAW8.OverflowContext));

});
parcelRegister("edAW8", function(module, exports) {
$parcel$export(module.exports, "OverflowContext", () => $2373fa0e5af9fa0f$export$79f16dd643143c25);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");
const $2373fa0e5af9fa0f$export$79f16dd643143c25 = /*#__PURE__*/ (0, $euxye.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $2oRWW.default),
    closeOverflowMenu: (0, $2oRWW.default)
});

});


parcelRegister("6HijD", function(module, exports) {
$parcel$export(module.exports, "AppSwitcher", () => $c59f5e2d0d2fb6e8$export$9923361bd43fa030);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $63GEN = parcelRequire("63GEN");

var $iqfTZ = parcelRequire("iqfTZ");

var $fX8LH = parcelRequire("fX8LH");
const $c59f5e2d0d2fb6e8$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
const $c59f5e2d0d2fb6e8$export$9923361bd43fa030 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, interactionName: interactionName, isSelected: isSelected, testId: testId, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const pickedAppSwitcherIcon = (0, $iqfTZ.fg)('platform_dst_ads_appswitcher_improvements') ? icon ?? (0, (/*@__PURE__*/$parcel$interopDefault($63GEN))) : (0, (/*@__PURE__*/$parcel$interopDefault($63GEN)));
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fX8LH.IconButton), {
        ref: ref,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        icon: pickedAppSwitcherIcon,
        label: label,
        appearance: "subtle",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        interactionName: interactionName,
        isTooltipDisabled: false,
        tooltip: $c59f5e2d0d2fb6e8$var$toggleButtonTooltipOptions,
        isSelected: isSelected,
        testId: testId
    });
});

});

parcelRegister("jleyn", function(module, exports) {
$parcel$export(module.exports, "SpotlightPrimaryLink", () => $486807fbc34f37f5$export$82ba9bc832fb64);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1MNmN = parcelRequire("1MNmN");

var $9MWap = parcelRequire("9MWap");
var $8Sdzy = parcelRequire("8Sdzy");
const $486807fbc34f37f5$var$styles = {
    root: "_0bjKvDKxmn _24h04i2Njc _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYze5R3",
    outline: "_00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _3hxITi6wH8 _2V7sgONvrM _3vBAKHFIvx _2Y7lL4gVvo _0KLXrugozt _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _1eOmH6kTlo _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8 _3gzVzLVbka",
    primary: "_00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _3hxITi6wH8 _2V7sgONvrM _3vBAKHJrlu _2Y7lL4gVvo _0KLXruDM2k _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _1eOmH6hmrj _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8 _3gzVzLczkD"
};
const $486807fbc34f37f5$export$82ba9bc832fb64 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId, appearance: appearance = 'outline', href: href, target: target, rel: rel }, ref)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $9MWap.Anchor), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: (0, $1MNmN.cx)($486807fbc34f37f5$var$styles.root, $486807fbc34f37f5$var$styles[appearance]),
        href: href,
        target: target,
        rel: rel,
        onClick: onClick ? (e, _analyticsEvent)=>onClick(e) : undefined,
        componentName: "SpotlightPrimaryLink",
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
            as: "span",
            children: children
        })
    }));

});

parcelRegister("54AB6", function(module, exports) {
$parcel$export(module.exports, "SpotlightSecondaryLink", () => $d6cf0273e7f410fb$export$797d360648cfd970);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $9MWap = parcelRequire("9MWap");
var $8Sdzy = parcelRequire("8Sdzy");
const $d6cf0273e7f410fb$var$styles = {
    root: "_0bjKvDKxmn _00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _2Y7lL4gVvo _4c065UFQfX _24h04i2Njc _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYze5R3 _0KLXrugozt _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _1eOmH6kTlo _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8 _3gzVzLVbka"
};
const $d6cf0273e7f410fb$export$797d360648cfd970 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId, href: href, target: target, rel: rel }, ref)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $9MWap.Anchor), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $d6cf0273e7f410fb$var$styles.root,
        href: href,
        target: target,
        rel: rel,
        onClick: onClick ? (e, _analyticsEvent)=>onClick(e) : undefined,
        componentName: "SpotlightSecondaryLink",
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
            as: "span",
            children: children
        })
    }));

});

parcelRegister("eRc9j", function(module, exports) {
$parcel$export(module.exports, "Aside", () => $0ba83f47a4ce8bdc$export$ac3bdfe4cb17f64e);
/* aside.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $gQ56h = parcelRequire("gQ56h");

var $iqfTZ = parcelRequire("iqfTZ");

var $dS3O2 = parcelRequire("dS3O2");

var $iFrrF = parcelRequire("iFrrF");

var $iFgsS = parcelRequire("iFgsS");

var $ccSgQ = parcelRequire("ccSgQ");

var $jqXzh = parcelRequire("jqXzh");

var $gBHrf = parcelRequire("gBHrf");

var $baSqD = parcelRequire("baSqD");

var $2q8Af = parcelRequire("2q8Af");
const $0ba83f47a4ce8bdc$var$panelSplitterResizingVar = '--n_asdRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $0ba83f47a4ce8bdc$var$asideWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $0ba83f47a4ce8bdc$var$asideWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
function $0ba83f47a4ce8bdc$var$getResizeBounds() {
    return $0ba83f47a4ce8bdc$var$asideWidthResizeBounds;
}
const $0ba83f47a4ce8bdc$var$styles = {
    root: "_1xC2CJjgYz _24h04i2Njc _1mT5xdRAKS _15X6Mhduac _1xHhlhF05b",
    inner: "_4bt5LAIZbP _2WAcuGIZbP _2I62gzgiHs _0jFU0VN91d _2MwU8rlOMI _2DiRUzHE3j"
};
const $0ba83f47a4ce8bdc$var$fallbackDefaultWidth = 330;
function $0ba83f47a4ce8bdc$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, defaultWidth: defaultWidthProp = $0ba83f47a4ce8bdc$var$fallbackDefaultWidth, label: label = 'Aside', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $euxye.useContext)((0, $ccSgQ.DangerouslyHoistSlotSizes));
    const id = (0, $gBHrf.useLayoutId)({
        providedId: providedId
    });
    const defaultWidth = (0, $2q8Af.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $0ba83f47a4ce8bdc$var$fallbackDefaultWidth,
        slotName: 'Aside'
    });
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   *
   * TODO: when cleaning up 'platform_dst_nav4_skip_link_a11y_1' remove this call entirely
   */ (0, $dS3O2.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0 || (0, $iqfTZ.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    const ref = (0, $euxye.useRef)(null);
    const [width, setWidth] = (0, $euxye.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const previousWidthProp = (0, $gQ56h.default)(defaultWidth);
    /**
   * Updates the width state based on changes to `defaultWidth`.
   * This is temporary and needed to support the current usage in Jira, and will be removed once it is no longer needed.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $euxye.useEffect)(()=>{
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    // Putting the warning in a separate effect to avoid adding `previousWidthProp` as an effect dependency when updating width.
    (0, $euxye.useEffect)(()=>{}, [
        defaultWidth,
        previousWidthProp
    ]);
    const asideVariableWidth = `clamp(${$0ba83f47a4ce8bdc$var$asideWidthSlotBounds.min}, ${width}px, ${$0ba83f47a4ce8bdc$var$asideWidthSlotBounds.max})`;
    (0, $baSqD.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes,
        panelId: (0, $iFrrF.asidePanelSplitterId),
        cssVar: $0ba83f47a4ce8bdc$var$panelSplitterResizingVar
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("aside", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $4jQY2.default)([
            $0ba83f47a4ce8bdc$var$styles.root,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            [(0, $iFrrF.asideVar)]: asideVariableWidth
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iFgsS.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $iFrrF.UNSAFE_asideLayoutVar),
                value: "0px",
                mediaQuery: '@media (min-width: 64rem)',
                responsiveValue: `var(${$0ba83f47a4ce8bdc$var$panelSplitterResizingVar}, ${asideVariableWidth})`
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jqXzh.PanelSplitterProvider), {
                panelId: (0, $iFrrF.asidePanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $0ba83f47a4ce8bdc$var$getResizeBounds,
                resizingCssVar: $0ba83f47a4ce8bdc$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    "data-testid": testId ? `${testId}--inner` : undefined,
                    className: (0, $4jQY2.default)([
                        $0ba83f47a4ce8bdc$var$styles.inner
                    ]),
                    children: children
                })
            })
        ]
    });
}
$0ba83f47a4ce8bdc$export$ac3bdfe4cb17f64e.displayName = "Aside";

});

parcelRegister("5Km63", function(module, exports) {
$parcel$export(module.exports, "Banner", () => $d8baff67398b39e6$export$3b4e64e77073e307);
/* banner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $iqfTZ = parcelRequire("iqfTZ");

var $dS3O2 = parcelRequire("dS3O2");

var $av7P9 = parcelRequire("av7P9");

var $iFrrF = parcelRequire("iFrrF");

var $iFgsS = parcelRequire("iFgsS");

var $ekaNt = parcelRequire("ekaNt");

var $ccSgQ = parcelRequire("ccSgQ");

var $gBHrf = parcelRequire("gBHrf");
const $d8baff67398b39e6$var$styles = {
    root: "_1xC2CJweDq _4bt5LAnQyn _2WAcuGnQyn _0jFU0V9QlX _2I62gzdnbC _1mT5xdHE3j _42Yu6B8OLE",
    fullHeightSidebar: "_42Yu6B7LI7"
};
function $d8baff67398b39e6$export$3b4e64e77073e307({ children: children, xcss: xcss, height: // 48px has been chosen to align with the height of the Banner component from `@atlaskit/banner`.
height = 48, skipLinkLabel: skipLinkLabel = 'Banner', testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $euxye.useContext)((0, $ccSgQ.DangerouslyHoistSlotSizes));
    const id = (0, $gBHrf.useLayoutId)({
        providedId: providedId
    });
    const isFhsEnabled = (0, $av7P9.useIsFhsEnabled)();
    /**
   * Don't show the skip link if the slot has 0 height.
   *
   * TODO: when cleaning up 'platform_dst_nav4_skip_link_a11y_1' remove this call entirely
   */ (0, $dS3O2.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: height === 0 || (0, $iqfTZ.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $4jQY2.default)([
            $d8baff67398b39e6$var$styles.root,
            isFhsEnabled && $d8baff67398b39e6$var$styles.fullHeightSidebar,
            xcss
        ]),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ekaNt.HoistCssVarToLocalGrid), {
                variableName: (0, $iFrrF.bannerMountedVar),
                value: height
            }),
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iFgsS.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $iFrrF.UNSAFE_bannerVar),
                value: height
            }),
            children
        ]
    });
}
$d8baff67398b39e6$export$3b4e64e77073e307.displayName = "Banner";

});
parcelRegister("ekaNt", function(module, exports) {
$parcel$export(module.exports, "HoistCssVarToLocalGrid", () => $c79d6f0744a21518$export$cfa3cd08d675e56e);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $17vVh = parcelRequire("17vVh");
const $c79d6f0744a21518$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>/*#__PURE__*/ (0, $e79Pd.jsx)("style", {
        children: `#${(0, $17vVh.gridRootId)} { ${variableName}: ${value}px }`
    });
$c79d6f0744a21518$export$cfa3cd08d675e56e.displayName = "HoistCssVarToLocalGrid";

});
parcelRegister("17vVh", function(module, exports) {
$parcel$export(module.exports, "gridRootId", () => $320ba306ae34aeeb$export$a6d827031bcb31d1);
$parcel$export(module.exports, "Root", () => $320ba306ae34aeeb$export$be92b6f5f03c0fe9);
/* root.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $doztG = parcelRequire("doztG");

var $iqfTZ = parcelRequire("iqfTZ");

var $fImBI = parcelRequire("fImBI");

var $3b9sC = parcelRequire("3b9sC");

var $ccSgQ = parcelRequire("ccSgQ");

var $59nHb = parcelRequire("59nHb");

var $8fnEd = parcelRequire("8fnEd");

var $fMNaB = parcelRequire("fMNaB");

var $1Ylwq = parcelRequire("1Ylwq");

var $4JZFE = parcelRequire("4JZFE");
const $320ba306ae34aeeb$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
const $320ba306ae34aeeb$var$styles = {
    legacyRoot: "_3iDTPbgBM8 _4kiQYAWP8C _3NN0tOsKlt _2iEGP28wUV _0ca6V72ulg _2xgI2Ymk5d _2yz9PXk6i4 _4cQPhCuAep _2dnLWx2dcB _1h2oUBk6i4 _1YDlQuSe0G",
    root: "_3e862PzZoh _3iDTPbgBM8 _4kiQYAWP8C _3NN0tOsKlt _2iEGP28wUV _0ca6V72ulg _2wGBBqwhpO _0sNGaG6Zsx _2xgI2Y0gUc _2yz9PXk6i4 _4cQPhCjX3G _2dnLWxRpCc _1YDlQu70dD",
    safetyRail: "_3cypjiOiJt",
    safetyRailWithTopLayer: "_4lA8aSOiJt",
    panelUplift: "_4bt5LAoWuR _2WAcuGoWuR"
};
function $320ba306ae34aeeb$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = (0, $iqfTZ.fg)('platform_dst_nav4_skip_link_a11y_1') ? 'Skip to' : 'Skip to:', skipLinksTriggerLabel: skipLinksTriggerLabel = 'Skip to', testId: testId, defaultSideNavCollapsed: defaultSideNavCollapsed, isSideNavShortcutEnabled: isSideNavShortcutEnabled = false }) {
    const ref = (0, $euxye.useRef)(null);
    const isChatPanelLayoutEnabled = (0, $iqfTZ.fg)('platform-dst-chat-panel-layout');
    const LayoutProvider = isChatPanelLayoutEnabled ? (0, $59nHb.LayoutAreaSizingProvider) : (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment;
    (0, $euxye.useEffect)(()=>{}, []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4JZFE.SideNavVisibilityProvider), {
        defaultCollapsed: defaultSideNavCollapsed,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1Ylwq.SideNavToggleButtonProvider), {
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fMNaB.SideNavElementProvider), {
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8fnEd.IsSideNavShortcutEnabledProvider), {
                    isSideNavShortcutEnabled: isSideNavShortcutEnabled,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3b9sC.TopNavStartProvider), {
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)(LayoutProvider, {
                            ...isChatPanelLayoutEnabled ? {
                                layoutRef: ref
                            } : {},
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $doztG.OpenLayerObserver), {
                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ccSgQ.DangerouslyHoistSlotSizes).Provider, {
                                    value: UNSAFE_dangerouslyHoistSlotSizes,
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fImBI.SkipLinksProvider), {
                                        label: skipLinksLabel,
                                        triggerLabel: skipLinksTriggerLabel,
                                        testId: testId,
                                        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                                            ref: ref,
                                            className: (0, $4jQY2.default)([
                                                isChatPanelLayoutEnabled ? $320ba306ae34aeeb$var$styles.root : $320ba306ae34aeeb$var$styles.legacyRoot,
                                                (0, $iqfTZ.fg)('platform-dst-motion-uplift-panel') && $320ba306ae34aeeb$var$styles.panelUplift,
                                                (0, $iqfTZ.fg)('platform-dst-top-layer') ? $320ba306ae34aeeb$var$styles.safetyRailWithTopLayer : $320ba306ae34aeeb$var$styles.safetyRail,
                                                xcss
                                            ]),
                                            id: $320ba306ae34aeeb$export$a6d827031bcb31d1,
                                            "data-testid": testId,
                                            children: children
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
}
$320ba306ae34aeeb$export$be92b6f5f03c0fe9.displayName = "Root";

});
parcelRegister("doztG", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserver", () => $8ef53a3c16932c1f$export$97afddda23bcd287);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");

var $jAinK = parcelRequire("jAinK");
/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ const $8ef53a3c16932c1f$var$noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function $8ef53a3c16932c1f$var$getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce((acc, listeners)=>acc + listeners.size, 0);
}
/**
 * Returns the number of layers in the set that match the type filter.
 */ function $8ef53a3c16932c1f$var$getLayerCountWithFilter({ layers: layers, type: type }) {
    return Array.from(layers.values()).filter((layer)=>layer.type === type).length;
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function $8ef53a3c16932c1f$var$getListeners({ registry: registry, namespace: namespace }) {
    // 1. If there are existing listeners for this namespace, return the existing set.
    const existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    const newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $8ef53a3c16932c1f$var$createInternalAPI() {
    /**
	 * The layer count change listeners for each namespace.
	 */ const namespaceToChangeListenerRegistry = new Map();
    /**
	 * The registered layers for each namespace.
	 * Each layer registers with an `onClose` callback, and optionally with a layer type (`type`).
	 * **When the layer is open**, its `onClose`
	 * callback is registered in this set along with its type.
	 *
	 * This data structure is also used determine the number of open layers.
	 */ const namespaceToLayerRegistry = new Map();
    /**
	 * Calls the appropriate layer count change listeners after the number of open layers has changed.
	 */ function callChangeListeners({ namespace: namespace, newCount: newCount }) {
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            const listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace ?? []).forEach((listener)=>listener({
                    count: newCount
                }));
        }
        // 2. Call listeners registered without a specific namespace
        const noNamespaceListeners = namespaceToChangeListenerRegistry.get($8ef53a3c16932c1f$var$noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        const totalCount = $8ef53a3c16932c1f$var$getTotalOpenLayerCount(namespaceToLayerRegistry);
        Array.from(noNamespaceListeners).forEach((listener)=>listener({
                count: totalCount
            }));
    }
    /**
	 * Returns the current count of open layers.
	 *
	 * - If a namespace is provided, the count for that namespace is returned.
	 * - If a type is provided, only layers of that type are counted.
	 * - If both are provided, only layers matching both criteria are counted.
	 * - Otherwise, the sum of all namespace counts is returned.
	 */ function getCount({ namespace: namespace, type: type } = {}) {
        if (namespace) {
            // 1. A namespace was requested, so we count only layers in that namespace
            const layersForNamespace = namespaceToLayerRegistry.get(namespace);
            if (!layersForNamespace) return 0;
            if (type) // Count layers in the namespace that match the type filter
            return $8ef53a3c16932c1f$var$getLayerCountWithFilter({
                layers: layersForNamespace,
                type: type
            });
            // No type filter - just return the size of the set
            return layersForNamespace.size;
        }
        // 2. A specific namespace was not requested, so we count across all namespaces
        if (type) // Count layers in each namespace that match the type filter
        return Array.from(namespaceToLayerRegistry.values()).reduce((acc, layers)=>acc + $8ef53a3c16932c1f$var$getLayerCountWithFilter({
                layers: layers,
                type: type
            }), 0);
        // No type filter - count all layers across all namespaces
        return $8ef53a3c16932c1f$var$getTotalOpenLayerCount(namespaceToLayerRegistry);
    }
    /**
	 * Adds a listener that will be called when the number of open layers changes.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onChange(listener, { namespace: providedNamespace } = {}) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped(...args) {
            listener(...args);
        }
        const namespace = providedNamespace ?? $8ef53a3c16932c1f$var$noNamespaceSymbol;
        const listenersForNamespace = $8ef53a3c16932c1f$var$getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Adds a listener to the registry that tells the observer how to close the layer component.
	 * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
	 *
	 * All close listeners will be called by the observer when `closeLayers` is called.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onClose(listener, { namespace: providedNamespace, type: type }) {
        const wrapped = {
            listener: listener,
            type: type
        };
        const namespace = providedNamespace ?? $8ef53a3c16932c1f$var$noNamespaceSymbol;
        const listenersForNamespace = $8ef53a3c16932c1f$var$getListeners({
            namespace: namespace,
            registry: namespaceToLayerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerRegistry.delete(namespace);
        };
    }
    /**
	 * Closes all open layers registered across all namespaces.
	 */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerRegistry.values()).forEach((listeners)=>{
            Array.from(listeners).forEach(({ listener: listener })=>listener());
        });
    }
    const internalAPI = {
        getCount: getCount,
        onChange: onChange,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
function $8ef53a3c16932c1f$export$97afddda23bcd287({ children: children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, $euxye.useState)(()=>$8ef53a3c16932c1f$var$createInternalAPI());
    const parentContext = (0, $euxye.useContext)((0, $jAinK.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, $jiTLE.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jAinK.OpenLayerObserverContext).Provider, {
        value: internalAPI,
        children: children
    });
}
$8ef53a3c16932c1f$export$97afddda23bcd287.displayName = "OpenLayerObserver";

});

parcelRegister("fImBI", function(module, exports) {
$parcel$export(module.exports, "SkipLinksProvider", () => $1d28ca183ae09177$export$fe514f9f7b03d46f);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $lrhxV = parcelRequire("lrhxV");

var $buY4I = parcelRequire("buY4I");
const $1d28ca183ae09177$var$getByDomOrderSortFunction = ()=>{
    const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
    return (a, b)=>{
        const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
        const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
        /**
		 * If they are tied it is because one (or both) is
		 * a custom skiplink with a set index.
		 *
		 * Give the custom skiplink priority.
		 */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
function $1d28ca183ae09177$export$fe514f9f7b03d46f({ children: children, label: label, triggerLabel: triggerLabel, testId: testId }) {
    const [links, setLinks] = (0, $euxye.useState)([]);
    const registerSkipLink = (0, $euxye.useCallback)((skipLinkData)=>{
        // Don't add duplicate skip links
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($1d28ca183ae09177$var$getByDomOrderSortFunction());
        });
    }, []);
    const unregisterSkipLink = (0, $euxye.useCallback)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    }, []);
    const contextValue = (0, $euxye.useMemo)(()=>{
        const data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $buY4I.SkipLinksContext).Provider, {
        value: contextValue,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lrhxV.SkipLinksContainer), {
                label: label,
                triggerLabel: triggerLabel,
                testId: testId,
                links: links
            }),
            children
        ]
    });
}
$1d28ca183ae09177$export$fe514f9f7b03d46f.displayName = "SkipLinksProvider";

});
parcelRegister("lrhxV", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContainer", () => $eb54d246b7b2a563$export$fce25a0c32fbc1e1);
/* skip-links-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $iqfTZ = parcelRequire("iqfTZ");

var $8Sdzy = parcelRequire("8Sdzy");

var $cO4Wq = parcelRequire("cO4Wq");

var $8YjPQ = parcelRequire("8YjPQ");
const $eb54d246b7b2a563$var$styles = {
    root: "_2mHwu81Y8M _0bjKvDKxmn _4c065U8HPE _2Y7lL48HPE _3iDTPbQ4SZ _0aFT5vbt8w _1mT5xdy1CL _3iC0zdkG2W _2I62gzkG2W _0KLXruoI2d _2OUyjtGk8v _42Yu6BvQQr _1YKVNsdnbC _1pp6NdYbGa _3gBTfLGYeU _3Tg68S7dHp _2VJVb2IZbP",
    skipLinkList: "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w _4zmD5lTNeH _0aNu0LYbGa _43nrzTPgdg _0LQT5EPgdg"
};
/**
 * Keydown handler to hide the skip links when escape is pressed.
 *
 * TODO: consider removing this, it doesn't make a lot of sense.
 * The skip links look like a popup but in reality they aren't.
 * Even though we hide them when the user presses Escape, when
 * they press TAB it will reopen the list and move to the next one...
 *
 * One potential option is to use a tree walker to focus on the
 * next focusable element in the DOM (outside the skip links
 * container).
 */ const $eb54d246b7b2a563$var$closeOnEscape = (event)=>{
    if (event.key !== 'Escape') return;
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
const $eb54d246b7b2a563$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $eb54d246b7b2a563$var$assignIndex(num + 1, arr);
};
/**
 * Sorts an array of skip links by list indexes.
 *
 * Skip links with custom list indexes are positioned first, followed by regular skip links,
 * which are automatically assigned available index positions to avoid conflicts.
 */ function $eb54d246b7b2a563$var$sortSkipLinks(arr) {
    const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
    if (customLinks.length === 0) return arr;
    const usedIndexes = customLinks.map((a)=>a.listIndex);
    const regularLinksWithIndex = arr.filter((link)=>link.listIndex === undefined).map((link, index)=>{
        const listIndex = $eb54d246b7b2a563$var$assignIndex(index, usedIndexes);
        usedIndexes.push(listIndex);
        return {
            ...link,
            listIndex: listIndex
        };
    });
    return [
        ...customLinks,
        ...regularLinksWithIndex
    ].sort((a, b)=>a.listIndex - b.listIndex);
}
const $eb54d246b7b2a563$var$isOnlyWhitespaceRegex = /^\s*$/;
function $eb54d246b7b2a563$export$fce25a0c32fbc1e1({ label: label, triggerLabel: triggerLabel, testId: testId, links: links }) {
    const sortedLinks = (0, $euxye.useMemo)(()=>{
        return $eb54d246b7b2a563$var$sortSkipLinks(links);
    }, [
        links
    ]);
    if (sortedLinks.length === 0) return null;
    const isEmptyLabel = $eb54d246b7b2a563$var$isOnlyWhitespaceRegex.test(label);
    if ((0, $iqfTZ.fg)('platform_dst_nav4_skip_link_a11y_1')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8YjPQ.SkipLinksPopup), {
        label: label,
        triggerLabel: triggerLabel,
        testId: testId,
        links: sortedLinks
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        onKeyDown: $eb54d246b7b2a563$var$closeOnEscape,
        "data-testid": testId ? `${testId}--skip-links-container` : undefined,
        className: (0, $4jQY2.default)([
            $eb54d246b7b2a563$var$styles.root
        ]),
        children: [
            !isEmptyLabel && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                weight: "bold",
                testId: testId ? `${testId}--skip-links-container--label` : undefined,
                children: label
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("ol", {
                className: (0, $4jQY2.default)([
                    $eb54d246b7b2a563$var$styles.skipLinkList
                ]),
                children: sortedLinks.map(({ id: id, label: label, onBeforeNavigate: onBeforeNavigate })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $cO4Wq.SkipLink), {
                        id: id,
                        onBeforeNavigate: onBeforeNavigate,
                        children: label
                    }, id))
            })
        ]
    });
}
$eb54d246b7b2a563$export$fce25a0c32fbc1e1.displayName = "SkipLinksContainer";

});
parcelRegister("cO4Wq", function(module, exports) {
$parcel$export(module.exports, "SkipLink", () => $b61f9c79f81d16fa$export$ef95c37428582a65);
/* skip-link.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");

var $9MWap = parcelRequire("9MWap");

var $66jRX = parcelRequire("66jRX");
const $b61f9c79f81d16fa$var$styles = {
    skipLinkListItem: "_43nrzTPgdg",
    skipLinkListItemNew: "_4c065U2ADO"
};
const $b61f9c79f81d16fa$export$ef95c37428582a65 = ({ id: id, children: children, onBeforeNavigate: onBeforeNavigate, navigate: navigate })=>{
    const href = `#${id}`;
    const handleClick = (0, $euxye.useCallback)((event)=>{
        event.preventDefault();
        if (navigate && (0, $iqfTZ.fg)('platform_dst_nav4_skip_link_a11y_1')) /**
       * The consumer takes over the navigation effect (e.g. expanding the
       * side nav and focusing the first nav item). The universal pre/post
       * work below (e.g. `window.scrollTo`) still runs around it.
       */ navigate();
        else {
            // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
            const target = document.getElementById(id);
            if (!target) return;
            /**
       * Legacy `onBeforeNavigate` hook. Intentionally NOT called when
       * `platform_dst_nav4_skip_link_a11y_1` is enabled — under the gate the
       * gate-on path delegates state mutation + focus management to `navigate`,
       * and `SkipLinksPopup` injects its popup-close behavior into the
       * `navigate` wrapper instead of relying on this hook.
       *
       * This callback can be removed entirely on gate cleanup.
       */ if (!(0, $iqfTZ.fg)('platform_dst_nav4_skip_link_a11y_1')) onBeforeNavigate?.();
            (0, $66jRX.focusElement)(target);
        }
        /**
     * We should look into removing this, or only calling it in specific cases.
     *
     * It means if the skip link element is in the window scroll container
     * then it might not get scrolled into view properly.
     *
     * This is not an issue for the default slots on desktop, but could break custom skip links or
     * even `Aside` on mobile.
     *
     * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
     * E.g. jumping to main / aside it makes sense to look at the start of the content.
     */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate,
        navigate
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("li", {
        className: (0, $4jQY2.default)([
            $b61f9c79f81d16fa$var$styles.skipLinkListItem,
            (0, $iqfTZ.fg)('platform_dst_nav4_skip_link_a11y_1') && $b61f9c79f81d16fa$var$styles.skipLinkListItemNew
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9MWap.Anchor), {
            /**
     * It looks like Safari handles link clicks during `pointerdown` unless it has an explicit `tabIndex={0}` :/
     *
     * Adding this explicitly makes the behavior consistent between browsers and lets us `event.preventDefault()`
     * in the `onClick` handler.
     */ tabIndex: 0,
            href: href,
            onClick: handleClick,
            children: children
        })
    });
};
$b61f9c79f81d16fa$export$ef95c37428582a65.displayName = "SkipLink";

});
parcelRegister("66jRX", function(module, exports) {
$parcel$export(module.exports, "focusElement", () => $01e444d4c3c2c59d$export$5fed9cc43865dc7e);

var $glbdM = parcelRequire("glbdM");
function $01e444d4c3c2c59d$export$5fed9cc43865dc7e(element) {
    /**
	 * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
	 * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
	 *
	 * Our slots are not interactive, so this is required.
	 *
	 * In the future we may want to check if there is an existing `tabindex` attribute,
	 * as custom skip linked elements might already have one.
	 */ element.setAttribute('tabindex', '-1');
    /**
	 * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
	 *
	 * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
	 *
	 * - mess with click events
	 * - potentially cause a focus ring to be always visible
	 */ (0, $glbdM.bind)(element, {
        type: 'blur',
        listener () {
            element.removeAttribute('tabindex');
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
	 * Move focus to the slot or custom target.
	 *
	 * Calling `.focus()` will also scroll the element into view:
	 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
	 */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        focusVisible: true
    });
}

});


parcelRegister("8YjPQ", function(module, exports) {
$parcel$export(module.exports, "SkipLinksPopup", () => $ce425c6d3d25ba93$export$759eb47efaee9eec);
/* skip-links-popup.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $fZb1b = parcelRequire("fZb1b");

var $iOfms = parcelRequire("iOfms");

var $ljVHR = parcelRequire("ljVHR");

var $4QBVk = parcelRequire("4QBVk");

var $66jRX = parcelRequire("66jRX");

var $cO4Wq = parcelRequire("cO4Wq");
const $ce425c6d3d25ba93$var$contentStyles = {
    root: "_4c065U2ADO _2Y7lL45zaO _3iDTPbQ4SZ _0aFT5vbt8w _42Yu6BGYeU",
    skipLinkList: "_3iDTPbQ4SZ _0aFT5vbt8w _4zmD5lTNeH _0aNu0LYbGa _43nrzTPgdg _0LQT5EPgdg",
    label: "_2sNsIgd8bj _4c065U2ADO _1UtDYzZpcK"
};
const $ce425c6d3d25ba93$var$triggerStyles = {
    root: "_0bjKvDKxmn _3hxITiYbGa _1mT5xdy1CL _3iC0zd8HPE _2I62gz8HPE _42Yu6BvQQr _1YKVNsdnbC _0KLXruoI2d _0j9PH9GYeU _0O4CrC7dHp",
    isOpen: "_1YKVNsdnbC _1VJPca0OLL"
};
const $ce425c6d3d25ba93$var$popupOffset = [
    0,
    0
];
function $ce425c6d3d25ba93$export$759eb47efaee9eec({ label: title, triggerLabel: triggerLabel, testId: testId, links: links }) {
    const titleId = (0, $euxye.useId)();
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    const triggerRef = (0, $euxye.useRef)(null);
    const openPopup = (0, $euxye.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    /**
   * Closes the popup.
   *
   * Uses `flushSync` to avoid issues with focus management.
   * This ensures the popup's focus lock is fully released by the time skip links or our `onClose` try to move focus.
   */ const closePopup = (0, $euxye.useCallback)(()=>{
        (0, $fZb1b.flushSync)(()=>{
            setIsOpen(false);
        });
    }, []);
    /**
   * Restores focus to the trigger on close, if it hasn't moved to another element, such as when Esc is pressed instead of a skip link.
   *
   * We need this because using the standard `shouldReturnFocus` on the popup would break the skip link focus behaviour,
   * as focus would always move back to the trigger.
   */ const onClose = (0, $euxye.useCallback)(()=>{
        closePopup();
        // Focus on the body implies a skip link was not clicked
        if (document.activeElement === document.body) triggerRef.current?.focus();
    }, [
        closePopup
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4QBVk.Popup), {
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        shouldRenderToParent: true,
        shouldReturnFocus: false,
        role: "dialog",
        titleId: titleId,
        testId: testId ? `${testId}--skip-links-container` : undefined,
        offset: $ce425c6d3d25ba93$var$popupOffset,
        content: ()=>/*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
                className: (0, $4jQY2.default)([
                    $ce425c6d3d25ba93$var$contentStyles.root
                ]),
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        "data-testid": testId ? `${testId}--skip-links-container--label` : undefined,
                        id: titleId,
                        className: (0, $4jQY2.default)([
                            $ce425c6d3d25ba93$var$contentStyles.label
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("ol", {
                        className: (0, $4jQY2.default)([
                            $ce425c6d3d25ba93$var$contentStyles.skipLinkList
                        ]),
                        children: links.map(({ id: id, label: label, navigate: navigate })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $cO4Wq.SkipLink), {
                                id: id,
                                /**
       * The popup always owns the navigation effect under the
       * `platform_dst_nav4_skip_link_a11y_1` gate (the only path
       * that renders `SkipLinksPopup`). It first closes itself
       * synchronously so its focus lock is released, then either:
       *
       *  - delegates to the consumer's `navigate` (e.g. SideNav
       *    expanding and focusing its first nav item), or
       *  - falls back to focusing the slot element with `id`.
       *
       * This means `SkipLink`'s `onBeforeNavigate` hook is never
       * needed under the gate and can be removed on cleanup.
       */ navigate: ()=>{
                                    closePopup();
                                    if (navigate) {
                                        navigate();
                                        return;
                                    }
                                    // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
                                    const target = document.getElementById(id);
                                    if (target) (0, $66jRX.focusElement)(target);
                                },
                                children: label
                            }, id))
                    })
                ]
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    $ce425c6d3d25ba93$var$triggerStyles.root,
                    isOpen && $ce425c6d3d25ba93$var$triggerStyles.isOpen
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iOfms.default), {
                    ...triggerProps,
                    ref: (0, $ljVHR.default)([
                        triggerProps.ref,
                        triggerRef
                    ]),
                    appearance: "primary",
                    isSelected: isOpen,
                    testId: testId ? `${testId}--skip-links-trigger` : undefined,
                    onClick: openPopup,
                    children: triggerLabel
                })
            })
    });
}
$ce425c6d3d25ba93$export$759eb47efaee9eec.displayName = "SkipLinksPopup";

});



parcelRegister("3b9sC", function(module, exports) {
$parcel$export(module.exports, "TopNavStartProvider", () => $8d5e4be3b6938942$export$bc9d0ad0bce43e75);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1R7xO = parcelRequire("1R7xO");

var $9fYEM = parcelRequire("9fYEM");
const $8d5e4be3b6938942$export$bc9d0ad0bce43e75 = ({ children: children })=>{
    const [element, setElement] = (0, $euxye.useState)(null);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9fYEM.TopNavStartElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1R7xO.TopNavStartAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};
$8d5e4be3b6938942$export$bc9d0ad0bce43e75.displayName = "TopNavStartProvider";

});

parcelRegister("59nHb", function(module, exports) {
$parcel$export(module.exports, "LayoutAreaSizingProvider", () => $69399cff83d5681c$export$c026181e8eaf0b9f);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $cBXep = parcelRequire("cBXep");

var $h8CBd = parcelRequire("h8CBd");

var $hlSlc = parcelRequire("hlSlc");

var $8EOMF = parcelRequire("8EOMF");
const $69399cff83d5681c$var$defaultMainMinWidth = 320;
function $69399cff83d5681c$var$useStableAreaState(state) {
    const { mode: mode, width: width, minWidth: minWidth } = state ?? {};
    return (0, $euxye.useMemo)(()=>mode !== undefined && width !== undefined && minWidth !== undefined ? {
            mode: mode,
            width: width,
            minWidth: minWidth
        } : undefined, [
        mode,
        width,
        minWidth
    ]);
}
function $69399cff83d5681c$export$c026181e8eaf0b9f({ children: children, layoutRef: layoutRef }) {
    const occupiedWidth = (0, $8EOMF.useOccupiedLayoutWidth)(layoutRef);
    const [dimensions, setDimensions] = (0, $euxye.useState)(null);
    const [mainMinWidth, setMainMinWidth] = (0, $euxye.useState)($69399cff83d5681c$var$defaultMainMinWidth);
    const [areas, setAreas] = (0, $euxye.useState)({});
    const [resizeSession, setResizeSession] = (0, $euxye.useState)(null);
    const areaStatesRef = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useRef({});
    const configsRef = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useRef({});
    const openSequence = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useRef(0);
    (0, $euxye.useEffect)(()=>{
        setResizeSession(null);
    }, [
        mainMinWidth,
        occupiedWidth
    ]);
    (0, $euxye.useEffect)(()=>{
        const root = layoutRef?.current;
        let previous = null;
        // Match the actual rem-based grid breakpoint, including browser font settings.
        const inlineChatQuery = window.matchMedia('(min-width: 40rem)');
        const inlineSideNavQuery = window.matchMedia('(min-width: 64rem)');
        const updateDimensions = (contentWidth)=>{
            const style = root && contentWidth === undefined ? getComputedStyle(root) : null;
            const layoutWidth = contentWidth ?? (root ? Math.max(0, root.clientWidth - (parseFloat(style?.paddingLeft ?? '') || 0) - (parseFloat(style?.paddingRight ?? '') || 0)) : window.innerWidth);
            const next = {
                viewportWidth: window.innerWidth,
                layoutWidth: layoutWidth,
                isChatPanelOverlay: !inlineChatQuery.matches,
                isSideNavOverlay: !inlineSideNavQuery.matches
            };
            if (previous?.viewportWidth === next.viewportWidth && previous.layoutWidth === next.layoutWidth && previous.isChatPanelOverlay === next.isChatPanelOverlay && previous.isSideNavOverlay === next.isSideNavOverlay) return;
            previous = next;
            setDimensions(next);
            setResizeSession(null);
        };
        updateDimensions();
        const observer = new ResizeObserver((entries)=>{
            const entry = entries.find((entry)=>entry.target === root);
            if (entry) updateDimensions(entry.contentRect.width);
        });
        if (root) observer.observe(root);
        const unbindResize = (0, $glbdM.bind)(window, {
            type: 'resize',
            listener: ()=>updateDimensions()
        });
        const unbindQuery = (0, $glbdM.bind)(inlineChatQuery, {
            type: 'change',
            listener: ()=>updateDimensions()
        });
        const unbindSideNavQuery = (0, $glbdM.bind)(inlineSideNavQuery, {
            type: 'change',
            listener: ()=>updateDimensions()
        });
        return ()=>{
            observer.disconnect();
            unbindResize();
            unbindQuery();
            unbindSideNavQuery();
        };
    }, [
        layoutRef
    ]);
    const registerArea = (0, $euxye.useCallback)((area, config)=>{
        const previous = configsRef.current[area];
        configsRef.current[area] = config;
        setResizeSession((current)=>{
            // A changed layout/configuration needs a fresh allocation. A controlled
            // acknowledgement for the resized area keeps its siblings fixed.
            return previous?.isOpen === config.isOpen && previous.minWidth === config.minWidth && previous.maxWidth === config.maxWidth && previous.defaultWidth === config.defaultWidth && previous.compactDefaultWidth === config.compactDefaultWidth && (previous.requestedWidth === config.requestedWidth || current?.area === area) ? current : null;
        });
        // Allocate once per registration, outside the updater React may replay. Gaps are
        // harmless: only relative ordering of closed-to-open transitions is significant.
        const openedAt = ++openSequence.current;
        setAreas((current)=>{
            const existing = current[area];
            return {
                ...current,
                [area]: {
                    ...existing,
                    ...config,
                    liveResize: config.isOpen ? existing?.liveResize : undefined,
                    openedAt: config.isOpen && !existing?.isOpen ? openedAt : existing?.openedAt
                }
            };
        });
    }, []);
    const unregisterArea = (0, $euxye.useCallback)((area)=>{
        delete configsRef.current[area];
        setResizeSession(null);
        setAreas((current)=>{
            if (!current[area]) return current;
            // Closing uses isOpen: false and retains preferences. Unregistering means
            // the owning component unmounted; a replacement must start with its own defaults.
            const next = {
                ...current
            };
            delete next[area];
            return next;
        });
    }, []);
    const freezeSiblingWidths = (0, $euxye.useCallback)((area)=>{
        const baselineWidths = {};
        for (const areaName of [
            'side-nav',
            'panel',
            'chat-panel'
        ]){
            const state = areaStatesRef.current[areaName];
            if (state?.mode === 'inline') baselineWidths[areaName] = state.width;
        }
        // Keep the same siblings fixed after completion, including while a controlled
        // consumer rejects or asynchronously accepts the requested width.
        setResizeSession({
            area: area,
            baselineWidths: baselineWidths
        });
    }, []);
    const startResize = (0, $euxye.useCallback)((area, mode)=>{
        if (mode !== 'inline') return;
        freezeSiblingWidths(area);
        // Start from the effective width, which may already be compressed below the preferred width.
        // Reapplying the preferred width here would move the splitter away from the pointer.
        const renderedState = areaStatesRef.current[area];
        if (renderedState?.mode === 'inline') setAreas((current)=>{
            const existing = current[area];
            return existing ? {
                ...current,
                [area]: {
                    ...existing,
                    liveResize: {
                        mode: mode,
                        width: renderedState.width
                    }
                }
            } : current;
        });
    }, [
        freezeSiblingWidths
    ]);
    const resize = (0, $euxye.useCallback)((area, mode, width)=>{
        setAreas((current)=>{
            const existing = current[area];
            if (existing?.liveResize?.mode === mode && existing.liveResize.width === width) return current;
            return existing ? {
                ...current,
                [area]: {
                    ...existing,
                    liveResize: {
                        mode: mode,
                        width: width
                    }
                }
            } : current;
        });
    }, []);
    const completeResize = (0, $euxye.useCallback)((area, mode, width)=>{
        if (mode === 'inline') // Keyboard resizing completes without a preceding pointer-drag session.
        freezeSiblingWidths(area);
        setAreas((current)=>{
            const existing = current[area];
            if (!existing) return current;
            if (mode === 'overlay') return {
                ...current,
                [area]: {
                    ...existing,
                    liveResize: undefined,
                    preferredOverlayWidth: width
                }
            };
            return {
                ...current,
                [area]: {
                    ...existing,
                    liveResize: undefined,
                    preferredInlineWidth: width
                }
            };
        });
    }, [
        freezeSiblingWidths
    ]);
    const areaStates = (0, $euxye.useMemo)(()=>dimensions === null ? {} : (0, $cBXep.calculateLayoutAreaStates)({
            ...dimensions,
            occupiedWidth: occupiedWidth,
            mainMinWidth: mainMinWidth,
            areas: areas,
            resizeSession: resizeSession
        }), [
        areas,
        mainMinWidth,
        resizeSession,
        dimensions,
        occupiedWidth
    ]);
    (0, $euxye.useEffect)(()=>{
        areaStatesRef.current = areaStates;
    }, [
        areaStates
    ]);
    (0, $euxye.useEffect)(()=>{
        if (areaStates['side-nav']?.mode !== 'overlay' || areaStates['chat-panel']?.mode !== 'overlay') return;
        const sideNav = areas['side-nav'];
        const chatPanel = areas['chat-panel'];
        if (!sideNav?.isOpen || !chatPanel?.isOpen) return;
        if ((sideNav.openedAt ?? 0) > (chatPanel.openedAt ?? 0)) chatPanel.onRequestClose?.();
        else sideNav.onRequestClose?.();
    }, [
        areas,
        areaStates
    ]);
    // Read bounds lazily: changing a sibling's capacity must not publish new render
    // state or recreate drag listeners for a region whose own width did not change.
    const getResizeBounds = (0, $euxye.useCallback)((area)=>{
        const bounds = areaStatesRef.current[area]?.resizeBounds;
        return bounds ? {
            min: `${bounds.min}px`,
            max: `${bounds.max}px`
        } : undefined;
    }, []);
    const value = (0, $euxye.useMemo)(()=>({
            getResizeBounds: getResizeBounds,
            registerArea: registerArea,
            unregisterArea: unregisterArea,
            startResize: startResize,
            resize: resize,
            completeResize: completeResize,
            setMainMinWidth: setMainMinWidth
        }), [
        completeResize,
        getResizeBounds,
        registerArea,
        resize,
        startResize,
        unregisterArea
    ]);
    const sideNavState = $69399cff83d5681c$var$useStableAreaState(areaStates['side-nav']);
    const panelState = $69399cff83d5681c$var$useStableAreaState(areaStates.panel);
    const chatPanelState = $69399cff83d5681c$var$useStableAreaState(areaStates['chat-panel']);
    const SideNavStateProvider = (0, $hlSlc.layoutAreaStateContexts)['side-nav'].Provider;
    const PanelStateProvider = (0, $hlSlc.layoutAreaStateContexts).panel.Provider;
    const ChatPanelStateProvider = (0, $hlSlc.layoutAreaStateContexts)['chat-panel'].Provider;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $h8CBd.LayoutAreaSizingContext).Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)(SideNavStateProvider, {
            value: sideNavState,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)(PanelStateProvider, {
                value: panelState,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)(ChatPanelStateProvider, {
                    value: chatPanelState,
                    children: children
                })
            })
        })
    });
}
$69399cff83d5681c$export$c026181e8eaf0b9f.displayName = "LayoutAreaSizingProvider";

});
parcelRegister("cBXep", function(module, exports) {
$parcel$export(module.exports, "calculateLayoutAreaStates", () => $70a4b41a0f92f01a$export$e3e222c96b2a4437);

var $2OF47 = parcelRequire("2OF47");
function $70a4b41a0f92f01a$var$clampTargetWidth({ target: target, min: min, max: max }) {
    return Math.max(min, Math.min(target, max));
}
function $70a4b41a0f92f01a$var$getTargetWidth(area, isSideNavOverlay) {
    const defaultWidth = isSideNavOverlay ? area.compactDefaultWidth ?? area.defaultWidth : area.defaultWidth;
    return area.liveResize?.mode === 'inline' ? area.liveResize.width : area.requestedWidth ?? area.preferredInlineWidth ?? defaultWidth;
}
function $70a4b41a0f92f01a$var$getOverlayTargetWidth(area, isSideNavOverlay) {
    const defaultWidth = isSideNavOverlay ? area.compactDefaultWidth ?? area.defaultWidth : area.defaultWidth;
    return area.liveResize?.mode === 'overlay' ? area.liveResize.width : area.requestedWidth ?? area.preferredOverlayWidth ?? defaultWidth;
}
function $70a4b41a0f92f01a$export$e3e222c96b2a4437({ viewportWidth: viewportWidth, layoutWidth: layoutWidth = viewportWidth, isChatPanelOverlay: isChatPanelOverlay, isSideNavOverlay: isSideNavOverlay, occupiedWidth: occupiedWidth = 0, mainMinWidth: mainMinWidthBound, areas: areas, resizeSession: resizeSession }) {
    const mainMinWidth = (0, $2OF47.resolveLayoutWidth)(mainMinWidthBound, viewportWidth);
    const availableWidth = Math.max(0, layoutWidth - occupiedWidth);
    const sideNav = areas['side-nav'];
    const panel = areas.panel;
    const chatPanel = areas['chat-panel'];
    const sideNavMinWidth = sideNav ? (0, $2OF47.resolveLayoutWidth)(sideNav.minWidth, viewportWidth) : 0;
    const panelMinWidth = panel ? (0, $2OF47.resolveLayoutWidth)(panel.minWidth, viewportWidth) : 0;
    const chatPanelMinWidth = chatPanel ? (0, $2OF47.resolveLayoutWidth)(chatPanel.minWidth, viewportWidth) : 0;
    const isSideNavOpenInline = Boolean(sideNav?.isOpen && !isSideNavOverlay && availableWidth >= mainMinWidth + sideNavMinWidth);
    const isChatPanelOpenInline = Boolean(chatPanel?.isOpen && !isChatPanelOverlay && availableWidth >= mainMinWidth + chatPanelMinWidth + (isSideNavOpenInline ? sideNavMinWidth : 0));
    const isPanelInline = Boolean(panel?.isOpen && availableWidth >= mainMinWidth + panelMinWidth + (isChatPanelOpenInline ? chatPanelMinWidth : 0) + (isSideNavOpenInline ? sideNavMinWidth : 0));
    const inlineAreas = [
        isSideNavOpenInline && 'side-nav',
        isPanelInline && 'panel',
        isChatPanelOpenInline && 'chat-panel'
    ].filter((area)=>Boolean(area));
    const widths = new Map();
    const minimums = new Map();
    for (const areaName of inlineAreas){
        const area = areas[areaName];
        if (!area) continue;
        const min = (0, $2OF47.resolveLayoutWidth)(area.minWidth, viewportWidth);
        const max = area.maxWidth ? (0, $2OF47.resolveLayoutWidth)(area.maxWidth, viewportWidth) : Number.POSITIVE_INFINITY;
        const baselineWidth = resizeSession?.baselineWidths[areaName];
        const requestedTarget = resizeSession && areaName !== resizeSession.area && baselineWidth !== undefined ? baselineWidth : $70a4b41a0f92f01a$var$getTargetWidth(area, isSideNavOverlay);
        const target = $70a4b41a0f92f01a$var$clampTargetWidth({
            target: requestedTarget,
            min: min,
            max: max
        });
        minimums.set(areaName, min);
        widths.set(areaName, target);
    }
    let overflow = Math.max(0, Array.from(widths.values()).reduce((total, width)=>total + width, 0) - (availableWidth - mainMinWidth));
    const compressionOrder = [
        'panel',
        'chat-panel',
        'side-nav'
    ];
    // User resizing consumes only Main's spare width. Viewport changes clear the
    // snapshot and retain the normal automatic compression order.
    const shrinkOrder = resizeSession ? [
        resizeSession.area
    ] : compressionOrder;
    for (const areaName of shrinkOrder){
        if (overflow <= 0) break;
        const width = widths.get(areaName) ?? 0;
        const min = minimums.get(areaName) ?? 0;
        const reduction = Math.min(overflow, Math.max(0, width - min));
        widths.set(areaName, width - reduction);
        overflow -= reduction;
    }
    const totalInlineWidth = Array.from(widths.values()).reduce((total, width)=>total + width, 0);
    const states = {};
    for (const areaName of inlineAreas){
        const width = widths.get(areaName) ?? 0;
        const min = minimums.get(areaName) ?? 0;
        const maxWidth = areas[areaName]?.maxWidth;
        const configuredMax = maxWidth !== undefined ? (0, $2OF47.resolveLayoutWidth)(maxWidth, viewportWidth) : Number.POSITIVE_INFINITY;
        states[areaName] = {
            mode: 'inline',
            width: width,
            minWidth: min,
            resizeBounds: {
                min: min,
                max: Math.max(min, Math.min(configuredMax, availableWidth - mainMinWidth - totalInlineWidth + width))
            }
        };
    }
    const inlineSideNavWidth = states['side-nav']?.width ?? 0;
    const inlineChatPanelWidth = states['chat-panel']?.width ?? 0;
    const mainAreaWidth = Math.max(0, availableWidth - inlineSideNavWidth - inlineChatPanelWidth);
    for (const areaName of [
        'side-nav',
        'panel',
        'chat-panel'
    ]){
        const area = areas[areaName];
        if (!area?.isOpen || states[areaName]?.mode === 'inline') continue;
        const min = (0, $2OF47.resolveLayoutWidth)(area.minWidth, viewportWidth);
        const configuredMax = area.maxWidth ? (0, $2OF47.resolveLayoutWidth)(area.maxWidth, viewportWidth) : Number.POSITIVE_INFINITY;
        // Chat covers Root; SideNav and the local panel overlay Main's grid track.
        // Occupied tracks and inline chat are not part of that covered region.
        const layoutMax = (areaName === 'chat-panel' ? layoutWidth : mainAreaWidth) * 0.9;
        const max = Math.max(0, Math.min(configuredMax, layoutMax));
        const effectiveMin = Math.min(min, max);
        const target = $70a4b41a0f92f01a$var$getOverlayTargetWidth(area, isSideNavOverlay);
        const width = $70a4b41a0f92f01a$var$clampTargetWidth({
            target: target,
            min: effectiveMin,
            max: max
        });
        states[areaName] = {
            mode: 'overlay',
            width: width,
            minWidth: effectiveMin,
            resizeBounds: {
                min: effectiveMin,
                max: max
            }
        };
    }
    return states;
}

});

parcelRegister("8EOMF", function(module, exports) {
$parcel$export(module.exports, "useOccupiedLayoutWidth", () => $543901e2d42d10a9$export$889b20a96a9cd3fb);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");
function $543901e2d42d10a9$export$889b20a96a9cd3fb(layoutRef) {
    const [width, setWidth] = (0, $euxye.useState)(0);
    (0, $euxye.useEffect)(()=>{
        const root = layoutRef?.current;
        if (!root) return;
        let occupiedSlots = [];
        const measure = ()=>{
            if (occupiedSlots.length === 0) {
                setWidth(0);
                return;
            }
            const rows = getComputedStyle(root).gridTemplateAreas.match(/"[^"]+"/g) ?? [];
            const mainRow = rows.map((row)=>row.replace(/"/g, '').split(/\s+/)).find((row)=>row.includes('main')) ?? [];
            let occupiedWidth = 0;
            for (const child of occupiedSlots){
                const style = getComputedStyle(child);
                const area = style.gridArea.split('/').map((part)=>part.trim());
                const slot = area[0];
                if ([
                    'ribbon',
                    'aside',
                    'panel'
                ].includes(slot) && area.every((part)=>part === slot) && mainRow.includes(slot) && style.display !== 'none' && style.position !== 'absolute' && style.position !== 'fixed') occupiedWidth += child.getBoundingClientRect().width;
            }
            setWidth(occupiedWidth);
        };
        const resizeObserver = new ResizeObserver(measure);
        const observeSlots = ()=>{
            resizeObserver.disconnect();
            resizeObserver.observe(root);
            // Managed regions resize on every drag frame but cannot consume extra tracks.
            // Keep them out of both the observer and the measurement loop. Slot identity,
            // unlike gridArea, remains stable when a region switches to overlay mode.
            // TopNav and Banner also span columns rather than consuming independent tracks.
            occupiedSlots = Array.from(root.children).filter((child)=>child instanceof HTMLElement && child.hasAttribute('data-layout-slot') && !child.matches('nav, header, [role="main"], [data-layout-chat-panel]') && getComputedStyle(child).gridArea.split('/')[0].trim() !== 'banner');
            for (const child of occupiedSlots)resizeObserver.observe(child);
            measure();
        };
        const mutationObserver = new MutationObserver(observeSlots);
        mutationObserver.observe(root, {
            childList: true
        });
        observeSlots();
        const unbind = (0, $glbdM.bind)(window, {
            type: 'resize',
            listener: measure
        });
        return ()=>{
            unbind();
            resizeObserver.disconnect();
            mutationObserver.disconnect();
        };
    }, [
        layoutRef
    ]);
    return width;
}

});


parcelRegister("8fnEd", function(module, exports) {
$parcel$export(module.exports, "IsSideNavShortcutEnabledProvider", () => $38e20c6162aa18e6$export$f76029d097da8c58);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $hGQM9 = parcelRequire("hGQM9");
function $38e20c6162aa18e6$export$f76029d097da8c58({ children: children, isSideNavShortcutEnabled: isSideNavShortcutEnabled }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hGQM9.IsSideNavShortcutEnabledContext).Provider, {
        value: isSideNavShortcutEnabled,
        children: children
    });
}
$38e20c6162aa18e6$export$f76029d097da8c58.displayName = "IsSideNavShortcutEnabledProvider";

});

parcelRegister("fMNaB", function(module, exports) {
$parcel$export(module.exports, "SideNavElementProvider", () => $9166b805b10daf27$export$85c1ff84bbf6e6dc);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $cnrX7 = parcelRequire("cnrX7");
function $9166b805b10daf27$export$85c1ff84bbf6e6dc({ children: children }) {
    const sideNavRef = (0, $euxye.useRef)(null);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cnrX7.SideNavRefContext).Provider, {
        value: sideNavRef,
        children: children
    });
}
$9166b805b10daf27$export$85c1ff84bbf6e6dc.displayName = "SideNavElementProvider";

});

parcelRegister("1Ylwq", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonProvider", () => $5f0a17a83630b0a6$export$ceb8e60e9790fc0f);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $ghrOZ = parcelRequire("ghrOZ");

var $7eybO = parcelRequire("7eybO");
const $5f0a17a83630b0a6$export$ceb8e60e9790fc0f = ({ children: children })=>{
    const [element, setElement] = (0, $euxye.useState)(null);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7eybO.SideNavToggleButtonElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ghrOZ.SideNavToggleButtonAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};
$5f0a17a83630b0a6$export$ceb8e60e9790fc0f.displayName = "SideNavToggleButtonProvider";

});

parcelRegister("4JZFE", function(module, exports) {
$parcel$export(module.exports, "SideNavVisibilityProvider", () => $71a64a1a90878657$export$aac8e996360f6ad9);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $cq1Hj = parcelRequire("cq1Hj");

var $hNf54 = parcelRequire("hNf54");
const $71a64a1a90878657$export$aac8e996360f6ad9 = ({ children: children, defaultCollapsed: defaultCollapsed })=>{
    const initialState = typeof defaultCollapsed === 'boolean' ? {
        desktop: defaultCollapsed ? 'collapsed' : 'expanded',
        mobile: 'collapsed',
        flyout: 'closed',
        lastTrigger: null
    } : null;
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    const [sideNavState, setSideNavState] = (0, $euxye.useState)(initialState);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hNf54.SideNavVisibilityState).Provider, {
        value: sideNavState,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cq1Hj.SetSideNavVisibilityState).Provider, {
            value: setSideNavState,
            children: children
        })
    });
};
$71a64a1a90878657$export$aac8e996360f6ad9.displayName = "SideNavVisibilityProvider";

});




parcelRegister("jFgvQ", function(module, exports) {
$parcel$export(module.exports, "Main", () => $cc7ebcf16ec72b26$export$861edd1ccea2f746);
/* main.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $iqfTZ = parcelRequire("iqfTZ");

var $98hlH = parcelRequire("98hlH");

var $iFrrF = parcelRequire("iFrrF");

var $17vVh = parcelRequire("17vVh");

var $gBHrf = parcelRequire("gBHrf");

var $8h3Ie = parcelRequire("8h3Ie");
const $cc7ebcf16ec72b26$var$contentInsetBlockStartStatic = `calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))`;
const $cc7ebcf16ec72b26$var$contentHeightWhenFixedStatic = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))`;
const $cc7ebcf16ec72b26$var$mainElementStyles = {
    root: "_1xC2CJOQJL _4bt5LAIZbP _2WAcuGIZbP _2YgrGrP0S5 _2I62gzgiHs _0jFU0VlOMI _0zToRPIZbP _1M50CAIZbP _2DiRUzHE3j"
};
function $cc7ebcf16ec72b26$export$861edd1ccea2f746({ children: children, xcss: xcss, skipLinkLabel: skipLinkLabel = (0, $iqfTZ.fg)('platform_dst_nav4_skip_link_a11y_1') ? 'Main content' : 'Main Content', testId: testId, id: providedId, minWidth: minWidth = 320 }) {
    const id = (0, $gBHrf.useLayoutId)({
        providedId: providedId
    });
    (0, $8h3Ie.useLayoutMainSizing)(minWidth);
    (0, $98hlH.useSkipLink)(id, skipLinkLabel);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            (0, $iqfTZ.fg)('platform-dst-chat-panel-layout') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
            /*#__PURE__*/ (0, $e79Pd.jsx)("style", {
                children: `#${(0, $17vVh.gridRootId)} { ${(0, $iFrrF.mainMinimumWidthVar)}: ${minWidth}px; }`
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                id: id,
                "data-layout-slot": true,
                className: (0, $4jQY2.default)([
                    $cc7ebcf16ec72b26$var$mainElementStyles.root,
                    xcss
                ]),
                role: "main",
                "data-testid": testId,
                children: children
            })
        ]
    });
}
$cc7ebcf16ec72b26$export$861edd1ccea2f746.displayName = "Main";

});
parcelRegister("98hlH", function(module, exports) {
$parcel$export(module.exports, "useSkipLink", () => $2e0497422c8d994a$export$89d9323301efc7d6);

var $dS3O2 = parcelRequire("dS3O2");
const $2e0497422c8d994a$export$89d9323301efc7d6 = (/**
	 * The unique ID for the skip link.
	 * You can use the `useSkipLinkId` hook to generate a unique ID.
	 */ id, /**
	 * The label for the skip link.
	 */ label, /**
	 * You can optionally set the position of the skip link in the list of skip links.
	 * Positions are zero-indexed.
	 */ listIndex)=>{
    (0, $dS3O2.useSkipLinkInternal)({
        id: id,
        label: label,
        listIndex: listIndex
    });
};

});

parcelRegister("8h3Ie", function(module, exports) {
$parcel$export(module.exports, "useLayoutMainSizing", () => $07d8556c6df5eaac$export$da289e07ef5e0a12);

var $euxye = parcelRequire("euxye");

var $h8CBd = parcelRequire("h8CBd");
function $07d8556c6df5eaac$export$da289e07ef5e0a12(minWidth) {
    const context = (0, $euxye.useContext)((0, $h8CBd.LayoutAreaSizingContext));
    const setMainMinWidth = context?.setMainMinWidth;
    (0, $euxye.useEffect)(()=>setMainMinWidth?.(minWidth), [
        minWidth,
        setMainMinWidth
    ]);
}

});


parcelRegister("kLUS0", function(module, exports) {
$parcel$export(module.exports, "Panel", () => $314ff7b713ede8cd$export$2ddb90ad54e5f587);
/* panel.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $ljVHR = parcelRequire("ljVHR");

var $fp8lq = parcelRequire("fp8lq");

var $8L2z6 = parcelRequire("8L2z6");

var $2ZIVA = parcelRequire("2ZIVA");

var $iqfTZ = parcelRequire("iqfTZ");

var $dS3O2 = parcelRequire("dS3O2");

var $iFrrF = parcelRequire("iFrrF");

var $iFgsS = parcelRequire("iFgsS");

var $ccSgQ = parcelRequire("ccSgQ");

var $jqXzh = parcelRequire("jqXzh");

var $l0LPS = parcelRequire("l0LPS");

var $gBHrf = parcelRequire("gBHrf");

var $baSqD = parcelRequire("baSqD");

var $2q8Af = parcelRequire("2q8Af");
const $314ff7b713ede8cd$var$panelSplitterResizingVar = '--n_pnlRsz';
const $314ff7b713ede8cd$var$fallbackDefaultWidth = 365;
/**
 * We typically use the `defaultWidth` as the minimum resizing width,
 * but for large default widths we fallback to a standard value.
 *
 * This standard value of `400px` is to align with the Global Preview Panels.
 */ const $314ff7b713ede8cd$var$fallbackResizeMinWidth = 400;
const $314ff7b713ede8cd$var$styles = {
    root: "_1xC2CJ39pk _2p6ht9F05b _24h04i2Njc _42Yu6B7dHp _0jFU0VlOMI _1mT5xdHE3j _2I62gzgiHs _0KLXruoI2d _39xV02mSzM _2EWYUbwuPN _0hAebtlfZc _3gynorcCME _0E5nkyIZbP",
    border: "_2YmqfPYbGa _2OUyjtGk8v _4uZkDnOeNX _1RYJRxYbGa",
    scrollContainer: "_4bt5LAIZbP _2WAcuGIZbP _0jFU0VN91d",
    hidden: "_3iDTPbYbGa",
    entering: "_1jZhRJ3mzc _2qDx9m7CF6 _03Q0eexlqh _4xtBsMCT93 _4tikTSThaV _3JI830y1CL _2nUT5xdEse",
    exiting: "_1jZhRJiZOe _2qDx9m7CF6 _03Q0eexlqh _4xtBsMouYb _4tikTSThaV _0LZf8iy1CL _2nUT5xcfkA",
    contentEntering: "_2fBhteeOAp",
    contentExiting: "_2fBhtezSOH",
    contentChangeContainer: "_0jFU0VN91d"
};
const $314ff7b713ede8cd$var$PanelContentMotion = ({ children: children })=>{
    const { state: state, ref: ref } = (0, $fp8lq.useMotion)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: ref,
        className: (0, $4jQY2.default)([
            $314ff7b713ede8cd$var$styles.contentChangeContainer,
            state === 'entering' && $314ff7b713ede8cd$var$styles.contentEntering,
            state === 'exiting' && $314ff7b713ede8cd$var$styles.contentExiting
        ]),
        children: children
    });
};
$314ff7b713ede8cd$var$PanelContentMotion.displayName = "PanelContentMotion";
function $314ff7b713ede8cd$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidthProp = $314ff7b713ede8cd$var$fallbackDefaultWidth, label: label = 'Panel', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId, xcss: xcss, hasBorder: hasBorder = true, maxWidth: maxWidth, contentKey: contentKey }) {
    const dangerouslyHoistSlotSizes = (0, $euxye.useContext)((0, $ccSgQ.DangerouslyHoistSlotSizes));
    const id = (0, $gBHrf.useLayoutId)({
        providedId: providedId
    });
    const isMotionUpliftEnabled = (0, $iqfTZ.fg)('platform-dst-motion-uplift-panel');
    const defaultWidth = (0, $2q8Af.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $314ff7b713ede8cd$var$fallbackDefaultWidth,
        slotName: 'Panel'
    });
    // useMotion is applied only when the `platform-dst-motion-uplift-panel` gate is enabled.
    const { state: state, ref: motionRef, reanimate: reanimate } = (0, $fp8lq.useMotion)({
        onFinish: (state)=>{
            if (state === 'exiting' && defaultWidthRef.current === 0) // Set width to 0 as animation is complete
            setWidth(0);
        },
        initialState: defaultWidth === 0 ? 'hidden' : undefined
    });
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   *
   * TODO: when cleaning up 'platform_dst_nav4_skip_link_a11y_1' remove this call entirely
   */ (0, $dS3O2.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0 || (0, $iqfTZ.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    const ref = (0, $euxye.useRef)(null);
    const [width, setWidth] = (0, $euxye.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $euxye.useRef)(defaultWidth);
    // `mergeRefs` returns a new callback ref on every call, and combined with a new array literal
    // this would cause React to detach/re-attach the ref on every render. Memoise it so the merged
    // ref is stable across renders.
    const mergedRef = (0, $euxye.useMemo)(()=>isMotionUpliftEnabled ? (0, $ljVHR.default)([
            ref,
            motionRef
        ]) : ref, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isMotionUpliftEnabled,
        motionRef
    ]);
    /**
   * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
   * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $euxye.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        if (isMotionUpliftEnabled) {
            if (defaultWidth === 0) {
                reanimate((0, $2ZIVA.Reanimate).exit);
                defaultWidthRef.current = defaultWidth;
                // Set width to 0 once the exit animation is complete
                return;
            } else if (defaultWidthRef.current === 0) reanimate((0, $2ZIVA.Reanimate).enter);
        }
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth,
        isMotionUpliftEnabled,
        reanimate
    ]);
    const sideNavRef = (0, $l0LPS.useSideNavRef)();
    /**
   * The minimum width that the panel can be resized to by the user.
   *
   * We only use the `defaultWidth` up to a point to avoid huge panels.
   */ const minWidth = Math.min(defaultWidth, $314ff7b713ede8cd$var$fallbackResizeMinWidth);
    /**
   * Returns the bounds for resizing, evaluated lazily when needed.
   *
   * Defined separately to the slot bounds because the resizing bounds need to be resolvable to a pixel value,
   * and the panel's slot bounds use a complex CSS expression.
   */ const getResizeBounds = (0, $euxye.useCallback)(()=>{
        const sideNavWidth = sideNavRef.current?.offsetWidth ?? 0;
        /**
     * By default the panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
     *
     * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
     *
     * Consumers can opt in to a larger maximum via the `maxWidth` prop.
     */ const defaultMaxWidth = `${Math.round((window.innerWidth - sideNavWidth) / 2)}px`;
        return {
            min: `${minWidth}px`,
            max: maxWidth ?? defaultMaxWidth
        };
    }, [
        maxWidth,
        minWidth,
        sideNavRef
    ]);
    const panelWidthSlotBounds = {
        min: `${minWidth}px`,
        // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
        // Consumers can opt in to a larger maximum via the `maxWidth` prop.
        max: maxWidth ?? `round(nearest, calc((100vw - var(${0, $iFrrF.sideNavLiveWidthVar}, 0px)) / 2), 1px)`
    };
    const panelVariableWidth = `clamp(${panelWidthSlotBounds.min}, ${width}px, ${panelWidthSlotBounds.max})`;
    (0, $baSqD.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes,
        cssVar: $314ff7b713ede8cd$var$panelSplitterResizingVar,
        panelId: (0, $iFrrF.panelPanelSplitterId)
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("section", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $4jQY2.default)([
            $314ff7b713ede8cd$var$styles.root,
            isMotionUpliftEnabled && state === 'hidden' && $314ff7b713ede8cd$var$styles.hidden,
            isMotionUpliftEnabled && state === 'entering' && $314ff7b713ede8cd$var$styles.entering,
            isMotionUpliftEnabled && state === 'exiting' && $314ff7b713ede8cd$var$styles.exiting,
            !isMotionUpliftEnabled && defaultWidth === 0 && $314ff7b713ede8cd$var$styles.hidden,
            hasBorder && $314ff7b713ede8cd$var$styles.border,
            xcss
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $iFrrF.panelVar)]: panelVariableWidth,
            '--minWidth': `${minWidth}px`
        },
        "data-testid": testId,
        ref: mergedRef,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iFgsS.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $iFrrF.UNSAFE_panelLayoutVar),
                value: "0px",
                mediaQuery: '@media (min-width: 90rem)',
                responsiveValue: `var(${$314ff7b713ede8cd$var$panelSplitterResizingVar}, ${panelVariableWidth})`
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jqXzh.PanelSplitterProvider), {
                panelId: (0, $iFrrF.panelPanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: getResizeBounds,
                resizingCssVar: $314ff7b713ede8cd$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $314ff7b713ede8cd$var$styles.scrollContainer,
                        isMotionUpliftEnabled && state === 'entering' && $314ff7b713ede8cd$var$styles.contentEntering,
                        isMotionUpliftEnabled && state === 'exiting' && $314ff7b713ede8cd$var$styles.contentExiting
                    ]),
                    children: isMotionUpliftEnabled && contentKey !== undefined ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
                        exitThenEnter: true,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)($314ff7b713ede8cd$var$PanelContentMotion, {
                            children: children
                        }, contentKey)
                    }) : children
                })
            })
        ]
    });
}
$314ff7b713ede8cd$export$2ddb90ad54e5f587.displayName = "Panel";

});

parcelRegister("7GI4h", function(module, exports) {
$parcel$export(module.exports, "TopNav", () => $e6f715c937e5fdd3$export$41d0d88a6b0e456f);
/* top-nav.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $iVtau = parcelRequire("iVtau");

var $iqfTZ = parcelRequire("iqfTZ");

var $dS3O2 = parcelRequire("dS3O2");

var $av7P9 = parcelRequire("av7P9");

var $d7tnL = parcelRequire("d7tnL");

var $hdQPQ = parcelRequire("hdQPQ");

var $fDU20 = parcelRequire("fDU20");

var $77KQh = parcelRequire("77KQh");

var $iFrrF = parcelRequire("iFrrF");

var $iFgsS = parcelRequire("iFgsS");

var $ekaNt = parcelRequire("ekaNt");

var $ccSgQ = parcelRequire("ccSgQ");

var $kmjbD = parcelRequire("kmjbD");

var $gBHrf = parcelRequire("gBHrf");
/**
 * Styles for the container for the top nav items.
 *
 * The background and border are applied to a different element for z-indexing reasons:
 *
 * - The items sit above the expanded side nav
 * - The background sits below the expanded side nav
 */ const $e6f715c937e5fdd3$var$styles = {
    root: "_1xC2CJ8ySg _2mHwu82ADO _2Y7lL48HPE _2R4pr3OeNX _3iDTPbgBM8 _2iEGP292QF _0hPCNLDIqT _0KLXrulfZc _24h04i2Njc _0jFU0VmTzZ _2I62gza2UD _1mT5xdHE3j _42Yu6B8OLE _0RYKppcK7c _3E0AG2ifeC",
    fullHeightSidebar: "_2Y7lL4Pgdg _2R4pr3YbGa _1pp6NdIZbP _0KLXrulfZc _42Yu6B7LI7 _0GBAIrogpp _2WYcYGWVPG _3ufiZDdnbC _3erkSQdnbC _13xWvlCZMv _3813f2NvrM _1ZWG3o6wH8 _3dLjQS9r67 _1FQBgZ8HPE",
    fullHeightSidebarExpanded: "_4cQPhC2a2F _1hGA1nifeC",
    fullHeightSidebarCustomTheming: "_3PYyoLYbGa"
};
/**
 * The top nav layout area. It will display at the top of the screen, below the banner if one is present.
 */ function $e6f715c937e5fdd3$var$TopNavOld({ children: children, xcss: xcss, height: heightProp, skipLinkLabel: skipLinkLabel = 'Top Bar', testId: testId, id: providedId, customTheme: customThemeConfig }) {
    const isFhsEnabled = (0, $av7P9.useIsFhsEnabled)();
    const dangerouslyHoistSlotSizes = (0, $euxye.useContext)((0, $ccSgQ.DangerouslyHoistSlotSizes));
    const id = (0, $gBHrf.useLayoutId)({
        providedId: providedId
    });
    (0, $dS3O2.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: (0, $iqfTZ.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    const height = heightProp ?? (isFhsEnabled || (0, $iqfTZ.fg)('platform_dst_ads_appswitcher_improvements') ? 56 : 48);
    const customTheme = (0, $fDU20.useCustomTheme)(customThemeConfig);
    const { isExpandedOnDesktop: isExpandedOnDesktop } = (0, $kmjbD.useSideNavVisibility)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $d7tnL.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)("header", {
            id: id,
            "data-layout-slot": true,
            className: (0, $4jQY2.default)([
                $e6f715c937e5fdd3$var$styles.root,
                isFhsEnabled && $e6f715c937e5fdd3$var$styles.fullHeightSidebar,
                isExpandedOnDesktop && isFhsEnabled && $e6f715c937e5fdd3$var$styles.fullHeightSidebarExpanded,
                xcss
            ]),
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: customTheme.isEnabled ? customTheme.style : undefined,
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ekaNt.HoistCssVarToLocalGrid), {
                    variableName: (0, $iFrrF.topNavMountedVar),
                    value: height
                }),
                dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                // When they aren't needed anymore we can delete them wholesale.
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iFgsS.DangerouslyHoistCssVarToDocumentRoot), {
                    variableName: (0, $iFrrF.UNSAFE_topNavVar),
                    value: height
                }),
                children
            ]
        })
    });
}
$e6f715c937e5fdd3$var$TopNavOld.displayName = "TopNavOld";
/**
 * The top nav layout area. It will display at the top of the screen, below the banner if one is present.
 */ function $e6f715c937e5fdd3$var$TopNavNew({ children: children, xcss: xcss, height: heightProp, skipLinkLabel: skipLinkLabel = 'Top Bar', testId: testId, id: providedId, customTheme: customThemeConfig }) {
    const isFhsEnabled = (0, $av7P9.useIsFhsEnabled)();
    const dangerouslyHoistSlotSizes = (0, $euxye.useContext)((0, $ccSgQ.DangerouslyHoistSlotSizes));
    const id = (0, $gBHrf.useLayoutId)({
        providedId: providedId
    });
    (0, $dS3O2.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: (0, $iqfTZ.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    const height = heightProp ?? (isFhsEnabled || (0, $iqfTZ.fg)('platform_dst_ads_appswitcher_improvements') ? 56 : 48);
    const customTheme = (0, $77KQh.useCustomThemeNew)(customThemeConfig);
    const hasDefaultBackground = customTheme.isEnabled ? customTheme.hasDefaultBackground : true;
    const { isExpandedOnDesktop: isExpandedOnDesktop } = (0, $kmjbD.useSideNavVisibility)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $d7tnL.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hdQPQ.HasDefaultBackgroundColorContext).Provider, {
            value: hasDefaultBackground,
            children: /*#__PURE__*/ (0, $e79Pd.jsxs)("header", {
                id: id,
                "data-layout-slot": true,
                className: (0, $4jQY2.default)([
                    $e6f715c937e5fdd3$var$styles.root,
                    isFhsEnabled && $e6f715c937e5fdd3$var$styles.fullHeightSidebar,
                    isExpandedOnDesktop && isFhsEnabled && $e6f715c937e5fdd3$var$styles.fullHeightSidebarExpanded,
                    customTheme.isEnabled && !hasDefaultBackground && (0, $iqfTZ.fg)('platform_dst_nav4_custom_theming_fhs_1') && $e6f715c937e5fdd3$var$styles.fullHeightSidebarCustomTheming,
                    xcss
                ]),
                "data-testid": testId,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: customTheme.isEnabled ? customTheme.style : undefined,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ekaNt.HoistCssVarToLocalGrid), {
                        variableName: (0, $iFrrF.topNavMountedVar),
                        value: height
                    }),
                    dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                    // When they aren't needed anymore we can delete them wholesale.
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iFgsS.DangerouslyHoistCssVarToDocumentRoot), {
                        variableName: (0, $iFrrF.UNSAFE_topNavVar),
                        value: height
                    }),
                    children
                ]
            })
        })
    });
}
$e6f715c937e5fdd3$var$TopNavNew.displayName = "TopNavNew";
const $e6f715c937e5fdd3$export$41d0d88a6b0e456f = (0, $iVtau.componentWithFG)('platform_dst_nav4_custom_theming_fhs_1', $e6f715c937e5fdd3$var$TopNavNew, $e6f715c937e5fdd3$var$TopNavOld);

});
parcelRegister("fDU20", function(module, exports) {
$parcel$export(module.exports, "useCustomTheme", () => $54e0126e3f4f8bc1$export$c0c5f5b297b77726);

var $euxye = parcelRequire("euxye");

var $kA8Sq = parcelRequire("kA8Sq");
function $54e0126e3f4f8bc1$export$c0c5f5b297b77726(theme) {
    const value = (0, $euxye.useMemo)(()=>{
        if (!theme?.backgroundColor || !theme?.highlightColor) return {
            isEnabled: false
        };
        /**
			 * Re-creating the `theme` object from it's pieces.
			 *
			 * _Technically_ we could just use `theme`, but that would involve an eslint opt out
			 * as we would be leveraging a value (`theme`) not in the dependency array.
			 *
			 * The current approach is the most correct™️ and avoids foot guns.
			 * We are only using values in the effect that are defined in the dependency array 🙌
			 */ const value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        const style = (0, $kA8Sq.getCustomThemeStyles)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme?.backgroundColor,
        theme?.highlightColor
    ]);
    return value;
}

});
parcelRegister("kA8Sq", function(module, exports) {
$parcel$export(module.exports, "getCustomThemeStyles", () => $6891aec8439663a3$export$3986d75fe2da3239);

var $3j7iD = parcelRequire("3j7iD");

var $bZC27 = parcelRequire("bZC27");

var $1TpvD = parcelRequire("1TpvD");

var $hOMxj = parcelRequire("hOMxj");

var $iplo7 = parcelRequire("iplo7");

var $793DL = parcelRequire("793DL");
function $6891aec8439663a3$var$toRGBString({ r: r, g: g, b: b }) {
    return `rgb(${r}, ${g}, ${b})`;
}
function $6891aec8439663a3$var$toRGBAString({ r: r, g: g, b: b, a: a }) {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
const $6891aec8439663a3$var$buttonStyles = {
    light: {
        ['--ds-top-bar-button-background']: 'transparent',
        ['--ds-top-bar-button-background-hovered']: (0, $hOMxj.palette).Neutral200A,
        ['--ds-top-bar-button-background-pressed']: (0, $hOMxj.palette).Neutral300A,
        ['--ds-top-bar-button-border']: (0, $hOMxj.palette).Neutral300A,
        ['--ds-top-bar-button-selected-background']: (0, $hOMxj.palette).Neutral300A,
        ['--ds-top-bar-button-selected-background-hovered']: (0, $hOMxj.palette).Neutral400A,
        ['--ds-top-bar-button-selected-background-pressed']: (0, $hOMxj.palette).Neutral500A,
        ['--ds-top-bar-button-disabled-text']: (0, $hOMxj.palette).Neutral400A,
        ['--ds-top-bar-button-disabled-background']: (0, $hOMxj.palette).Neutral100A
    },
    dark: {
        ['--ds-top-bar-button-background']: 'transparent',
        ['--ds-top-bar-button-background-hovered']: (0, $hOMxj.palette).DarkNeutral200A,
        ['--ds-top-bar-button-background-pressed']: (0, $hOMxj.palette).DarkNeutral300A,
        ['--ds-top-bar-button-border']: (0, $hOMxj.palette).DarkNeutral300A,
        ['--ds-top-bar-button-selected-background']: (0, $hOMxj.palette).DarkNeutral300A,
        ['--ds-top-bar-button-selected-background-hovered']: (0, $hOMxj.palette).DarkNeutral400A,
        ['--ds-top-bar-button-selected-background-pressed']: (0, $hOMxj.palette).DarkNeutral500A,
        ['--ds-top-bar-button-disabled-text']: (0, $hOMxj.palette).DarkNeutral400A,
        ['--ds-top-bar-button-disabled-background']: (0, $hOMxj.palette).DarkNeutral100A
    }
};
const $6891aec8439663a3$var$logoStyles = {
    light: {
        ['--ds-top-bar-logo-icon']: (0, $hOMxj.palette).DarkNeutral0,
        ['--ds-top-bar-logo-text']: (0, $hOMxj.palette).DarkNeutral0
    },
    dark: {
        [(0, $3j7iD.themedLogoIcon)]: (0, $hOMxj.palette).Neutral0,
        [(0, $3j7iD.themedLogoText)]: (0, $hOMxj.palette).Neutral0
    }
};
function $6891aec8439663a3$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
    const backgroundRgb = typeof backgroundColor === 'string' ? (0, $1TpvD.parseHex)(backgroundColor) : backgroundColor;
    const highlightRgb = typeof highlightColor === 'string' ? (0, $1TpvD.parseHex)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    const textColor = (0, $bZC27.getTextColor)(backgroundRgb);
    const colorMode = (0, $bZC27.getColorMode)(backgroundRgb);
    const highlightTextColor = (0, $bZC27.getTextColor)(highlightRgb);
    return {
        backgroundColor: $6891aec8439663a3$var$toRGBString(backgroundRgb),
        color: textColor.hex,
        ...$6891aec8439663a3$var$buttonStyles[colorMode],
        ...$6891aec8439663a3$var$logoStyles[colorMode],
        ...$6891aec8439663a3$var$getSelectedStyles({
            backgroundColor: backgroundRgb,
            colorMode: colorMode
        }),
        /**
		 * Search colors are the same as Nav 3
		 */ [(0, $793DL.themedSearchBorder)]: $6891aec8439663a3$var$toRGBAString({
            ...textColor.rgb,
            a: 0.5
        }),
        [(0, $793DL.themedSearchBorderFocused)]: $6891aec8439663a3$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        /**
		 * Primary button colors are the same as Nav 3,
		 * except the text color which can sometimes differ because we're
		 * now following WCAG
		 */ ['--ds-top-bar-button-primary-background']: $6891aec8439663a3$var$toRGBString(highlightRgb),
        ['--ds-top-bar-button-primary-background-hovered']: $6891aec8439663a3$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        ['--ds-top-bar-button-primary-background-pressed']: $6891aec8439663a3$var$toRGBAString({
            ...highlightRgb,
            a: 0.65
        }),
        ['--ds-top-bar-button-primary-text']: highlightTextColor.hex
    };
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ const $6891aec8439663a3$var$selectedBackgroundRGBA = {
    light: (0, $iplo7.paletteRgba).Neutral300A,
    dark: (0, $iplo7.paletteRgba).DarkNeutral300A
};
function $6891aec8439663a3$var$getSelectedStyles({ backgroundColor: backgroundColor, colorMode: colorMode }) {
    /**
	 * The background color of the selected button in its default state.
	 *
	 * We are referring to this as a foreground color because it is semi-transparent,
	 * so is not the actual color displayed when the button is on top of a background color.
	 */ const foregroundColor = $6891aec8439663a3$var$selectedBackgroundRGBA[colorMode];
    /**
	 * The blended color seen when the selected background is over the top bar.
	 */ const blendedBackground = (0, $bZC27.simpleAlphaComposite)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return {
        ['--ds-top-bar-button-selected-text']: (0, $bZC27.getTextColor)(blendedBackground).hex,
        // Border colors are chosen to match the text, while remaining in the palette
        ['--ds-top-bar-button-selected-border']: (0, $bZC27.isLight)(blendedBackground) ? (0, $hOMxj.palette).Neutral1100 : (0, $hOMxj.palette).DarkNeutral1100
    };
}

});
parcelRegister("3j7iD", function(module, exports) {
$parcel$export(module.exports, "themedLogoIcon", () => $4c6e94c0f2bff50f$export$24328117f1132113);
$parcel$export(module.exports, "themedLogoText", () => $4c6e94c0f2bff50f$export$91b0830f8f4ab279);
$parcel$export(module.exports, "LogoRenderer", () => $4c6e94c0f2bff50f$export$35e88bd9b061a3a4);
/* logo-renderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $d7tnL = parcelRequire("d7tnL");
const $4c6e94c0f2bff50f$export$24328117f1132113 = '--ds-top-bar-logo-icon';
const $4c6e94c0f2bff50f$export$91b0830f8f4ab279 = '--ds-top-bar-logo-text';
function $4c6e94c0f2bff50f$export$35e88bd9b061a3a4({ logoOrIcon: LogoOrIcon }) {
    const hasCustomTheme = (0, $d7tnL.useHasCustomTheme)();
    if (hasCustomTheme) return /*#__PURE__*/ (0, $e79Pd.jsx)(LogoOrIcon, {
        label: "",
        size: "small",
        iconColor: `var(${$4c6e94c0f2bff50f$export$24328117f1132113})`,
        textColor: `var(${$4c6e94c0f2bff50f$export$91b0830f8f4ab279})`
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)(LogoOrIcon, {
        size: "small",
        label: "",
        appearance: "brand"
    });
}
$4c6e94c0f2bff50f$export$35e88bd9b061a3a4.displayName = "LogoRenderer";

});

parcelRegister("bZC27", function(module, exports) {
$parcel$export(module.exports, "isLight", () => $8f4437db069a3a43$export$44af652f4cca9039);
$parcel$export(module.exports, "getColorMode", () => $8f4437db069a3a43$export$5573a5bab3e074b5);
$parcel$export(module.exports, "getTextColor", () => $8f4437db069a3a43$export$5357fe757c335c0d);
$parcel$export(module.exports, "simpleAlphaComposite", () => $8f4437db069a3a43$export$e5e64c30bee1469b);
/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $8f4437db069a3a43$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $8f4437db069a3a43$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
    /**
	 * Normalized sRGB - each channel is between 0 and 1
	 */ const normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
	 * linear RGB - the gamma correction of sRGB is removed and
	 * the channels correspond directly to subpixel intensity
	 */ const linear = {
        r: $8f4437db069a3a43$var$linearizeRGBChannel(normal.r),
        g: $8f4437db069a3a43$var$linearizeRGBChannel(normal.g),
        b: $8f4437db069a3a43$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ const $8f4437db069a3a43$var$flipLuminance = 0.179129;
function $8f4437db069a3a43$export$44af652f4cca9039(color) {
    return $8f4437db069a3a43$var$relativeLuminanceW3C(color) >= $8f4437db069a3a43$var$flipLuminance;
}
function $8f4437db069a3a43$export$5573a5bab3e074b5(backgroundColor) {
    if ($8f4437db069a3a43$var$relativeLuminanceW3C(backgroundColor) >= $8f4437db069a3a43$var$flipLuminance) return 'light';
    return 'dark';
}
const $8f4437db069a3a43$var$textColor = {
    light: {
        hex: '#000',
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: '#FFF',
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $8f4437db069a3a43$export$5357fe757c335c0d(backgroundColor) {
    const colorMode = $8f4437db069a3a43$export$5573a5bab3e074b5(backgroundColor);
    return $8f4437db069a3a43$var$textColor[colorMode];
}
function $8f4437db069a3a43$export$e5e64c30bee1469b({ background: background, foreground: foreground }) {
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}

});

parcelRegister("1TpvD", function(module, exports) {
$parcel$export(module.exports, "parseHex", () => $3d8aef4730e91565$export$103711ef09c6edec);
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
const $3d8aef4730e91565$var$isValidHex = (hex)=>// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex);
function $3d8aef4730e91565$export$103711ef09c6edec(color) {
    if (!$3d8aef4730e91565$var$isValidHex(color)) return null;
    let channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}

});

parcelRegister("hOMxj", function(module, exports) {
$parcel$export(module.exports, "palette", () => $504be2eb04e0e24d$export$eaad8caa32d2521d);
const $504be2eb04e0e24d$export$eaad8caa32d2521d = {
    'DarkNeutral-100': '#111213',
    'DarkNeutral-100A': '#01040475',
    DarkNeutral0: '#18191A',
    DarkNeutral100: '#1F1F21',
    DarkNeutral100A: '#BDBDBD0A',
    DarkNeutral200: '#242528',
    DarkNeutral200A: '#CECED912',
    DarkNeutral250: '#2B2C2F',
    DarkNeutral250A: '#D9DAE71A',
    DarkNeutral300: '#303134',
    DarkNeutral300A: '#E3E4F21F',
    DarkNeutral350: '#3D3F43',
    DarkNeutral350A: '#E8EDFD2E',
    DarkNeutral400: '#4B4D51',
    DarkNeutral400A: '#E5E9F640',
    DarkNeutral500: '#63666B',
    DarkNeutral500A: '#E9F0FB5C',
    DarkNeutral600: '#7E8188',
    DarkNeutral700: '#96999E',
    DarkNeutral800: '#A9ABAF',
    DarkNeutral900: '#BFC1C4',
    DarkNeutral1000: '#CECFD2',
    DarkNeutral1100: '#E2E3E4',
    Neutral0: '#FFFFFF',
    Neutral100: '#F8F8F8',
    Neutral100A: '#17171708',
    Neutral200: '#F0F1F2',
    Neutral200A: '#0515240F',
    Neutral300: '#DDDEE1',
    Neutral300A: '#0B120E24',
    Neutral400: '#B7B9BE',
    Neutral400A: '#080F214A',
    Neutral500: '#8C8F97',
    Neutral500A: '#050C1F75',
    Neutral600: '#7D818A',
    Neutral700: '#6B6E76',
    Neutral800: '#505258',
    Neutral900: '#3B3D42',
    Neutral1000: '#292A2E',
    Neutral1100: '#1E1F21'
};

});

parcelRegister("iplo7", function(module, exports) {
$parcel$export(module.exports, "paletteRgba", () => $a97e5152ec712d03$export$c9b84419dae66a82);
const $a97e5152ec712d03$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};

});

parcelRegister("793DL", function(module, exports) {
$parcel$export(module.exports, "themedSearchBorder", () => $0f409f1a7998b14f$export$ae6fbf5ba3a7a784);
$parcel$export(module.exports, "themedSearchBorderFocused", () => $0f409f1a7998b14f$export$ee42b8430f4c19bd);
$parcel$export(module.exports, "useLegacySearchTheme", () => $0f409f1a7998b14f$export$18a29b1ed2212823);

var $d7tnL = parcelRequire("d7tnL");
const $0f409f1a7998b14f$export$ae6fbf5ba3a7a784 = '--ds-top-bar-search-border';
const $0f409f1a7998b14f$export$ee42b8430f4c19bd = '--ds-top-bar-search-border-focused';
/**
 * Theme object intended for use with Search Platform components while transitioning to nav4.
 *
 * This is for backwards compatibility with the legacy theming API that was designed for nav3.
 *
 * As nav4 matures we will ideally evolve the theming solution inside Search Platform,
 * at which point this legacy theme object will not be needed.
 */ const $0f409f1a7998b14f$var$legacySearchTheme = {
    default: {
        backgroundColor: 'transparent',
        color: 'currentColor',
        borderColor: `var(${$0f409f1a7998b14f$export$ae6fbf5ba3a7a784})`
    },
    focus: {
        /**
     * When expanded the input ignores the custom theme,
     * except for its border which is derived from the highlight color.
     */ color: "var(--ds-text, #292A2E)",
        backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
        borderColor: `var(${$0f409f1a7998b14f$export$ee42b8430f4c19bd})`,
        boxShadow: `inset 0px 0px 0px 1px var(${$0f409f1a7998b14f$export$ee42b8430f4c19bd})`
    },
    hover: {
        /**
     * This is not actually used for the search bar input (at least by the Search Platform components).
     *
     * Instead it's used as the hover background color for a close button when on mobile.
     */ backgroundColor: `var(--ds-top-bar-button-background-hovered)`
    }
};
function $0f409f1a7998b14f$export$18a29b1ed2212823() {
    const hasCustomTheme = (0, $d7tnL.useHasCustomTheme)();
    if (hasCustomTheme) return $0f409f1a7998b14f$var$legacySearchTheme;
    return undefined;
}

});



parcelRegister("77KQh", function(module, exports) {
$parcel$export(module.exports, "useCustomThemeNew", () => $7066214f25c7f2f1$export$92ae7a8762fba89e);

var $euxye = parcelRequire("euxye");

var $bV5W6 = parcelRequire("bV5W6");

var $bgHVp = parcelRequire("bgHVp");

var $1TpvD = parcelRequire("1TpvD");

var $fDU20 = parcelRequire("fDU20");
function $7066214f25c7f2f1$var$toRGBString({ r: r, g: g, b: b }) {
    return `rgb(${r}, ${g}, ${b})`;
}
function $7066214f25c7f2f1$export$92ae7a8762fba89e(theme) {
    const value = (0, $fDU20.useCustomTheme)(theme);
    /**
   * We use the color mode to determine the default background color for the top nav.
   * We need to use the hook because the user could change their color mode preference.
   */ const colorMode = (0, $bV5W6.useColorMode)();
    const hasDefaultBackground = (0, $euxye.useMemo)(()=>{
        if (!value.isEnabled) return true;
        const defaultBackground = (0, $1TpvD.parseHex)((0, $bgHVp.getTokenValue)('elevation.surface', colorMode === 'light' ? '#FFFFFF' : '#1F1F21'));
        return defaultBackground ? value.style.backgroundColor === $7066214f25c7f2f1$var$toRGBString(defaultBackground) : true;
    }, [
        value,
        colorMode
    ]);
    if (value.isEnabled) return {
        ...value,
        hasDefaultBackground: hasDefaultBackground
    };
    return value;
}

});


parcelRegister("d0kkS", function(module, exports) {
$parcel$export(module.exports, "PrimaryButton", () => $4cba800d2d23ee78$export$ac16a6a04d9b7c84);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $4YhY5 = parcelRequire("4YhY5");

var $hZDXn = parcelRequire("hZDXn");

var $g4X1T = parcelRequire("g4X1T");

var $l1MrW = parcelRequire("l1MrW");
function $4cba800d2d23ee78$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4cba800d2d23ee78$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $4cba800d2d23ee78$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $4cba800d2d23ee78$var$buttonBaseStyles = {
    name: "8cx1fx",
    styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
};
const $4cba800d2d23ee78$var$buttonNoOpStyle = {
    name: "zvio0b",
    styles: "--noop:1"
};
const $4cba800d2d23ee78$var$buttonHighlightedStyles = /*#__PURE__*/ (0, $hStPE.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$4cba800d2d23ee78$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$4cba800d2d23ee78$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-radius-xsmall, 1px)",
        borderStartStartRadius: "var(--ds-radius-xsmall, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $4cba800d2d23ee78$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const { children: children, component: component, isHighlighted: isHighlighted, isLoading: isLoading, isSelected: isSelected, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, shortcut: shortcut, ...rest } = props;
    const themeFromContext = (0, $g4X1T.useTheme)();
    const button = /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        style: {
            [$4cba800d2d23ee78$var$VAR_BUTTON_SELECTED_COLOR]: themeFromContext.mode.primaryButton.selected.color,
            [$4cba800d2d23ee78$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: themeFromContext.mode.primaryButton.selected.borderColor
        },
        css: [
            $4cba800d2d23ee78$var$buttonBaseStyles,
            isHighlighted && $4cba800d2d23ee78$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $hStPE.jsx)((0, $4YhY5.default), {
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $l1MrW.getPrimaryButtonTheme)(themeFromContext),
        css: [
            $4cba800d2d23ee78$var$buttonNoOpStyle
        ],
        ...rest
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $hStPE.jsx)((0, $hZDXn.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        shortcut: shortcut
    }, button);
    return button;
});

});
parcelRegister("g4X1T", function(module, exports) {
$parcel$export(module.exports, "useTheme", () => $a7b2c60ea65f21cc$export$93d4e7f90805808f);

var $euxye = parcelRequire("euxye");

var $iutmg = parcelRequire("iutmg");
const $a7b2c60ea65f21cc$export$93d4e7f90805808f = ()=>(0, $euxye.useContext)((0, $iutmg.ThemeContext));

});
parcelRegister("iutmg", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $b30d1d554198e3ac$export$2c657da244d00bd6);

var $euxye = parcelRequire("euxye");

var $dQBft = parcelRequire("dQBft");
const $b30d1d554198e3ac$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $euxye.createContext)((0, $dQBft.defaultTheme));

});
parcelRegister("dQBft", function(module, exports) {
$parcel$export(module.exports, "defaultTheme", () => $51756333323306cb$export$164de7ab8df77ef0);

var $5wXWj = parcelRequire("5wXWj");
const $51756333323306cb$export$164de7ab8df77ef0 = (0, $5wXWj.atlassianTheme);

});
parcelRegister("5wXWj", function(module, exports) {
$parcel$export(module.exports, "atlassianTheme", () => $9aae61b4b29efdca$export$eeee8619e1b91cb0);

var $2rchq = parcelRequire("2rchq");

var $aej1R = parcelRequire("aej1R");
const $9aae61b4b29efdca$export$eeee8619e1b91cb0 = (0, $aej1R.generateTheme)({
    name: (0, $2rchq.DEFAULT_THEME_NAME),
    backgroundColor: '#FFFFFF',
    highlightColor: '#0052CC'
});

});




parcelRegister("l1MrW", function(module, exports) {
$parcel$export(module.exports, "getPrimaryButtonTheme", () => $993afc10596d45f8$export$14dd6915caf431fe);
const $993afc10596d45f8$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});


parcelRegister("lB9M9", function(module, exports) {
$parcel$export(module.exports, "usePanelManager", () => $2745addd4534218f$export$3946869e2f4977e4);

var $lRV6k = parcelRequire("lRV6k");

var $gTGvd = parcelRequire("gTGvd");
function $2745addd4534218f$export$3946869e2f4977e4() {
    const manager = (0, $lRV6k.usePanelActionsInternal)();
    const state = (0, $gTGvd.usePanelStateInternal)();
    return {
        state: state,
        manager: manager
    };
}

});
parcelRegister("lRV6k", function(module, exports) {
$parcel$export(module.exports, "PanelProvider", () => $127f8da661737223$export$e7dba2ce3ae71ca);
$parcel$export(module.exports, "usePanelActionsInternal", () => $127f8da661737223$export$5f6762d4d1cd693d);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iqfTZ = parcelRequire("iqfTZ");


var $bpSpU = parcelRequire("bpSpU");
const $127f8da661737223$export$18d6b45fa585ca8a = /*#__PURE__*/ (0, $euxye.createContext)(null);
/**
 * Pure reducer function handling panel, preloaded entry point, and requested-width state transitions.
 *
 * LayoutWithPanel mirrors its requested width here. To apply provider width changes to an
 * already-mounted layout, connect its panelWidth and onPanelWidthChange props to the provider
 * with platform-dst-panel-system-width-persistence enabled.
 */ function $127f8da661737223$var$panelReducer(state, action) {
    switch(action.type){
        case 'PANEL_OPEN':
            {
                const { instanceId: instanceId, panelContent: panelContent, params: params, shouldReplace: shouldReplace } = action.payload;
                const newPanel = {
                    instanceId: instanceId,
                    panelContent: panelContent,
                    params: params || {}
                };
                if (shouldReplace) return {
                    ...state,
                    activePanels: [
                        newPanel
                    ]
                };
                return {
                    ...state,
                    activePanels: [
                        ...state.activePanels,
                        newPanel
                    ]
                };
            }
        case 'PANEL_OPEN_ENTRYPOINT':
            {
                const { instanceId: instanceId, entryPoint: entryPoint, params: params, entryPointReference: entryPointReference, shouldReplace: shouldReplace } = action.payload;
                const newPanel = {
                    instanceId: instanceId,
                    entryPoint: entryPoint,
                    params: params || {},
                    entryPointReference: entryPointReference
                };
                if (shouldReplace) return {
                    ...state,
                    activePanels: [
                        newPanel
                    ]
                };
                return {
                    ...state,
                    activePanels: [
                        ...state.activePanels,
                        newPanel
                    ]
                };
            }
        case 'PANEL_CLOSE':
            {
                const { instanceId: instanceId } = action.payload;
                return {
                    ...state,
                    activePanels: state.activePanels.filter((p)=>p.instanceId !== instanceId)
                };
            }
        case 'PANEL_SAVE_ENTRYPOINT':
            {
                const { instanceId: instanceId, entryPointReference: entryPointReference } = action.payload;
                const filtered = state.preloadedPanels.filter((p)=>p.instanceId !== instanceId);
                return {
                    ...state,
                    preloadedPanels: [
                        ...filtered,
                        {
                            instanceId: instanceId,
                            entryPointReference: entryPointReference
                        }
                    ]
                };
            }
        case 'PANEL_SET_WIDTH':
            {
                const { width: width } = action.payload;
                if (state.panelWidth === width) return state;
                return {
                    ...state,
                    panelWidth: width
                };
            }
        default:
            return state;
    }
}
function $127f8da661737223$export$e7dba2ce3ae71ca({ children: children, initialState: initialState }) {
    const [state, dispatch] = (0, $euxye.useReducer)($127f8da661737223$var$panelReducer, {
        activePanels: [],
        preloadedPanels: [],
        panelWidth: (0, $iqfTZ.fg)('platform-dst-chat-panel-layout') ? (0, $d7fb64ed546bb10f$export$f1a3e4e33b782668) : (0, $d7fb64ed546bb10f$export$cf6877cd1fb9ba52),
        ...initialState
    });
    // Create stable manager object with memoization
    // This object reference never changes, so ManagerContext consumers never re-render
    const manager = (0, $euxye.useMemo)(()=>{
        return {
            /**
			 * Opens a panel with the given instance ID, entry point, and params.
			 * By default, this replaces any existing panels (single panel mode).
			 *
			 * **Note:** This is a low-level API. For most use cases, prefer using the `Trigger` component,
			 * which handles entry point loading and ID generation automatically.
			 *
			 * **ID Generation:** The instanceId must be provided. For best practices, use the `Trigger`
			 * component's instanceId (either provided or auto-generated) rather than generating IDs
			 * at the manager level. This keeps ID management co-located with the trigger.
			 *
			 * @param instanceId - Unique identifier for this panel instance. Should come from Trigger when possible.
			 * @param entryPoint - Entry point definition (not the loaded reference)
			 * @param params - Optional params to pass to the panel
			 * @param entryPointReference - Optional preloaded entry point reference (typically provided by Trigger)
			 */ openPanel: (instanceId, entryPoint, params, entryPointReference, shouldReplace = true)=>{
                dispatch({
                    type: 'PANEL_OPEN_ENTRYPOINT',
                    payload: {
                        instanceId: instanceId,
                        entryPoint: entryPoint,
                        params: params,
                        entryPointReference: entryPointReference,
                        shouldReplace: shouldReplace
                    }
                });
            },
            closePanel: (instanceId)=>{
                dispatch({
                    type: 'PANEL_CLOSE',
                    payload: {
                        instanceId: instanceId
                    }
                });
            },
            /**
			 * Replaces the current panel(s) with a new panel via entrypoints.
			 * This is a convenience method that closes all existing panels and opens a new one.
			 *
			 * @param instanceId - Unique identifier for this panel instance
			 * @param entryPoint - Entry point definition (not the loaded reference)
			 * @param params - Optional params to pass to the panel
			 * @param entryPointReference - Optional preloaded entry point reference
			 */ replacePanelEntryPoint: (instanceId, entryPoint, params, entryPointReference)=>{
                dispatch({
                    type: 'PANEL_OPEN_ENTRYPOINT',
                    payload: {
                        instanceId: instanceId,
                        entryPoint: entryPoint,
                        params: params,
                        entryPointReference: entryPointReference,
                        shouldReplace: true
                    }
                });
            },
            /**
			 * Replaces the current panel(s) with a new panel by providing panel content.
			 * This is a convenience method that closes all existing panels and opens a new one.
			 *
			 * @param instanceId - Unique identifier for this panel instance
			 * @param panelContent - Panel content (ReactNode) to render inside the panel
			 * @param params - Optional params to pass to the panel
			 */ replacePanel: (instanceId, panelContent, params)=>{
                dispatch({
                    type: 'PANEL_OPEN',
                    payload: {
                        instanceId: instanceId,
                        params: params,
                        shouldReplace: true,
                        panelContent: panelContent
                    }
                });
            },
            /**
			 * Saves a preloaded EntryPoint reference for a given panel instance.
			 * Useful for mixing Trigger and programmatic panel opening.
			 *
			 * @param instanceId - Unique identifier for this panel instance
			 * @param entryPointReference - Preloaded EntryPoint reference
			 */ saveEntryPointReference: (instanceId, entryPointReference)=>{
                dispatch({
                    type: 'PANEL_SAVE_ENTRYPOINT',
                    payload: {
                        instanceId: instanceId,
                        entryPointReference: entryPointReference
                    }
                });
            },
            setPanelWidth: (width)=>{
                dispatch({
                    type: 'PANEL_SET_WIDTH',
                    payload: {
                        width: width
                    }
                });
            }
        };
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($127f8da661737223$export$18d6b45fa585ca8a.Provider, {
        value: manager,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bpSpU.StateContext).Provider, {
            value: state,
            children: children
        })
    });
}
$127f8da661737223$export$e7dba2ce3ae71ca.displayName = "PanelProvider";
function $127f8da661737223$export$5f6762d4d1cd693d() {
    const manager = (0, $euxye.useContext)($127f8da661737223$export$18d6b45fa585ca8a);
    if (!manager) throw new Error("usePanelActionsInternal must be used within a <PanelProvider>. Wrap your app with: <PanelProvider><App /></PanelProvider>");
    return manager;
}

});
const $d7fb64ed546bb10f$export$cf6877cd1fb9ba52 = 365;
const $d7fb64ed546bb10f$export$f1a3e4e33b782668 = 400;

parcelRegister("bpSpU", function(module, exports) {
$parcel$export(module.exports, "StateContext", () => $5160e9d206303811$export$437ae3f50102760d);

var $euxye = parcelRequire("euxye");
const $5160e9d206303811$export$437ae3f50102760d = /*#__PURE__*/ (0, $euxye.createContext)(null);

});


parcelRegister("gTGvd", function(module, exports) {
$parcel$export(module.exports, "usePanelStateInternal", () => $fdc4a60e643a58a8$export$3fff25b77d81bf59);

var $euxye = parcelRequire("euxye");

var $bpSpU = parcelRequire("bpSpU");
function $fdc4a60e643a58a8$export$3fff25b77d81bf59() {
    const state = (0, $euxye.useContext)((0, $bpSpU.StateContext));
    if (!state) throw new Error("usePanelStateInternal must be used within a <PanelProvider>. Wrap your app with: <PanelProvider><App /></PanelProvider>");
    return state;
}

});


parcelRegister("hXMfa", function(module, exports) {
$parcel$export(module.exports, "Help", () => $022b21eb4febaf05$export$1be7516c0280bee8);
/**
 * @jsxRuntime classic
 */ 
var $euxye = parcelRequire("euxye");

var $iCEM6 = parcelRequire("iCEM6");

var $jCYXR = parcelRequire("jCYXR");

var $2sB6P = parcelRequire("2sB6P");
const $022b21eb4febaf05$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $022b21eb4febaf05$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $euxye.forwardRef)(function Help({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, isListItem: isListItem, badge: badge, shortcut: shortcut }, ref) {
    const sharedProps = {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iCEM6))),
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        isSelected: isSelected,
        testId: testId,
        interactionName: interactionName,
        ref: ref,
        shortcut: shortcut
    };
    if (!badge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2sB6P.EndItem), {
        ...sharedProps,
        isListItem: isListItem
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jCYXR.BadgeContainer), {
        id: $022b21eb4febaf05$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2sB6P.EndItem), {
        ...sharedProps,
        // We explicitly set the EndItem to not be a list item,
        // because the BadgeContainer already has a list item role (if `isListItem` is true)
        isListItem: false
    }));
});

});
parcelRegister("jCYXR", function(module, exports) {
$parcel$export(module.exports, "BadgeContainer", () => $96e374793ce0339a$export$f710265eb5a003da);
/* badge-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $96e374793ce0339a$var$styles = {
    root: "_1mT5xdRAKS _3iDTPbQ4SZ",
    badgeContainer: "_1mT5xdWVPG _1ANEUSLRg7 _2I62gz5UaJ _3iC0zd8HPE _1pp6NdYbGa"
};
const $96e374793ce0339a$export$f710265eb5a003da = ({ children: children, id: badgeId, badge: Badge, isListItem: isListItem = true })=>/*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        role: isListItem ? 'listitem' : undefined,
        className: (0, $4jQY2.default)([
            $96e374793ce0339a$var$styles.root
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                id: badgeId,
                "aria-hidden": true,
                className: (0, $4jQY2.default)([
                    $96e374793ce0339a$var$styles.badgeContainer
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)(Badge, {})
            })
        ]
    });
$96e374793ce0339a$export$f710265eb5a003da.displayName = "BadgeContainer";

});

parcelRegister("2sB6P", function(module, exports) {
$parcel$export(module.exports, "EndItem", () => $3343e21f86c4ec9e$export$b3477e90773be2d0);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $dDQf8 = parcelRequire("dDQf8");

var $fX8LH = parcelRequire("fX8LH");
const $3343e21f86c4ec9e$export$b3477e90773be2d0 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem = true, shortcut: shortcut }, forwardedRef)=>{
    const Wrapper = isListItem ? (0, $dDQf8.ListItem) : (0, $euxye.Fragment);
    return /*#__PURE__*/ (0, $e79Pd.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fX8LH.IconButton), {
            ref: forwardedRef,
            icon: icon,
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            appearance: "subtle",
            isSelected: isSelected,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            // Only creating object when shortcut is provided
            tooltip: shortcut ? {
                shortcut: shortcut
            } : undefined
        })
    });
});

});
parcelRegister("dDQf8", function(module, exports) {
$parcel$export(module.exports, "ListItem", () => $162e1872d3009242$export$a7b06bfba60a8a78);
/* list-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
function $162e1872d3009242$var$_ListItem({ children: children, testId: testId, xcss: xcss }, ref) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId,
        children: children
    });
}
const $162e1872d3009242$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $euxye.forwardRef)($162e1872d3009242$var$_ListItem);

});



parcelRegister("38wW7", function(module, exports) {
$parcel$export(module.exports, "Notifications", () => $e4bb4d00a496cfef$export$36ba2f559d49a8f6);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2OHo9 = parcelRequire("2OHo9");

var $jCYXR = parcelRequire("jCYXR");

var $2sB6P = parcelRequire("2sB6P");
const $e4bb4d00a496cfef$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $e4bb4d00a496cfef$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $euxye.forwardRef)(function Notifications({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem, badge: badge, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jCYXR.BadgeContainer), {
        id: $e4bb4d00a496cfef$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2sB6P.EndItem), {
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            isSelected: isSelected,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            ref: ref,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2OHo9))),
            // We explicitly set the EndItem to not be a list item,
            // because the BadgeContainer already has a list item role (if `isListItem` is true)
            isListItem: false,
            shortcut: shortcut
        })
    });
});

});

parcelRegister("3QxIB", function(module, exports) {
$parcel$export(module.exports, "AppLogo", () => $639dcf1c725ee7f1$export$113a612889e1565d);
/* app-logo.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $9S1b6 = parcelRequire("9S1b6");

var $iqfTZ = parcelRequire("iqfTZ");

var $9MWap = parcelRequire("9MWap");
var $defJG = parcelRequire("defJG");
var $8Sdzy = parcelRequire("8Sdzy");

var $hZDXn = parcelRequire("hZDXn");

var $av7P9 = parcelRequire("av7P9");

var $d7tnL = parcelRequire("d7tnL");

var $3j7iD = parcelRequire("3j7iD");
const $639dcf1c725ee7f1$var$anchorStyles = {
    root: "_0bjKvD8fU6 _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VUofl _3YEZNOdnbC _0GTcwR1Y8M _4kLJBnyL8i _0mJftuYbGa _1vb6Qj6wH8 _4vhRtvOLYo",
    interactionStates: "_1eOmH6o126 _3gzVzLJovG",
    interactionStatesCustomTheming: "_1eOmH6JxD8 _3gzVzL8abp",
    fullHeightSidebar: "_4bt5LAnQyn _2WAcuGnQyn _3YEZNO7dHp"
};
const $639dcf1c725ee7f1$var$logoWrapperStyles = {
    root: "_2Y7lL41Y8M",
    fullHeightSidebar: "_1EqgXlN91d"
};
const $639dcf1c725ee7f1$var$iconContainerStyles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _1EqgXloWWg _0NUa3roWWg",
    fullHeightSidebar: "_3YEZNOdnbC"
};
const $639dcf1c725ee7f1$var$logoTextStyles = {
    root: "_39xV02W9qI _1EqgXlsz7G _20VacPYbGa _03SyCPFQfX _3iDTPbYbGa _0aFT5vbt8w _37wbyuDIqT _2rc81eQ4SZ"
};
const $639dcf1c725ee7f1$var$secondaryNameStyles = {
    root: "_43nrzTLl21"
};
function $639dcf1c725ee7f1$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $639dcf1c725ee7f1$export$113a612889e1565d = ({ name: name, label: label, secondaryName: secondaryName, href: href, icon: icon, onClick: onClick })=>{
    const isFhsEnabled = (0, $av7P9.useIsFhsEnabled)();
    const ref = (0, $euxye.useRef)(null);
    const nameRef = (0, $euxye.useRef)(null);
    const hasCustomTheme = (0, $d7tnL.useHasCustomTheme)();
    const showSecondaryName = Boolean(secondaryName) && (0, $iqfTZ.fg)('platform_dst_ads_appswitcher_improvements');
    /**
   * Show the tooltip if the name is truncated
   */ const canTooltipAppear = (0, $euxye.useCallback)(()=>{
        const text = nameRef.current;
        return Boolean(text && $639dcf1c725ee7f1$var$isTextClamped(text));
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9MWap.Anchor), {
        ref: ref,
        "aria-label": label,
        href: href,
        // @ts-expect-error - non-standard values for `borderRadius` and the custom theming interaction states
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $9S1b6.cx)($639dcf1c725ee7f1$var$anchorStyles.root, hasCustomTheme ? $639dcf1c725ee7f1$var$anchorStyles.interactionStatesCustomTheming : $639dcf1c725ee7f1$var$anchorStyles.interactionStates, isFhsEnabled && $639dcf1c725ee7f1$var$anchorStyles.fullHeightSidebar),
        onClick: onClick,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.Inline), {
            space: "space.075",
            alignBlock: "center",
            xcss: (0, $9S1b6.cx)($639dcf1c725ee7f1$var$logoWrapperStyles.root, isFhsEnabled && $639dcf1c725ee7f1$var$logoWrapperStyles.fullHeightSidebar),
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $639dcf1c725ee7f1$var$iconContainerStyles.root,
                        isFhsEnabled && $639dcf1c725ee7f1$var$iconContainerStyles.fullHeightSidebar
                    ]),
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3j7iD.LogoRenderer), {
                        logoOrIcon: icon
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsxs)("span", {
                    className: (0, $4jQY2.default)([
                        $639dcf1c725ee7f1$var$logoTextStyles.root
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
                            content: name,
                            position: "bottom",
                            ignoreTooltipPointerEvents: true,
                            hideTooltipOnMouseDown: true,
                            // We don't need a duplicate hidden element containing tooltip content
                            // as the content of the tooltip matches what is rendered in the nav item.
                            isScreenReaderAnnouncementDisabled: true,
                            canAppear: canTooltipAppear,
                            children: (tooltipProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                                    ...tooltipProps,
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                                        "aria-hidden": true,
                                        color: "inherit",
                                        weight: "semibold",
                                        maxLines: 1,
                                        ref: nameRef,
                                        children: name
                                    })
                                })
                        }),
                        showSecondaryName && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                            className: (0, $4jQY2.default)([
                                $639dcf1c725ee7f1$var$secondaryNameStyles.root
                            ]),
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.Text), {
                                "aria-hidden": true,
                                color: "color.text.subtlest",
                                weight: "regular",
                                maxLines: 1,
                                size: "small",
                                children: secondaryName
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$639dcf1c725ee7f1$export$113a612889e1565d.displayName = "AppLogo";

});

parcelRegister("jTfIv", function(module, exports) {
$parcel$export(module.exports, "CustomLogo", () => $c75b865b60fec6c1$export$4156d88e9ccc616b);
/* custom-logo.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $9S1b6 = parcelRequire("9S1b6");

var $9MWap = parcelRequire("9MWap");

var $av7P9 = parcelRequire("av7P9");

var $d7tnL = parcelRequire("d7tnL");

var $3j7iD = parcelRequire("3j7iD");
const $c75b865b60fec6c1$var$anchorStyles = {
    root: "_0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VUofl",
    customLogoBorderRadius: "_0bjKvD8fU6",
    newMargin: "_0GTcwR1Y8M",
    newInteractionStates: "_1eOmH6o126 _3gzVzLJovG",
    newInteractionStatesCustomTheming: "_1eOmH6JxD8 _3gzVzL8abp"
};
const $c75b865b60fec6c1$var$sharedIconOrLogoContainerStyles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _2Y7lL41Y8M _0LETLXoWWg _1PTmduOLYo _3G0Ib8gIor",
    withFullHeightSidebar: "_1EqgXlN91d _4ouGXIoWWg"
};
const $c75b865b60fec6c1$var$iconContainerStyles = {
    root: "_3iDTPbQ4SZ _1EqgXloWWg _24h04iyL8i _2rc81eYbGa"
};
const $c75b865b60fec6c1$var$logoContainerStyles = {
    root: "_3iDTPbYbGa _1EqgXlsz7G _24h04iyL8i _2rc81eQ4SZ"
};
const $c75b865b60fec6c1$export$4156d88e9ccc616b = ({ href: href, logo: logo, icon: icon, onClick: onClick, label: label })=>{
    const ref = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        return;
    }, []);
    const hasCustomTheme = (0, $d7tnL.useHasCustomTheme)();
    const isFhsEnabled = (0, $av7P9.useIsFhsEnabled)();
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $9MWap.Anchor), {
        ref: ref,
        "aria-label": label,
        href: href,
        // @ts-expect-error - non-standard values for `borderRadius` and the custom theming interaction states
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $9S1b6.cx)($c75b865b60fec6c1$var$anchorStyles.root, $c75b865b60fec6c1$var$anchorStyles.customLogoBorderRadius, $c75b865b60fec6c1$var$anchorStyles.newMargin, hasCustomTheme ? $c75b865b60fec6c1$var$anchorStyles.newInteractionStatesCustomTheming : $c75b865b60fec6c1$var$anchorStyles.newInteractionStates),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    $c75b865b60fec6c1$var$sharedIconOrLogoContainerStyles.root,
                    $c75b865b60fec6c1$var$iconContainerStyles.root,
                    isFhsEnabled && $c75b865b60fec6c1$var$sharedIconOrLogoContainerStyles.withFullHeightSidebar
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3j7iD.LogoRenderer), {
                    logoOrIcon: icon
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    $c75b865b60fec6c1$var$sharedIconOrLogoContainerStyles.root,
                    $c75b865b60fec6c1$var$logoContainerStyles.root,
                    isFhsEnabled && $c75b865b60fec6c1$var$sharedIconOrLogoContainerStyles.withFullHeightSidebar
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3j7iD.LogoRenderer), {
                    logoOrIcon: logo
                })
            })
        ]
    });
};
$c75b865b60fec6c1$export$4156d88e9ccc616b.displayName = "CustomLogo";

});

parcelRegister("9Y5Vz", function(module, exports) {
$parcel$export(module.exports, "CustomTitle", () => $29ca17df91b5c2fb$export$9ccddf7ee2a0e24e);
/* custom-title.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $d7tnL = parcelRequire("d7tnL");
const $29ca17df91b5c2fb$var$styles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _1ANEUSLRg7 _1EqgXlgZxp _39HuIbz8Lp _0LQT5E1Y8M _03SyCP2ADO _3iDTPbYbGa _2rc81eQ4SZ",
    subtleText: "_1UtDYzZpcK"
};
const $29ca17df91b5c2fb$export$9ccddf7ee2a0e24e = /*#__PURE__*/ (0, $euxye.forwardRef)(function CustomTitle({ children: children, testId: testId }, ref) {
    const hasCustomTheme = (0, $d7tnL.useHasCustomTheme)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            $29ca17df91b5c2fb$var$styles.root,
            !hasCustomTheme && $29ca17df91b5c2fb$var$styles.subtleText
        ]),
        children: children
    });
});

});

parcelRegister("1oKpZ", function(module, exports) {
$parcel$export(module.exports, "LogIn", () => $4119c59a23acd987$export$88195aaac9f90319);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $5FApK = parcelRequire("5FApK");

var $dDQf8 = parcelRequire("dDQf8");

var $2mLzk = parcelRequire("2mLzk");
const $4119c59a23acd987$export$88195aaac9f90319 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, interactionName: interactionName, href: href, label: label }, ref)=>/**
		 * This component doesn't use `EndItem` internally because it renders a
		 * `LinkIconButton` instead of an `IconButton`.
		 *
		 * We could make another abstraction, but this is the only top navigation item
		 * that renders a link.
		 */ /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dDQf8.ListItem), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2mLzk.LinkIconButton), {
            ref: ref,
            label: label,
            href: href,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            testId: testId,
            interactionName: interactionName,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5FApK))),
            appearance: "subtle",
            isTooltipDisabled: false
        })
    }));

});
parcelRegister("2mLzk", function(module, exports) {
$parcel$export(module.exports, "LinkIconButton", () => $540d4dca8c002b60$export$edad7fca51b767e1);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $lMezl = parcelRequire("lMezl");

var $d7tnL = parcelRequire("d7tnL");

var $faZlw = parcelRequire("faZlw");
const $540d4dca8c002b60$export$edad7fca51b767e1 = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $d7tnL.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $faZlw.ThemedLinkIconButton) : (0, $lMezl.default);
    return /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("faZlw", function(module, exports) {
$parcel$export(module.exports, "ThemedLinkIconButton", () => $345a852830754c99$export$a1ab08e79d264ec8);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $lpQqY = parcelRequire("lpQqY");

var $ljVHR = parcelRequire("ljVHR");

var $hZDXn = parcelRequire("hZDXn");

var $apUrw = parcelRequire("apUrw");

var $ffDyU = parcelRequire("ffDyU");
function $345a852830754c99$var$ThemedLinkIconButtonFn({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
				 * The `aria-describedby` from `triggerProps` is intentionally not passed down,
				 * because it would cause double announcements with the `VisuallyHidden` label.
				 *
				 * The `@atlaskit/button` IconButton uses the same approach.
				 */ /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ffDyU.ThemedAnchor), {
                ...props,
                shape: "square",
                ref: (0, $ljVHR.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)(Icon, {
                        label: "",
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apUrw.default), {
                        children: label
                    })
                ]
            })
    });
}
$345a852830754c99$var$ThemedLinkIconButtonFn.displayName = "ThemedLinkIconButtonFn";
const $345a852830754c99$export$a1ab08e79d264ec8 = (0, $lpQqY.default)($345a852830754c99$var$ThemedLinkIconButtonFn);

});



parcelRegister("dbQw2", function(module, exports) {
$parcel$export(module.exports, "Profile", () => $ce600d1fb3c28a0d$export$5120f2d0b8d4cab8);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $8z2GW = parcelRequire("8z2GW");

var $2sB6P = parcelRequire("2sB6P");
const $ce600d1fb3c28a0d$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ src: src, ...props }, ref)=>{
    const ProfileAvatar = (0, $euxye.useCallback)(()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $8z2GW.default), {
            appearance: "circle",
            src: src,
            size: "small"
        }), [
        src
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2sB6P.EndItem), {
        ...props,
        ref: ref,
        icon: ProfileAvatar
    });
});

});

parcelRegister("fbmzj", function(module, exports) {
$parcel$export(module.exports, "Settings", () => $0b26541f705a8a91$export$c72f6eaae7b9adff);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $gBaKj = parcelRequire("gBaKj");

var $2sB6P = parcelRequire("2sB6P");
const $0b26541f705a8a91$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $2sB6P.EndItem), {
        ...props,
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gBaKj)))
    }));

});

parcelRegister("jPTMp", function(module, exports) {
$parcel$export(module.exports, "default", () => $71dacea26540c012$export$2e2bcd8739ae039);
/* skeleton-heading-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $71dacea26540c012$var$styles = {
    skeleton: "_4c065UPgdg _2Y7lL45zaO _2Gfj6iQEt6 _4Gb5FivLZJ _2jfUf9r1As _47eTBt2ADO _3wEj0XGsB2 _0GBAIrogpp",
    customWidth: "_2jfUf9yRC6"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-item.tsx
 *
 * Please update both.
 */ const $71dacea26540c012$var$shimmerKeyframes = null;
/**
 * These styles are defined using `css` rather than `cssMap` as there is a
 * bug when using `cssMap` that causes a build failure due to the use of keyframes.
 */ const $71dacea26540c012$var$shimmerStyles = null;
/**
 * __Skeleton heading item__
 *
 * A skeleton heading item is used in place of a heading item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $71dacea26540c012$var$SkeletonHeadingItem = ({ isShimmering: isShimmering = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $71dacea26540c012$var$styles.skeleton,
            width && $71dacea26540c012$var$styles.customWidth,
            isShimmering && "",
            isShimmering && "_21qtfOkSs3 _0160FKkSs3 _1nw4qxfONH _1iAcE9fONH _2VLDZtSHWH _0YTlblSHWH _30VpOT55dm _2ofBtg55dm _2WuqwLHVQb _2lXp1JHVQb _3wEj0XGsB2 _4diMdqGsB2",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-ds--menu--skeleton-heading-item": true,
        "data-testid": testId
    });
};
$71dacea26540c012$var$SkeletonHeadingItem.displayName = "SkeletonHeadingItem";
var $71dacea26540c012$export$2e2bcd8739ae039 = $71dacea26540c012$var$SkeletonHeadingItem;

});

const $32f4f7c20d37fe6f$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $32f4f7c20d37fe6f$export$f005e2e9f707cb5f = 'commercial';
const $32f4f7c20d37fe6f$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $32f4f7c20d37fe6f$export$a739cd5aac835909 = 'stg';
const $32f4f7c20d37fe6f$export$42dd0cdd351a4a9 = 'prod';
const $32f4f7c20d37fe6f$export$404582bc18fe4d9e = 'dev';

// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $28faff212a143649$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $41191a919c68fe1a$export$7d0a15ee70427305 = 2147483647;

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $bba7dc78ee4d9c2c$export$fd3d00026297c0ad = 'text/plain';

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $3db3d7ba430e6e3e$export$4c44a460f123106 = 'text/uri-list';

/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $493a15c399719ace$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

const $f12a3c5938f2e39b$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $f12a3c5938f2e39b$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $f12a3c5938f2e39b$export$13f57c02915787b3 = 'atlaskit-portal';

const $607cd8ed0bd97f9c$export$ed5835cc67e87f72 = 'akPortalMount';
const $607cd8ed0bd97f9c$export$80816bd900e5bd00 = 'akPortalUnmount';

const $454bc9fe95ddf677$export$42f4885608027d0c = 'non_boolean';

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

/* eslint-disable jira/filename-case */ const $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $eb8cfa569eede1a9$export$e9c56aa3b027d98f = 'jira-customer-service';
const $eb8cfa569eede1a9$export$1346c9aa3cbb477d = 'jira-software';
const $eb8cfa569eede1a9$export$202f50ee62667e32 = 'jira-product-discovery';
const $eb8cfa569eede1a9$export$db515c8cec1e6f79 = 'jira-core';
const $eb8cfa569eede1a9$export$c811f21c9ad05dc2 = 'confluence';
const $eb8cfa569eede1a9$export$961148c98d198270 = 'opsgenie';
const $eb8cfa569eede1a9$export$a310f85340477585 = 'assets';
const $eb8cfa569eede1a9$export$d5e9b613bc4c47f = 'compass';

const $8fdfc4bb9d992697$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $8fdfc4bb9d992697$export$f005e2e9f707cb5f = 'commercial';
const $8fdfc4bb9d992697$export$17b81a3d6c98013c = 'isolated-cloud';
const $8fdfc4bb9d992697$export$a739cd5aac835909 = 'staging';
const $8fdfc4bb9d992697$export$42dd0cdd351a4a9 = 'prod';
const $8fdfc4bb9d992697$export$404582bc18fe4d9e = 'dev';
const $8fdfc4bb9d992697$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $8fdfc4bb9d992697$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $8fdfc4bb9d992697$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $8fdfc4bb9d992697$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $8fdfc4bb9d992697$export$b61e047ddcc35726 = 'GCP';
const $8fdfc4bb9d992697$export$1baf17f3e645a2b2 = 'AWS';

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // this is autogenerated file, see scripts/version-update.js
const $00148203a485acf7$export$a4ad2735b021c132 = '1.9.1';

const $e2756ba340ada086$export$790b3707cd7b148f = 'network';
const $e2756ba340ada086$export$31e3351e7cd6ef5 = 'memory';
const $e2756ba340ada086$export$1f09aaaa930516f = 'disk';

const $a33a0b7c1b6db775$export$3f072f06b90c3985 = 'navigation';

const $9eab319dcc173e7e$export$d6830277b06edd6 = 'normal';
const $9eab319dcc173e7e$export$1eee5ddc4f6d41c5 = 400;

// Gate off keepAlive. UCT refresh window:
// https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $4987114a75f06bf7$export$8b012b965402e06a = 580000;
const $4987114a75f06bf7$export$68a6a6cccbaf5f06 = 30000;
const $4987114a75f06bf7$export$6fe3216720bb7a79 = 15000;
const $4987114a75f06bf7$export$e5f3cb8ab5223cd4 = 15000;
const $4987114a75f06bf7$export$bf6cd96e19b2987f = 100;
const $4987114a75f06bf7$export$bcf3b302e1a0ba63 = 30000;
const $4987114a75f06bf7$export$6a0c27ebdbd1f0ed = 240;
const $4987114a75f06bf7$export$3f57674185473b5d = 5000;
const $4987114a75f06bf7$export$1ad8434180c5936c = 300000;

const $395af3bcc45812d9$export$81189edc9b923717 = 1;

const $a858cae85500b1b2$export$cf090d5281b5ae06 = 10000;
const $a858cae85500b1b2$export$8575e30be0feb909 = 30000;

// temp solution until we can get it automated
const $c6ef15cf6ce743a7$export$2295b861f318254a = '0.1.5';

const $f262fb6c2e32d015$export$d8b468db8a225bc9 = 250;

const $a25ce74b7f405cc1$export$e5a5b1df38d9e289 = 4;

const $42033962320073ac$export$5e28bf885ebebfa6 = '[browser-storage-controls]';
const $42033962320073ac$export$aeb1f5aa1188ce28 = 5000; // min gap between sends of the same action
const $42033962320073ac$export$ee3d07c2528881e2 = 10; // hard cap per action per page load

/* eslint-disable jira/filename-case */ const $d0b0f317b4f60123$export$881d135f98d8d7d0 = 100;
const $d0b0f317b4f60123$export$9ab5bdcb8a1d6c34 = false;
const $d0b0f317b4f60123$export$f267d0e9ab3eb265 = false;
const $d0b0f317b4f60123$export$12c1dc38ea1692da = 0;
const $d0b0f317b4f60123$export$34932e325e1234b3 = false;

const $7bbaa8ad37f7eb61$export$98a7370239de6730 = 86400000;

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $dad283f7a54162bf$export$338a9f6c7a1f02b0 = 'text/html';

// ACT Event types
// AdControlDropdownMenu
const $89f94d9a31406c96$export$17ff257e1f6e39f5 = 'AD_CONTROL_DROP_DOWN_MENU_OPENED';
const $89f94d9a31406c96$export$7fc09cf740f33ed4 = 'AD_CONTROL_DROP_DOWN_MENU_CLOSED';
const $89f94d9a31406c96$export$e33200507ac1d20a = 'DISMISS_STARTED';
const $89f94d9a31406c96$export$103f41d1f3bf374e = 'DISMISS_SUCCEEDED';
const $89f94d9a31406c96$export$6d3088110036f124 = 'DISMISS_FAILED';
const $89f94d9a31406c96$export$5595c6967e83d351 = 'REASONS_BUTTON_CLICKED';
const $89f94d9a31406c96$export$ff50ad60f08a4bc0 = 'REASONS_MODAL_SHOWN';
const $89f94d9a31406c96$export$6bd2d8eacca15ce1 = 'REASONS_MODAL_DISMISSED';
const $89f94d9a31406c96$export$5c5fc6956b7600ea = 'FLAG_DISMISSED';

// same types defined in analytics-web-client but avoid creating dependency with that
const $6d4033511f75ada1$export$a1562d08625f5d7e = 'ui';
const $6d4033511f75ada1$export$947dac6c72b26f81 = 'track';
const $6d4033511f75ada1$export$f1d537d508d2945a = 'screen';
const $6d4033511f75ada1$export$12346a674644c156 = 'operational';
const $6d4033511f75ada1$export$b055de0e665cb20c = 'unknown';

/* eslint-disable jira/filename-case */ const $8f860a533cc71fca$export$ff39ebd4bb12b718 = 201;
const $8f860a533cc71fca$export$3288b14b6745c572 = 204;
const $8f860a533cc71fca$export$9de493bcd9b1d977 = 400;
const $8f860a533cc71fca$export$67d19e9a991baa07 = 401;
const $8f860a533cc71fca$export$a3269a3914b007e3 = 403;
const $8f860a533cc71fca$export$8bca792d963eb0ef = 404;
const $8f860a533cc71fca$export$4a3cb39801694eee = 407;
const $8f860a533cc71fca$export$fa405bbf47d510e2 = 408;
const $8f860a533cc71fca$export$c09e7ea0fc79f34f = 409;
const $8f860a533cc71fca$export$5244030134e99 = 412;
const $8f860a533cc71fca$export$f90ac1df0b60853d = 413;
const $8f860a533cc71fca$export$a447d0a965e16776 = 422;
const $8f860a533cc71fca$export$3b48aba8957000cd = 426;
const $8f860a533cc71fca$export$6763168a631449a2 = 429;
const $8f860a533cc71fca$export$e813cd7045fcc98d = 500;
const $8f860a533cc71fca$export$2ce38d41a306034e = 502;
const $8f860a533cc71fca$export$974c37534b0191b1 = 503;
const $8f860a533cc71fca$export$5400e8dddac3fcf3 = 504;

/* eslint-disable jira/filename-case */ const $f0e9a194674bc930$export$b5a308a17bc991f3 = 'projectKey';
const $f0e9a194674bc930$export$929d50f83189406c = 'boardId';
const $f0e9a194674bc930$export$da6f46390e1a426f = 'projectId';

/* eslint-disable jira/filename-case */ const $5f6e091542d432a9$export$b8b9d90f9e5bd72b = 'jiraAtlassianNavigationNav4';
const $5f6e091542d432a9$export$d57b6b390e78d90f = 'jira-cosmos';
const $5f6e091542d432a9$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
const $5f6e091542d432a9$export$eed606b4351295d7 = 'login';
const $5f6e091542d432a9$export$35e541d26a145a7c = 'logout';

/* eslint-disable jira/filename-case */ const $3b258ee19859baa5$export$2bd315ece9f68967 = 'v4';

/* eslint-disable jira/filename-case */ const $192a2eeaa0a1dbf6$export$2ee9e5a3556c1e43 = 'sidebar';
const $192a2eeaa0a1dbf6$export$793ed84f5e13fedc = 'top';
const $192a2eeaa0a1dbf6$export$f1c9dd0f5207dd5e = 'tab';
const $192a2eeaa0a1dbf6$export$b83d0ee9325a2d0a = 'projectTitle';

/* eslint-disable jira/filename-case */ // TopNav or sidebar
const $fad9173ee481d7de$export$17ff3f7e02c6ac22 = 'global';
const $fad9173ee481d7de$export$33d8c916a600c5e9 = 'container';

/* eslint-disable jira/filename-case */ const $6b2913942bd90807$export$6dd9406e478a1fe2 = 'navigationItem';
const $6b2913942bd90807$export$b887e88d8d0739f6 = 'button';
const $6b2913942bd90807$export$64fed82162bd367 = 'dropdownItem';
const $6b2913942bd90807$export$b0a8b257f1f878a2 = 'searchInput';

const $5bdb53f12f87b5a8$export$cb2f616a76599e00 = 'APP_SWITCHER';

const $b435b412b2dfd147$export$b8b9d90f9e5bd72b = '@jira/navigation-apps__atlassian-navigation';
const $b435b412b2dfd147$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $b435b412b2dfd147$export$9934c8d98fd9e572 = 'atlassianSwitcher';

const $da40f9c8c8a3398d$export$3364800d9d60baf9 = 'localStorage';

const $f50a465f4b3fb0e5$export$45e63649edff1e2a = 'ASSETS';
const $f50a465f4b3fb0e5$export$eb7589a4ee50c678 = 'tenantless';

const $11c0f1bd3f72e082$export$c2c502a6524b22c7 = 'com.atlassian.jira.modules.servicemanagement.status-pages-entity:status-pages-entity-field-cftype';

const $cc897b291750f655$export$e26f00bd90899835 = 'success';
const $cc897b291750f655$export$edb46161045fece7 = 'error';

/**
 * CSS variables that mirror the legacy `@atlaskit/page-layout` CSS custom properties.
 *
 * These are provided for consumers that previously relied on the `@atlaskit/page-layout`
 * CSS variables and need to reference them when using the navigation system.
 */ const $7c8e8130cce4c6fa$export$f963aecf2d4465bd = 'var(--leftPanelWidth, 0px)';
const $7c8e8130cce4c6fa$export$750459958906793 = 'var(--rightPanelWidth, 0px)';
const $7c8e8130cce4c6fa$export$f897e1ed9f8ed251 = 'var(--leftSidebarWidth, 0px)';
const $7c8e8130cce4c6fa$export$b44ab66843c05a69 = 'var(--rightSidebarWidth, 0px)';
const $7c8e8130cce4c6fa$export$aeff86a16f13529 = 'var(--topNavigationHeight, 0px)';
const $7c8e8130cce4c6fa$export$ed7cc0d417ee89e = 'var(--bannerHeight, 0px)';

// temp solution until we can get it automated
const $a63b8901dea4a6fd$export$2295b861f318254a = '0.1.5';

const $f8b6a4fe60918e67$export$d8b468db8a225bc9 = 250;

const $f950aed7bc96486c$export$e0744546db5b6189 = 'rovo_chat_sites_source_filter';

const $f3039341ab1981e1$export$ad7805b1cbcab15e = 'JSMGROWTH-524';
const $f3039341ab1981e1$export$ac82a6f95aaaebf5 = 'grw-524_jsm_jpd_rovo_sidekick_killswitch';
const $f3039341ab1981e1$export$f562d49e335d7782 = 'jsm-contextual-suggestions';
const $f3039341ab1981e1$export$47ba9a433044383c = 'rovoQuickActions';
const $f3039341ab1981e1$export$8103addd67bbde0d = 60;

/* eslint-disable jira/filename-case */ const $74cc6705a5fdb0de$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!, $shouldIncludeBetaAiFeatures: Boolean!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	}

	jira_isRovoLLMEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	jira_isBetaAiFeaturesEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence") @include(if: $shouldIncludeBetaAiFeatures)
	jira_rovoEnablementStatus(cloudId: $cloudId)@optIn(to: "JiraRovoEnablementStatus") {
		isRovoEntitlementEnabledForTenant
		isRovoAiFeaturesEnabledInAnyJiraProducts {
			isEnabled
			disabledReason
		}
		rovoAiFeaturesEnabledJiraProducts
	}
}
`;

const $1056e2b7e19aa4e0$export$f4208f01301e1342 = 'HELP';

/* eslint-disable jira/filename-case */ const $2b56b53c34bc2033$export$c43c7444da662fa1 = '1';
const $2b56b53c34bc2033$export$e99efa3985fa3c26 = 'helpPanel';
const $2b56b53c34bc2033$export$23aa6670f346c214 = 368;

/* eslint-disable jira/filename-case */ const $a250aea31dc76f65$export$53f45136e435c2fd = 'help_button_ui_state';

const $863aeee714b20c92$export$2ce650757fdac12a = 'NOTIFICATIONS';

/* eslint-disable jira/filename-case */ const $71a8d80581e45c48$export$e0226a83abddbd07 = 'check-notifications';

/* eslint-disable jira/filename-case */ const $8dfb0c8c68d6c8c9$export$14c62ba6f49b806f = 9;

/* eslint-disable jira/filename-case */ const $70e36d23224a09de$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $70e36d23224a09de$export$2ee9e5a3556c1e43 = 'SIDEBAR';

const $c3b876b1e2716851$export$b98e411ae80c806f = '/';

const $eb044bb12d0b1d65$export$c1b33b1e65f8bd62 = 'SEARCH';

const $19cdad16ba956d29$export$eeb0307e2964e28d = "var(--ds-text, #292A2E)";

const $1574973252f10ca9$export$7168c0a11fb9ab29 = "var(--ds-text-subtlest, #6B6E76)";

const $a91cdcebb262d5e5$export$4ac85ff259fe4fce = "var(--ds-background-neutral-subtle-hovered, #0515240F)";

const $2242fed6b156c6c0$export$271fb8b1437b1d62 = "var(--ds-link-visited, #803FA5)";

const $57a8d3ee2467d6bc$export$1b6b909295618bea = 'SETTINGS';


$parcel$global.rlb("iZe2c")
//# sourceMappingURL=shared~atlassian-navigation~atlaskit~ar.de91c4f9.js.map
